import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: number; output: number; }
  jsonb: { input: any; output: any; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
};

/** columns and relationships of "AccessPoint" */
export type AccessPoint = {
  accessPointId: Scalars['uuid']['output'];
  /** An array relationship */
  accessPointRelays: Array<AccessPointRelay>;
  /** An aggregate relationship */
  accessPointRelays_aggregate: AccessPointRelay_aggregate;
  /** An array relationship */
  accessPointRoles: Array<AccessPointRole>;
  /** An aggregate relationship */
  accessPointRoles_aggregate: AccessPointRole_aggregate;
  accessTimeout: Scalars['Int']['output'];
  archivedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  archivedByUser?: Maybe<User>;
  archivedByUserId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  beacons: Array<Beacon>;
  /** An aggregate relationship */
  beacons_aggregate: Beacon_aggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  deprecatedAccessPointId: Scalars['Int']['output'];
  dpsAlertDelay?: Maybe<Scalars['Int']['output']>;
  dpsAlertInterval?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  favorites: Array<Favorite>;
  /** An aggregate relationship */
  favorites_aggregate: Favorite_aggregate;
  /** An object relationship */
  image?: Maybe<Image>;
  imageId?: Maybe<Scalars['uuid']['output']>;
  mapLocation?: Maybe<Scalars['jsonb']['output']>;
  maxOccupancy?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  property: Property;
  propertyId: Scalars['uuid']['output'];
  proximityRestriction: Scalars['Boolean']['output'];
  /** An array relationship */
  relayLogs: Array<RelayLog>;
  /** An aggregate relationship */
  relayLogs_aggregate: RelayLog_aggregate;
  rexAccessTimeout: Scalars['Int']['output'];
  spaceshipModeEnabled: Scalars['Boolean']['output'];
  timetable?: Maybe<Scalars['jsonb']['output']>;
  type: AccessPointType_enum;
  /** An object relationship */
  typeEnum: AccessPointType;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userRolePermissions: Array<UserRolePermission>;
  /** An aggregate relationship */
  userRolePermissions_aggregate: UserRolePermission_aggregate;
  /** An array relationship */
  userRoles: Array<UserRole>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRole_aggregate;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_accessPointRelaysArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRelay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRelay_order_by>>;
  where?: InputMaybe<AccessPointRelay_bool_exp>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_accessPointRelays_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRelay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRelay_order_by>>;
  where?: InputMaybe<AccessPointRelay_bool_exp>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_accessPointRolesArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRole_order_by>>;
  where?: InputMaybe<AccessPointRole_bool_exp>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_accessPointRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRole_order_by>>;
  where?: InputMaybe<AccessPointRole_bool_exp>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_beaconsArgs = {
  distinct_on?: InputMaybe<Array<Beacon_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Beacon_order_by>>;
  where?: InputMaybe<Beacon_bool_exp>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_beacons_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Beacon_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Beacon_order_by>>;
  where?: InputMaybe<Beacon_bool_exp>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_favoritesArgs = {
  distinct_on?: InputMaybe<Array<Favorite_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorite_order_by>>;
  where?: InputMaybe<Favorite_bool_exp>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_favorites_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Favorite_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorite_order_by>>;
  where?: InputMaybe<Favorite_bool_exp>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_mapLocationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_relayLogsArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_relayLogs_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_timetableArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_userRolePermissionsArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_userRolePermissions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_userRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "AccessPoint" */
export type AccessPoint_userRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};

/** columns and relationships of "AccessPointRelay" */
export type AccessPointRelay = {
  /** An object relationship */
  accessPoint: AccessPoint;
  accessPointId: Scalars['uuid']['output'];
  accessPointRelayId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  relay: Relay;
  relayId: Scalars['uuid']['output'];
};

/** aggregated selection of "AccessPointRelay" */
export type AccessPointRelay_aggregate = {
  aggregate?: Maybe<AccessPointRelay_aggregate_fields>;
  nodes: Array<AccessPointRelay>;
};

export type AccessPointRelay_aggregate_bool_exp = {
  count?: InputMaybe<AccessPointRelay_aggregate_bool_exp_count>;
};

export type AccessPointRelay_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<AccessPointRelay_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AccessPointRelay_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "AccessPointRelay" */
export type AccessPointRelay_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<AccessPointRelay_max_fields>;
  min?: Maybe<AccessPointRelay_min_fields>;
};


/** aggregate fields of "AccessPointRelay" */
export type AccessPointRelay_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<AccessPointRelay_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "AccessPointRelay" */
export type AccessPointRelay_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<AccessPointRelay_max_order_by>;
  min?: InputMaybe<AccessPointRelay_min_order_by>;
};

/** Boolean expression to filter rows from the table "AccessPointRelay". All fields are combined with a logical 'AND'. */
export type AccessPointRelay_bool_exp = {
  _and?: InputMaybe<Array<AccessPointRelay_bool_exp>>;
  _not?: InputMaybe<AccessPointRelay_bool_exp>;
  _or?: InputMaybe<Array<AccessPointRelay_bool_exp>>;
  accessPoint?: InputMaybe<AccessPoint_bool_exp>;
  accessPointId?: InputMaybe<uuid_comparison_exp>;
  accessPointRelayId?: InputMaybe<uuid_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  relay?: InputMaybe<Relay_bool_exp>;
  relayId?: InputMaybe<uuid_comparison_exp>;
};

/** aggregate max on columns */
export type AccessPointRelay_max_fields = {
  accessPointId?: Maybe<Scalars['uuid']['output']>;
  accessPointRelayId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  relayId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "AccessPointRelay" */
export type AccessPointRelay_max_order_by = {
  accessPointId?: InputMaybe<order_by>;
  accessPointRelayId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  relayId?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type AccessPointRelay_min_fields = {
  accessPointId?: Maybe<Scalars['uuid']['output']>;
  accessPointRelayId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  relayId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "AccessPointRelay" */
export type AccessPointRelay_min_order_by = {
  accessPointId?: InputMaybe<order_by>;
  accessPointRelayId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  relayId?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "AccessPointRelay". */
export type AccessPointRelay_order_by = {
  accessPoint?: InputMaybe<AccessPoint_order_by>;
  accessPointId?: InputMaybe<order_by>;
  accessPointRelayId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  relay?: InputMaybe<Relay_order_by>;
  relayId?: InputMaybe<order_by>;
};

/** select columns of table "AccessPointRelay" */
export enum AccessPointRelay_select_column {
  /** column name */
  accessPointId = 'accessPointId',
  /** column name */
  accessPointRelayId = 'accessPointRelayId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  relayId = 'relayId'
}

/** Streaming cursor of the table "AccessPointRelay" */
export type AccessPointRelay_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: AccessPointRelay_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccessPointRelay_stream_cursor_value_input = {
  accessPointId?: InputMaybe<Scalars['uuid']['input']>;
  accessPointRelayId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  relayId?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "AccessPointRole" */
export type AccessPointRole = {
  /** An object relationship */
  accessPoint: AccessPoint;
  accessPointId: Scalars['uuid']['output'];
  accessPointRoleId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  hasAccess: Scalars['Boolean']['output'];
  /** An object relationship */
  role: Role;
  roleId: Scalars['uuid']['output'];
  schedule?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  unitGroup?: Maybe<UnitGroup>;
  unitGroupId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "AccessPointRole" */
export type AccessPointRole_scheduleArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "AccessPointRole" */
export type AccessPointRole_aggregate = {
  aggregate?: Maybe<AccessPointRole_aggregate_fields>;
  nodes: Array<AccessPointRole>;
};

export type AccessPointRole_aggregate_bool_exp = {
  bool_and?: InputMaybe<AccessPointRole_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<AccessPointRole_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<AccessPointRole_aggregate_bool_exp_count>;
};

export type AccessPointRole_aggregate_bool_exp_bool_and = {
  arguments: AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AccessPointRole_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type AccessPointRole_aggregate_bool_exp_bool_or = {
  arguments: AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AccessPointRole_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type AccessPointRole_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<AccessPointRole_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AccessPointRole_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "AccessPointRole" */
export type AccessPointRole_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<AccessPointRole_max_fields>;
  min?: Maybe<AccessPointRole_min_fields>;
};


/** aggregate fields of "AccessPointRole" */
export type AccessPointRole_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<AccessPointRole_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "AccessPointRole" */
export type AccessPointRole_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<AccessPointRole_max_order_by>;
  min?: InputMaybe<AccessPointRole_min_order_by>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AccessPointRole_append_input = {
  schedule?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "AccessPointRole" */
export type AccessPointRole_arr_rel_insert_input = {
  data: Array<AccessPointRole_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AccessPointRole_on_conflict>;
};

/** Boolean expression to filter rows from the table "AccessPointRole". All fields are combined with a logical 'AND'. */
export type AccessPointRole_bool_exp = {
  _and?: InputMaybe<Array<AccessPointRole_bool_exp>>;
  _not?: InputMaybe<AccessPointRole_bool_exp>;
  _or?: InputMaybe<Array<AccessPointRole_bool_exp>>;
  accessPoint?: InputMaybe<AccessPoint_bool_exp>;
  accessPointId?: InputMaybe<uuid_comparison_exp>;
  accessPointRoleId?: InputMaybe<uuid_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  hasAccess?: InputMaybe<Boolean_comparison_exp>;
  role?: InputMaybe<Role_bool_exp>;
  roleId?: InputMaybe<uuid_comparison_exp>;
  schedule?: InputMaybe<jsonb_comparison_exp>;
  unitGroup?: InputMaybe<UnitGroup_bool_exp>;
  unitGroupId?: InputMaybe<uuid_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "AccessPointRole" */
export enum AccessPointRole_constraint {
  /** unique or primary key constraint on columns "accessPointRoleId" */
  AccessPointRole_pkey = 'AccessPointRole_pkey',
  /** unique or primary key constraint on columns "accessPointId", "roleId" */
  AccessPointRole_roleId_key = 'AccessPointRole_roleId_key',
  /** unique or primary key constraint on columns "accessPointId", "roleId", "unitGroupId" */
  AccessPointRole_roleId_unitGroupId_key = 'AccessPointRole_roleId_unitGroupId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AccessPointRole_delete_at_path_input = {
  schedule?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AccessPointRole_delete_elem_input = {
  schedule?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AccessPointRole_delete_key_input = {
  schedule?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "AccessPointRole" */
export type AccessPointRole_insert_input = {
  accessPoint?: InputMaybe<AccessPoint_obj_rel_insert_input>;
  accessPointId?: InputMaybe<Scalars['uuid']['input']>;
  hasAccess?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Role_obj_rel_insert_input>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  schedule?: InputMaybe<Scalars['jsonb']['input']>;
  unitGroup?: InputMaybe<UnitGroup_obj_rel_insert_input>;
  unitGroupId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AccessPointRole_max_fields = {
  accessPointId?: Maybe<Scalars['uuid']['output']>;
  accessPointRoleId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  unitGroupId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "AccessPointRole" */
export type AccessPointRole_max_order_by = {
  accessPointId?: InputMaybe<order_by>;
  accessPointRoleId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  roleId?: InputMaybe<order_by>;
  unitGroupId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type AccessPointRole_min_fields = {
  accessPointId?: Maybe<Scalars['uuid']['output']>;
  accessPointRoleId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  unitGroupId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "AccessPointRole" */
export type AccessPointRole_min_order_by = {
  accessPointId?: InputMaybe<order_by>;
  accessPointRoleId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  roleId?: InputMaybe<order_by>;
  unitGroupId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** response of any mutation on the table "AccessPointRole" */
export type AccessPointRole_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AccessPointRole>;
};

/** on_conflict condition type for table "AccessPointRole" */
export type AccessPointRole_on_conflict = {
  constraint: AccessPointRole_constraint;
  update_columns?: Array<AccessPointRole_update_column>;
  where?: InputMaybe<AccessPointRole_bool_exp>;
};

/** Ordering options when selecting data from "AccessPointRole". */
export type AccessPointRole_order_by = {
  accessPoint?: InputMaybe<AccessPoint_order_by>;
  accessPointId?: InputMaybe<order_by>;
  accessPointRoleId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  hasAccess?: InputMaybe<order_by>;
  role?: InputMaybe<Role_order_by>;
  roleId?: InputMaybe<order_by>;
  schedule?: InputMaybe<order_by>;
  unitGroup?: InputMaybe<UnitGroup_order_by>;
  unitGroupId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** primary key columns input for table: AccessPointRole */
export type AccessPointRole_pk_columns_input = {
  accessPointRoleId: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AccessPointRole_prepend_input = {
  schedule?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "AccessPointRole" */
export enum AccessPointRole_select_column {
  /** column name */
  accessPointId = 'accessPointId',
  /** column name */
  accessPointRoleId = 'accessPointRoleId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  hasAccess = 'hasAccess',
  /** column name */
  roleId = 'roleId',
  /** column name */
  schedule = 'schedule',
  /** column name */
  unitGroupId = 'unitGroupId',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "AccessPointRole_aggregate_bool_exp_bool_and_arguments_columns" columns of table "AccessPointRole" */
export enum AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  hasAccess = 'hasAccess'
}

/** select "AccessPointRole_aggregate_bool_exp_bool_or_arguments_columns" columns of table "AccessPointRole" */
export enum AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  hasAccess = 'hasAccess'
}

/** input type for updating data in table "AccessPointRole" */
export type AccessPointRole_set_input = {
  schedule?: InputMaybe<Scalars['jsonb']['input']>;
  unitGroupId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "AccessPointRole" */
export type AccessPointRole_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: AccessPointRole_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccessPointRole_stream_cursor_value_input = {
  accessPointId?: InputMaybe<Scalars['uuid']['input']>;
  accessPointRoleId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  hasAccess?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  schedule?: InputMaybe<Scalars['jsonb']['input']>;
  unitGroupId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "AccessPointRole" */
export enum AccessPointRole_update_column {
  /** column name */
  schedule = 'schedule',
  /** column name */
  unitGroupId = 'unitGroupId'
}

export type AccessPointRole_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AccessPointRole_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AccessPointRole_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AccessPointRole_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AccessPointRole_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AccessPointRole_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccessPointRole_set_input>;
  /** filter the rows which have to be updated */
  where: AccessPointRole_bool_exp;
};

/** columns and relationships of "AccessPointType" */
export type AccessPointType = {
  /** An array relationship */
  accessPoints: Array<AccessPoint>;
  /** An aggregate relationship */
  accessPoints_aggregate: AccessPoint_aggregate;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** columns and relationships of "AccessPointType" */
export type AccessPointType_accessPointsArgs = {
  distinct_on?: InputMaybe<Array<AccessPoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPoint_order_by>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};


/** columns and relationships of "AccessPointType" */
export type AccessPointType_accessPoints_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPoint_order_by>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};

/** aggregated selection of "AccessPointType" */
export type AccessPointType_aggregate = {
  aggregate?: Maybe<AccessPointType_aggregate_fields>;
  nodes: Array<AccessPointType>;
};

/** aggregate fields of "AccessPointType" */
export type AccessPointType_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<AccessPointType_max_fields>;
  min?: Maybe<AccessPointType_min_fields>;
};


/** aggregate fields of "AccessPointType" */
export type AccessPointType_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<AccessPointType_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "AccessPointType". All fields are combined with a logical 'AND'. */
export type AccessPointType_bool_exp = {
  _and?: InputMaybe<Array<AccessPointType_bool_exp>>;
  _not?: InputMaybe<AccessPointType_bool_exp>;
  _or?: InputMaybe<Array<AccessPointType_bool_exp>>;
  accessPoints?: InputMaybe<AccessPoint_bool_exp>;
  accessPoints_aggregate?: InputMaybe<AccessPoint_aggregate_bool_exp>;
  label?: InputMaybe<String_comparison_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum AccessPointType_enum {
  /** Amenity */
  AMENITY = 'AMENITY',
  /** Common Area */
  COMMON_AREA = 'COMMON_AREA',
  /** Reservation Only */
  RESERVATION_ONLY = 'RESERVATION_ONLY',
  /** Restricted (Blacklist) */
  RESTRICTED_BLACKLIST = 'RESTRICTED_BLACKLIST',
  /** Restricted (Whitelist) */
  RESTRICTED_WHITELIST = 'RESTRICTED_WHITELIST'
}

/** Boolean expression to compare columns of type "AccessPointType_enum". All fields are combined with logical 'AND'. */
export type AccessPointType_enum_comparison_exp = {
  _eq?: InputMaybe<AccessPointType_enum>;
  _in?: InputMaybe<Array<AccessPointType_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AccessPointType_enum>;
  _nin?: InputMaybe<Array<AccessPointType_enum>>;
};

/** aggregate max on columns */
export type AccessPointType_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AccessPointType_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "AccessPointType". */
export type AccessPointType_order_by = {
  accessPoints_aggregate?: InputMaybe<AccessPoint_aggregate_order_by>;
  label?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "AccessPointType" */
export enum AccessPointType_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "AccessPointType" */
export type AccessPointType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: AccessPointType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccessPointType_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "AccessPoint" */
export type AccessPoint_aggregate = {
  aggregate?: Maybe<AccessPoint_aggregate_fields>;
  nodes: Array<AccessPoint>;
};

export type AccessPoint_aggregate_bool_exp = {
  bool_and?: InputMaybe<AccessPoint_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<AccessPoint_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<AccessPoint_aggregate_bool_exp_count>;
};

export type AccessPoint_aggregate_bool_exp_bool_and = {
  arguments: AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AccessPoint_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type AccessPoint_aggregate_bool_exp_bool_or = {
  arguments: AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AccessPoint_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type AccessPoint_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<AccessPoint_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AccessPoint_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "AccessPoint" */
export type AccessPoint_aggregate_fields = {
  avg?: Maybe<AccessPoint_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AccessPoint_max_fields>;
  min?: Maybe<AccessPoint_min_fields>;
  stddev?: Maybe<AccessPoint_stddev_fields>;
  stddev_pop?: Maybe<AccessPoint_stddev_pop_fields>;
  stddev_samp?: Maybe<AccessPoint_stddev_samp_fields>;
  sum?: Maybe<AccessPoint_sum_fields>;
  var_pop?: Maybe<AccessPoint_var_pop_fields>;
  var_samp?: Maybe<AccessPoint_var_samp_fields>;
  variance?: Maybe<AccessPoint_variance_fields>;
};


/** aggregate fields of "AccessPoint" */
export type AccessPoint_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<AccessPoint_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "AccessPoint" */
export type AccessPoint_aggregate_order_by = {
  avg?: InputMaybe<AccessPoint_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<AccessPoint_max_order_by>;
  min?: InputMaybe<AccessPoint_min_order_by>;
  stddev?: InputMaybe<AccessPoint_stddev_order_by>;
  stddev_pop?: InputMaybe<AccessPoint_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<AccessPoint_stddev_samp_order_by>;
  sum?: InputMaybe<AccessPoint_sum_order_by>;
  var_pop?: InputMaybe<AccessPoint_var_pop_order_by>;
  var_samp?: InputMaybe<AccessPoint_var_samp_order_by>;
  variance?: InputMaybe<AccessPoint_variance_order_by>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AccessPoint_append_input = {
  timetable?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "AccessPoint" */
export type AccessPoint_arr_rel_insert_input = {
  data: Array<AccessPoint_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AccessPoint_on_conflict>;
};

/** aggregate avg on columns */
export type AccessPoint_avg_fields = {
  accessTimeout?: Maybe<Scalars['Float']['output']>;
  deprecatedAccessPointId?: Maybe<Scalars['Float']['output']>;
  dpsAlertDelay?: Maybe<Scalars['Float']['output']>;
  dpsAlertInterval?: Maybe<Scalars['Float']['output']>;
  maxOccupancy?: Maybe<Scalars['Float']['output']>;
  rexAccessTimeout?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "AccessPoint" */
export type AccessPoint_avg_order_by = {
  accessTimeout?: InputMaybe<order_by>;
  deprecatedAccessPointId?: InputMaybe<order_by>;
  dpsAlertDelay?: InputMaybe<order_by>;
  dpsAlertInterval?: InputMaybe<order_by>;
  maxOccupancy?: InputMaybe<order_by>;
  rexAccessTimeout?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "AccessPoint". All fields are combined with a logical 'AND'. */
export type AccessPoint_bool_exp = {
  _and?: InputMaybe<Array<AccessPoint_bool_exp>>;
  _not?: InputMaybe<AccessPoint_bool_exp>;
  _or?: InputMaybe<Array<AccessPoint_bool_exp>>;
  accessPointId?: InputMaybe<uuid_comparison_exp>;
  accessPointRelays?: InputMaybe<AccessPointRelay_bool_exp>;
  accessPointRelays_aggregate?: InputMaybe<AccessPointRelay_aggregate_bool_exp>;
  accessPointRoles?: InputMaybe<AccessPointRole_bool_exp>;
  accessPointRoles_aggregate?: InputMaybe<AccessPointRole_aggregate_bool_exp>;
  accessTimeout?: InputMaybe<Int_comparison_exp>;
  archivedAt?: InputMaybe<timestamptz_comparison_exp>;
  archivedByUser?: InputMaybe<User_bool_exp>;
  archivedByUserId?: InputMaybe<uuid_comparison_exp>;
  beacons?: InputMaybe<Beacon_bool_exp>;
  beacons_aggregate?: InputMaybe<Beacon_aggregate_bool_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  createdByUser?: InputMaybe<User_bool_exp>;
  createdByUserId?: InputMaybe<uuid_comparison_exp>;
  deprecatedAccessPointId?: InputMaybe<Int_comparison_exp>;
  dpsAlertDelay?: InputMaybe<Int_comparison_exp>;
  dpsAlertInterval?: InputMaybe<Int_comparison_exp>;
  favorites?: InputMaybe<Favorite_bool_exp>;
  favorites_aggregate?: InputMaybe<Favorite_aggregate_bool_exp>;
  image?: InputMaybe<Image_bool_exp>;
  imageId?: InputMaybe<uuid_comparison_exp>;
  mapLocation?: InputMaybe<jsonb_comparison_exp>;
  maxOccupancy?: InputMaybe<Int_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  property?: InputMaybe<Property_bool_exp>;
  propertyId?: InputMaybe<uuid_comparison_exp>;
  proximityRestriction?: InputMaybe<Boolean_comparison_exp>;
  relayLogs?: InputMaybe<RelayLog_bool_exp>;
  relayLogs_aggregate?: InputMaybe<RelayLog_aggregate_bool_exp>;
  rexAccessTimeout?: InputMaybe<Int_comparison_exp>;
  spaceshipModeEnabled?: InputMaybe<Boolean_comparison_exp>;
  timetable?: InputMaybe<jsonb_comparison_exp>;
  type?: InputMaybe<AccessPointType_enum_comparison_exp>;
  typeEnum?: InputMaybe<AccessPointType_bool_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  userRolePermissions?: InputMaybe<UserRolePermission_bool_exp>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_bool_exp>;
  userRoles?: InputMaybe<UserRole_bool_exp>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "AccessPoint" */
export enum AccessPoint_constraint {
  /** unique or primary key constraint on columns "deprecatedAccessPointId" */
  AccessPoint_deprecatedAccessPointId_key = 'AccessPoint_deprecatedAccessPointId_key',
  /** unique or primary key constraint on columns "accessPointId" */
  AccessPoint_pkey = 'AccessPoint_pkey',
  /** unique or primary key constraint on columns "name", "propertyId" */
  AccessPoint_propertyId_name_key = 'AccessPoint_propertyId_name_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AccessPoint_delete_at_path_input = {
  timetable?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AccessPoint_delete_elem_input = {
  timetable?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AccessPoint_delete_key_input = {
  timetable?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "AccessPoint" */
export type AccessPoint_inc_input = {
  accessTimeout?: InputMaybe<Scalars['Int']['input']>;
  dpsAlertDelay?: InputMaybe<Scalars['Int']['input']>;
  dpsAlertInterval?: InputMaybe<Scalars['Int']['input']>;
  maxOccupancy?: InputMaybe<Scalars['Int']['input']>;
  rexAccessTimeout?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "AccessPoint" */
export type AccessPoint_insert_input = {
  accessPointRoles?: InputMaybe<AccessPointRole_arr_rel_insert_input>;
  accessTimeout?: InputMaybe<Scalars['Int']['input']>;
  dpsAlertDelay?: InputMaybe<Scalars['Int']['input']>;
  dpsAlertInterval?: InputMaybe<Scalars['Int']['input']>;
  imageId?: InputMaybe<Scalars['uuid']['input']>;
  maxOccupancy?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Property_obj_rel_insert_input>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  proximityRestriction?: InputMaybe<Scalars['Boolean']['input']>;
  rexAccessTimeout?: InputMaybe<Scalars['Int']['input']>;
  spaceshipModeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timetable?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<AccessPointType_enum>;
};

/** aggregate max on columns */
export type AccessPoint_max_fields = {
  accessPointId?: Maybe<Scalars['uuid']['output']>;
  accessTimeout?: Maybe<Scalars['Int']['output']>;
  archivedAt?: Maybe<Scalars['timestamptz']['output']>;
  archivedByUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  deprecatedAccessPointId?: Maybe<Scalars['Int']['output']>;
  dpsAlertDelay?: Maybe<Scalars['Int']['output']>;
  dpsAlertInterval?: Maybe<Scalars['Int']['output']>;
  imageId?: Maybe<Scalars['uuid']['output']>;
  maxOccupancy?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  rexAccessTimeout?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "AccessPoint" */
export type AccessPoint_max_order_by = {
  accessPointId?: InputMaybe<order_by>;
  accessTimeout?: InputMaybe<order_by>;
  archivedAt?: InputMaybe<order_by>;
  archivedByUserId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUserId?: InputMaybe<order_by>;
  deprecatedAccessPointId?: InputMaybe<order_by>;
  dpsAlertDelay?: InputMaybe<order_by>;
  dpsAlertInterval?: InputMaybe<order_by>;
  imageId?: InputMaybe<order_by>;
  maxOccupancy?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  rexAccessTimeout?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type AccessPoint_min_fields = {
  accessPointId?: Maybe<Scalars['uuid']['output']>;
  accessTimeout?: Maybe<Scalars['Int']['output']>;
  archivedAt?: Maybe<Scalars['timestamptz']['output']>;
  archivedByUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  deprecatedAccessPointId?: Maybe<Scalars['Int']['output']>;
  dpsAlertDelay?: Maybe<Scalars['Int']['output']>;
  dpsAlertInterval?: Maybe<Scalars['Int']['output']>;
  imageId?: Maybe<Scalars['uuid']['output']>;
  maxOccupancy?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  rexAccessTimeout?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "AccessPoint" */
export type AccessPoint_min_order_by = {
  accessPointId?: InputMaybe<order_by>;
  accessTimeout?: InputMaybe<order_by>;
  archivedAt?: InputMaybe<order_by>;
  archivedByUserId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUserId?: InputMaybe<order_by>;
  deprecatedAccessPointId?: InputMaybe<order_by>;
  dpsAlertDelay?: InputMaybe<order_by>;
  dpsAlertInterval?: InputMaybe<order_by>;
  imageId?: InputMaybe<order_by>;
  maxOccupancy?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  rexAccessTimeout?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** response of any mutation on the table "AccessPoint" */
export type AccessPoint_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AccessPoint>;
};

/** input type for inserting object relation for remote table "AccessPoint" */
export type AccessPoint_obj_rel_insert_input = {
  data: AccessPoint_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<AccessPoint_on_conflict>;
};

/** on_conflict condition type for table "AccessPoint" */
export type AccessPoint_on_conflict = {
  constraint: AccessPoint_constraint;
  update_columns?: Array<AccessPoint_update_column>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};

/** Ordering options when selecting data from "AccessPoint". */
export type AccessPoint_order_by = {
  accessPointId?: InputMaybe<order_by>;
  accessPointRelays_aggregate?: InputMaybe<AccessPointRelay_aggregate_order_by>;
  accessPointRoles_aggregate?: InputMaybe<AccessPointRole_aggregate_order_by>;
  accessTimeout?: InputMaybe<order_by>;
  archivedAt?: InputMaybe<order_by>;
  archivedByUser?: InputMaybe<User_order_by>;
  archivedByUserId?: InputMaybe<order_by>;
  beacons_aggregate?: InputMaybe<Beacon_aggregate_order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUser?: InputMaybe<User_order_by>;
  createdByUserId?: InputMaybe<order_by>;
  deprecatedAccessPointId?: InputMaybe<order_by>;
  dpsAlertDelay?: InputMaybe<order_by>;
  dpsAlertInterval?: InputMaybe<order_by>;
  favorites_aggregate?: InputMaybe<Favorite_aggregate_order_by>;
  image?: InputMaybe<Image_order_by>;
  imageId?: InputMaybe<order_by>;
  mapLocation?: InputMaybe<order_by>;
  maxOccupancy?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  property?: InputMaybe<Property_order_by>;
  propertyId?: InputMaybe<order_by>;
  proximityRestriction?: InputMaybe<order_by>;
  relayLogs_aggregate?: InputMaybe<RelayLog_aggregate_order_by>;
  rexAccessTimeout?: InputMaybe<order_by>;
  spaceshipModeEnabled?: InputMaybe<order_by>;
  timetable?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  typeEnum?: InputMaybe<AccessPointType_order_by>;
  updatedAt?: InputMaybe<order_by>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_order_by>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
};

/** primary key columns input for table: AccessPoint */
export type AccessPoint_pk_columns_input = {
  accessPointId: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AccessPoint_prepend_input = {
  timetable?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "AccessPoint" */
export enum AccessPoint_select_column {
  /** column name */
  accessPointId = 'accessPointId',
  /** column name */
  accessTimeout = 'accessTimeout',
  /** column name */
  archivedAt = 'archivedAt',
  /** column name */
  archivedByUserId = 'archivedByUserId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdByUserId = 'createdByUserId',
  /** column name */
  deprecatedAccessPointId = 'deprecatedAccessPointId',
  /** column name */
  dpsAlertDelay = 'dpsAlertDelay',
  /** column name */
  dpsAlertInterval = 'dpsAlertInterval',
  /** column name */
  imageId = 'imageId',
  /** column name */
  mapLocation = 'mapLocation',
  /** column name */
  maxOccupancy = 'maxOccupancy',
  /** column name */
  name = 'name',
  /** column name */
  propertyId = 'propertyId',
  /** column name */
  proximityRestriction = 'proximityRestriction',
  /** column name */
  rexAccessTimeout = 'rexAccessTimeout',
  /** column name */
  spaceshipModeEnabled = 'spaceshipModeEnabled',
  /** column name */
  timetable = 'timetable',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "AccessPoint_aggregate_bool_exp_bool_and_arguments_columns" columns of table "AccessPoint" */
export enum AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  proximityRestriction = 'proximityRestriction',
  /** column name */
  spaceshipModeEnabled = 'spaceshipModeEnabled'
}

/** select "AccessPoint_aggregate_bool_exp_bool_or_arguments_columns" columns of table "AccessPoint" */
export enum AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  proximityRestriction = 'proximityRestriction',
  /** column name */
  spaceshipModeEnabled = 'spaceshipModeEnabled'
}

/** input type for updating data in table "AccessPoint" */
export type AccessPoint_set_input = {
  accessTimeout?: InputMaybe<Scalars['Int']['input']>;
  dpsAlertDelay?: InputMaybe<Scalars['Int']['input']>;
  dpsAlertInterval?: InputMaybe<Scalars['Int']['input']>;
  imageId?: InputMaybe<Scalars['uuid']['input']>;
  maxOccupancy?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  proximityRestriction?: InputMaybe<Scalars['Boolean']['input']>;
  rexAccessTimeout?: InputMaybe<Scalars['Int']['input']>;
  spaceshipModeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timetable?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<AccessPointType_enum>;
};

/** aggregate stddev on columns */
export type AccessPoint_stddev_fields = {
  accessTimeout?: Maybe<Scalars['Float']['output']>;
  deprecatedAccessPointId?: Maybe<Scalars['Float']['output']>;
  dpsAlertDelay?: Maybe<Scalars['Float']['output']>;
  dpsAlertInterval?: Maybe<Scalars['Float']['output']>;
  maxOccupancy?: Maybe<Scalars['Float']['output']>;
  rexAccessTimeout?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "AccessPoint" */
export type AccessPoint_stddev_order_by = {
  accessTimeout?: InputMaybe<order_by>;
  deprecatedAccessPointId?: InputMaybe<order_by>;
  dpsAlertDelay?: InputMaybe<order_by>;
  dpsAlertInterval?: InputMaybe<order_by>;
  maxOccupancy?: InputMaybe<order_by>;
  rexAccessTimeout?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type AccessPoint_stddev_pop_fields = {
  accessTimeout?: Maybe<Scalars['Float']['output']>;
  deprecatedAccessPointId?: Maybe<Scalars['Float']['output']>;
  dpsAlertDelay?: Maybe<Scalars['Float']['output']>;
  dpsAlertInterval?: Maybe<Scalars['Float']['output']>;
  maxOccupancy?: Maybe<Scalars['Float']['output']>;
  rexAccessTimeout?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "AccessPoint" */
export type AccessPoint_stddev_pop_order_by = {
  accessTimeout?: InputMaybe<order_by>;
  deprecatedAccessPointId?: InputMaybe<order_by>;
  dpsAlertDelay?: InputMaybe<order_by>;
  dpsAlertInterval?: InputMaybe<order_by>;
  maxOccupancy?: InputMaybe<order_by>;
  rexAccessTimeout?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type AccessPoint_stddev_samp_fields = {
  accessTimeout?: Maybe<Scalars['Float']['output']>;
  deprecatedAccessPointId?: Maybe<Scalars['Float']['output']>;
  dpsAlertDelay?: Maybe<Scalars['Float']['output']>;
  dpsAlertInterval?: Maybe<Scalars['Float']['output']>;
  maxOccupancy?: Maybe<Scalars['Float']['output']>;
  rexAccessTimeout?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "AccessPoint" */
export type AccessPoint_stddev_samp_order_by = {
  accessTimeout?: InputMaybe<order_by>;
  deprecatedAccessPointId?: InputMaybe<order_by>;
  dpsAlertDelay?: InputMaybe<order_by>;
  dpsAlertInterval?: InputMaybe<order_by>;
  maxOccupancy?: InputMaybe<order_by>;
  rexAccessTimeout?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "AccessPoint" */
export type AccessPoint_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: AccessPoint_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccessPoint_stream_cursor_value_input = {
  accessPointId?: InputMaybe<Scalars['uuid']['input']>;
  accessTimeout?: InputMaybe<Scalars['Int']['input']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  archivedByUserId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  deprecatedAccessPointId?: InputMaybe<Scalars['Int']['input']>;
  dpsAlertDelay?: InputMaybe<Scalars['Int']['input']>;
  dpsAlertInterval?: InputMaybe<Scalars['Int']['input']>;
  imageId?: InputMaybe<Scalars['uuid']['input']>;
  mapLocation?: InputMaybe<Scalars['jsonb']['input']>;
  maxOccupancy?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  proximityRestriction?: InputMaybe<Scalars['Boolean']['input']>;
  rexAccessTimeout?: InputMaybe<Scalars['Int']['input']>;
  spaceshipModeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timetable?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<AccessPointType_enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type AccessPoint_sum_fields = {
  accessTimeout?: Maybe<Scalars['Int']['output']>;
  deprecatedAccessPointId?: Maybe<Scalars['Int']['output']>;
  dpsAlertDelay?: Maybe<Scalars['Int']['output']>;
  dpsAlertInterval?: Maybe<Scalars['Int']['output']>;
  maxOccupancy?: Maybe<Scalars['Int']['output']>;
  rexAccessTimeout?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "AccessPoint" */
export type AccessPoint_sum_order_by = {
  accessTimeout?: InputMaybe<order_by>;
  deprecatedAccessPointId?: InputMaybe<order_by>;
  dpsAlertDelay?: InputMaybe<order_by>;
  dpsAlertInterval?: InputMaybe<order_by>;
  maxOccupancy?: InputMaybe<order_by>;
  rexAccessTimeout?: InputMaybe<order_by>;
};

/** update columns of table "AccessPoint" */
export enum AccessPoint_update_column {
  /** column name */
  accessTimeout = 'accessTimeout',
  /** column name */
  dpsAlertDelay = 'dpsAlertDelay',
  /** column name */
  dpsAlertInterval = 'dpsAlertInterval',
  /** column name */
  imageId = 'imageId',
  /** column name */
  maxOccupancy = 'maxOccupancy',
  /** column name */
  name = 'name',
  /** column name */
  proximityRestriction = 'proximityRestriction',
  /** column name */
  rexAccessTimeout = 'rexAccessTimeout',
  /** column name */
  spaceshipModeEnabled = 'spaceshipModeEnabled',
  /** column name */
  timetable = 'timetable',
  /** column name */
  type = 'type'
}

export type AccessPoint_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AccessPoint_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AccessPoint_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AccessPoint_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AccessPoint_delete_key_input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AccessPoint_inc_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AccessPoint_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccessPoint_set_input>;
  /** filter the rows which have to be updated */
  where: AccessPoint_bool_exp;
};

/** aggregate var_pop on columns */
export type AccessPoint_var_pop_fields = {
  accessTimeout?: Maybe<Scalars['Float']['output']>;
  deprecatedAccessPointId?: Maybe<Scalars['Float']['output']>;
  dpsAlertDelay?: Maybe<Scalars['Float']['output']>;
  dpsAlertInterval?: Maybe<Scalars['Float']['output']>;
  maxOccupancy?: Maybe<Scalars['Float']['output']>;
  rexAccessTimeout?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "AccessPoint" */
export type AccessPoint_var_pop_order_by = {
  accessTimeout?: InputMaybe<order_by>;
  deprecatedAccessPointId?: InputMaybe<order_by>;
  dpsAlertDelay?: InputMaybe<order_by>;
  dpsAlertInterval?: InputMaybe<order_by>;
  maxOccupancy?: InputMaybe<order_by>;
  rexAccessTimeout?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type AccessPoint_var_samp_fields = {
  accessTimeout?: Maybe<Scalars['Float']['output']>;
  deprecatedAccessPointId?: Maybe<Scalars['Float']['output']>;
  dpsAlertDelay?: Maybe<Scalars['Float']['output']>;
  dpsAlertInterval?: Maybe<Scalars['Float']['output']>;
  maxOccupancy?: Maybe<Scalars['Float']['output']>;
  rexAccessTimeout?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "AccessPoint" */
export type AccessPoint_var_samp_order_by = {
  accessTimeout?: InputMaybe<order_by>;
  deprecatedAccessPointId?: InputMaybe<order_by>;
  dpsAlertDelay?: InputMaybe<order_by>;
  dpsAlertInterval?: InputMaybe<order_by>;
  maxOccupancy?: InputMaybe<order_by>;
  rexAccessTimeout?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type AccessPoint_variance_fields = {
  accessTimeout?: Maybe<Scalars['Float']['output']>;
  deprecatedAccessPointId?: Maybe<Scalars['Float']['output']>;
  dpsAlertDelay?: Maybe<Scalars['Float']['output']>;
  dpsAlertInterval?: Maybe<Scalars['Float']['output']>;
  maxOccupancy?: Maybe<Scalars['Float']['output']>;
  rexAccessTimeout?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "AccessPoint" */
export type AccessPoint_variance_order_by = {
  accessTimeout?: InputMaybe<order_by>;
  deprecatedAccessPointId?: InputMaybe<order_by>;
  dpsAlertDelay?: InputMaybe<order_by>;
  dpsAlertInterval?: InputMaybe<order_by>;
  maxOccupancy?: InputMaybe<order_by>;
  rexAccessTimeout?: InputMaybe<order_by>;
};

/** columns and relationships of "AccountStatus" */
export type AccountStatus = {
  label?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  users: Array<User>;
  /** An aggregate relationship */
  users_aggregate: User_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "AccountStatus" */
export type AccountStatus_usersArgs = {
  distinct_on?: InputMaybe<Array<User_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_order_by>>;
  where?: InputMaybe<User_bool_exp>;
};


/** columns and relationships of "AccountStatus" */
export type AccountStatus_users_aggregateArgs = {
  distinct_on?: InputMaybe<Array<User_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_order_by>>;
  where?: InputMaybe<User_bool_exp>;
};

/** aggregated selection of "AccountStatus" */
export type AccountStatus_aggregate = {
  aggregate?: Maybe<AccountStatus_aggregate_fields>;
  nodes: Array<AccountStatus>;
};

/** aggregate fields of "AccountStatus" */
export type AccountStatus_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<AccountStatus_max_fields>;
  min?: Maybe<AccountStatus_min_fields>;
};


/** aggregate fields of "AccountStatus" */
export type AccountStatus_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<AccountStatus_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "AccountStatus". All fields are combined with a logical 'AND'. */
export type AccountStatus_bool_exp = {
  _and?: InputMaybe<Array<AccountStatus_bool_exp>>;
  _not?: InputMaybe<AccountStatus_bool_exp>;
  _or?: InputMaybe<Array<AccountStatus_bool_exp>>;
  label?: InputMaybe<String_comparison_exp>;
  users?: InputMaybe<User_bool_exp>;
  users_aggregate?: InputMaybe<User_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum AccountStatus_enum {
  /** Disabled */
  DISABLED = 'DISABLED',
  /** Enabled */
  ENABLED = 'ENABLED'
}

/** Boolean expression to compare columns of type "AccountStatus_enum". All fields are combined with logical 'AND'. */
export type AccountStatus_enum_comparison_exp = {
  _eq?: InputMaybe<AccountStatus_enum>;
  _in?: InputMaybe<Array<AccountStatus_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AccountStatus_enum>;
  _nin?: InputMaybe<Array<AccountStatus_enum>>;
};

/** aggregate max on columns */
export type AccountStatus_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AccountStatus_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "AccountStatus". */
export type AccountStatus_order_by = {
  label?: InputMaybe<order_by>;
  users_aggregate?: InputMaybe<User_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "AccountStatus" */
export enum AccountStatus_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "AccountStatus" */
export type AccountStatus_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: AccountStatus_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountStatus_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum AugustRemoteOperation {
  lock = 'lock',
  rebootLock = 'rebootLock',
  status = 'status',
  unlock = 'unlock'
}

/** columns and relationships of "AuthMethod" */
export type AuthMethod = {
  label: Scalars['String']['output'];
  /** An array relationship */
  sessions: Array<Session>;
  /** An aggregate relationship */
  sessions_aggregate: Session_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "AuthMethod" */
export type AuthMethod_sessionsArgs = {
  distinct_on?: InputMaybe<Array<Session_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_order_by>>;
  where?: InputMaybe<Session_bool_exp>;
};


/** columns and relationships of "AuthMethod" */
export type AuthMethod_sessions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Session_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_order_by>>;
  where?: InputMaybe<Session_bool_exp>;
};

/** aggregated selection of "AuthMethod" */
export type AuthMethod_aggregate = {
  aggregate?: Maybe<AuthMethod_aggregate_fields>;
  nodes: Array<AuthMethod>;
};

/** aggregate fields of "AuthMethod" */
export type AuthMethod_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<AuthMethod_max_fields>;
  min?: Maybe<AuthMethod_min_fields>;
};


/** aggregate fields of "AuthMethod" */
export type AuthMethod_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<AuthMethod_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "AuthMethod". All fields are combined with a logical 'AND'. */
export type AuthMethod_bool_exp = {
  _and?: InputMaybe<Array<AuthMethod_bool_exp>>;
  _not?: InputMaybe<AuthMethod_bool_exp>;
  _or?: InputMaybe<Array<AuthMethod_bool_exp>>;
  label?: InputMaybe<String_comparison_exp>;
  sessions?: InputMaybe<Session_bool_exp>;
  sessions_aggregate?: InputMaybe<Session_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum AuthMethod_enum {
  /** 2FA - August OAuth */
  AUGUST_OAUTH = 'AUGUST_OAUTH',
  /** 1FA - Email */
  EMAIL = 'EMAIL',
  /** 2FA - Email and Password */
  EMAIL_AND_PASSWORD = 'EMAIL_AND_PASSWORD',
  /** 1FA - Phone Number */
  PHONE_NUMBER = 'PHONE_NUMBER',
  /** 2FA - Phone Number and Email */
  PHONE_NUMBER_AND_EMAIL = 'PHONE_NUMBER_AND_EMAIL',
  /** 2FA - Phone Number and Password */
  PHONE_NUMBER_AND_PASSWORD = 'PHONE_NUMBER_AND_PASSWORD',
  /** Single Sign-On */
  SINGLE_SIGN_ON = 'SINGLE_SIGN_ON'
}

/** Boolean expression to compare columns of type "AuthMethod_enum". All fields are combined with logical 'AND'. */
export type AuthMethod_enum_comparison_exp = {
  _eq?: InputMaybe<AuthMethod_enum>;
  _in?: InputMaybe<Array<AuthMethod_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AuthMethod_enum>;
  _nin?: InputMaybe<Array<AuthMethod_enum>>;
};

/** aggregate max on columns */
export type AuthMethod_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthMethod_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "AuthMethod". */
export type AuthMethod_order_by = {
  label?: InputMaybe<order_by>;
  sessions_aggregate?: InputMaybe<Session_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "AuthMethod" */
export enum AuthMethod_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "AuthMethod" */
export type AuthMethod_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: AuthMethod_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthMethod_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "Beacon" */
export type Beacon = {
  /** An object relationship */
  accessPoint: AccessPoint;
  accessPointId: Scalars['uuid']['output'];
  beaconId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  location?: Maybe<Scalars['String']['output']>;
  macAddress: Scalars['String']['output'];
  major: Scalars['Int']['output'];
  minor: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** A computed field, executes function "beacon_password_rotated_at" */
  passwordRotatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  uuid: Scalars['uuid']['output'];
};

/** aggregated selection of "Beacon" */
export type Beacon_aggregate = {
  aggregate?: Maybe<Beacon_aggregate_fields>;
  nodes: Array<Beacon>;
};

export type Beacon_aggregate_bool_exp = {
  count?: InputMaybe<Beacon_aggregate_bool_exp_count>;
};

export type Beacon_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<Beacon_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Beacon_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "Beacon" */
export type Beacon_aggregate_fields = {
  avg?: Maybe<Beacon_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Beacon_max_fields>;
  min?: Maybe<Beacon_min_fields>;
  stddev?: Maybe<Beacon_stddev_fields>;
  stddev_pop?: Maybe<Beacon_stddev_pop_fields>;
  stddev_samp?: Maybe<Beacon_stddev_samp_fields>;
  sum?: Maybe<Beacon_sum_fields>;
  var_pop?: Maybe<Beacon_var_pop_fields>;
  var_samp?: Maybe<Beacon_var_samp_fields>;
  variance?: Maybe<Beacon_variance_fields>;
};


/** aggregate fields of "Beacon" */
export type Beacon_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<Beacon_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Beacon" */
export type Beacon_aggregate_order_by = {
  avg?: InputMaybe<Beacon_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<Beacon_max_order_by>;
  min?: InputMaybe<Beacon_min_order_by>;
  stddev?: InputMaybe<Beacon_stddev_order_by>;
  stddev_pop?: InputMaybe<Beacon_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<Beacon_stddev_samp_order_by>;
  sum?: InputMaybe<Beacon_sum_order_by>;
  var_pop?: InputMaybe<Beacon_var_pop_order_by>;
  var_samp?: InputMaybe<Beacon_var_samp_order_by>;
  variance?: InputMaybe<Beacon_variance_order_by>;
};

/** aggregate avg on columns */
export type Beacon_avg_fields = {
  major?: Maybe<Scalars['Float']['output']>;
  minor?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "Beacon" */
export type Beacon_avg_order_by = {
  major?: InputMaybe<order_by>;
  minor?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "Beacon". All fields are combined with a logical 'AND'. */
export type Beacon_bool_exp = {
  _and?: InputMaybe<Array<Beacon_bool_exp>>;
  _not?: InputMaybe<Beacon_bool_exp>;
  _or?: InputMaybe<Array<Beacon_bool_exp>>;
  accessPoint?: InputMaybe<AccessPoint_bool_exp>;
  accessPointId?: InputMaybe<uuid_comparison_exp>;
  beaconId?: InputMaybe<uuid_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  location?: InputMaybe<String_comparison_exp>;
  macAddress?: InputMaybe<String_comparison_exp>;
  major?: InputMaybe<Int_comparison_exp>;
  minor?: InputMaybe<Int_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  passwordRotatedAt?: InputMaybe<timestamptz_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  uuid?: InputMaybe<uuid_comparison_exp>;
};

/** aggregate max on columns */
export type Beacon_max_fields = {
  accessPointId?: Maybe<Scalars['uuid']['output']>;
  beaconId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  macAddress?: Maybe<Scalars['String']['output']>;
  major?: Maybe<Scalars['Int']['output']>;
  minor?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "Beacon" */
export type Beacon_max_order_by = {
  accessPointId?: InputMaybe<order_by>;
  beaconId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  location?: InputMaybe<order_by>;
  macAddress?: InputMaybe<order_by>;
  major?: InputMaybe<order_by>;
  minor?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  uuid?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type Beacon_min_fields = {
  accessPointId?: Maybe<Scalars['uuid']['output']>;
  beaconId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  macAddress?: Maybe<Scalars['String']['output']>;
  major?: Maybe<Scalars['Int']['output']>;
  minor?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "Beacon" */
export type Beacon_min_order_by = {
  accessPointId?: InputMaybe<order_by>;
  beaconId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  location?: InputMaybe<order_by>;
  macAddress?: InputMaybe<order_by>;
  major?: InputMaybe<order_by>;
  minor?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  uuid?: InputMaybe<order_by>;
};

/** response of any mutation on the table "Beacon" */
export type Beacon_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Beacon>;
};

/** Ordering options when selecting data from "Beacon". */
export type Beacon_order_by = {
  accessPoint?: InputMaybe<AccessPoint_order_by>;
  accessPointId?: InputMaybe<order_by>;
  beaconId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  location?: InputMaybe<order_by>;
  macAddress?: InputMaybe<order_by>;
  major?: InputMaybe<order_by>;
  minor?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  passwordRotatedAt?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  uuid?: InputMaybe<order_by>;
};

/** primary key columns input for table: Beacon */
export type Beacon_pk_columns_input = {
  beaconId: Scalars['uuid']['input'];
};

/** select columns of table "Beacon" */
export enum Beacon_select_column {
  /** column name */
  accessPointId = 'accessPointId',
  /** column name */
  beaconId = 'beaconId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  location = 'location',
  /** column name */
  macAddress = 'macAddress',
  /** column name */
  major = 'major',
  /** column name */
  minor = 'minor',
  /** column name */
  name = 'name',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  uuid = 'uuid'
}

/** input type for updating data in table "Beacon" */
export type Beacon_set_input = {
  accessPointId?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Beacon_stddev_fields = {
  major?: Maybe<Scalars['Float']['output']>;
  minor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "Beacon" */
export type Beacon_stddev_order_by = {
  major?: InputMaybe<order_by>;
  minor?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type Beacon_stddev_pop_fields = {
  major?: Maybe<Scalars['Float']['output']>;
  minor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "Beacon" */
export type Beacon_stddev_pop_order_by = {
  major?: InputMaybe<order_by>;
  minor?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type Beacon_stddev_samp_fields = {
  major?: Maybe<Scalars['Float']['output']>;
  minor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "Beacon" */
export type Beacon_stddev_samp_order_by = {
  major?: InputMaybe<order_by>;
  minor?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "Beacon" */
export type Beacon_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Beacon_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Beacon_stream_cursor_value_input = {
  accessPointId?: InputMaybe<Scalars['uuid']['input']>;
  beaconId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  macAddress?: InputMaybe<Scalars['String']['input']>;
  major?: InputMaybe<Scalars['Int']['input']>;
  minor?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Beacon_sum_fields = {
  major?: Maybe<Scalars['Int']['output']>;
  minor?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "Beacon" */
export type Beacon_sum_order_by = {
  major?: InputMaybe<order_by>;
  minor?: InputMaybe<order_by>;
};

export type Beacon_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Beacon_set_input>;
  /** filter the rows which have to be updated */
  where: Beacon_bool_exp;
};

/** aggregate var_pop on columns */
export type Beacon_var_pop_fields = {
  major?: Maybe<Scalars['Float']['output']>;
  minor?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "Beacon" */
export type Beacon_var_pop_order_by = {
  major?: InputMaybe<order_by>;
  minor?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type Beacon_var_samp_fields = {
  major?: Maybe<Scalars['Float']['output']>;
  minor?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "Beacon" */
export type Beacon_var_samp_order_by = {
  major?: InputMaybe<order_by>;
  minor?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type Beacon_variance_fields = {
  major?: Maybe<Scalars['Float']['output']>;
  minor?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "Beacon" */
export type Beacon_variance_order_by = {
  major?: InputMaybe<order_by>;
  minor?: InputMaybe<order_by>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_comparison_exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** columns and relationships of "Credential" */
export type Credential = {
  /** An object relationship */
  assignedToUser?: Maybe<User>;
  assignedToUserId?: Maybe<Scalars['uuid']['output']>;
  cardNumber?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  credentialId: Scalars['uuid']['output'];
  facilityCode?: Maybe<Scalars['Int']['output']>;
  identifier: Scalars['String']['output'];
  /** An object relationship */
  ownedByProperty?: Maybe<Property>;
  ownedByPropertyId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  provisionedByUser?: Maybe<User>;
  provisionedByUserId?: Maybe<Scalars['uuid']['output']>;
  sourcePayload?: Maybe<Scalars['jsonb']['output']>;
  type: CredentialType_enum;
  /** An object relationship */
  typeEnum: CredentialType;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "Credential" */
export type Credential_sourcePayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "CredentialType" */
export type CredentialType = {
  /** An array relationship */
  credentials: Array<Credential>;
  /** An aggregate relationship */
  credentials_aggregate: Credential_aggregate;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** columns and relationships of "CredentialType" */
export type CredentialType_credentialsArgs = {
  distinct_on?: InputMaybe<Array<Credential_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credential_order_by>>;
  where?: InputMaybe<Credential_bool_exp>;
};


/** columns and relationships of "CredentialType" */
export type CredentialType_credentials_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Credential_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credential_order_by>>;
  where?: InputMaybe<Credential_bool_exp>;
};

/** aggregated selection of "CredentialType" */
export type CredentialType_aggregate = {
  aggregate?: Maybe<CredentialType_aggregate_fields>;
  nodes: Array<CredentialType>;
};

/** aggregate fields of "CredentialType" */
export type CredentialType_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<CredentialType_max_fields>;
  min?: Maybe<CredentialType_min_fields>;
};


/** aggregate fields of "CredentialType" */
export type CredentialType_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<CredentialType_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "CredentialType". All fields are combined with a logical 'AND'. */
export type CredentialType_bool_exp = {
  _and?: InputMaybe<Array<CredentialType_bool_exp>>;
  _not?: InputMaybe<CredentialType_bool_exp>;
  _or?: InputMaybe<Array<CredentialType_bool_exp>>;
  credentials?: InputMaybe<Credential_bool_exp>;
  credentials_aggregate?: InputMaybe<Credential_aggregate_bool_exp>;
  label?: InputMaybe<String_comparison_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum CredentialType_enum {
  /** Fob */
  FOB = 'FOB',
  /** Mobile */
  MOBILE = 'MOBILE'
}

/** Boolean expression to compare columns of type "CredentialType_enum". All fields are combined with logical 'AND'. */
export type CredentialType_enum_comparison_exp = {
  _eq?: InputMaybe<CredentialType_enum>;
  _in?: InputMaybe<Array<CredentialType_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<CredentialType_enum>;
  _nin?: InputMaybe<Array<CredentialType_enum>>;
};

/** aggregate max on columns */
export type CredentialType_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CredentialType_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "CredentialType". */
export type CredentialType_order_by = {
  credentials_aggregate?: InputMaybe<Credential_aggregate_order_by>;
  label?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "CredentialType" */
export enum CredentialType_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "CredentialType" */
export type CredentialType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: CredentialType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CredentialType_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Credential" */
export type Credential_aggregate = {
  aggregate?: Maybe<Credential_aggregate_fields>;
  nodes: Array<Credential>;
};

export type Credential_aggregate_bool_exp = {
  count?: InputMaybe<Credential_aggregate_bool_exp_count>;
};

export type Credential_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<Credential_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Credential_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "Credential" */
export type Credential_aggregate_fields = {
  avg?: Maybe<Credential_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Credential_max_fields>;
  min?: Maybe<Credential_min_fields>;
  stddev?: Maybe<Credential_stddev_fields>;
  stddev_pop?: Maybe<Credential_stddev_pop_fields>;
  stddev_samp?: Maybe<Credential_stddev_samp_fields>;
  sum?: Maybe<Credential_sum_fields>;
  var_pop?: Maybe<Credential_var_pop_fields>;
  var_samp?: Maybe<Credential_var_samp_fields>;
  variance?: Maybe<Credential_variance_fields>;
};


/** aggregate fields of "Credential" */
export type Credential_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<Credential_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Credential" */
export type Credential_aggregate_order_by = {
  avg?: InputMaybe<Credential_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<Credential_max_order_by>;
  min?: InputMaybe<Credential_min_order_by>;
  stddev?: InputMaybe<Credential_stddev_order_by>;
  stddev_pop?: InputMaybe<Credential_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<Credential_stddev_samp_order_by>;
  sum?: InputMaybe<Credential_sum_order_by>;
  var_pop?: InputMaybe<Credential_var_pop_order_by>;
  var_samp?: InputMaybe<Credential_var_samp_order_by>;
  variance?: InputMaybe<Credential_variance_order_by>;
};

/** input type for inserting array relation for remote table "Credential" */
export type Credential_arr_rel_insert_input = {
  data: Array<Credential_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Credential_on_conflict>;
};

/** aggregate avg on columns */
export type Credential_avg_fields = {
  cardNumber?: Maybe<Scalars['Float']['output']>;
  facilityCode?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "Credential" */
export type Credential_avg_order_by = {
  cardNumber?: InputMaybe<order_by>;
  facilityCode?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "Credential". All fields are combined with a logical 'AND'. */
export type Credential_bool_exp = {
  _and?: InputMaybe<Array<Credential_bool_exp>>;
  _not?: InputMaybe<Credential_bool_exp>;
  _or?: InputMaybe<Array<Credential_bool_exp>>;
  assignedToUser?: InputMaybe<User_bool_exp>;
  assignedToUserId?: InputMaybe<uuid_comparison_exp>;
  cardNumber?: InputMaybe<Int_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  credentialId?: InputMaybe<uuid_comparison_exp>;
  facilityCode?: InputMaybe<Int_comparison_exp>;
  identifier?: InputMaybe<String_comparison_exp>;
  ownedByProperty?: InputMaybe<Property_bool_exp>;
  ownedByPropertyId?: InputMaybe<uuid_comparison_exp>;
  provisionedByUser?: InputMaybe<User_bool_exp>;
  provisionedByUserId?: InputMaybe<uuid_comparison_exp>;
  sourcePayload?: InputMaybe<jsonb_comparison_exp>;
  type?: InputMaybe<CredentialType_enum_comparison_exp>;
  typeEnum?: InputMaybe<CredentialType_bool_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "Credential" */
export enum Credential_constraint {
  /** unique or primary key constraint on columns "identifier" */
  Credential_identifier_key = 'Credential_identifier_key',
  /** unique or primary key constraint on columns "identifier", "ownedByPropertyId" */
  Credential_identifier_propertyId_key = 'Credential_identifier_propertyId_key',
  /** unique or primary key constraint on columns "credentialId" */
  Credential_pkey = 'Credential_pkey',
  /** unique or primary key constraint on columns "cardNumber", "facilityCode", "ownedByPropertyId" */
  Credential_propertyId_facilityCode_cardNumber_key = 'Credential_propertyId_facilityCode_cardNumber_key'
}

/** input type for inserting data into table "Credential" */
export type Credential_insert_input = {
  assignedToUserId?: InputMaybe<Scalars['uuid']['input']>;
  cardNumber?: InputMaybe<Scalars['Int']['input']>;
  facilityCode?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  ownedByProperty?: InputMaybe<Property_obj_rel_insert_input>;
  ownedByPropertyId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<CredentialType_enum>;
};

/** aggregate max on columns */
export type Credential_max_fields = {
  assignedToUserId?: Maybe<Scalars['uuid']['output']>;
  cardNumber?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  credentialId?: Maybe<Scalars['uuid']['output']>;
  facilityCode?: Maybe<Scalars['Int']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  ownedByPropertyId?: Maybe<Scalars['uuid']['output']>;
  provisionedByUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Credential" */
export type Credential_max_order_by = {
  assignedToUserId?: InputMaybe<order_by>;
  cardNumber?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  credentialId?: InputMaybe<order_by>;
  facilityCode?: InputMaybe<order_by>;
  identifier?: InputMaybe<order_by>;
  ownedByPropertyId?: InputMaybe<order_by>;
  provisionedByUserId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type Credential_min_fields = {
  assignedToUserId?: Maybe<Scalars['uuid']['output']>;
  cardNumber?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  credentialId?: Maybe<Scalars['uuid']['output']>;
  facilityCode?: Maybe<Scalars['Int']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  ownedByPropertyId?: Maybe<Scalars['uuid']['output']>;
  provisionedByUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Credential" */
export type Credential_min_order_by = {
  assignedToUserId?: InputMaybe<order_by>;
  cardNumber?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  credentialId?: InputMaybe<order_by>;
  facilityCode?: InputMaybe<order_by>;
  identifier?: InputMaybe<order_by>;
  ownedByPropertyId?: InputMaybe<order_by>;
  provisionedByUserId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** response of any mutation on the table "Credential" */
export type Credential_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Credential>;
};

/** on_conflict condition type for table "Credential" */
export type Credential_on_conflict = {
  constraint: Credential_constraint;
  update_columns?: Array<Credential_update_column>;
  where?: InputMaybe<Credential_bool_exp>;
};

/** Ordering options when selecting data from "Credential". */
export type Credential_order_by = {
  assignedToUser?: InputMaybe<User_order_by>;
  assignedToUserId?: InputMaybe<order_by>;
  cardNumber?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  credentialId?: InputMaybe<order_by>;
  facilityCode?: InputMaybe<order_by>;
  identifier?: InputMaybe<order_by>;
  ownedByProperty?: InputMaybe<Property_order_by>;
  ownedByPropertyId?: InputMaybe<order_by>;
  provisionedByUser?: InputMaybe<User_order_by>;
  provisionedByUserId?: InputMaybe<order_by>;
  sourcePayload?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  typeEnum?: InputMaybe<CredentialType_order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** primary key columns input for table: Credential */
export type Credential_pk_columns_input = {
  credentialId: Scalars['uuid']['input'];
};

/** select columns of table "Credential" */
export enum Credential_select_column {
  /** column name */
  assignedToUserId = 'assignedToUserId',
  /** column name */
  cardNumber = 'cardNumber',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  credentialId = 'credentialId',
  /** column name */
  facilityCode = 'facilityCode',
  /** column name */
  identifier = 'identifier',
  /** column name */
  ownedByPropertyId = 'ownedByPropertyId',
  /** column name */
  provisionedByUserId = 'provisionedByUserId',
  /** column name */
  sourcePayload = 'sourcePayload',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "Credential" */
export type Credential_set_input = {
  assignedToUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Credential_stddev_fields = {
  cardNumber?: Maybe<Scalars['Float']['output']>;
  facilityCode?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "Credential" */
export type Credential_stddev_order_by = {
  cardNumber?: InputMaybe<order_by>;
  facilityCode?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type Credential_stddev_pop_fields = {
  cardNumber?: Maybe<Scalars['Float']['output']>;
  facilityCode?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "Credential" */
export type Credential_stddev_pop_order_by = {
  cardNumber?: InputMaybe<order_by>;
  facilityCode?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type Credential_stddev_samp_fields = {
  cardNumber?: Maybe<Scalars['Float']['output']>;
  facilityCode?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "Credential" */
export type Credential_stddev_samp_order_by = {
  cardNumber?: InputMaybe<order_by>;
  facilityCode?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "Credential" */
export type Credential_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Credential_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credential_stream_cursor_value_input = {
  assignedToUserId?: InputMaybe<Scalars['uuid']['input']>;
  cardNumber?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  credentialId?: InputMaybe<Scalars['uuid']['input']>;
  facilityCode?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  ownedByPropertyId?: InputMaybe<Scalars['uuid']['input']>;
  provisionedByUserId?: InputMaybe<Scalars['uuid']['input']>;
  sourcePayload?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<CredentialType_enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Credential_sum_fields = {
  cardNumber?: Maybe<Scalars['Int']['output']>;
  facilityCode?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "Credential" */
export type Credential_sum_order_by = {
  cardNumber?: InputMaybe<order_by>;
  facilityCode?: InputMaybe<order_by>;
};

/** update columns of table "Credential" */
export enum Credential_update_column {
  /** column name */
  assignedToUserId = 'assignedToUserId'
}

export type Credential_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Credential_set_input>;
  /** filter the rows which have to be updated */
  where: Credential_bool_exp;
};

/** aggregate var_pop on columns */
export type Credential_var_pop_fields = {
  cardNumber?: Maybe<Scalars['Float']['output']>;
  facilityCode?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "Credential" */
export type Credential_var_pop_order_by = {
  cardNumber?: InputMaybe<order_by>;
  facilityCode?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type Credential_var_samp_fields = {
  cardNumber?: Maybe<Scalars['Float']['output']>;
  facilityCode?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "Credential" */
export type Credential_var_samp_order_by = {
  cardNumber?: InputMaybe<order_by>;
  facilityCode?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type Credential_variance_fields = {
  cardNumber?: Maybe<Scalars['Float']['output']>;
  facilityCode?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "Credential" */
export type Credential_variance_order_by = {
  cardNumber?: InputMaybe<order_by>;
  facilityCode?: InputMaybe<order_by>;
};

export type Custom_AccessPointMapLocationInput = {
  externalFloorId?: InputMaybe<Scalars['ID']['input']>;
  location: Array<Scalars['Float']['input']>;
};

export type Custom_AugustLockUserRole = {
  augustUserId?: Maybe<Scalars['uuid']['output']>;
  augustUserType?: Maybe<Scalars['String']['output']>;
  permissions: Array<Scalars['String']['output']>;
  role?: Maybe<Role>;
  roleId: Scalars['uuid']['output'];
  userRole?: Maybe<UserRole>;
  userRoleId: Scalars['uuid']['output'];
};

export type Custom_CreateGuestPassInput = {
  activatesAt?: InputMaybe<Scalars['timestamptz']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  enablePropertyPinCode?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt: Scalars['timestamptz']['input'];
  nickname: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  scopedPropertyId: Scalars['uuid']['input'];
  scopedSmartLockIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type Custom_CreateGuestPassOutput = {
  code?: Maybe<Scalars['String']['output']>;
  userRole?: Maybe<UserRole>;
  userRoleId: Scalars['uuid']['output'];
};

export type Custom_GetAugustLockUserRolesInput = {
  augustLockId: Scalars['String']['input'];
};

export type Custom_GetAugustLockUserRolesOutput = {
  augustLockUserRoles: Array<Custom_AugustLockUserRole>;
  smartLock?: Maybe<SmartLock>;
  smartLockId?: Maybe<Scalars['uuid']['output']>;
};

export type Custom_GetHubHealthReportsInput = {
  endDateTime: Scalars['timestamptz']['input'];
  hubId: Scalars['uuid']['input'];
  startDateTime: Scalars['timestamptz']['input'];
};

export type Custom_GetHubHealthReportsOutput = {
  healthReports: Array<Scalars['jsonb']['output']>;
  hub?: Maybe<Hub>;
  hubId: Scalars['uuid']['output'];
};

export type Custom_HubMessage = {
  hubId: Scalars['uuid']['output'];
  message?: Maybe<Scalars['String']['output']>;
  messageGroupId?: Maybe<Scalars['uuid']['output']>;
  messageId: Scalars['uuid']['output'];
  payload: Scalars['jsonb']['output'];
  timestamp: Scalars['timestamptz']['output'];
  type: Scalars['String']['output'];
};

export type Custom_HubMessageInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  messageGroupId?: InputMaybe<Scalars['uuid']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  type: Scalars['String']['input'];
};

export type Custom_HubResponse = {
  hub?: Maybe<Hub>;
  hubId: Scalars['uuid']['output'];
  response?: Maybe<Custom_HubMessage>;
};

export type Custom_HubsFilterInput = {
  accessPointIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  hubIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  relayIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type Custom_RemoteOperateAugustLockInput = {
  augustLockId: Scalars['String']['input'];
  operation: AugustRemoteOperation;
};

export type Custom_RemoteOperateAugustLockOutput = {
  doorStatus: Scalars['String']['output'];
  lockStatus: Scalars['String']['output'];
};

export type Custom_RevokeSessionOutput = {
  session?: Maybe<Session>;
  sessionId: Scalars['uuid']['output'];
};

export type Custom_RevokeUserRoleOutput = {
  userRole?: Maybe<UserRole>;
  userRoleId: Scalars['uuid']['output'];
};

export type Custom_SendMessageToHubsInput = {
  awaitResponse: Scalars['Boolean']['input'];
  filter: Custom_HubsFilterInput;
  message: Custom_HubMessageInput;
  responseTimeout?: InputMaybe<Scalars['Int']['input']>;
};

export type Custom_SendMessageToHubsOutput = {
  hubResponses: Array<Custom_HubResponse>;
  messageGroupId: Scalars['uuid']['output'];
};

export type Custom_SyncEngrainPropertyMapInput = {
  externalAssetId: Scalars['String']['input'];
  externalMapId: Scalars['String']['input'];
  propertyId: Scalars['uuid']['input'];
};

export type Custom_SyncEngrainPropertyMapOutput = {
  property?: Maybe<Property>;
  propertyId: Scalars['uuid']['output'];
  propertyMap?: Maybe<PropertyMap>;
  propertyMapId: Scalars['uuid']['output'];
};

export type Custom_ToggleAccessPointArchivedOutput = {
  accessPoint?: Maybe<AccessPoint>;
  accessPointId: Scalars['uuid']['output'];
};

export type Custom_UnlockAccessPointInput = {
  accessPointId: Scalars['String']['input'];
  unlockMethod: Scalars['String']['input'];
};

export type Custom_UnlockAccessPointOutput = {
  accessPoint?: Maybe<AccessPoint>;
  accessPointId: Scalars['uuid']['output'];
  result: Custom_UnlockAccessPointResult;
};

export enum Custom_UnlockAccessPointResult {
  SUCCESS = 'SUCCESS',
  UNKNOWN = 'UNKNOWN'
}

export type Custom_UnlockHubRelaysInput = {
  hubId: Scalars['uuid']['input'];
  relayPositions: Array<Scalars['Int']['input']>;
};

export type Custom_UpdateAccessPointMapLocationOutput = {
  accessPoint?: Maybe<AccessPoint>;
  accessPointId: Scalars['uuid']['output'];
};

export type Custom_UpdateTicketStatusOutput = {
  ticket?: Maybe<Ticket>;
  ticketId: Scalars['uuid']['output'];
};

export type Custom_UpdateUserInput = {
  accountStatus?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Custom_UpdateUserOutput = {
  user?: Maybe<User>;
  userId: Scalars['uuid']['output'];
};

/** columns and relationships of "EmergencyPlan" */
export type EmergencyPlan = {
  value: Scalars['String']['output'];
};

/** aggregated selection of "EmergencyPlan" */
export type EmergencyPlan_aggregate = {
  aggregate?: Maybe<EmergencyPlan_aggregate_fields>;
  nodes: Array<EmergencyPlan>;
};

/** aggregate fields of "EmergencyPlan" */
export type EmergencyPlan_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<EmergencyPlan_max_fields>;
  min?: Maybe<EmergencyPlan_min_fields>;
};


/** aggregate fields of "EmergencyPlan" */
export type EmergencyPlan_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<EmergencyPlan_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "EmergencyPlan". All fields are combined with a logical 'AND'. */
export type EmergencyPlan_bool_exp = {
  _and?: InputMaybe<Array<EmergencyPlan_bool_exp>>;
  _not?: InputMaybe<EmergencyPlan_bool_exp>;
  _or?: InputMaybe<Array<EmergencyPlan_bool_exp>>;
  value?: InputMaybe<String_comparison_exp>;
};

/** aggregate max on columns */
export type EmergencyPlan_max_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EmergencyPlan_min_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "EmergencyPlan". */
export type EmergencyPlan_order_by = {
  value?: InputMaybe<order_by>;
};

/** select columns of table "EmergencyPlan" */
export enum EmergencyPlan_select_column {
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "EmergencyPlan" */
export type EmergencyPlan_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: EmergencyPlan_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EmergencyPlan_stream_cursor_value_input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "EmergencyScenarioStatus" */
export type EmergencyScenarioStatus = {
  value: Scalars['String']['output'];
};

/** aggregated selection of "EmergencyScenarioStatus" */
export type EmergencyScenarioStatus_aggregate = {
  aggregate?: Maybe<EmergencyScenarioStatus_aggregate_fields>;
  nodes: Array<EmergencyScenarioStatus>;
};

/** aggregate fields of "EmergencyScenarioStatus" */
export type EmergencyScenarioStatus_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<EmergencyScenarioStatus_max_fields>;
  min?: Maybe<EmergencyScenarioStatus_min_fields>;
};


/** aggregate fields of "EmergencyScenarioStatus" */
export type EmergencyScenarioStatus_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<EmergencyScenarioStatus_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "EmergencyScenarioStatus". All fields are combined with a logical 'AND'. */
export type EmergencyScenarioStatus_bool_exp = {
  _and?: InputMaybe<Array<EmergencyScenarioStatus_bool_exp>>;
  _not?: InputMaybe<EmergencyScenarioStatus_bool_exp>;
  _or?: InputMaybe<Array<EmergencyScenarioStatus_bool_exp>>;
  value?: InputMaybe<String_comparison_exp>;
};

/** aggregate max on columns */
export type EmergencyScenarioStatus_max_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EmergencyScenarioStatus_min_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "EmergencyScenarioStatus". */
export type EmergencyScenarioStatus_order_by = {
  value?: InputMaybe<order_by>;
};

/** select columns of table "EmergencyScenarioStatus" */
export enum EmergencyScenarioStatus_select_column {
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "EmergencyScenarioStatus" */
export type EmergencyScenarioStatus_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: EmergencyScenarioStatus_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EmergencyScenarioStatus_stream_cursor_value_input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "FailurePlan" */
export type FailurePlan = {
  label: Scalars['String']['output'];
  /** An array relationship */
  relays: Array<Relay>;
  /** An aggregate relationship */
  relays_aggregate: Relay_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "FailurePlan" */
export type FailurePlan_relaysArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};


/** columns and relationships of "FailurePlan" */
export type FailurePlan_relays_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};

/** aggregated selection of "FailurePlan" */
export type FailurePlan_aggregate = {
  aggregate?: Maybe<FailurePlan_aggregate_fields>;
  nodes: Array<FailurePlan>;
};

/** aggregate fields of "FailurePlan" */
export type FailurePlan_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<FailurePlan_max_fields>;
  min?: Maybe<FailurePlan_min_fields>;
};


/** aggregate fields of "FailurePlan" */
export type FailurePlan_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<FailurePlan_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "FailurePlan". All fields are combined with a logical 'AND'. */
export type FailurePlan_bool_exp = {
  _and?: InputMaybe<Array<FailurePlan_bool_exp>>;
  _not?: InputMaybe<FailurePlan_bool_exp>;
  _or?: InputMaybe<Array<FailurePlan_bool_exp>>;
  label?: InputMaybe<String_comparison_exp>;
  relays?: InputMaybe<Relay_bool_exp>;
  relays_aggregate?: InputMaybe<Relay_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum FailurePlan_enum {
  /** Fail-Safe */
  FAIL_SAFE = 'FAIL_SAFE',
  /** Fail-Secure */
  FAIL_SECURE = 'FAIL_SECURE'
}

/** Boolean expression to compare columns of type "FailurePlan_enum". All fields are combined with logical 'AND'. */
export type FailurePlan_enum_comparison_exp = {
  _eq?: InputMaybe<FailurePlan_enum>;
  _in?: InputMaybe<Array<FailurePlan_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<FailurePlan_enum>;
  _nin?: InputMaybe<Array<FailurePlan_enum>>;
};

/** aggregate max on columns */
export type FailurePlan_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type FailurePlan_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "FailurePlan". */
export type FailurePlan_order_by = {
  label?: InputMaybe<order_by>;
  relays_aggregate?: InputMaybe<Relay_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "FailurePlan" */
export enum FailurePlan_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "FailurePlan" */
export type FailurePlan_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: FailurePlan_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FailurePlan_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "Favorite" */
export type Favorite = {
  /** An object relationship */
  accessPoint: AccessPoint;
  accessPointId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  favoriteId: Scalars['uuid']['output'];
  position: Scalars['Int']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: User;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "Favorite" */
export type Favorite_aggregate = {
  aggregate?: Maybe<Favorite_aggregate_fields>;
  nodes: Array<Favorite>;
};

export type Favorite_aggregate_bool_exp = {
  count?: InputMaybe<Favorite_aggregate_bool_exp_count>;
};

export type Favorite_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<Favorite_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Favorite_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "Favorite" */
export type Favorite_aggregate_fields = {
  avg?: Maybe<Favorite_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Favorite_max_fields>;
  min?: Maybe<Favorite_min_fields>;
  stddev?: Maybe<Favorite_stddev_fields>;
  stddev_pop?: Maybe<Favorite_stddev_pop_fields>;
  stddev_samp?: Maybe<Favorite_stddev_samp_fields>;
  sum?: Maybe<Favorite_sum_fields>;
  var_pop?: Maybe<Favorite_var_pop_fields>;
  var_samp?: Maybe<Favorite_var_samp_fields>;
  variance?: Maybe<Favorite_variance_fields>;
};


/** aggregate fields of "Favorite" */
export type Favorite_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<Favorite_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Favorite" */
export type Favorite_aggregate_order_by = {
  avg?: InputMaybe<Favorite_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<Favorite_max_order_by>;
  min?: InputMaybe<Favorite_min_order_by>;
  stddev?: InputMaybe<Favorite_stddev_order_by>;
  stddev_pop?: InputMaybe<Favorite_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<Favorite_stddev_samp_order_by>;
  sum?: InputMaybe<Favorite_sum_order_by>;
  var_pop?: InputMaybe<Favorite_var_pop_order_by>;
  var_samp?: InputMaybe<Favorite_var_samp_order_by>;
  variance?: InputMaybe<Favorite_variance_order_by>;
};

/** aggregate avg on columns */
export type Favorite_avg_fields = {
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "Favorite" */
export type Favorite_avg_order_by = {
  position?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "Favorite". All fields are combined with a logical 'AND'. */
export type Favorite_bool_exp = {
  _and?: InputMaybe<Array<Favorite_bool_exp>>;
  _not?: InputMaybe<Favorite_bool_exp>;
  _or?: InputMaybe<Array<Favorite_bool_exp>>;
  accessPoint?: InputMaybe<AccessPoint_bool_exp>;
  accessPointId?: InputMaybe<uuid_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  favoriteId?: InputMaybe<uuid_comparison_exp>;
  position?: InputMaybe<Int_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<User_bool_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** aggregate max on columns */
export type Favorite_max_fields = {
  accessPointId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  favoriteId?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "Favorite" */
export type Favorite_max_order_by = {
  accessPointId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  favoriteId?: InputMaybe<order_by>;
  position?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type Favorite_min_fields = {
  accessPointId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  favoriteId?: Maybe<Scalars['uuid']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "Favorite" */
export type Favorite_min_order_by = {
  accessPointId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  favoriteId?: InputMaybe<order_by>;
  position?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "Favorite". */
export type Favorite_order_by = {
  accessPoint?: InputMaybe<AccessPoint_order_by>;
  accessPointId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  favoriteId?: InputMaybe<order_by>;
  position?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  user?: InputMaybe<User_order_by>;
  userId?: InputMaybe<order_by>;
};

/** select columns of table "Favorite" */
export enum Favorite_select_column {
  /** column name */
  accessPointId = 'accessPointId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  favoriteId = 'favoriteId',
  /** column name */
  position = 'position',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  userId = 'userId'
}

/** aggregate stddev on columns */
export type Favorite_stddev_fields = {
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "Favorite" */
export type Favorite_stddev_order_by = {
  position?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type Favorite_stddev_pop_fields = {
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "Favorite" */
export type Favorite_stddev_pop_order_by = {
  position?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type Favorite_stddev_samp_fields = {
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "Favorite" */
export type Favorite_stddev_samp_order_by = {
  position?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "Favorite" */
export type Favorite_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Favorite_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Favorite_stream_cursor_value_input = {
  accessPointId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  favoriteId?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Favorite_sum_fields = {
  position?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "Favorite" */
export type Favorite_sum_order_by = {
  position?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type Favorite_var_pop_fields = {
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "Favorite" */
export type Favorite_var_pop_order_by = {
  position?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type Favorite_var_samp_fields = {
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "Favorite" */
export type Favorite_var_samp_order_by = {
  position?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type Favorite_variance_fields = {
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "Favorite" */
export type Favorite_variance_order_by = {
  position?: InputMaybe<order_by>;
};

/** columns and relationships of "FeatureFlag" */
export type FeatureFlag = {
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  featureFlagId: Scalars['uuid']['output'];
  isLocked: Scalars['Boolean']['output'];
  key: FeatureFlagKey_enum;
  /** An object relationship */
  keyEnum: FeatureFlagKey;
  name: Scalars['String']['output'];
  /** An array relationship */
  propertyFeatureFlags: Array<PropertyFeatureFlag>;
  /** An aggregate relationship */
  propertyFeatureFlags_aggregate: PropertyFeatureFlag_aggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "FeatureFlag" */
export type FeatureFlag_propertyFeatureFlagsArgs = {
  distinct_on?: InputMaybe<Array<PropertyFeatureFlag_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertyFeatureFlag_order_by>>;
  where?: InputMaybe<PropertyFeatureFlag_bool_exp>;
};


/** columns and relationships of "FeatureFlag" */
export type FeatureFlag_propertyFeatureFlags_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PropertyFeatureFlag_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertyFeatureFlag_order_by>>;
  where?: InputMaybe<PropertyFeatureFlag_bool_exp>;
};

/** columns and relationships of "FeatureFlagKey" */
export type FeatureFlagKey = {
  /** An object relationship */
  featureFlag?: Maybe<FeatureFlag>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "FeatureFlagKey" */
export type FeatureFlagKey_aggregate = {
  aggregate?: Maybe<FeatureFlagKey_aggregate_fields>;
  nodes: Array<FeatureFlagKey>;
};

/** aggregate fields of "FeatureFlagKey" */
export type FeatureFlagKey_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<FeatureFlagKey_max_fields>;
  min?: Maybe<FeatureFlagKey_min_fields>;
};


/** aggregate fields of "FeatureFlagKey" */
export type FeatureFlagKey_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<FeatureFlagKey_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "FeatureFlagKey". All fields are combined with a logical 'AND'. */
export type FeatureFlagKey_bool_exp = {
  _and?: InputMaybe<Array<FeatureFlagKey_bool_exp>>;
  _not?: InputMaybe<FeatureFlagKey_bool_exp>;
  _or?: InputMaybe<Array<FeatureFlagKey_bool_exp>>;
  featureFlag?: InputMaybe<FeatureFlag_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum FeatureFlagKey_enum {
  COMMUNITY_CONNECT = 'COMMUNITY_CONNECT',
  DPS = 'DPS',
  ENGRAIN_MAP_INTEGRATION = 'ENGRAIN_MAP_INTEGRATION',
  GATEWAY_ACCESS_MANAGER = 'GATEWAY_ACCESS_MANAGER',
  GATEWAY_MICROSERVICES = 'GATEWAY_MICROSERVICES',
  GATEWAY_MOBILE_ENHANCER = 'GATEWAY_MOBILE_ENHANCER',
  GATEWAY_PIN_CODES = 'GATEWAY_PIN_CODES',
  GATEWAY_TEMP_GUEST_PIN_CODES = 'GATEWAY_TEMP_GUEST_PIN_CODES',
  GATEWAY_UNLOCK_FEEDBACK = 'GATEWAY_UNLOCK_FEEDBACK',
  HOME_ACCESS = 'HOME_ACCESS',
  PMS_BACKBONE_RESIDENT_SYNC = 'PMS_BACKBONE_RESIDENT_SYNC',
  PMS_RESIDENT_SYNC = 'PMS_RESIDENT_SYNC',
  SMART_SIGNS = 'SMART_SIGNS',
  VENDOR_PASSCODES = 'VENDOR_PASSCODES',
  VIRTUAL_DIRECTORY = 'VIRTUAL_DIRECTORY'
}

/** Boolean expression to compare columns of type "FeatureFlagKey_enum". All fields are combined with logical 'AND'. */
export type FeatureFlagKey_enum_comparison_exp = {
  _eq?: InputMaybe<FeatureFlagKey_enum>;
  _in?: InputMaybe<Array<FeatureFlagKey_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<FeatureFlagKey_enum>;
  _nin?: InputMaybe<Array<FeatureFlagKey_enum>>;
};

/** aggregate max on columns */
export type FeatureFlagKey_max_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type FeatureFlagKey_min_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "FeatureFlagKey". */
export type FeatureFlagKey_order_by = {
  featureFlag?: InputMaybe<FeatureFlag_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "FeatureFlagKey" */
export enum FeatureFlagKey_select_column {
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "FeatureFlagKey" */
export type FeatureFlagKey_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: FeatureFlagKey_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FeatureFlagKey_stream_cursor_value_input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "FeatureFlag" */
export type FeatureFlag_aggregate = {
  aggregate?: Maybe<FeatureFlag_aggregate_fields>;
  nodes: Array<FeatureFlag>;
};

/** aggregate fields of "FeatureFlag" */
export type FeatureFlag_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<FeatureFlag_max_fields>;
  min?: Maybe<FeatureFlag_min_fields>;
};


/** aggregate fields of "FeatureFlag" */
export type FeatureFlag_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<FeatureFlag_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "FeatureFlag". All fields are combined with a logical 'AND'. */
export type FeatureFlag_bool_exp = {
  _and?: InputMaybe<Array<FeatureFlag_bool_exp>>;
  _not?: InputMaybe<FeatureFlag_bool_exp>;
  _or?: InputMaybe<Array<FeatureFlag_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  featureFlagId?: InputMaybe<uuid_comparison_exp>;
  isLocked?: InputMaybe<Boolean_comparison_exp>;
  key?: InputMaybe<FeatureFlagKey_enum_comparison_exp>;
  keyEnum?: InputMaybe<FeatureFlagKey_bool_exp>;
  name?: InputMaybe<String_comparison_exp>;
  propertyFeatureFlags?: InputMaybe<PropertyFeatureFlag_bool_exp>;
  propertyFeatureFlags_aggregate?: InputMaybe<PropertyFeatureFlag_aggregate_bool_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
};

/** aggregate max on columns */
export type FeatureFlag_max_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featureFlagId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type FeatureFlag_min_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featureFlagId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "FeatureFlag". */
export type FeatureFlag_order_by = {
  createdAt?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  featureFlagId?: InputMaybe<order_by>;
  isLocked?: InputMaybe<order_by>;
  key?: InputMaybe<order_by>;
  keyEnum?: InputMaybe<FeatureFlagKey_order_by>;
  name?: InputMaybe<order_by>;
  propertyFeatureFlags_aggregate?: InputMaybe<PropertyFeatureFlag_aggregate_order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** select columns of table "FeatureFlag" */
export enum FeatureFlag_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  featureFlagId = 'featureFlagId',
  /** column name */
  isLocked = 'isLocked',
  /** column name */
  key = 'key',
  /** column name */
  name = 'name',
  /** column name */
  updatedAt = 'updatedAt'
}

/** Streaming cursor of the table "FeatureFlag" */
export type FeatureFlag_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: FeatureFlag_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FeatureFlag_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featureFlagId?: InputMaybe<Scalars['uuid']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<FeatureFlagKey_enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "GpioMode" */
export type GpioMode = {
  label: Scalars['String']['output'];
  /** An array relationship */
  relays: Array<Relay>;
  /** An aggregate relationship */
  relays_aggregate: Relay_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "GpioMode" */
export type GpioMode_relaysArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};


/** columns and relationships of "GpioMode" */
export type GpioMode_relays_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};

/** aggregated selection of "GpioMode" */
export type GpioMode_aggregate = {
  aggregate?: Maybe<GpioMode_aggregate_fields>;
  nodes: Array<GpioMode>;
};

/** aggregate fields of "GpioMode" */
export type GpioMode_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<GpioMode_max_fields>;
  min?: Maybe<GpioMode_min_fields>;
};


/** aggregate fields of "GpioMode" */
export type GpioMode_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<GpioMode_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "GpioMode". All fields are combined with a logical 'AND'. */
export type GpioMode_bool_exp = {
  _and?: InputMaybe<Array<GpioMode_bool_exp>>;
  _not?: InputMaybe<GpioMode_bool_exp>;
  _or?: InputMaybe<Array<GpioMode_bool_exp>>;
  label?: InputMaybe<String_comparison_exp>;
  relays?: InputMaybe<Relay_bool_exp>;
  relays_aggregate?: InputMaybe<Relay_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum GpioMode_enum {
  /** Input */
  INPUT = 'INPUT',
  /** Output */
  OUTPUT = 'OUTPUT'
}

/** Boolean expression to compare columns of type "GpioMode_enum". All fields are combined with logical 'AND'. */
export type GpioMode_enum_comparison_exp = {
  _eq?: InputMaybe<GpioMode_enum>;
  _in?: InputMaybe<Array<GpioMode_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<GpioMode_enum>;
  _nin?: InputMaybe<Array<GpioMode_enum>>;
};

/** aggregate max on columns */
export type GpioMode_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type GpioMode_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "GpioMode". */
export type GpioMode_order_by = {
  label?: InputMaybe<order_by>;
  relays_aggregate?: InputMaybe<Relay_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "GpioMode" */
export enum GpioMode_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "GpioMode" */
export type GpioMode_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: GpioMode_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type GpioMode_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "Hub" */
export type Hub = {
  activationStatus: HubActivationStatus_enum;
  /** An object relationship */
  activationStatusEnum: HubActivationStatus;
  channels?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  childHubs: Array<Hub>;
  /** An aggregate relationship */
  childHubs_aggregate: Hub_aggregate;
  cliVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deviceType: HubDeviceType_enum;
  /** An object relationship */
  deviceTypeEnum: HubDeviceType;
  fingerprint?: Maybe<Scalars['String']['output']>;
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  hubId: Scalars['uuid']['output'];
  hubVersion?: Maybe<Scalars['String']['output']>;
  installedAt?: Maybe<Scalars['timestamptz']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  macAddress?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  parentHub?: Maybe<Hub>;
  parentHubId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  parentHubRelays: Array<Relay>;
  /** An aggregate relationship */
  parentHubRelays_aggregate: Relay_aggregate;
  port?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  relays: Array<Relay>;
  /** An aggregate relationship */
  relays_aggregate: Relay_aggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "Hub" */
export type Hub_childHubsArgs = {
  distinct_on?: InputMaybe<Array<Hub_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_order_by>>;
  where?: InputMaybe<Hub_bool_exp>;
};


/** columns and relationships of "Hub" */
export type Hub_childHubs_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Hub_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_order_by>>;
  where?: InputMaybe<Hub_bool_exp>;
};


/** columns and relationships of "Hub" */
export type Hub_parentHubRelaysArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};


/** columns and relationships of "Hub" */
export type Hub_parentHubRelays_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};


/** columns and relationships of "Hub" */
export type Hub_relaysArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};


/** columns and relationships of "Hub" */
export type Hub_relays_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};

/** columns and relationships of "HubActivationStatus" */
export type HubActivationStatus = {
  /** An array relationship */
  hubs: Array<Hub>;
  /** An aggregate relationship */
  hubs_aggregate: Hub_aggregate;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** columns and relationships of "HubActivationStatus" */
export type HubActivationStatus_hubsArgs = {
  distinct_on?: InputMaybe<Array<Hub_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_order_by>>;
  where?: InputMaybe<Hub_bool_exp>;
};


/** columns and relationships of "HubActivationStatus" */
export type HubActivationStatus_hubs_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Hub_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_order_by>>;
  where?: InputMaybe<Hub_bool_exp>;
};

/** aggregated selection of "HubActivationStatus" */
export type HubActivationStatus_aggregate = {
  aggregate?: Maybe<HubActivationStatus_aggregate_fields>;
  nodes: Array<HubActivationStatus>;
};

/** aggregate fields of "HubActivationStatus" */
export type HubActivationStatus_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<HubActivationStatus_max_fields>;
  min?: Maybe<HubActivationStatus_min_fields>;
};


/** aggregate fields of "HubActivationStatus" */
export type HubActivationStatus_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<HubActivationStatus_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "HubActivationStatus". All fields are combined with a logical 'AND'. */
export type HubActivationStatus_bool_exp = {
  _and?: InputMaybe<Array<HubActivationStatus_bool_exp>>;
  _not?: InputMaybe<HubActivationStatus_bool_exp>;
  _or?: InputMaybe<Array<HubActivationStatus_bool_exp>>;
  hubs?: InputMaybe<Hub_bool_exp>;
  hubs_aggregate?: InputMaybe<Hub_aggregate_bool_exp>;
  label?: InputMaybe<String_comparison_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum HubActivationStatus_enum {
  /** Activated */
  ACTIVATED = 'ACTIVATED',
  /** Deactivated */
  DEACTIVATED = 'DEACTIVATED',
  /** Pending Activation */
  PENDING_ACTIVATION = 'PENDING_ACTIVATION'
}

/** Boolean expression to compare columns of type "HubActivationStatus_enum". All fields are combined with logical 'AND'. */
export type HubActivationStatus_enum_comparison_exp = {
  _eq?: InputMaybe<HubActivationStatus_enum>;
  _in?: InputMaybe<Array<HubActivationStatus_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<HubActivationStatus_enum>;
  _nin?: InputMaybe<Array<HubActivationStatus_enum>>;
};

/** aggregate max on columns */
export type HubActivationStatus_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type HubActivationStatus_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "HubActivationStatus". */
export type HubActivationStatus_order_by = {
  hubs_aggregate?: InputMaybe<Hub_aggregate_order_by>;
  label?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "HubActivationStatus" */
export enum HubActivationStatus_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "HubActivationStatus" */
export type HubActivationStatus_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: HubActivationStatus_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type HubActivationStatus_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "HubDeviceType" */
export type HubDeviceType = {
  /** An array relationship */
  hubs: Array<Hub>;
  /** An aggregate relationship */
  hubs_aggregate: Hub_aggregate;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** columns and relationships of "HubDeviceType" */
export type HubDeviceType_hubsArgs = {
  distinct_on?: InputMaybe<Array<Hub_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_order_by>>;
  where?: InputMaybe<Hub_bool_exp>;
};


/** columns and relationships of "HubDeviceType" */
export type HubDeviceType_hubs_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Hub_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_order_by>>;
  where?: InputMaybe<Hub_bool_exp>;
};

/** aggregated selection of "HubDeviceType" */
export type HubDeviceType_aggregate = {
  aggregate?: Maybe<HubDeviceType_aggregate_fields>;
  nodes: Array<HubDeviceType>;
};

/** aggregate fields of "HubDeviceType" */
export type HubDeviceType_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<HubDeviceType_max_fields>;
  min?: Maybe<HubDeviceType_min_fields>;
};


/** aggregate fields of "HubDeviceType" */
export type HubDeviceType_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<HubDeviceType_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "HubDeviceType". All fields are combined with a logical 'AND'. */
export type HubDeviceType_bool_exp = {
  _and?: InputMaybe<Array<HubDeviceType_bool_exp>>;
  _not?: InputMaybe<HubDeviceType_bool_exp>;
  _or?: InputMaybe<Array<HubDeviceType_bool_exp>>;
  hubs?: InputMaybe<Hub_bool_exp>;
  hubs_aggregate?: InputMaybe<Hub_aggregate_bool_exp>;
  label?: InputMaybe<String_comparison_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum HubDeviceType_enum {
  /** Ethos Edge Reader */
  ETHOS_EDGE_READER = 'ETHOS_EDGE_READER',
  /** Ethos Edge Reader N/C */
  ETHOS_EDGE_READER_NC = 'ETHOS_EDGE_READER_NC',
  /** Ethos Edge Reader N/O */
  ETHOS_EDGE_READER_NO = 'ETHOS_EDGE_READER_NO',
  /** Ethos Secure-Side Device */
  ETHOS_SECURE_SIDE_DEVICE = 'ETHOS_SECURE_SIDE_DEVICE',
  /** Ethos Secure-Side Device N/C */
  ETHOS_SECURE_SIDE_DEVICE_NC = 'ETHOS_SECURE_SIDE_DEVICE_NC',
  /** Ethos Secure-Side Device N/O */
  ETHOS_SECURE_SIDE_DEVICE_NO = 'ETHOS_SECURE_SIDE_DEVICE_NO',
  /** Raspberry Pi */
  RASPBERRY_PI = 'RASPBERRY_PI'
}

/** Boolean expression to compare columns of type "HubDeviceType_enum". All fields are combined with logical 'AND'. */
export type HubDeviceType_enum_comparison_exp = {
  _eq?: InputMaybe<HubDeviceType_enum>;
  _in?: InputMaybe<Array<HubDeviceType_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<HubDeviceType_enum>;
  _nin?: InputMaybe<Array<HubDeviceType_enum>>;
};

/** aggregate max on columns */
export type HubDeviceType_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type HubDeviceType_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "HubDeviceType". */
export type HubDeviceType_order_by = {
  hubs_aggregate?: InputMaybe<Hub_aggregate_order_by>;
  label?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "HubDeviceType" */
export enum HubDeviceType_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "HubDeviceType" */
export type HubDeviceType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: HubDeviceType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type HubDeviceType_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Hub" */
export type Hub_aggregate = {
  aggregate?: Maybe<Hub_aggregate_fields>;
  nodes: Array<Hub>;
};

export type Hub_aggregate_bool_exp = {
  count?: InputMaybe<Hub_aggregate_bool_exp_count>;
};

export type Hub_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<Hub_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Hub_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "Hub" */
export type Hub_aggregate_fields = {
  avg?: Maybe<Hub_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Hub_max_fields>;
  min?: Maybe<Hub_min_fields>;
  stddev?: Maybe<Hub_stddev_fields>;
  stddev_pop?: Maybe<Hub_stddev_pop_fields>;
  stddev_samp?: Maybe<Hub_stddev_samp_fields>;
  sum?: Maybe<Hub_sum_fields>;
  var_pop?: Maybe<Hub_var_pop_fields>;
  var_samp?: Maybe<Hub_var_samp_fields>;
  variance?: Maybe<Hub_variance_fields>;
};


/** aggregate fields of "Hub" */
export type Hub_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<Hub_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Hub" */
export type Hub_aggregate_order_by = {
  avg?: InputMaybe<Hub_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<Hub_max_order_by>;
  min?: InputMaybe<Hub_min_order_by>;
  stddev?: InputMaybe<Hub_stddev_order_by>;
  stddev_pop?: InputMaybe<Hub_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<Hub_stddev_samp_order_by>;
  sum?: InputMaybe<Hub_sum_order_by>;
  var_pop?: InputMaybe<Hub_var_pop_order_by>;
  var_samp?: InputMaybe<Hub_var_samp_order_by>;
  variance?: InputMaybe<Hub_variance_order_by>;
};

/** aggregate avg on columns */
export type Hub_avg_fields = {
  channels?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "Hub" */
export type Hub_avg_order_by = {
  channels?: InputMaybe<order_by>;
  port?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "Hub". All fields are combined with a logical 'AND'. */
export type Hub_bool_exp = {
  _and?: InputMaybe<Array<Hub_bool_exp>>;
  _not?: InputMaybe<Hub_bool_exp>;
  _or?: InputMaybe<Array<Hub_bool_exp>>;
  activationStatus?: InputMaybe<HubActivationStatus_enum_comparison_exp>;
  activationStatusEnum?: InputMaybe<HubActivationStatus_bool_exp>;
  channels?: InputMaybe<Int_comparison_exp>;
  childHubs?: InputMaybe<Hub_bool_exp>;
  childHubs_aggregate?: InputMaybe<Hub_aggregate_bool_exp>;
  cliVersion?: InputMaybe<String_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  deviceType?: InputMaybe<HubDeviceType_enum_comparison_exp>;
  deviceTypeEnum?: InputMaybe<HubDeviceType_bool_exp>;
  fingerprint?: InputMaybe<String_comparison_exp>;
  firmwareVersion?: InputMaybe<String_comparison_exp>;
  host?: InputMaybe<String_comparison_exp>;
  hubId?: InputMaybe<uuid_comparison_exp>;
  hubVersion?: InputMaybe<String_comparison_exp>;
  installedAt?: InputMaybe<timestamptz_comparison_exp>;
  ipAddress?: InputMaybe<String_comparison_exp>;
  location?: InputMaybe<String_comparison_exp>;
  macAddress?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  parentHub?: InputMaybe<Hub_bool_exp>;
  parentHubId?: InputMaybe<uuid_comparison_exp>;
  parentHubRelays?: InputMaybe<Relay_bool_exp>;
  parentHubRelays_aggregate?: InputMaybe<Relay_aggregate_bool_exp>;
  port?: InputMaybe<Int_comparison_exp>;
  property?: InputMaybe<Property_bool_exp>;
  propertyId?: InputMaybe<uuid_comparison_exp>;
  relays?: InputMaybe<Relay_bool_exp>;
  relays_aggregate?: InputMaybe<Relay_aggregate_bool_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
};

/** input type for incrementing numeric columns in table "Hub" */
export type Hub_inc_input = {
  channels?: InputMaybe<Scalars['Int']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Hub_max_fields = {
  channels?: Maybe<Scalars['Int']['output']>;
  cliVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  hubId?: Maybe<Scalars['uuid']['output']>;
  hubVersion?: Maybe<Scalars['String']['output']>;
  installedAt?: Maybe<Scalars['timestamptz']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  macAddress?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentHubId?: Maybe<Scalars['uuid']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Hub" */
export type Hub_max_order_by = {
  channels?: InputMaybe<order_by>;
  cliVersion?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  fingerprint?: InputMaybe<order_by>;
  firmwareVersion?: InputMaybe<order_by>;
  host?: InputMaybe<order_by>;
  hubId?: InputMaybe<order_by>;
  hubVersion?: InputMaybe<order_by>;
  installedAt?: InputMaybe<order_by>;
  ipAddress?: InputMaybe<order_by>;
  location?: InputMaybe<order_by>;
  macAddress?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  parentHubId?: InputMaybe<order_by>;
  port?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type Hub_min_fields = {
  channels?: Maybe<Scalars['Int']['output']>;
  cliVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  hubId?: Maybe<Scalars['uuid']['output']>;
  hubVersion?: Maybe<Scalars['String']['output']>;
  installedAt?: Maybe<Scalars['timestamptz']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  macAddress?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentHubId?: Maybe<Scalars['uuid']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Hub" */
export type Hub_min_order_by = {
  channels?: InputMaybe<order_by>;
  cliVersion?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  fingerprint?: InputMaybe<order_by>;
  firmwareVersion?: InputMaybe<order_by>;
  host?: InputMaybe<order_by>;
  hubId?: InputMaybe<order_by>;
  hubVersion?: InputMaybe<order_by>;
  installedAt?: InputMaybe<order_by>;
  ipAddress?: InputMaybe<order_by>;
  location?: InputMaybe<order_by>;
  macAddress?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  parentHubId?: InputMaybe<order_by>;
  port?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** response of any mutation on the table "Hub" */
export type Hub_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Hub>;
};

/** Ordering options when selecting data from "Hub". */
export type Hub_order_by = {
  activationStatus?: InputMaybe<order_by>;
  activationStatusEnum?: InputMaybe<HubActivationStatus_order_by>;
  channels?: InputMaybe<order_by>;
  childHubs_aggregate?: InputMaybe<Hub_aggregate_order_by>;
  cliVersion?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  deviceType?: InputMaybe<order_by>;
  deviceTypeEnum?: InputMaybe<HubDeviceType_order_by>;
  fingerprint?: InputMaybe<order_by>;
  firmwareVersion?: InputMaybe<order_by>;
  host?: InputMaybe<order_by>;
  hubId?: InputMaybe<order_by>;
  hubVersion?: InputMaybe<order_by>;
  installedAt?: InputMaybe<order_by>;
  ipAddress?: InputMaybe<order_by>;
  location?: InputMaybe<order_by>;
  macAddress?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  parentHub?: InputMaybe<Hub_order_by>;
  parentHubId?: InputMaybe<order_by>;
  parentHubRelays_aggregate?: InputMaybe<Relay_aggregate_order_by>;
  port?: InputMaybe<order_by>;
  property?: InputMaybe<Property_order_by>;
  propertyId?: InputMaybe<order_by>;
  relays_aggregate?: InputMaybe<Relay_aggregate_order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** primary key columns input for table: Hub */
export type Hub_pk_columns_input = {
  hubId: Scalars['uuid']['input'];
};

/** select columns of table "Hub" */
export enum Hub_select_column {
  /** column name */
  activationStatus = 'activationStatus',
  /** column name */
  channels = 'channels',
  /** column name */
  cliVersion = 'cliVersion',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deviceType = 'deviceType',
  /** column name */
  fingerprint = 'fingerprint',
  /** column name */
  firmwareVersion = 'firmwareVersion',
  /** column name */
  host = 'host',
  /** column name */
  hubId = 'hubId',
  /** column name */
  hubVersion = 'hubVersion',
  /** column name */
  installedAt = 'installedAt',
  /** column name */
  ipAddress = 'ipAddress',
  /** column name */
  location = 'location',
  /** column name */
  macAddress = 'macAddress',
  /** column name */
  name = 'name',
  /** column name */
  parentHubId = 'parentHubId',
  /** column name */
  port = 'port',
  /** column name */
  propertyId = 'propertyId',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "Hub" */
export type Hub_set_input = {
  activationStatus?: InputMaybe<HubActivationStatus_enum>;
  channels?: InputMaybe<Scalars['Int']['input']>;
  deviceType?: InputMaybe<HubDeviceType_enum>;
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  installedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Hub_stddev_fields = {
  channels?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "Hub" */
export type Hub_stddev_order_by = {
  channels?: InputMaybe<order_by>;
  port?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type Hub_stddev_pop_fields = {
  channels?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "Hub" */
export type Hub_stddev_pop_order_by = {
  channels?: InputMaybe<order_by>;
  port?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type Hub_stddev_samp_fields = {
  channels?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "Hub" */
export type Hub_stddev_samp_order_by = {
  channels?: InputMaybe<order_by>;
  port?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "Hub" */
export type Hub_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Hub_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hub_stream_cursor_value_input = {
  activationStatus?: InputMaybe<HubActivationStatus_enum>;
  channels?: InputMaybe<Scalars['Int']['input']>;
  cliVersion?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deviceType?: InputMaybe<HubDeviceType_enum>;
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  firmwareVersion?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  hubId?: InputMaybe<Scalars['uuid']['input']>;
  hubVersion?: InputMaybe<Scalars['String']['input']>;
  installedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  macAddress?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentHubId?: InputMaybe<Scalars['uuid']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Hub_sum_fields = {
  channels?: Maybe<Scalars['Int']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "Hub" */
export type Hub_sum_order_by = {
  channels?: InputMaybe<order_by>;
  port?: InputMaybe<order_by>;
};

export type Hub_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hub_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hub_set_input>;
  /** filter the rows which have to be updated */
  where: Hub_bool_exp;
};

/** aggregate var_pop on columns */
export type Hub_var_pop_fields = {
  channels?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "Hub" */
export type Hub_var_pop_order_by = {
  channels?: InputMaybe<order_by>;
  port?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type Hub_var_samp_fields = {
  channels?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "Hub" */
export type Hub_var_samp_order_by = {
  channels?: InputMaybe<order_by>;
  port?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type Hub_variance_fields = {
  channels?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "Hub" */
export type Hub_variance_order_by = {
  channels?: InputMaybe<order_by>;
  port?: InputMaybe<order_by>;
};

/** columns and relationships of "Image" */
export type Image = {
  /** An array relationship */
  accessPoints: Array<AccessPoint>;
  /** An aggregate relationship */
  accessPoints_aggregate: AccessPoint_aggregate;
  cloudId: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  imageId: Scalars['uuid']['output'];
  /** An array relationship */
  properties: Array<Property>;
  /** An aggregate relationship */
  properties_aggregate: Property_aggregate;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  uploadedByUser?: Maybe<User>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "Image" */
export type Image_accessPointsArgs = {
  distinct_on?: InputMaybe<Array<AccessPoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPoint_order_by>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};


/** columns and relationships of "Image" */
export type Image_accessPoints_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPoint_order_by>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};


/** columns and relationships of "Image" */
export type Image_propertiesArgs = {
  distinct_on?: InputMaybe<Array<Property_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_order_by>>;
  where?: InputMaybe<Property_bool_exp>;
};


/** columns and relationships of "Image" */
export type Image_properties_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_order_by>>;
  where?: InputMaybe<Property_bool_exp>;
};

/** aggregated selection of "Image" */
export type Image_aggregate = {
  aggregate?: Maybe<Image_aggregate_fields>;
  nodes: Array<Image>;
};

export type Image_aggregate_bool_exp = {
  count?: InputMaybe<Image_aggregate_bool_exp_count>;
};

export type Image_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<Image_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Image_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "Image" */
export type Image_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Image_max_fields>;
  min?: Maybe<Image_min_fields>;
};


/** aggregate fields of "Image" */
export type Image_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<Image_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Image" */
export type Image_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<Image_max_order_by>;
  min?: InputMaybe<Image_min_order_by>;
};

/** Boolean expression to filter rows from the table "Image". All fields are combined with a logical 'AND'. */
export type Image_bool_exp = {
  _and?: InputMaybe<Array<Image_bool_exp>>;
  _not?: InputMaybe<Image_bool_exp>;
  _or?: InputMaybe<Array<Image_bool_exp>>;
  accessPoints?: InputMaybe<AccessPoint_bool_exp>;
  accessPoints_aggregate?: InputMaybe<AccessPoint_aggregate_bool_exp>;
  cloudId?: InputMaybe<String_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  imageId?: InputMaybe<uuid_comparison_exp>;
  properties?: InputMaybe<Property_bool_exp>;
  properties_aggregate?: InputMaybe<Property_aggregate_bool_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  uploadedByUser?: InputMaybe<User_bool_exp>;
  uploadedByUserId?: InputMaybe<uuid_comparison_exp>;
};

/** aggregate max on columns */
export type Image_max_fields = {
  cloudId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  imageId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "Image" */
export type Image_max_order_by = {
  cloudId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  imageId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  uploadedByUserId?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type Image_min_fields = {
  cloudId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  imageId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "Image" */
export type Image_min_order_by = {
  cloudId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  imageId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  uploadedByUserId?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "Image". */
export type Image_order_by = {
  accessPoints_aggregate?: InputMaybe<AccessPoint_aggregate_order_by>;
  cloudId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  imageId?: InputMaybe<order_by>;
  properties_aggregate?: InputMaybe<Property_aggregate_order_by>;
  updatedAt?: InputMaybe<order_by>;
  uploadedByUser?: InputMaybe<User_order_by>;
  uploadedByUserId?: InputMaybe<order_by>;
};

/** select columns of table "Image" */
export enum Image_select_column {
  /** column name */
  cloudId = 'cloudId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  imageId = 'imageId',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  uploadedByUserId = 'uploadedByUserId'
}

/** Streaming cursor of the table "Image" */
export type Image_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Image_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Image_stream_cursor_value_input = {
  cloudId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  imageId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "InputDevice" */
export type InputDevice = {
  label: Scalars['String']['output'];
  /** An array relationship */
  relays: Array<Relay>;
  /** An aggregate relationship */
  relays_aggregate: Relay_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "InputDevice" */
export type InputDevice_relaysArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};


/** columns and relationships of "InputDevice" */
export type InputDevice_relays_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};

/** aggregated selection of "InputDevice" */
export type InputDevice_aggregate = {
  aggregate?: Maybe<InputDevice_aggregate_fields>;
  nodes: Array<InputDevice>;
};

/** aggregate fields of "InputDevice" */
export type InputDevice_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<InputDevice_max_fields>;
  min?: Maybe<InputDevice_min_fields>;
};


/** aggregate fields of "InputDevice" */
export type InputDevice_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<InputDevice_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "InputDevice". All fields are combined with a logical 'AND'. */
export type InputDevice_bool_exp = {
  _and?: InputMaybe<Array<InputDevice_bool_exp>>;
  _not?: InputMaybe<InputDevice_bool_exp>;
  _or?: InputMaybe<Array<InputDevice_bool_exp>>;
  label?: InputMaybe<String_comparison_exp>;
  relays?: InputMaybe<Relay_bool_exp>;
  relays_aggregate?: InputMaybe<Relay_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum InputDevice_enum {
  /** Amazon Key */
  AMAZON_KEY = 'AMAZON_KEY',
  /** Door Position Sensor (DPS) */
  DPS = 'DPS',
  /** Intercom */
  INTERCOM = 'INTERCOM',
  /** Other */
  OTHER = 'OTHER',
  /** Request-to-Exit (REX) */
  REX = 'REX'
}

/** Boolean expression to compare columns of type "InputDevice_enum". All fields are combined with logical 'AND'. */
export type InputDevice_enum_comparison_exp = {
  _eq?: InputMaybe<InputDevice_enum>;
  _in?: InputMaybe<Array<InputDevice_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InputDevice_enum>;
  _nin?: InputMaybe<Array<InputDevice_enum>>;
};

/** aggregate max on columns */
export type InputDevice_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type InputDevice_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "InputDevice". */
export type InputDevice_order_by = {
  label?: InputMaybe<order_by>;
  relays_aggregate?: InputMaybe<Relay_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "InputDevice" */
export enum InputDevice_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "InputDevice" */
export type InputDevice_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: InputDevice_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type InputDevice_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_comparison_exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** columns and relationships of "Organization" */
export type Organization = {
  createdAt: Scalars['timestamptz']['output'];
  identifier: Scalars['String']['output'];
  /** An array relationship */
  managedUserRoles: Array<UserRole>;
  /** An aggregate relationship */
  managedUserRoles_aggregate: UserRole_aggregate;
  name: Scalars['String']['output'];
  organizationId: Scalars['uuid']['output'];
  /** An array relationship */
  properties: Array<Property>;
  /** An aggregate relationship */
  properties_aggregate: Property_aggregate;
  /** An array relationship */
  roles: Array<Role>;
  /** An aggregate relationship */
  roles_aggregate: Role_aggregate;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userRolePermissions: Array<UserRolePermission>;
  /** An aggregate relationship */
  userRolePermissions_aggregate: UserRolePermission_aggregate;
  /** An array relationship */
  userRoles: Array<UserRole>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRole_aggregate;
};


/** columns and relationships of "Organization" */
export type Organization_managedUserRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "Organization" */
export type Organization_managedUserRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "Organization" */
export type Organization_propertiesArgs = {
  distinct_on?: InputMaybe<Array<Property_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_order_by>>;
  where?: InputMaybe<Property_bool_exp>;
};


/** columns and relationships of "Organization" */
export type Organization_properties_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_order_by>>;
  where?: InputMaybe<Property_bool_exp>;
};


/** columns and relationships of "Organization" */
export type Organization_rolesArgs = {
  distinct_on?: InputMaybe<Array<Role_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_order_by>>;
  where?: InputMaybe<Role_bool_exp>;
};


/** columns and relationships of "Organization" */
export type Organization_roles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_order_by>>;
  where?: InputMaybe<Role_bool_exp>;
};


/** columns and relationships of "Organization" */
export type Organization_userRolePermissionsArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


/** columns and relationships of "Organization" */
export type Organization_userRolePermissions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


/** columns and relationships of "Organization" */
export type Organization_userRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "Organization" */
export type Organization_userRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};

/** aggregated selection of "Organization" */
export type Organization_aggregate = {
  aggregate?: Maybe<Organization_aggregate_fields>;
  nodes: Array<Organization>;
};

/** aggregate fields of "Organization" */
export type Organization_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_max_fields>;
  min?: Maybe<Organization_min_fields>;
};


/** aggregate fields of "Organization" */
export type Organization_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<Organization_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "Organization". All fields are combined with a logical 'AND'. */
export type Organization_bool_exp = {
  _and?: InputMaybe<Array<Organization_bool_exp>>;
  _not?: InputMaybe<Organization_bool_exp>;
  _or?: InputMaybe<Array<Organization_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  identifier?: InputMaybe<String_comparison_exp>;
  managedUserRoles?: InputMaybe<UserRole_bool_exp>;
  managedUserRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
  name?: InputMaybe<String_comparison_exp>;
  organizationId?: InputMaybe<uuid_comparison_exp>;
  properties?: InputMaybe<Property_bool_exp>;
  properties_aggregate?: InputMaybe<Property_aggregate_bool_exp>;
  roles?: InputMaybe<Role_bool_exp>;
  roles_aggregate?: InputMaybe<Role_aggregate_bool_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  userRolePermissions?: InputMaybe<UserRolePermission_bool_exp>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_bool_exp>;
  userRoles?: InputMaybe<UserRole_bool_exp>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "Organization" */
export enum Organization_constraint {
  /** unique or primary key constraint on columns "identifier" */
  Organization_identifier_key = 'Organization_identifier_key',
  /** unique or primary key constraint on columns "organizationId" */
  Organization_pkey = 'Organization_pkey'
}

/** input type for inserting data into table "Organization" */
export type Organization_insert_input = {
  identifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Property_arr_rel_insert_input>;
  roles?: InputMaybe<Role_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type Organization_max_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Organization_min_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "Organization" */
export type Organization_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization>;
};

/** input type for inserting object relation for remote table "Organization" */
export type Organization_obj_rel_insert_input = {
  data: Organization_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_on_conflict>;
};

/** on_conflict condition type for table "Organization" */
export type Organization_on_conflict = {
  constraint: Organization_constraint;
  update_columns?: Array<Organization_update_column>;
  where?: InputMaybe<Organization_bool_exp>;
};

/** Ordering options when selecting data from "Organization". */
export type Organization_order_by = {
  createdAt?: InputMaybe<order_by>;
  identifier?: InputMaybe<order_by>;
  managedUserRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
  name?: InputMaybe<order_by>;
  organizationId?: InputMaybe<order_by>;
  properties_aggregate?: InputMaybe<Property_aggregate_order_by>;
  roles_aggregate?: InputMaybe<Role_aggregate_order_by>;
  updatedAt?: InputMaybe<order_by>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_order_by>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
};

/** primary key columns input for table: Organization */
export type Organization_pk_columns_input = {
  organizationId: Scalars['uuid']['input'];
};

/** select columns of table "Organization" */
export enum Organization_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  identifier = 'identifier',
  /** column name */
  name = 'name',
  /** column name */
  organizationId = 'organizationId',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "Organization" */
export type Organization_set_input = {
  identifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "Organization" */
export type Organization_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Organization_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "Organization" */
export enum Organization_update_column {
  /** column name */
  identifier = 'identifier',
  /** column name */
  name = 'name'
}

export type Organization_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_set_input>;
  /** filter the rows which have to be updated */
  where: Organization_bool_exp;
};

/** Password table with hash redacted. (User table is joined as a workaround to disable Hasura mutations.) */
export type PasswordRedacted = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  passwordId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "PasswordRedacted". All fields are combined with a logical 'AND'. */
export type PasswordRedacted_bool_exp = {
  _and?: InputMaybe<Array<PasswordRedacted_bool_exp>>;
  _not?: InputMaybe<PasswordRedacted_bool_exp>;
  _or?: InputMaybe<Array<PasswordRedacted_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  passwordId?: InputMaybe<uuid_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<User_bool_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** Ordering options when selecting data from "PasswordRedacted". */
export type PasswordRedacted_order_by = {
  createdAt?: InputMaybe<order_by>;
  passwordId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  user?: InputMaybe<User_order_by>;
  userId?: InputMaybe<order_by>;
};

/** columns and relationships of "Permission" */
export type Permission = {
  createdAt: Scalars['timestamptz']['output'];
  isLocked: Scalars['Boolean']['output'];
  key: PermissionKey_enum;
  /** An object relationship */
  keyEnum: PermissionKey;
  permissionId: Scalars['uuid']['output'];
  /** An array relationship */
  rolePermissions: Array<RolePermission>;
  /** An aggregate relationship */
  rolePermissions_aggregate: RolePermission_aggregate;
  scope: PermissionScope_enum;
  /** An object relationship */
  scopeEnum: PermissionScope;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userRolePermissions: Array<UserRolePermission>;
  /** An aggregate relationship */
  userRolePermissions_aggregate: UserRolePermission_aggregate;
};


/** columns and relationships of "Permission" */
export type Permission_rolePermissionsArgs = {
  distinct_on?: InputMaybe<Array<RolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RolePermission_order_by>>;
  where?: InputMaybe<RolePermission_bool_exp>;
};


/** columns and relationships of "Permission" */
export type Permission_rolePermissions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RolePermission_order_by>>;
  where?: InputMaybe<RolePermission_bool_exp>;
};


/** columns and relationships of "Permission" */
export type Permission_userRolePermissionsArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


/** columns and relationships of "Permission" */
export type Permission_userRolePermissions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};

/** columns and relationships of "PermissionKey" */
export type PermissionKey = {
  /** An array relationship */
  permissions: Array<Permission>;
  /** An aggregate relationship */
  permissions_aggregate: Permission_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "PermissionKey" */
export type PermissionKey_permissionsArgs = {
  distinct_on?: InputMaybe<Array<Permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permission_order_by>>;
  where?: InputMaybe<Permission_bool_exp>;
};


/** columns and relationships of "PermissionKey" */
export type PermissionKey_permissions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permission_order_by>>;
  where?: InputMaybe<Permission_bool_exp>;
};

/** aggregated selection of "PermissionKey" */
export type PermissionKey_aggregate = {
  aggregate?: Maybe<PermissionKey_aggregate_fields>;
  nodes: Array<PermissionKey>;
};

/** aggregate fields of "PermissionKey" */
export type PermissionKey_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<PermissionKey_max_fields>;
  min?: Maybe<PermissionKey_min_fields>;
};


/** aggregate fields of "PermissionKey" */
export type PermissionKey_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<PermissionKey_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "PermissionKey". All fields are combined with a logical 'AND'. */
export type PermissionKey_bool_exp = {
  _and?: InputMaybe<Array<PermissionKey_bool_exp>>;
  _not?: InputMaybe<PermissionKey_bool_exp>;
  _or?: InputMaybe<Array<PermissionKey_bool_exp>>;
  permissions?: InputMaybe<Permission_bool_exp>;
  permissions_aggregate?: InputMaybe<Permission_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum PermissionKey_enum {
  AccessPoint_Archive = 'AccessPoint_Archive',
  AccessPoint_BypassEmergencyLockdown = 'AccessPoint_BypassEmergencyLockdown',
  AccessPoint_BypassReservationOnly = 'AccessPoint_BypassReservationOnly',
  AccessPoint_BypassSchedule = 'AccessPoint_BypassSchedule',
  AccessPoint_Create = 'AccessPoint_Create',
  AccessPoint_Delete = 'AccessPoint_Delete',
  AccessPoint_ManageRelays = 'AccessPoint_ManageRelays',
  AccessPoint_Read = 'AccessPoint_Read',
  AccessPoint_StaffAccess = 'AccessPoint_StaffAccess',
  AccessPoint_Unlock = 'AccessPoint_Unlock',
  AccessPoint_Update = 'AccessPoint_Update',
  Beacon_Create = 'Beacon_Create',
  Beacon_Delete = 'Beacon_Delete',
  Beacon_Read = 'Beacon_Read',
  Beacon_Update = 'Beacon_Update',
  Credential_Create = 'Credential_Create',
  Credential_Delete = 'Credential_Delete',
  Credential_Read = 'Credential_Read',
  Credential_Update = 'Credential_Update',
  EmergencyScenario_Manage = 'EmergencyScenario_Manage',
  EmergencyScenario_Read = 'EmergencyScenario_Read',
  Hub_Installation = 'Hub_Installation',
  Hub_ManageReaders = 'Hub_ManageReaders',
  Hub_Messenger = 'Hub_Messenger',
  Hub_Read = 'Hub_Read',
  Hub_Restart = 'Hub_Restart',
  Hub_Update = 'Hub_Update',
  Organization_Create = 'Organization_Create',
  Organization_Update = 'Organization_Update',
  PinCodePrivate_Read = 'PinCodePrivate_Read',
  PinCode_AutoReceive = 'PinCode_AutoReceive',
  PinCode_Create = 'PinCode_Create',
  PinCode_Delete = 'PinCode_Delete',
  PinCode_GenerateRandomByProperty = 'PinCode_GenerateRandomByProperty',
  PinCode_GenerateRandomByUser = 'PinCode_GenerateRandomByUser',
  PinCode_Read = 'PinCode_Read',
  PinCode_Update = 'PinCode_Update',
  Property_Create = 'Property_Create',
  Property_Delete = 'Property_Delete',
  Property_ManageFeatureFlags = 'Property_ManageFeatureFlags',
  Property_ManageMaps = 'Property_ManageMaps',
  Property_PmsResidentAudit = 'Property_PmsResidentAudit',
  Property_PmsResidentSync = 'Property_PmsResidentSync',
  Property_PmsUnitSync = 'Property_PmsUnitSync',
  Property_Update = 'Property_Update',
  RelayLogPrivate_Read = 'RelayLogPrivate_Read',
  RelayLog_Read = 'RelayLog_Read',
  Relay_Create = 'Relay_Create',
  Relay_Delete = 'Relay_Delete',
  Relay_Read = 'Relay_Read',
  Relay_Update = 'Relay_Update',
  Role_Create = 'Role_Create',
  Role_Delete = 'Role_Delete',
  Role_ManagePermissions = 'Role_ManagePermissions',
  Role_ManageUnrestricted = 'Role_ManageUnrestricted',
  Role_Read = 'Role_Read',
  Role_Update = 'Role_Update',
  Session_AccessApp = 'Session_AccessApp',
  Session_AdminPanel = 'Session_AdminPanel',
  Session_Read = 'Session_Read',
  Session_Revoke = 'Session_Revoke',
  SmartLockLog_Read = 'SmartLockLog_Read',
  SmartLock_AugustSdkFeesReport = 'SmartLock_AugustSdkFeesReport',
  SmartLock_AutoReceivePinCode = 'SmartLock_AutoReceivePinCode',
  SmartLock_Create = 'SmartLock_Create',
  SmartLock_Delete = 'SmartLock_Delete',
  SmartLock_FactoryReset = 'SmartLock_FactoryReset',
  SmartLock_ManagePinCodes = 'SmartLock_ManagePinCodes',
  SmartLock_PropertyReport = 'SmartLock_PropertyReport',
  SmartLock_Read = 'SmartLock_Read',
  SmartLock_Unlock = 'SmartLock_Unlock',
  SmartLock_Update = 'SmartLock_Update',
  Ticket_Create = 'Ticket_Create',
  Ticket_Delete = 'Ticket_Delete',
  Ticket_Read = 'Ticket_Read',
  Ticket_Update = 'Ticket_Update',
  UnitGroup_Create = 'UnitGroup_Create',
  UnitGroup_Delete = 'UnitGroup_Delete',
  UnitGroup_Update = 'UnitGroup_Update',
  Unit_Create = 'Unit_Create',
  Unit_Delete = 'Unit_Delete',
  Unit_PmsResidentAudit = 'Unit_PmsResidentAudit',
  Unit_PmsResidentSync = 'Unit_PmsResidentSync',
  Unit_Read = 'Unit_Read',
  Unit_Update = 'Unit_Update',
  UserRole_GrantRevokeGlobal = 'UserRole_GrantRevokeGlobal',
  UserRole_GrantRevokeScoped = 'UserRole_GrantRevokeScoped',
  UserRole_GrantVacantUnitsOnly = 'UserRole_GrantVacantUnitsOnly',
  UserRole_SgtFunnelIntegration = 'UserRole_SgtFunnelIntegration',
  UserRole_Update = 'UserRole_Update',
  User_Create = 'User_Create',
  User_Metrics = 'User_Metrics',
  User_Read = 'User_Read',
  User_SendMessage = 'User_SendMessage',
  User_UpdateAccountStatus = 'User_UpdateAccountStatus',
  User_UpdateProfile = 'User_UpdateProfile',
  VendorPasscode_Read = 'VendorPasscode_Read',
  VendorPasscode_ReadCode = 'VendorPasscode_ReadCode',
  VendorPasscode_Regenerate = 'VendorPasscode_Regenerate'
}

/** Boolean expression to compare columns of type "PermissionKey_enum". All fields are combined with logical 'AND'. */
export type PermissionKey_enum_comparison_exp = {
  _eq?: InputMaybe<PermissionKey_enum>;
  _in?: InputMaybe<Array<PermissionKey_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<PermissionKey_enum>;
  _nin?: InputMaybe<Array<PermissionKey_enum>>;
};

/** aggregate max on columns */
export type PermissionKey_max_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type PermissionKey_min_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "PermissionKey". */
export type PermissionKey_order_by = {
  permissions_aggregate?: InputMaybe<Permission_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "PermissionKey" */
export enum PermissionKey_select_column {
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "PermissionKey" */
export type PermissionKey_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: PermissionKey_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PermissionKey_stream_cursor_value_input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "PermissionScope" */
export type PermissionScope = {
  label: Scalars['String']['output'];
  /** An array relationship */
  permissions: Array<Permission>;
  /** An aggregate relationship */
  permissions_aggregate: Permission_aggregate;
  /** An array relationship */
  roles: Array<Role>;
  /** An aggregate relationship */
  roles_aggregate: Role_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "PermissionScope" */
export type PermissionScope_permissionsArgs = {
  distinct_on?: InputMaybe<Array<Permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permission_order_by>>;
  where?: InputMaybe<Permission_bool_exp>;
};


/** columns and relationships of "PermissionScope" */
export type PermissionScope_permissions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permission_order_by>>;
  where?: InputMaybe<Permission_bool_exp>;
};


/** columns and relationships of "PermissionScope" */
export type PermissionScope_rolesArgs = {
  distinct_on?: InputMaybe<Array<Role_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_order_by>>;
  where?: InputMaybe<Role_bool_exp>;
};


/** columns and relationships of "PermissionScope" */
export type PermissionScope_roles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_order_by>>;
  where?: InputMaybe<Role_bool_exp>;
};

/** aggregated selection of "PermissionScope" */
export type PermissionScope_aggregate = {
  aggregate?: Maybe<PermissionScope_aggregate_fields>;
  nodes: Array<PermissionScope>;
};

/** aggregate fields of "PermissionScope" */
export type PermissionScope_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<PermissionScope_max_fields>;
  min?: Maybe<PermissionScope_min_fields>;
};


/** aggregate fields of "PermissionScope" */
export type PermissionScope_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<PermissionScope_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "PermissionScope". All fields are combined with a logical 'AND'. */
export type PermissionScope_bool_exp = {
  _and?: InputMaybe<Array<PermissionScope_bool_exp>>;
  _not?: InputMaybe<PermissionScope_bool_exp>;
  _or?: InputMaybe<Array<PermissionScope_bool_exp>>;
  label?: InputMaybe<String_comparison_exp>;
  permissions?: InputMaybe<Permission_bool_exp>;
  permissions_aggregate?: InputMaybe<Permission_aggregate_bool_exp>;
  roles?: InputMaybe<Role_bool_exp>;
  roles_aggregate?: InputMaybe<Role_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum PermissionScope_enum {
  /** Access Point */
  ACCESS_POINT = 'ACCESS_POINT',
  /** Global */
  GLOBAL = 'GLOBAL',
  /** Organization */
  ORGANIZATION = 'ORGANIZATION',
  /** Property */
  PROPERTY = 'PROPERTY',
  /** Smart Lock */
  SMART_LOCK = 'SMART_LOCK',
  /** Unit */
  UNIT = 'UNIT'
}

/** Boolean expression to compare columns of type "PermissionScope_enum". All fields are combined with logical 'AND'. */
export type PermissionScope_enum_comparison_exp = {
  _eq?: InputMaybe<PermissionScope_enum>;
  _in?: InputMaybe<Array<PermissionScope_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<PermissionScope_enum>;
  _nin?: InputMaybe<Array<PermissionScope_enum>>;
};

/** aggregate max on columns */
export type PermissionScope_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type PermissionScope_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "PermissionScope". */
export type PermissionScope_order_by = {
  label?: InputMaybe<order_by>;
  permissions_aggregate?: InputMaybe<Permission_aggregate_order_by>;
  roles_aggregate?: InputMaybe<Role_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "PermissionScope" */
export enum PermissionScope_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "PermissionScope" */
export type PermissionScope_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: PermissionScope_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PermissionScope_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Permission" */
export type Permission_aggregate = {
  aggregate?: Maybe<Permission_aggregate_fields>;
  nodes: Array<Permission>;
};

export type Permission_aggregate_bool_exp = {
  bool_and?: InputMaybe<Permission_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<Permission_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<Permission_aggregate_bool_exp_count>;
};

export type Permission_aggregate_bool_exp_bool_and = {
  arguments: Permission_select_column_Permission_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Permission_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type Permission_aggregate_bool_exp_bool_or = {
  arguments: Permission_select_column_Permission_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Permission_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type Permission_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<Permission_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Permission_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "Permission" */
export type Permission_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Permission_max_fields>;
  min?: Maybe<Permission_min_fields>;
};


/** aggregate fields of "Permission" */
export type Permission_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<Permission_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Permission" */
export type Permission_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<Permission_max_order_by>;
  min?: InputMaybe<Permission_min_order_by>;
};

/** Boolean expression to filter rows from the table "Permission". All fields are combined with a logical 'AND'. */
export type Permission_bool_exp = {
  _and?: InputMaybe<Array<Permission_bool_exp>>;
  _not?: InputMaybe<Permission_bool_exp>;
  _or?: InputMaybe<Array<Permission_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  isLocked?: InputMaybe<Boolean_comparison_exp>;
  key?: InputMaybe<PermissionKey_enum_comparison_exp>;
  keyEnum?: InputMaybe<PermissionKey_bool_exp>;
  permissionId?: InputMaybe<uuid_comparison_exp>;
  rolePermissions?: InputMaybe<RolePermission_bool_exp>;
  rolePermissions_aggregate?: InputMaybe<RolePermission_aggregate_bool_exp>;
  scope?: InputMaybe<PermissionScope_enum_comparison_exp>;
  scopeEnum?: InputMaybe<PermissionScope_bool_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  userRolePermissions?: InputMaybe<UserRolePermission_bool_exp>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_bool_exp>;
};

/** aggregate max on columns */
export type Permission_max_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  permissionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Permission" */
export type Permission_max_order_by = {
  createdAt?: InputMaybe<order_by>;
  permissionId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type Permission_min_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  permissionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Permission" */
export type Permission_min_order_by = {
  createdAt?: InputMaybe<order_by>;
  permissionId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "Permission". */
export type Permission_order_by = {
  createdAt?: InputMaybe<order_by>;
  isLocked?: InputMaybe<order_by>;
  key?: InputMaybe<order_by>;
  keyEnum?: InputMaybe<PermissionKey_order_by>;
  permissionId?: InputMaybe<order_by>;
  rolePermissions_aggregate?: InputMaybe<RolePermission_aggregate_order_by>;
  scope?: InputMaybe<order_by>;
  scopeEnum?: InputMaybe<PermissionScope_order_by>;
  updatedAt?: InputMaybe<order_by>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_order_by>;
};

/** select columns of table "Permission" */
export enum Permission_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  isLocked = 'isLocked',
  /** column name */
  key = 'key',
  /** column name */
  permissionId = 'permissionId',
  /** column name */
  scope = 'scope',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "Permission_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Permission" */
export enum Permission_select_column_Permission_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  isLocked = 'isLocked'
}

/** select "Permission_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Permission" */
export enum Permission_select_column_Permission_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  isLocked = 'isLocked'
}

/** Streaming cursor of the table "Permission" */
export type Permission_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Permission_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Permission_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<PermissionKey_enum>;
  permissionId?: InputMaybe<Scalars['uuid']['input']>;
  scope?: InputMaybe<PermissionScope_enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "PinCode" */
export type PinCode = {
  /** An object relationship */
  assignedToUser?: Maybe<User>;
  assignedToUserId?: Maybe<Scalars['uuid']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  pinCodeId: Scalars['uuid']['output'];
  /** An object relationship */
  private?: Maybe<PinCodePrivate>;
  /** An object relationship */
  property: Property;
  propertyId: Scalars['uuid']['output'];
  sourcePayload?: Maybe<Scalars['jsonb']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  updatedByUser?: Maybe<User>;
  updatedByUserId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  userRole?: Maybe<UserRole>;
  userRoleId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "PinCode" */
export type PinCode_sourcePayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "PinCodePrivate" */
export type PinCodePrivate = {
  code?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  pinCode?: Maybe<PinCode>;
  pinCodeId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "PinCodePrivate" */
export type PinCodePrivate_aggregate = {
  aggregate?: Maybe<PinCodePrivate_aggregate_fields>;
  nodes: Array<PinCodePrivate>;
};

/** aggregate fields of "PinCodePrivate" */
export type PinCodePrivate_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<PinCodePrivate_max_fields>;
  min?: Maybe<PinCodePrivate_min_fields>;
};


/** aggregate fields of "PinCodePrivate" */
export type PinCodePrivate_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<PinCodePrivate_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "PinCodePrivate". All fields are combined with a logical 'AND'. */
export type PinCodePrivate_bool_exp = {
  _and?: InputMaybe<Array<PinCodePrivate_bool_exp>>;
  _not?: InputMaybe<PinCodePrivate_bool_exp>;
  _or?: InputMaybe<Array<PinCodePrivate_bool_exp>>;
  code?: InputMaybe<String_comparison_exp>;
  pinCode?: InputMaybe<PinCode_bool_exp>;
  pinCodeId?: InputMaybe<uuid_comparison_exp>;
};

/** aggregate max on columns */
export type PinCodePrivate_max_fields = {
  code?: Maybe<Scalars['String']['output']>;
  pinCodeId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type PinCodePrivate_min_fields = {
  code?: Maybe<Scalars['String']['output']>;
  pinCodeId?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "PinCodePrivate". */
export type PinCodePrivate_order_by = {
  code?: InputMaybe<order_by>;
  pinCode?: InputMaybe<PinCode_order_by>;
  pinCodeId?: InputMaybe<order_by>;
};

/** select columns of table "PinCodePrivate" */
export enum PinCodePrivate_select_column {
  /** column name */
  code = 'code',
  /** column name */
  pinCodeId = 'pinCodeId'
}

/** Streaming cursor of the table "PinCodePrivate" */
export type PinCodePrivate_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: PinCodePrivate_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PinCodePrivate_stream_cursor_value_input = {
  code?: InputMaybe<Scalars['String']['input']>;
  pinCodeId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregated selection of "PinCode" */
export type PinCode_aggregate = {
  aggregate?: Maybe<PinCode_aggregate_fields>;
  nodes: Array<PinCode>;
};

export type PinCode_aggregate_bool_exp = {
  count?: InputMaybe<PinCode_aggregate_bool_exp_count>;
};

export type PinCode_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<PinCode_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PinCode_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "PinCode" */
export type PinCode_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<PinCode_max_fields>;
  min?: Maybe<PinCode_min_fields>;
};


/** aggregate fields of "PinCode" */
export type PinCode_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<PinCode_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "PinCode" */
export type PinCode_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<PinCode_max_order_by>;
  min?: InputMaybe<PinCode_min_order_by>;
};

/** input type for inserting array relation for remote table "PinCode" */
export type PinCode_arr_rel_insert_input = {
  data: Array<PinCode_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PinCode_on_conflict>;
};

/** Boolean expression to filter rows from the table "PinCode". All fields are combined with a logical 'AND'. */
export type PinCode_bool_exp = {
  _and?: InputMaybe<Array<PinCode_bool_exp>>;
  _not?: InputMaybe<PinCode_bool_exp>;
  _or?: InputMaybe<Array<PinCode_bool_exp>>;
  assignedToUser?: InputMaybe<User_bool_exp>;
  assignedToUserId?: InputMaybe<uuid_comparison_exp>;
  code?: InputMaybe<String_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  createdByUser?: InputMaybe<User_bool_exp>;
  createdByUserId?: InputMaybe<uuid_comparison_exp>;
  pinCodeId?: InputMaybe<uuid_comparison_exp>;
  private?: InputMaybe<PinCodePrivate_bool_exp>;
  property?: InputMaybe<Property_bool_exp>;
  propertyId?: InputMaybe<uuid_comparison_exp>;
  sourcePayload?: InputMaybe<jsonb_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  updatedByUser?: InputMaybe<User_bool_exp>;
  updatedByUserId?: InputMaybe<uuid_comparison_exp>;
  userRole?: InputMaybe<UserRole_bool_exp>;
  userRoleId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "PinCode" */
export enum PinCode_constraint {
  /** unique or primary key constraint on columns "assignedToUserId", "propertyId" */
  PinCode_assignedToUserId_propertyId_key = 'PinCode_assignedToUserId_propertyId_key',
  /** unique or primary key constraint on columns "pinCodeId" */
  PinCode_pkey = 'PinCode_pkey',
  /** unique or primary key constraint on columns "code", "propertyId" */
  PinCode_propertyId_code_key = 'PinCode_propertyId_code_key',
  /** unique or primary key constraint on columns "userRoleId" */
  PinCode_userRoleId_key = 'PinCode_userRoleId_key'
}

/** input type for inserting data into table "PinCode" */
export type PinCode_insert_input = {
  assignedToUserId?: InputMaybe<Scalars['uuid']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Property_obj_rel_insert_input>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type PinCode_max_fields = {
  assignedToUserId?: Maybe<Scalars['uuid']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  pinCodeId?: Maybe<Scalars['uuid']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedByUserId?: Maybe<Scalars['uuid']['output']>;
  userRoleId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "PinCode" */
export type PinCode_max_order_by = {
  assignedToUserId?: InputMaybe<order_by>;
  code?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUserId?: InputMaybe<order_by>;
  pinCodeId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  updatedByUserId?: InputMaybe<order_by>;
  userRoleId?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type PinCode_min_fields = {
  assignedToUserId?: Maybe<Scalars['uuid']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  pinCodeId?: Maybe<Scalars['uuid']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedByUserId?: Maybe<Scalars['uuid']['output']>;
  userRoleId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "PinCode" */
export type PinCode_min_order_by = {
  assignedToUserId?: InputMaybe<order_by>;
  code?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUserId?: InputMaybe<order_by>;
  pinCodeId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  updatedByUserId?: InputMaybe<order_by>;
  userRoleId?: InputMaybe<order_by>;
};

/** response of any mutation on the table "PinCode" */
export type PinCode_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PinCode>;
};

/** on_conflict condition type for table "PinCode" */
export type PinCode_on_conflict = {
  constraint: PinCode_constraint;
  update_columns?: Array<PinCode_update_column>;
  where?: InputMaybe<PinCode_bool_exp>;
};

/** Ordering options when selecting data from "PinCode". */
export type PinCode_order_by = {
  assignedToUser?: InputMaybe<User_order_by>;
  assignedToUserId?: InputMaybe<order_by>;
  code?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUser?: InputMaybe<User_order_by>;
  createdByUserId?: InputMaybe<order_by>;
  pinCodeId?: InputMaybe<order_by>;
  private?: InputMaybe<PinCodePrivate_order_by>;
  property?: InputMaybe<Property_order_by>;
  propertyId?: InputMaybe<order_by>;
  sourcePayload?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  updatedByUser?: InputMaybe<User_order_by>;
  updatedByUserId?: InputMaybe<order_by>;
  userRole?: InputMaybe<UserRole_order_by>;
  userRoleId?: InputMaybe<order_by>;
};

/** primary key columns input for table: PinCode */
export type PinCode_pk_columns_input = {
  pinCodeId: Scalars['uuid']['input'];
};

/** select columns of table "PinCode" */
export enum PinCode_select_column {
  /** column name */
  assignedToUserId = 'assignedToUserId',
  /** column name */
  code = 'code',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdByUserId = 'createdByUserId',
  /** column name */
  pinCodeId = 'pinCodeId',
  /** column name */
  propertyId = 'propertyId',
  /** column name */
  sourcePayload = 'sourcePayload',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  updatedByUserId = 'updatedByUserId',
  /** column name */
  userRoleId = 'userRoleId'
}

/** input type for updating data in table "PinCode" */
export type PinCode_set_input = {
  code?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "PinCode" */
export type PinCode_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: PinCode_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PinCode_stream_cursor_value_input = {
  assignedToUserId?: InputMaybe<Scalars['uuid']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  pinCodeId?: InputMaybe<Scalars['uuid']['input']>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  sourcePayload?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedByUserId?: InputMaybe<Scalars['uuid']['input']>;
  userRoleId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "PinCode" */
export enum PinCode_update_column {
  /** column name */
  code = 'code'
}

export type PinCode_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PinCode_set_input>;
  /** filter the rows which have to be updated */
  where: PinCode_bool_exp;
};

/** columns and relationships of "Property" */
export type Property = {
  /** An array relationship */
  accessPoints: Array<AccessPoint>;
  /** An aggregate relationship */
  accessPoints_aggregate: AccessPoint_aggregate;
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  credentials: Array<Credential>;
  /** An aggregate relationship */
  credentials_aggregate: Credential_aggregate;
  funnelCommunityId?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  hubs: Array<Hub>;
  /** An aggregate relationship */
  hubs_aggregate: Hub_aggregate;
  /** An object relationship */
  image?: Maybe<Image>;
  imageId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  managedUserRoles: Array<UserRole>;
  /** An aggregate relationship */
  managedUserRoles_aggregate: UserRole_aggregate;
  name: Scalars['String']['output'];
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['uuid']['output'];
  /** An array relationship */
  pinCodes: Array<PinCode>;
  /** An aggregate relationship */
  pinCodes_aggregate: PinCode_aggregate;
  /** An array relationship */
  propertyFeatureFlags: Array<PropertyFeatureFlag>;
  /** An aggregate relationship */
  propertyFeatureFlags_aggregate: PropertyFeatureFlag_aggregate;
  propertyId: Scalars['uuid']['output'];
  /** An object relationship */
  propertyMap?: Maybe<PropertyMap>;
  /** An array relationship */
  propertySources: Array<PropertySource>;
  /** An aggregate relationship */
  propertySources_aggregate: PropertySource_aggregate;
  /** An array relationship */
  relayLogs: Array<RelayLog>;
  /** An aggregate relationship */
  relayLogs_aggregate: RelayLog_aggregate;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  tickets: Array<Ticket>;
  /** An aggregate relationship */
  tickets_aggregate: Ticket_aggregate;
  timezone: Scalars['String']['output'];
  /** An object relationship */
  timezoneEnum: Timezone;
  /** An array relationship */
  unitGroups: Array<UnitGroup>;
  /** An aggregate relationship */
  unitGroups_aggregate: UnitGroup_aggregate;
  /** An array relationship */
  units: Array<Unit>;
  /** An aggregate relationship */
  units_aggregate: Unit_aggregate;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userRolePermissions: Array<UserRolePermission>;
  /** An aggregate relationship */
  userRolePermissions_aggregate: UserRolePermission_aggregate;
  /** An array relationship */
  userRoles: Array<UserRole>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRole_aggregate;
  virtualDirectoryPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Hours that visitors and vendors can request access from staff via Virtual Directory */
  virtualDirectoryStaffHours?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "Property" */
export type Property_accessPointsArgs = {
  distinct_on?: InputMaybe<Array<AccessPoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPoint_order_by>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_accessPoints_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPoint_order_by>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_credentialsArgs = {
  distinct_on?: InputMaybe<Array<Credential_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credential_order_by>>;
  where?: InputMaybe<Credential_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_credentials_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Credential_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credential_order_by>>;
  where?: InputMaybe<Credential_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_hubsArgs = {
  distinct_on?: InputMaybe<Array<Hub_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_order_by>>;
  where?: InputMaybe<Hub_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_hubs_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Hub_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_order_by>>;
  where?: InputMaybe<Hub_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_managedUserRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_managedUserRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_pinCodesArgs = {
  distinct_on?: InputMaybe<Array<PinCode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCode_order_by>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_pinCodes_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PinCode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCode_order_by>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_propertyFeatureFlagsArgs = {
  distinct_on?: InputMaybe<Array<PropertyFeatureFlag_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertyFeatureFlag_order_by>>;
  where?: InputMaybe<PropertyFeatureFlag_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_propertyFeatureFlags_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PropertyFeatureFlag_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertyFeatureFlag_order_by>>;
  where?: InputMaybe<PropertyFeatureFlag_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_propertySourcesArgs = {
  distinct_on?: InputMaybe<Array<PropertySource_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertySource_order_by>>;
  where?: InputMaybe<PropertySource_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_propertySources_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PropertySource_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertySource_order_by>>;
  where?: InputMaybe<PropertySource_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_relayLogsArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_relayLogs_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_ticketsArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_tickets_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_unitGroupsArgs = {
  distinct_on?: InputMaybe<Array<UnitGroup_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnitGroup_order_by>>;
  where?: InputMaybe<UnitGroup_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_unitGroups_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UnitGroup_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnitGroup_order_by>>;
  where?: InputMaybe<UnitGroup_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_unitsArgs = {
  distinct_on?: InputMaybe<Array<Unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_order_by>>;
  where?: InputMaybe<Unit_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_units_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_order_by>>;
  where?: InputMaybe<Unit_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_userRolePermissionsArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_userRolePermissions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_userRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_userRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "Property" */
export type Property_virtualDirectoryStaffHoursArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "PropertyFeatureFlag" */
export type PropertyFeatureFlag = {
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  featureFlag: FeatureFlag;
  featureFlagKey: Scalars['String']['output'];
  /** An object relationship */
  property: Property;
  propertyFeatureFlagId: Scalars['uuid']['output'];
  propertyId: Scalars['uuid']['output'];
};

/** aggregated selection of "PropertyFeatureFlag" */
export type PropertyFeatureFlag_aggregate = {
  aggregate?: Maybe<PropertyFeatureFlag_aggregate_fields>;
  nodes: Array<PropertyFeatureFlag>;
};

export type PropertyFeatureFlag_aggregate_bool_exp = {
  count?: InputMaybe<PropertyFeatureFlag_aggregate_bool_exp_count>;
};

export type PropertyFeatureFlag_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<PropertyFeatureFlag_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PropertyFeatureFlag_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "PropertyFeatureFlag" */
export type PropertyFeatureFlag_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<PropertyFeatureFlag_max_fields>;
  min?: Maybe<PropertyFeatureFlag_min_fields>;
};


/** aggregate fields of "PropertyFeatureFlag" */
export type PropertyFeatureFlag_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<PropertyFeatureFlag_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "PropertyFeatureFlag" */
export type PropertyFeatureFlag_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<PropertyFeatureFlag_max_order_by>;
  min?: InputMaybe<PropertyFeatureFlag_min_order_by>;
};

/** input type for inserting array relation for remote table "PropertyFeatureFlag" */
export type PropertyFeatureFlag_arr_rel_insert_input = {
  data: Array<PropertyFeatureFlag_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PropertyFeatureFlag_on_conflict>;
};

/** Boolean expression to filter rows from the table "PropertyFeatureFlag". All fields are combined with a logical 'AND'. */
export type PropertyFeatureFlag_bool_exp = {
  _and?: InputMaybe<Array<PropertyFeatureFlag_bool_exp>>;
  _not?: InputMaybe<PropertyFeatureFlag_bool_exp>;
  _or?: InputMaybe<Array<PropertyFeatureFlag_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  featureFlag?: InputMaybe<FeatureFlag_bool_exp>;
  featureFlagKey?: InputMaybe<String_comparison_exp>;
  property?: InputMaybe<Property_bool_exp>;
  propertyFeatureFlagId?: InputMaybe<uuid_comparison_exp>;
  propertyId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "PropertyFeatureFlag" */
export enum PropertyFeatureFlag_constraint {
  /** unique or primary key constraint on columns "propertyFeatureFlagId" */
  PropertyFeatureFlag_pkey = 'PropertyFeatureFlag_pkey',
  /** unique or primary key constraint on columns "propertyId", "featureFlagKey" */
  PropertyFeatureFlag_propertyId_featureFlagKey_key = 'PropertyFeatureFlag_propertyId_featureFlagKey_key'
}

/** input type for inserting data into table "PropertyFeatureFlag" */
export type PropertyFeatureFlag_insert_input = {
  featureFlagKey?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Property_obj_rel_insert_input>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type PropertyFeatureFlag_max_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  featureFlagKey?: Maybe<Scalars['String']['output']>;
  propertyFeatureFlagId?: Maybe<Scalars['uuid']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "PropertyFeatureFlag" */
export type PropertyFeatureFlag_max_order_by = {
  createdAt?: InputMaybe<order_by>;
  featureFlagKey?: InputMaybe<order_by>;
  propertyFeatureFlagId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type PropertyFeatureFlag_min_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  featureFlagKey?: Maybe<Scalars['String']['output']>;
  propertyFeatureFlagId?: Maybe<Scalars['uuid']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "PropertyFeatureFlag" */
export type PropertyFeatureFlag_min_order_by = {
  createdAt?: InputMaybe<order_by>;
  featureFlagKey?: InputMaybe<order_by>;
  propertyFeatureFlagId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
};

/** response of any mutation on the table "PropertyFeatureFlag" */
export type PropertyFeatureFlag_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PropertyFeatureFlag>;
};

/** on_conflict condition type for table "PropertyFeatureFlag" */
export type PropertyFeatureFlag_on_conflict = {
  constraint: PropertyFeatureFlag_constraint;
  update_columns?: Array<PropertyFeatureFlag_update_column>;
  where?: InputMaybe<PropertyFeatureFlag_bool_exp>;
};

/** Ordering options when selecting data from "PropertyFeatureFlag". */
export type PropertyFeatureFlag_order_by = {
  createdAt?: InputMaybe<order_by>;
  featureFlag?: InputMaybe<FeatureFlag_order_by>;
  featureFlagKey?: InputMaybe<order_by>;
  property?: InputMaybe<Property_order_by>;
  propertyFeatureFlagId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
};

/** primary key columns input for table: PropertyFeatureFlag */
export type PropertyFeatureFlag_pk_columns_input = {
  propertyFeatureFlagId: Scalars['uuid']['input'];
};

/** select columns of table "PropertyFeatureFlag" */
export enum PropertyFeatureFlag_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  featureFlagKey = 'featureFlagKey',
  /** column name */
  propertyFeatureFlagId = 'propertyFeatureFlagId',
  /** column name */
  propertyId = 'propertyId'
}

/** input type for updating data in table "PropertyFeatureFlag" */
export type PropertyFeatureFlag_set_input = {
  featureFlagKey?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "PropertyFeatureFlag" */
export type PropertyFeatureFlag_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: PropertyFeatureFlag_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PropertyFeatureFlag_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  featureFlagKey?: InputMaybe<Scalars['String']['input']>;
  propertyFeatureFlagId?: InputMaybe<Scalars['uuid']['input']>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "PropertyFeatureFlag" */
export enum PropertyFeatureFlag_update_column {
  /** column name */
  featureFlagKey = 'featureFlagKey',
  /** column name */
  propertyId = 'propertyId'
}

export type PropertyFeatureFlag_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PropertyFeatureFlag_set_input>;
  /** filter the rows which have to be updated */
  where: PropertyFeatureFlag_bool_exp;
};

/** columns and relationships of "PropertyMap" */
export type PropertyMap = {
  createdAt: Scalars['timestamptz']['output'];
  externalAssetId: Scalars['String']['output'];
  externalFloors: Scalars['jsonb']['output'];
  externalMapId: Scalars['String']['output'];
  externalUnits: Scalars['jsonb']['output'];
  /** An object relationship */
  property: Property;
  propertyId: Scalars['uuid']['output'];
  propertyMapId: Scalars['uuid']['output'];
  published: Scalars['Boolean']['output'];
  type: PropertyMapType_enum;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "PropertyMap" */
export type PropertyMap_externalFloorsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "PropertyMap" */
export type PropertyMap_externalUnitsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export enum PropertyMapType_enum {
  /** Elevation */
  ELEVATION = 'ELEVATION',
  /** Floor Plate */
  FLOOR_PLATE = 'FLOOR_PLATE',
  /** Oblique */
  OBLIQUE = 'OBLIQUE',
  /** Stack */
  STACK = 'STACK'
}

/** Boolean expression to compare columns of type "PropertyMapType_enum". All fields are combined with logical 'AND'. */
export type PropertyMapType_enum_comparison_exp = {
  _eq?: InputMaybe<PropertyMapType_enum>;
  _in?: InputMaybe<Array<PropertyMapType_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<PropertyMapType_enum>;
  _nin?: InputMaybe<Array<PropertyMapType_enum>>;
};

/** aggregated selection of "PropertyMap" */
export type PropertyMap_aggregate = {
  aggregate?: Maybe<PropertyMap_aggregate_fields>;
  nodes: Array<PropertyMap>;
};

/** aggregate fields of "PropertyMap" */
export type PropertyMap_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<PropertyMap_max_fields>;
  min?: Maybe<PropertyMap_min_fields>;
};


/** aggregate fields of "PropertyMap" */
export type PropertyMap_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<PropertyMap_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "PropertyMap". All fields are combined with a logical 'AND'. */
export type PropertyMap_bool_exp = {
  _and?: InputMaybe<Array<PropertyMap_bool_exp>>;
  _not?: InputMaybe<PropertyMap_bool_exp>;
  _or?: InputMaybe<Array<PropertyMap_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  externalAssetId?: InputMaybe<String_comparison_exp>;
  externalFloors?: InputMaybe<jsonb_comparison_exp>;
  externalMapId?: InputMaybe<String_comparison_exp>;
  externalUnits?: InputMaybe<jsonb_comparison_exp>;
  property?: InputMaybe<Property_bool_exp>;
  propertyId?: InputMaybe<uuid_comparison_exp>;
  propertyMapId?: InputMaybe<uuid_comparison_exp>;
  published?: InputMaybe<Boolean_comparison_exp>;
  type?: InputMaybe<PropertyMapType_enum_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
};

/** aggregate max on columns */
export type PropertyMap_max_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  externalAssetId?: Maybe<Scalars['String']['output']>;
  externalMapId?: Maybe<Scalars['String']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  propertyMapId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type PropertyMap_min_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  externalAssetId?: Maybe<Scalars['String']['output']>;
  externalMapId?: Maybe<Scalars['String']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  propertyMapId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "PropertyMap" */
export type PropertyMap_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PropertyMap>;
};

/** Ordering options when selecting data from "PropertyMap". */
export type PropertyMap_order_by = {
  createdAt?: InputMaybe<order_by>;
  externalAssetId?: InputMaybe<order_by>;
  externalFloors?: InputMaybe<order_by>;
  externalMapId?: InputMaybe<order_by>;
  externalUnits?: InputMaybe<order_by>;
  property?: InputMaybe<Property_order_by>;
  propertyId?: InputMaybe<order_by>;
  propertyMapId?: InputMaybe<order_by>;
  published?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** primary key columns input for table: PropertyMap */
export type PropertyMap_pk_columns_input = {
  propertyMapId: Scalars['uuid']['input'];
};

/** select columns of table "PropertyMap" */
export enum PropertyMap_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  externalAssetId = 'externalAssetId',
  /** column name */
  externalFloors = 'externalFloors',
  /** column name */
  externalMapId = 'externalMapId',
  /** column name */
  externalUnits = 'externalUnits',
  /** column name */
  propertyId = 'propertyId',
  /** column name */
  propertyMapId = 'propertyMapId',
  /** column name */
  published = 'published',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "PropertyMap" */
export type PropertyMap_set_input = {
  published?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "PropertyMap" */
export type PropertyMap_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: PropertyMap_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PropertyMap_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  externalAssetId?: InputMaybe<Scalars['String']['input']>;
  externalFloors?: InputMaybe<Scalars['jsonb']['input']>;
  externalMapId?: InputMaybe<Scalars['String']['input']>;
  externalUnits?: InputMaybe<Scalars['jsonb']['input']>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  propertyMapId?: InputMaybe<Scalars['uuid']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<PropertyMapType_enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type PropertyMap_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PropertyMap_set_input>;
  /** filter the rows which have to be updated */
  where: PropertyMap_bool_exp;
};

/** columns and relationships of "PropertySource" */
export type PropertySource = {
  createdAt: Scalars['timestamptz']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  property: Property;
  propertyId: Scalars['uuid']['output'];
  propertySourceId: Scalars['uuid']['output'];
  sourceId: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "PropertySource" */
export type PropertySource_aggregate = {
  aggregate?: Maybe<PropertySource_aggregate_fields>;
  nodes: Array<PropertySource>;
};

export type PropertySource_aggregate_bool_exp = {
  count?: InputMaybe<PropertySource_aggregate_bool_exp_count>;
};

export type PropertySource_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<PropertySource_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PropertySource_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "PropertySource" */
export type PropertySource_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<PropertySource_max_fields>;
  min?: Maybe<PropertySource_min_fields>;
};


/** aggregate fields of "PropertySource" */
export type PropertySource_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<PropertySource_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "PropertySource" */
export type PropertySource_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<PropertySource_max_order_by>;
  min?: InputMaybe<PropertySource_min_order_by>;
};

/** Boolean expression to filter rows from the table "PropertySource". All fields are combined with a logical 'AND'. */
export type PropertySource_bool_exp = {
  _and?: InputMaybe<Array<PropertySource_bool_exp>>;
  _not?: InputMaybe<PropertySource_bool_exp>;
  _or?: InputMaybe<Array<PropertySource_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  property?: InputMaybe<Property_bool_exp>;
  propertyId?: InputMaybe<uuid_comparison_exp>;
  propertySourceId?: InputMaybe<uuid_comparison_exp>;
  sourceId?: InputMaybe<String_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
};

/** aggregate max on columns */
export type PropertySource_max_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  propertySourceId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "PropertySource" */
export type PropertySource_max_order_by = {
  createdAt?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  propertySourceId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type PropertySource_min_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  propertySourceId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "PropertySource" */
export type PropertySource_min_order_by = {
  createdAt?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  propertySourceId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "PropertySource". */
export type PropertySource_order_by = {
  createdAt?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  property?: InputMaybe<Property_order_by>;
  propertyId?: InputMaybe<order_by>;
  propertySourceId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** select columns of table "PropertySource" */
export enum PropertySource_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  name = 'name',
  /** column name */
  propertyId = 'propertyId',
  /** column name */
  propertySourceId = 'propertySourceId',
  /** column name */
  sourceId = 'sourceId',
  /** column name */
  updatedAt = 'updatedAt'
}

/** Streaming cursor of the table "PropertySource" */
export type PropertySource_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: PropertySource_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PropertySource_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  propertySourceId?: InputMaybe<Scalars['uuid']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregated selection of "Property" */
export type Property_aggregate = {
  aggregate?: Maybe<Property_aggregate_fields>;
  nodes: Array<Property>;
};

export type Property_aggregate_bool_exp = {
  count?: InputMaybe<Property_aggregate_bool_exp_count>;
};

export type Property_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<Property_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "Property" */
export type Property_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Property_max_fields>;
  min?: Maybe<Property_min_fields>;
};


/** aggregate fields of "Property" */
export type Property_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<Property_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Property" */
export type Property_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<Property_max_order_by>;
  min?: InputMaybe<Property_min_order_by>;
};

/** input type for inserting array relation for remote table "Property" */
export type Property_arr_rel_insert_input = {
  data: Array<Property_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_on_conflict>;
};

/** Boolean expression to filter rows from the table "Property". All fields are combined with a logical 'AND'. */
export type Property_bool_exp = {
  _and?: InputMaybe<Array<Property_bool_exp>>;
  _not?: InputMaybe<Property_bool_exp>;
  _or?: InputMaybe<Array<Property_bool_exp>>;
  accessPoints?: InputMaybe<AccessPoint_bool_exp>;
  accessPoints_aggregate?: InputMaybe<AccessPoint_aggregate_bool_exp>;
  address?: InputMaybe<String_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  credentials?: InputMaybe<Credential_bool_exp>;
  credentials_aggregate?: InputMaybe<Credential_aggregate_bool_exp>;
  funnelCommunityId?: InputMaybe<String_comparison_exp>;
  hubs?: InputMaybe<Hub_bool_exp>;
  hubs_aggregate?: InputMaybe<Hub_aggregate_bool_exp>;
  image?: InputMaybe<Image_bool_exp>;
  imageId?: InputMaybe<uuid_comparison_exp>;
  managedUserRoles?: InputMaybe<UserRole_bool_exp>;
  managedUserRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
  name?: InputMaybe<String_comparison_exp>;
  organization?: InputMaybe<Organization_bool_exp>;
  organizationId?: InputMaybe<uuid_comparison_exp>;
  pinCodes?: InputMaybe<PinCode_bool_exp>;
  pinCodes_aggregate?: InputMaybe<PinCode_aggregate_bool_exp>;
  propertyFeatureFlags?: InputMaybe<PropertyFeatureFlag_bool_exp>;
  propertyFeatureFlags_aggregate?: InputMaybe<PropertyFeatureFlag_aggregate_bool_exp>;
  propertyId?: InputMaybe<uuid_comparison_exp>;
  propertyMap?: InputMaybe<PropertyMap_bool_exp>;
  propertySources?: InputMaybe<PropertySource_bool_exp>;
  propertySources_aggregate?: InputMaybe<PropertySource_aggregate_bool_exp>;
  relayLogs?: InputMaybe<RelayLog_bool_exp>;
  relayLogs_aggregate?: InputMaybe<RelayLog_aggregate_bool_exp>;
  supportEmail?: InputMaybe<String_comparison_exp>;
  supportPhoneNumber?: InputMaybe<String_comparison_exp>;
  tickets?: InputMaybe<Ticket_bool_exp>;
  tickets_aggregate?: InputMaybe<Ticket_aggregate_bool_exp>;
  timezone?: InputMaybe<String_comparison_exp>;
  timezoneEnum?: InputMaybe<Timezone_bool_exp>;
  unitGroups?: InputMaybe<UnitGroup_bool_exp>;
  unitGroups_aggregate?: InputMaybe<UnitGroup_aggregate_bool_exp>;
  units?: InputMaybe<Unit_bool_exp>;
  units_aggregate?: InputMaybe<Unit_aggregate_bool_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  userRolePermissions?: InputMaybe<UserRolePermission_bool_exp>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_bool_exp>;
  userRoles?: InputMaybe<UserRole_bool_exp>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
  virtualDirectoryPhoneNumber?: InputMaybe<String_comparison_exp>;
  virtualDirectoryStaffHours?: InputMaybe<jsonb_comparison_exp>;
};

/** unique or primary key constraints on table "Property" */
export enum Property_constraint {
  /** unique or primary key constraint on columns "name", "organizationId" */
  Property_organizationId_name_key = 'Property_organizationId_name_key',
  /** unique or primary key constraint on columns "propertyId" */
  Property_pkey = 'Property_pkey'
}

/** input type for inserting data into table "Property" */
export type Property_insert_input = {
  accessPoints?: InputMaybe<AccessPoint_arr_rel_insert_input>;
  address?: InputMaybe<Scalars['String']['input']>;
  credentials?: InputMaybe<Credential_arr_rel_insert_input>;
  imageId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_obj_rel_insert_input>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  pinCodes?: InputMaybe<PinCode_arr_rel_insert_input>;
  propertyFeatureFlags?: InputMaybe<PropertyFeatureFlag_arr_rel_insert_input>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  tickets?: InputMaybe<Ticket_arr_rel_insert_input>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  unitGroups?: InputMaybe<UnitGroup_arr_rel_insert_input>;
  units?: InputMaybe<Unit_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type Property_max_fields = {
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  funnelCommunityId?: Maybe<Scalars['String']['output']>;
  imageId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportPhoneNumber?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virtualDirectoryPhoneNumber?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "Property" */
export type Property_max_order_by = {
  address?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  funnelCommunityId?: InputMaybe<order_by>;
  imageId?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  organizationId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  supportEmail?: InputMaybe<order_by>;
  supportPhoneNumber?: InputMaybe<order_by>;
  timezone?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  virtualDirectoryPhoneNumber?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type Property_min_fields = {
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  funnelCommunityId?: Maybe<Scalars['String']['output']>;
  imageId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportPhoneNumber?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virtualDirectoryPhoneNumber?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "Property" */
export type Property_min_order_by = {
  address?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  funnelCommunityId?: InputMaybe<order_by>;
  imageId?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  organizationId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  supportEmail?: InputMaybe<order_by>;
  supportPhoneNumber?: InputMaybe<order_by>;
  timezone?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  virtualDirectoryPhoneNumber?: InputMaybe<order_by>;
};

/** response of any mutation on the table "Property" */
export type Property_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property>;
};

/** input type for inserting object relation for remote table "Property" */
export type Property_obj_rel_insert_input = {
  data: Property_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_on_conflict>;
};

/** on_conflict condition type for table "Property" */
export type Property_on_conflict = {
  constraint: Property_constraint;
  update_columns?: Array<Property_update_column>;
  where?: InputMaybe<Property_bool_exp>;
};

/** Ordering options when selecting data from "Property". */
export type Property_order_by = {
  accessPoints_aggregate?: InputMaybe<AccessPoint_aggregate_order_by>;
  address?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  credentials_aggregate?: InputMaybe<Credential_aggregate_order_by>;
  funnelCommunityId?: InputMaybe<order_by>;
  hubs_aggregate?: InputMaybe<Hub_aggregate_order_by>;
  image?: InputMaybe<Image_order_by>;
  imageId?: InputMaybe<order_by>;
  managedUserRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
  name?: InputMaybe<order_by>;
  organization?: InputMaybe<Organization_order_by>;
  organizationId?: InputMaybe<order_by>;
  pinCodes_aggregate?: InputMaybe<PinCode_aggregate_order_by>;
  propertyFeatureFlags_aggregate?: InputMaybe<PropertyFeatureFlag_aggregate_order_by>;
  propertyId?: InputMaybe<order_by>;
  propertyMap?: InputMaybe<PropertyMap_order_by>;
  propertySources_aggregate?: InputMaybe<PropertySource_aggregate_order_by>;
  relayLogs_aggregate?: InputMaybe<RelayLog_aggregate_order_by>;
  supportEmail?: InputMaybe<order_by>;
  supportPhoneNumber?: InputMaybe<order_by>;
  tickets_aggregate?: InputMaybe<Ticket_aggregate_order_by>;
  timezone?: InputMaybe<order_by>;
  timezoneEnum?: InputMaybe<Timezone_order_by>;
  unitGroups_aggregate?: InputMaybe<UnitGroup_aggregate_order_by>;
  units_aggregate?: InputMaybe<Unit_aggregate_order_by>;
  updatedAt?: InputMaybe<order_by>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_order_by>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
  virtualDirectoryPhoneNumber?: InputMaybe<order_by>;
  virtualDirectoryStaffHours?: InputMaybe<order_by>;
};

/** primary key columns input for table: Property */
export type Property_pk_columns_input = {
  propertyId: Scalars['uuid']['input'];
};

/** select columns of table "Property" */
export enum Property_select_column {
  /** column name */
  address = 'address',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  funnelCommunityId = 'funnelCommunityId',
  /** column name */
  imageId = 'imageId',
  /** column name */
  name = 'name',
  /** column name */
  organizationId = 'organizationId',
  /** column name */
  propertyId = 'propertyId',
  /** column name */
  supportEmail = 'supportEmail',
  /** column name */
  supportPhoneNumber = 'supportPhoneNumber',
  /** column name */
  timezone = 'timezone',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  virtualDirectoryPhoneNumber = 'virtualDirectoryPhoneNumber',
  /** column name */
  virtualDirectoryStaffHours = 'virtualDirectoryStaffHours'
}

/** input type for updating data in table "Property" */
export type Property_set_input = {
  address?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "Property" */
export type Property_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Property_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_stream_cursor_value_input = {
  address?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  funnelCommunityId?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  virtualDirectoryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Hours that visitors and vendors can request access from staff via Virtual Directory */
  virtualDirectoryStaffHours?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "Property" */
export enum Property_update_column {
  /** column name */
  address = 'address',
  /** column name */
  imageId = 'imageId',
  /** column name */
  name = 'name',
  /** column name */
  supportEmail = 'supportEmail',
  /** column name */
  supportPhoneNumber = 'supportPhoneNumber',
  /** column name */
  timezone = 'timezone'
}

export type Property_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_set_input>;
  /** filter the rows which have to be updated */
  where: Property_bool_exp;
};

/** columns and relationships of "ReaderType" */
export type ReaderType = {
  /** An array relationship */
  relays: Array<Relay>;
  /** An aggregate relationship */
  relays_aggregate: Relay_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "ReaderType" */
export type ReaderType_relaysArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};


/** columns and relationships of "ReaderType" */
export type ReaderType_relays_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};

/** aggregated selection of "ReaderType" */
export type ReaderType_aggregate = {
  aggregate?: Maybe<ReaderType_aggregate_fields>;
  nodes: Array<ReaderType>;
};

/** aggregate fields of "ReaderType" */
export type ReaderType_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<ReaderType_max_fields>;
  min?: Maybe<ReaderType_min_fields>;
};


/** aggregate fields of "ReaderType" */
export type ReaderType_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<ReaderType_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "ReaderType". All fields are combined with a logical 'AND'. */
export type ReaderType_bool_exp = {
  _and?: InputMaybe<Array<ReaderType_bool_exp>>;
  _not?: InputMaybe<ReaderType_bool_exp>;
  _or?: InputMaybe<Array<ReaderType_bool_exp>>;
  relays?: InputMaybe<Relay_bool_exp>;
  relays_aggregate?: InputMaybe<Relay_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum ReaderType_enum {
  KEYPAD = 'KEYPAD',
  LONG_RANGE = 'LONG_RANGE',
  NON_KEYPAD = 'NON_KEYPAD'
}

/** Boolean expression to compare columns of type "ReaderType_enum". All fields are combined with logical 'AND'. */
export type ReaderType_enum_comparison_exp = {
  _eq?: InputMaybe<ReaderType_enum>;
  _in?: InputMaybe<Array<ReaderType_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ReaderType_enum>;
  _nin?: InputMaybe<Array<ReaderType_enum>>;
};

/** aggregate max on columns */
export type ReaderType_max_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ReaderType_min_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "ReaderType". */
export type ReaderType_order_by = {
  relays_aggregate?: InputMaybe<Relay_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "ReaderType" */
export enum ReaderType_select_column {
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "ReaderType" */
export type ReaderType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: ReaderType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ReaderType_stream_cursor_value_input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "Relay" */
export type Relay = {
  /** An array relationship */
  accessPointRelays: Array<AccessPointRelay>;
  /** An aggregate relationship */
  accessPointRelays_aggregate: AccessPointRelay_aggregate;
  /** An object relationship */
  childHub?: Maybe<Hub>;
  childHubId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  failurePlan: FailurePlan_enum;
  /** An object relationship */
  failurePlanEnum: FailurePlan;
  gpioMode: GpioMode_enum;
  /** An object relationship */
  gpioModeEnum: GpioMode;
  /** An object relationship */
  hub: Hub;
  hubId: Scalars['uuid']['output'];
  inputDevice?: Maybe<InputDevice_enum>;
  /** An object relationship */
  inputDeviceEnum?: Maybe<InputDevice>;
  /** An array relationship */
  inputRelayLogs: Array<RelayLog>;
  /** An aggregate relationship */
  inputRelayLogs_aggregate: RelayLog_aggregate;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  readerAddress?: Maybe<Scalars['String']['output']>;
  readerSerialNumber?: Maybe<Scalars['String']['output']>;
  /** Only applies to output relays with readers */
  readerType?: Maybe<ReaderType_enum>;
  /** An object relationship */
  readerTypeEnum?: Maybe<ReaderType>;
  relayId: Scalars['uuid']['output'];
  /** An array relationship */
  relayLogs: Array<RelayLog>;
  /** An aggregate relationship */
  relayLogs_aggregate: RelayLog_aggregate;
  /** Only applies to properties with Gateway Access Manager enabled */
  unlockOnInternetFailure: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "Relay" */
export type Relay_accessPointRelaysArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRelay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRelay_order_by>>;
  where?: InputMaybe<AccessPointRelay_bool_exp>;
};


/** columns and relationships of "Relay" */
export type Relay_accessPointRelays_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRelay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRelay_order_by>>;
  where?: InputMaybe<AccessPointRelay_bool_exp>;
};


/** columns and relationships of "Relay" */
export type Relay_inputRelayLogsArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


/** columns and relationships of "Relay" */
export type Relay_inputRelayLogs_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


/** columns and relationships of "Relay" */
export type Relay_relayLogsArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


/** columns and relationships of "Relay" */
export type Relay_relayLogs_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};

/** columns and relationships of "RelayLog" */
export type RelayLog = {
  /** An object relationship */
  accessPoint?: Maybe<AccessPoint>;
  accessPointId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  inputRelay?: Maybe<Relay>;
  inputRelayId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  property: Property;
  propertyId: Scalars['uuid']['output'];
  /** An object relationship */
  relay: Relay;
  relayId: Scalars['uuid']['output'];
  relayLogId: Scalars['uuid']['output'];
  unlockMethod?: Maybe<UnlockMethod_enum>;
  /** An object relationship */
  unlockMethodEnum?: Maybe<UnlockMethod>;
  unlockResult: UnlockResult_enum;
  /** An object relationship */
  unlockResultEnum: UnlockResult;
  /** An object relationship */
  user?: Maybe<User>;
  /** An object relationship */
  userRole?: Maybe<UserRole>;
};

/** aggregated selection of "RelayLog" */
export type RelayLog_aggregate = {
  aggregate?: Maybe<RelayLog_aggregate_fields>;
  nodes: Array<RelayLog>;
};

export type RelayLog_aggregate_bool_exp = {
  count?: InputMaybe<RelayLog_aggregate_bool_exp_count>;
};

export type RelayLog_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<RelayLog_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RelayLog_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "RelayLog" */
export type RelayLog_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<RelayLog_max_fields>;
  min?: Maybe<RelayLog_min_fields>;
};


/** aggregate fields of "RelayLog" */
export type RelayLog_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<RelayLog_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "RelayLog" */
export type RelayLog_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<RelayLog_max_order_by>;
  min?: InputMaybe<RelayLog_min_order_by>;
};

/** Boolean expression to filter rows from the table "RelayLog". All fields are combined with a logical 'AND'. */
export type RelayLog_bool_exp = {
  _and?: InputMaybe<Array<RelayLog_bool_exp>>;
  _not?: InputMaybe<RelayLog_bool_exp>;
  _or?: InputMaybe<Array<RelayLog_bool_exp>>;
  accessPoint?: InputMaybe<AccessPoint_bool_exp>;
  accessPointId?: InputMaybe<uuid_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  inputRelay?: InputMaybe<Relay_bool_exp>;
  inputRelayId?: InputMaybe<uuid_comparison_exp>;
  property?: InputMaybe<Property_bool_exp>;
  propertyId?: InputMaybe<uuid_comparison_exp>;
  relay?: InputMaybe<Relay_bool_exp>;
  relayId?: InputMaybe<uuid_comparison_exp>;
  relayLogId?: InputMaybe<uuid_comparison_exp>;
  unlockMethod?: InputMaybe<UnlockMethod_enum_comparison_exp>;
  unlockMethodEnum?: InputMaybe<UnlockMethod_bool_exp>;
  unlockResult?: InputMaybe<UnlockResult_enum_comparison_exp>;
  unlockResultEnum?: InputMaybe<UnlockResult_bool_exp>;
  user?: InputMaybe<User_bool_exp>;
  userRole?: InputMaybe<UserRole_bool_exp>;
};

/** aggregate max on columns */
export type RelayLog_max_fields = {
  accessPointId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  inputRelayId?: Maybe<Scalars['uuid']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  relayId?: Maybe<Scalars['uuid']['output']>;
  relayLogId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "RelayLog" */
export type RelayLog_max_order_by = {
  accessPointId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  inputRelayId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  relayId?: InputMaybe<order_by>;
  relayLogId?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type RelayLog_min_fields = {
  accessPointId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  inputRelayId?: Maybe<Scalars['uuid']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  relayId?: Maybe<Scalars['uuid']['output']>;
  relayLogId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "RelayLog" */
export type RelayLog_min_order_by = {
  accessPointId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  inputRelayId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  relayId?: InputMaybe<order_by>;
  relayLogId?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "RelayLog". */
export type RelayLog_order_by = {
  accessPoint?: InputMaybe<AccessPoint_order_by>;
  accessPointId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  inputRelay?: InputMaybe<Relay_order_by>;
  inputRelayId?: InputMaybe<order_by>;
  property?: InputMaybe<Property_order_by>;
  propertyId?: InputMaybe<order_by>;
  relay?: InputMaybe<Relay_order_by>;
  relayId?: InputMaybe<order_by>;
  relayLogId?: InputMaybe<order_by>;
  unlockMethod?: InputMaybe<order_by>;
  unlockMethodEnum?: InputMaybe<UnlockMethod_order_by>;
  unlockResult?: InputMaybe<order_by>;
  unlockResultEnum?: InputMaybe<UnlockResult_order_by>;
  user?: InputMaybe<User_order_by>;
  userRole?: InputMaybe<UserRole_order_by>;
};

/** select columns of table "RelayLog" */
export enum RelayLog_select_column {
  /** column name */
  accessPointId = 'accessPointId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  inputRelayId = 'inputRelayId',
  /** column name */
  propertyId = 'propertyId',
  /** column name */
  relayId = 'relayId',
  /** column name */
  relayLogId = 'relayLogId',
  /** column name */
  unlockMethod = 'unlockMethod',
  /** column name */
  unlockResult = 'unlockResult'
}

/** Streaming cursor of the table "RelayLog" */
export type RelayLog_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: RelayLog_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RelayLog_stream_cursor_value_input = {
  accessPointId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  inputRelayId?: InputMaybe<Scalars['uuid']['input']>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  relayId?: InputMaybe<Scalars['uuid']['input']>;
  relayLogId?: InputMaybe<Scalars['uuid']['input']>;
  unlockMethod?: InputMaybe<UnlockMethod_enum>;
  unlockResult?: InputMaybe<UnlockResult_enum>;
};

/** aggregated selection of "Relay" */
export type Relay_aggregate = {
  aggregate?: Maybe<Relay_aggregate_fields>;
  nodes: Array<Relay>;
};

export type Relay_aggregate_bool_exp = {
  bool_and?: InputMaybe<Relay_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<Relay_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<Relay_aggregate_bool_exp_count>;
};

export type Relay_aggregate_bool_exp_bool_and = {
  arguments: Relay_select_column_Relay_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Relay_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type Relay_aggregate_bool_exp_bool_or = {
  arguments: Relay_select_column_Relay_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Relay_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type Relay_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<Relay_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Relay_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "Relay" */
export type Relay_aggregate_fields = {
  avg?: Maybe<Relay_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Relay_max_fields>;
  min?: Maybe<Relay_min_fields>;
  stddev?: Maybe<Relay_stddev_fields>;
  stddev_pop?: Maybe<Relay_stddev_pop_fields>;
  stddev_samp?: Maybe<Relay_stddev_samp_fields>;
  sum?: Maybe<Relay_sum_fields>;
  var_pop?: Maybe<Relay_var_pop_fields>;
  var_samp?: Maybe<Relay_var_samp_fields>;
  variance?: Maybe<Relay_variance_fields>;
};


/** aggregate fields of "Relay" */
export type Relay_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<Relay_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Relay" */
export type Relay_aggregate_order_by = {
  avg?: InputMaybe<Relay_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<Relay_max_order_by>;
  min?: InputMaybe<Relay_min_order_by>;
  stddev?: InputMaybe<Relay_stddev_order_by>;
  stddev_pop?: InputMaybe<Relay_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<Relay_stddev_samp_order_by>;
  sum?: InputMaybe<Relay_sum_order_by>;
  var_pop?: InputMaybe<Relay_var_pop_order_by>;
  var_samp?: InputMaybe<Relay_var_samp_order_by>;
  variance?: InputMaybe<Relay_variance_order_by>;
};

/** aggregate avg on columns */
export type Relay_avg_fields = {
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "Relay" */
export type Relay_avg_order_by = {
  position?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "Relay". All fields are combined with a logical 'AND'. */
export type Relay_bool_exp = {
  _and?: InputMaybe<Array<Relay_bool_exp>>;
  _not?: InputMaybe<Relay_bool_exp>;
  _or?: InputMaybe<Array<Relay_bool_exp>>;
  accessPointRelays?: InputMaybe<AccessPointRelay_bool_exp>;
  accessPointRelays_aggregate?: InputMaybe<AccessPointRelay_aggregate_bool_exp>;
  childHub?: InputMaybe<Hub_bool_exp>;
  childHubId?: InputMaybe<uuid_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  failurePlan?: InputMaybe<FailurePlan_enum_comparison_exp>;
  failurePlanEnum?: InputMaybe<FailurePlan_bool_exp>;
  gpioMode?: InputMaybe<GpioMode_enum_comparison_exp>;
  gpioModeEnum?: InputMaybe<GpioMode_bool_exp>;
  hub?: InputMaybe<Hub_bool_exp>;
  hubId?: InputMaybe<uuid_comparison_exp>;
  inputDevice?: InputMaybe<InputDevice_enum_comparison_exp>;
  inputDeviceEnum?: InputMaybe<InputDevice_bool_exp>;
  inputRelayLogs?: InputMaybe<RelayLog_bool_exp>;
  inputRelayLogs_aggregate?: InputMaybe<RelayLog_aggregate_bool_exp>;
  name?: InputMaybe<String_comparison_exp>;
  position?: InputMaybe<Int_comparison_exp>;
  readerAddress?: InputMaybe<String_comparison_exp>;
  readerSerialNumber?: InputMaybe<String_comparison_exp>;
  readerType?: InputMaybe<ReaderType_enum_comparison_exp>;
  readerTypeEnum?: InputMaybe<ReaderType_bool_exp>;
  relayId?: InputMaybe<uuid_comparison_exp>;
  relayLogs?: InputMaybe<RelayLog_bool_exp>;
  relayLogs_aggregate?: InputMaybe<RelayLog_aggregate_bool_exp>;
  unlockOnInternetFailure?: InputMaybe<Boolean_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
};

/** input type for incrementing numeric columns in table "Relay" */
export type Relay_inc_input = {
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Relay_max_fields = {
  childHubId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  hubId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  readerAddress?: Maybe<Scalars['String']['output']>;
  readerSerialNumber?: Maybe<Scalars['String']['output']>;
  relayId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Relay" */
export type Relay_max_order_by = {
  childHubId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  hubId?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  position?: InputMaybe<order_by>;
  readerAddress?: InputMaybe<order_by>;
  readerSerialNumber?: InputMaybe<order_by>;
  relayId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type Relay_min_fields = {
  childHubId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  hubId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  readerAddress?: Maybe<Scalars['String']['output']>;
  readerSerialNumber?: Maybe<Scalars['String']['output']>;
  relayId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Relay" */
export type Relay_min_order_by = {
  childHubId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  hubId?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  position?: InputMaybe<order_by>;
  readerAddress?: InputMaybe<order_by>;
  readerSerialNumber?: InputMaybe<order_by>;
  relayId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** response of any mutation on the table "Relay" */
export type Relay_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Relay>;
};

/** Ordering options when selecting data from "Relay". */
export type Relay_order_by = {
  accessPointRelays_aggregate?: InputMaybe<AccessPointRelay_aggregate_order_by>;
  childHub?: InputMaybe<Hub_order_by>;
  childHubId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  failurePlan?: InputMaybe<order_by>;
  failurePlanEnum?: InputMaybe<FailurePlan_order_by>;
  gpioMode?: InputMaybe<order_by>;
  gpioModeEnum?: InputMaybe<GpioMode_order_by>;
  hub?: InputMaybe<Hub_order_by>;
  hubId?: InputMaybe<order_by>;
  inputDevice?: InputMaybe<order_by>;
  inputDeviceEnum?: InputMaybe<InputDevice_order_by>;
  inputRelayLogs_aggregate?: InputMaybe<RelayLog_aggregate_order_by>;
  name?: InputMaybe<order_by>;
  position?: InputMaybe<order_by>;
  readerAddress?: InputMaybe<order_by>;
  readerSerialNumber?: InputMaybe<order_by>;
  readerType?: InputMaybe<order_by>;
  readerTypeEnum?: InputMaybe<ReaderType_order_by>;
  relayId?: InputMaybe<order_by>;
  relayLogs_aggregate?: InputMaybe<RelayLog_aggregate_order_by>;
  unlockOnInternetFailure?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** primary key columns input for table: Relay */
export type Relay_pk_columns_input = {
  relayId: Scalars['uuid']['input'];
};

/** select columns of table "Relay" */
export enum Relay_select_column {
  /** column name */
  childHubId = 'childHubId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  failurePlan = 'failurePlan',
  /** column name */
  gpioMode = 'gpioMode',
  /** column name */
  hubId = 'hubId',
  /** column name */
  inputDevice = 'inputDevice',
  /** column name */
  name = 'name',
  /** column name */
  position = 'position',
  /** column name */
  readerAddress = 'readerAddress',
  /** column name */
  readerSerialNumber = 'readerSerialNumber',
  /** column name */
  readerType = 'readerType',
  /** column name */
  relayId = 'relayId',
  /** column name */
  unlockOnInternetFailure = 'unlockOnInternetFailure',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "Relay_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Relay" */
export enum Relay_select_column_Relay_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  unlockOnInternetFailure = 'unlockOnInternetFailure'
}

/** select "Relay_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Relay" */
export enum Relay_select_column_Relay_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  unlockOnInternetFailure = 'unlockOnInternetFailure'
}

/** input type for updating data in table "Relay" */
export type Relay_set_input = {
  childHubId?: InputMaybe<Scalars['uuid']['input']>;
  failurePlan?: InputMaybe<FailurePlan_enum>;
  gpioMode?: InputMaybe<GpioMode_enum>;
  hubId?: InputMaybe<Scalars['uuid']['input']>;
  inputDevice?: InputMaybe<InputDevice_enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  readerAddress?: InputMaybe<Scalars['String']['input']>;
  readerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Only applies to output relays with readers */
  readerType?: InputMaybe<ReaderType_enum>;
  /** Only applies to properties with Gateway Access Manager enabled */
  unlockOnInternetFailure?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Relay_stddev_fields = {
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "Relay" */
export type Relay_stddev_order_by = {
  position?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type Relay_stddev_pop_fields = {
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "Relay" */
export type Relay_stddev_pop_order_by = {
  position?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type Relay_stddev_samp_fields = {
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "Relay" */
export type Relay_stddev_samp_order_by = {
  position?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "Relay" */
export type Relay_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Relay_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Relay_stream_cursor_value_input = {
  childHubId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  failurePlan?: InputMaybe<FailurePlan_enum>;
  gpioMode?: InputMaybe<GpioMode_enum>;
  hubId?: InputMaybe<Scalars['uuid']['input']>;
  inputDevice?: InputMaybe<InputDevice_enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  readerAddress?: InputMaybe<Scalars['String']['input']>;
  readerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Only applies to output relays with readers */
  readerType?: InputMaybe<ReaderType_enum>;
  relayId?: InputMaybe<Scalars['uuid']['input']>;
  /** Only applies to properties with Gateway Access Manager enabled */
  unlockOnInternetFailure?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Relay_sum_fields = {
  position?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "Relay" */
export type Relay_sum_order_by = {
  position?: InputMaybe<order_by>;
};

export type Relay_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Relay_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Relay_set_input>;
  /** filter the rows which have to be updated */
  where: Relay_bool_exp;
};

/** aggregate var_pop on columns */
export type Relay_var_pop_fields = {
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "Relay" */
export type Relay_var_pop_order_by = {
  position?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type Relay_var_samp_fields = {
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "Relay" */
export type Relay_var_samp_order_by = {
  position?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type Relay_variance_fields = {
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "Relay" */
export type Relay_variance_order_by = {
  position?: InputMaybe<order_by>;
};

/** columns and relationships of "Role" */
export type Role = {
  /** An array relationship */
  accessPointRoles: Array<AccessPointRole>;
  /** An aggregate relationship */
  accessPointRoles_aggregate: AccessPointRole_aggregate;
  createdAt: Scalars['timestamptz']['output'];
  deprecatedType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isLocked: Scalars['Boolean']['output'];
  key?: Maybe<RoleKey_enum>;
  maxAccessDurationSeconds?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  permissionScope: PermissionScope_enum;
  /** An object relationship */
  permissionScopeEnum: PermissionScope;
  roleId: Scalars['uuid']['output'];
  /** An object relationship */
  roleKeyEnum?: Maybe<RoleKey>;
  /** An array relationship */
  rolePermissions: Array<RolePermission>;
  /** An aggregate relationship */
  rolePermissions_aggregate: RolePermission_aggregate;
  /** An array relationship */
  roleRelationshipsByRelatedRole: Array<RoleRelationship>;
  /** An aggregate relationship */
  roleRelationshipsByRelatedRole_aggregate: RoleRelationship_aggregate;
  /** An array relationship */
  roleRelationshipsByRole: Array<RoleRelationship>;
  /** An aggregate relationship */
  roleRelationshipsByRole_aggregate: RoleRelationship_aggregate;
  uniqueName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userRolePermissions: Array<UserRolePermission>;
  /** An aggregate relationship */
  userRolePermissions_aggregate: UserRolePermission_aggregate;
  /** An array relationship */
  userRoles: Array<UserRole>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRole_aggregate;
};


/** columns and relationships of "Role" */
export type Role_accessPointRolesArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRole_order_by>>;
  where?: InputMaybe<AccessPointRole_bool_exp>;
};


/** columns and relationships of "Role" */
export type Role_accessPointRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRole_order_by>>;
  where?: InputMaybe<AccessPointRole_bool_exp>;
};


/** columns and relationships of "Role" */
export type Role_rolePermissionsArgs = {
  distinct_on?: InputMaybe<Array<RolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RolePermission_order_by>>;
  where?: InputMaybe<RolePermission_bool_exp>;
};


/** columns and relationships of "Role" */
export type Role_rolePermissions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RolePermission_order_by>>;
  where?: InputMaybe<RolePermission_bool_exp>;
};


/** columns and relationships of "Role" */
export type Role_roleRelationshipsByRelatedRoleArgs = {
  distinct_on?: InputMaybe<Array<RoleRelationship_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoleRelationship_order_by>>;
  where?: InputMaybe<RoleRelationship_bool_exp>;
};


/** columns and relationships of "Role" */
export type Role_roleRelationshipsByRelatedRole_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleRelationship_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoleRelationship_order_by>>;
  where?: InputMaybe<RoleRelationship_bool_exp>;
};


/** columns and relationships of "Role" */
export type Role_roleRelationshipsByRoleArgs = {
  distinct_on?: InputMaybe<Array<RoleRelationship_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoleRelationship_order_by>>;
  where?: InputMaybe<RoleRelationship_bool_exp>;
};


/** columns and relationships of "Role" */
export type Role_roleRelationshipsByRole_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleRelationship_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoleRelationship_order_by>>;
  where?: InputMaybe<RoleRelationship_bool_exp>;
};


/** columns and relationships of "Role" */
export type Role_userRolePermissionsArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


/** columns and relationships of "Role" */
export type Role_userRolePermissions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


/** columns and relationships of "Role" */
export type Role_userRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "Role" */
export type Role_userRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};

/** columns and relationships of "RoleKey" */
export type RoleKey = {
  /** An object relationship */
  role?: Maybe<Role>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "RoleKey" */
export type RoleKey_aggregate = {
  aggregate?: Maybe<RoleKey_aggregate_fields>;
  nodes: Array<RoleKey>;
};

/** aggregate fields of "RoleKey" */
export type RoleKey_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<RoleKey_max_fields>;
  min?: Maybe<RoleKey_min_fields>;
};


/** aggregate fields of "RoleKey" */
export type RoleKey_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<RoleKey_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "RoleKey". All fields are combined with a logical 'AND'. */
export type RoleKey_bool_exp = {
  _and?: InputMaybe<Array<RoleKey_bool_exp>>;
  _not?: InputMaybe<RoleKey_bool_exp>;
  _or?: InputMaybe<Array<RoleKey_bool_exp>>;
  role?: InputMaybe<Role_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum RoleKey_enum {
  AMENITY_ACCESS = 'AMENITY_ACCESS',
  BASIC_ACCESS = 'BASIC_ACCESS',
  GUEST_PROPERTY_KEY = 'GUEST_PROPERTY_KEY',
  GUEST_UNIT_KEY = 'GUEST_UNIT_KEY',
  INTEGRATOR = 'INTEGRATOR',
  INTEGRATOR_GATEWAY = 'INTEGRATOR_GATEWAY',
  INTEGRATOR_GATEWAY_CERTIFICATION = 'INTEGRATOR_GATEWAY_CERTIFICATION',
  INTEGRATOR_HOME_ACCESS = 'INTEGRATOR_HOME_ACCESS',
  INTEGRATOR_SUPERVISOR_ORGANIZATION = 'INTEGRATOR_SUPERVISOR_ORGANIZATION',
  INTEGRATOR_SUPERVISOR_PROPERTY = 'INTEGRATOR_SUPERVISOR_PROPERTY',
  RESERVATION = 'RESERVATION',
  RESIDENT = 'RESIDENT',
  ROLE_MANAGER = 'ROLE_MANAGER',
  SBP_SUPERUSER = 'SBP_SUPERUSER',
  SMART_LOCK_UNREGISTERED_USER = 'SMART_LOCK_UNREGISTERED_USER',
  STAFF_PROPERTY_KEY = 'STAFF_PROPERTY_KEY',
  STAFF_UNIT_KEY = 'STAFF_UNIT_KEY',
  STRATIS_MAINTENANCE = 'STRATIS_MAINTENANCE',
  STRATIS_OFFICE_STAFF = 'STRATIS_OFFICE_STAFF',
  STRATIS_PROPERTY_MANAGER = 'STRATIS_PROPERTY_MANAGER',
  STRATIS_RESIDENT = 'STRATIS_RESIDENT',
  SUPER_ADMIN = 'SUPER_ADMIN',
  SUPER_ADMIN_READ_ONLY = 'SUPER_ADMIN_READ_ONLY',
  VENDOR_PASS = 'VENDOR_PASS'
}

/** Boolean expression to compare columns of type "RoleKey_enum". All fields are combined with logical 'AND'. */
export type RoleKey_enum_comparison_exp = {
  _eq?: InputMaybe<RoleKey_enum>;
  _in?: InputMaybe<Array<RoleKey_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RoleKey_enum>;
  _nin?: InputMaybe<Array<RoleKey_enum>>;
};

/** aggregate max on columns */
export type RoleKey_max_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type RoleKey_min_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "RoleKey". */
export type RoleKey_order_by = {
  role?: InputMaybe<Role_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "RoleKey" */
export enum RoleKey_select_column {
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "RoleKey" */
export type RoleKey_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: RoleKey_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoleKey_stream_cursor_value_input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "RolePermission" */
export type RolePermission = {
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  permission: Permission;
  permissionId: Scalars['uuid']['output'];
  /** An object relationship */
  role: Role;
  roleId: Scalars['uuid']['output'];
  rolePermissionId: Scalars['uuid']['output'];
};

/** aggregated selection of "RolePermission" */
export type RolePermission_aggregate = {
  aggregate?: Maybe<RolePermission_aggregate_fields>;
  nodes: Array<RolePermission>;
};

export type RolePermission_aggregate_bool_exp = {
  count?: InputMaybe<RolePermission_aggregate_bool_exp_count>;
};

export type RolePermission_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<RolePermission_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RolePermission_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "RolePermission" */
export type RolePermission_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<RolePermission_max_fields>;
  min?: Maybe<RolePermission_min_fields>;
};


/** aggregate fields of "RolePermission" */
export type RolePermission_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<RolePermission_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "RolePermission" */
export type RolePermission_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<RolePermission_max_order_by>;
  min?: InputMaybe<RolePermission_min_order_by>;
};

/** input type for inserting array relation for remote table "RolePermission" */
export type RolePermission_arr_rel_insert_input = {
  data: Array<RolePermission_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RolePermission_on_conflict>;
};

/** Boolean expression to filter rows from the table "RolePermission". All fields are combined with a logical 'AND'. */
export type RolePermission_bool_exp = {
  _and?: InputMaybe<Array<RolePermission_bool_exp>>;
  _not?: InputMaybe<RolePermission_bool_exp>;
  _or?: InputMaybe<Array<RolePermission_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  permission?: InputMaybe<Permission_bool_exp>;
  permissionId?: InputMaybe<uuid_comparison_exp>;
  role?: InputMaybe<Role_bool_exp>;
  roleId?: InputMaybe<uuid_comparison_exp>;
  rolePermissionId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "RolePermission" */
export enum RolePermission_constraint {
  /** unique or primary key constraint on columns "rolePermissionId" */
  RolePermission_pkey = 'RolePermission_pkey',
  /** unique or primary key constraint on columns "permissionId", "roleId" */
  RolePermission_roleId_permissionId_key = 'RolePermission_roleId_permissionId_key'
}

/** input type for inserting data into table "RolePermission" */
export type RolePermission_insert_input = {
  permissionId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Role_obj_rel_insert_input>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RolePermission_max_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  permissionId?: Maybe<Scalars['uuid']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  rolePermissionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "RolePermission" */
export type RolePermission_max_order_by = {
  createdAt?: InputMaybe<order_by>;
  permissionId?: InputMaybe<order_by>;
  roleId?: InputMaybe<order_by>;
  rolePermissionId?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type RolePermission_min_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  permissionId?: Maybe<Scalars['uuid']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  rolePermissionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "RolePermission" */
export type RolePermission_min_order_by = {
  createdAt?: InputMaybe<order_by>;
  permissionId?: InputMaybe<order_by>;
  roleId?: InputMaybe<order_by>;
  rolePermissionId?: InputMaybe<order_by>;
};

/** response of any mutation on the table "RolePermission" */
export type RolePermission_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RolePermission>;
};

/** on_conflict condition type for table "RolePermission" */
export type RolePermission_on_conflict = {
  constraint: RolePermission_constraint;
  update_columns?: Array<RolePermission_update_column>;
  where?: InputMaybe<RolePermission_bool_exp>;
};

/** Ordering options when selecting data from "RolePermission". */
export type RolePermission_order_by = {
  createdAt?: InputMaybe<order_by>;
  permission?: InputMaybe<Permission_order_by>;
  permissionId?: InputMaybe<order_by>;
  role?: InputMaybe<Role_order_by>;
  roleId?: InputMaybe<order_by>;
  rolePermissionId?: InputMaybe<order_by>;
};

/** primary key columns input for table: RolePermission */
export type RolePermission_pk_columns_input = {
  rolePermissionId: Scalars['uuid']['input'];
};

/** select columns of table "RolePermission" */
export enum RolePermission_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  permissionId = 'permissionId',
  /** column name */
  roleId = 'roleId',
  /** column name */
  rolePermissionId = 'rolePermissionId'
}

/** input type for updating data in table "RolePermission" */
export type RolePermission_set_input = {
  permissionId?: InputMaybe<Scalars['uuid']['input']>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "RolePermission" */
export type RolePermission_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: RolePermission_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RolePermission_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  permissionId?: InputMaybe<Scalars['uuid']['input']>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  rolePermissionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "RolePermission" */
export enum RolePermission_update_column {
  /** column name */
  permissionId = 'permissionId',
  /** column name */
  roleId = 'roleId'
}

export type RolePermission_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RolePermission_set_input>;
  /** filter the rows which have to be updated */
  where: RolePermission_bool_exp;
};

/** columns and relationships of "RoleRelationship" */
export type RoleRelationship = {
  canGrantUserRole: Scalars['Boolean']['output'];
  canReadUserRole: Scalars['Boolean']['output'];
  canRevokeUserRole: Scalars['Boolean']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  relatedRole: Role;
  relatedRoleId: Scalars['uuid']['output'];
  /** An object relationship */
  role: Role;
  roleId: Scalars['uuid']['output'];
  roleRelationshipId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "RoleRelationship" */
export type RoleRelationship_aggregate = {
  aggregate?: Maybe<RoleRelationship_aggregate_fields>;
  nodes: Array<RoleRelationship>;
};

export type RoleRelationship_aggregate_bool_exp = {
  bool_and?: InputMaybe<RoleRelationship_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<RoleRelationship_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<RoleRelationship_aggregate_bool_exp_count>;
};

export type RoleRelationship_aggregate_bool_exp_bool_and = {
  arguments: RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RoleRelationship_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type RoleRelationship_aggregate_bool_exp_bool_or = {
  arguments: RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RoleRelationship_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type RoleRelationship_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<RoleRelationship_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RoleRelationship_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "RoleRelationship" */
export type RoleRelationship_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<RoleRelationship_max_fields>;
  min?: Maybe<RoleRelationship_min_fields>;
};


/** aggregate fields of "RoleRelationship" */
export type RoleRelationship_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<RoleRelationship_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "RoleRelationship" */
export type RoleRelationship_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<RoleRelationship_max_order_by>;
  min?: InputMaybe<RoleRelationship_min_order_by>;
};

/** input type for inserting array relation for remote table "RoleRelationship" */
export type RoleRelationship_arr_rel_insert_input = {
  data: Array<RoleRelationship_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RoleRelationship_on_conflict>;
};

/** Boolean expression to filter rows from the table "RoleRelationship". All fields are combined with a logical 'AND'. */
export type RoleRelationship_bool_exp = {
  _and?: InputMaybe<Array<RoleRelationship_bool_exp>>;
  _not?: InputMaybe<RoleRelationship_bool_exp>;
  _or?: InputMaybe<Array<RoleRelationship_bool_exp>>;
  canGrantUserRole?: InputMaybe<Boolean_comparison_exp>;
  canReadUserRole?: InputMaybe<Boolean_comparison_exp>;
  canRevokeUserRole?: InputMaybe<Boolean_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  relatedRole?: InputMaybe<Role_bool_exp>;
  relatedRoleId?: InputMaybe<uuid_comparison_exp>;
  role?: InputMaybe<Role_bool_exp>;
  roleId?: InputMaybe<uuid_comparison_exp>;
  roleRelationshipId?: InputMaybe<uuid_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "RoleRelationship" */
export enum RoleRelationship_constraint {
  /** unique or primary key constraint on columns "roleRelationshipId" */
  RoleRelationship_pkey = 'RoleRelationship_pkey',
  /** unique or primary key constraint on columns "relatedRoleId", "roleId" */
  RoleRelationship_roleId_relatedRoleId_key = 'RoleRelationship_roleId_relatedRoleId_key'
}

/** input type for inserting data into table "RoleRelationship" */
export type RoleRelationship_insert_input = {
  canGrantUserRole?: InputMaybe<Scalars['Boolean']['input']>;
  canReadUserRole?: InputMaybe<Scalars['Boolean']['input']>;
  canRevokeUserRole?: InputMaybe<Scalars['Boolean']['input']>;
  relatedRole?: InputMaybe<Role_obj_rel_insert_input>;
  relatedRoleId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Role_obj_rel_insert_input>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RoleRelationship_max_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  relatedRoleId?: Maybe<Scalars['uuid']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  roleRelationshipId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "RoleRelationship" */
export type RoleRelationship_max_order_by = {
  createdAt?: InputMaybe<order_by>;
  relatedRoleId?: InputMaybe<order_by>;
  roleId?: InputMaybe<order_by>;
  roleRelationshipId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type RoleRelationship_min_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  relatedRoleId?: Maybe<Scalars['uuid']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  roleRelationshipId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "RoleRelationship" */
export type RoleRelationship_min_order_by = {
  createdAt?: InputMaybe<order_by>;
  relatedRoleId?: InputMaybe<order_by>;
  roleId?: InputMaybe<order_by>;
  roleRelationshipId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** response of any mutation on the table "RoleRelationship" */
export type RoleRelationship_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoleRelationship>;
};

/** on_conflict condition type for table "RoleRelationship" */
export type RoleRelationship_on_conflict = {
  constraint: RoleRelationship_constraint;
  update_columns?: Array<RoleRelationship_update_column>;
  where?: InputMaybe<RoleRelationship_bool_exp>;
};

/** Ordering options when selecting data from "RoleRelationship". */
export type RoleRelationship_order_by = {
  canGrantUserRole?: InputMaybe<order_by>;
  canReadUserRole?: InputMaybe<order_by>;
  canRevokeUserRole?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  relatedRole?: InputMaybe<Role_order_by>;
  relatedRoleId?: InputMaybe<order_by>;
  role?: InputMaybe<Role_order_by>;
  roleId?: InputMaybe<order_by>;
  roleRelationshipId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** primary key columns input for table: RoleRelationship */
export type RoleRelationship_pk_columns_input = {
  roleRelationshipId: Scalars['uuid']['input'];
};

/** select columns of table "RoleRelationship" */
export enum RoleRelationship_select_column {
  /** column name */
  canGrantUserRole = 'canGrantUserRole',
  /** column name */
  canReadUserRole = 'canReadUserRole',
  /** column name */
  canRevokeUserRole = 'canRevokeUserRole',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  relatedRoleId = 'relatedRoleId',
  /** column name */
  roleId = 'roleId',
  /** column name */
  roleRelationshipId = 'roleRelationshipId',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "RoleRelationship_aggregate_bool_exp_bool_and_arguments_columns" columns of table "RoleRelationship" */
export enum RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  canGrantUserRole = 'canGrantUserRole',
  /** column name */
  canReadUserRole = 'canReadUserRole',
  /** column name */
  canRevokeUserRole = 'canRevokeUserRole'
}

/** select "RoleRelationship_aggregate_bool_exp_bool_or_arguments_columns" columns of table "RoleRelationship" */
export enum RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  canGrantUserRole = 'canGrantUserRole',
  /** column name */
  canReadUserRole = 'canReadUserRole',
  /** column name */
  canRevokeUserRole = 'canRevokeUserRole'
}

/** input type for updating data in table "RoleRelationship" */
export type RoleRelationship_set_input = {
  canGrantUserRole?: InputMaybe<Scalars['Boolean']['input']>;
  canReadUserRole?: InputMaybe<Scalars['Boolean']['input']>;
  canRevokeUserRole?: InputMaybe<Scalars['Boolean']['input']>;
  relatedRoleId?: InputMaybe<Scalars['uuid']['input']>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "RoleRelationship" */
export type RoleRelationship_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: RoleRelationship_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoleRelationship_stream_cursor_value_input = {
  canGrantUserRole?: InputMaybe<Scalars['Boolean']['input']>;
  canReadUserRole?: InputMaybe<Scalars['Boolean']['input']>;
  canRevokeUserRole?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  relatedRoleId?: InputMaybe<Scalars['uuid']['input']>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  roleRelationshipId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "RoleRelationship" */
export enum RoleRelationship_update_column {
  /** column name */
  canGrantUserRole = 'canGrantUserRole',
  /** column name */
  canReadUserRole = 'canReadUserRole',
  /** column name */
  canRevokeUserRole = 'canRevokeUserRole',
  /** column name */
  relatedRoleId = 'relatedRoleId',
  /** column name */
  roleId = 'roleId'
}

export type RoleRelationship_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoleRelationship_set_input>;
  /** filter the rows which have to be updated */
  where: RoleRelationship_bool_exp;
};

/** aggregated selection of "Role" */
export type Role_aggregate = {
  aggregate?: Maybe<Role_aggregate_fields>;
  nodes: Array<Role>;
};

export type Role_aggregate_bool_exp = {
  bool_and?: InputMaybe<Role_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<Role_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<Role_aggregate_bool_exp_count>;
};

export type Role_aggregate_bool_exp_bool_and = {
  arguments: Role_select_column_Role_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Role_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type Role_aggregate_bool_exp_bool_or = {
  arguments: Role_select_column_Role_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Role_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type Role_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<Role_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Role_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "Role" */
export type Role_aggregate_fields = {
  avg?: Maybe<Role_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Role_max_fields>;
  min?: Maybe<Role_min_fields>;
  stddev?: Maybe<Role_stddev_fields>;
  stddev_pop?: Maybe<Role_stddev_pop_fields>;
  stddev_samp?: Maybe<Role_stddev_samp_fields>;
  sum?: Maybe<Role_sum_fields>;
  var_pop?: Maybe<Role_var_pop_fields>;
  var_samp?: Maybe<Role_var_samp_fields>;
  variance?: Maybe<Role_variance_fields>;
};


/** aggregate fields of "Role" */
export type Role_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<Role_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Role" */
export type Role_aggregate_order_by = {
  avg?: InputMaybe<Role_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<Role_max_order_by>;
  min?: InputMaybe<Role_min_order_by>;
  stddev?: InputMaybe<Role_stddev_order_by>;
  stddev_pop?: InputMaybe<Role_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<Role_stddev_samp_order_by>;
  sum?: InputMaybe<Role_sum_order_by>;
  var_pop?: InputMaybe<Role_var_pop_order_by>;
  var_samp?: InputMaybe<Role_var_samp_order_by>;
  variance?: InputMaybe<Role_variance_order_by>;
};

/** input type for inserting array relation for remote table "Role" */
export type Role_arr_rel_insert_input = {
  data: Array<Role_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_on_conflict>;
};

/** aggregate avg on columns */
export type Role_avg_fields = {
  maxAccessDurationSeconds?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "Role" */
export type Role_avg_order_by = {
  maxAccessDurationSeconds?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "Role". All fields are combined with a logical 'AND'. */
export type Role_bool_exp = {
  _and?: InputMaybe<Array<Role_bool_exp>>;
  _not?: InputMaybe<Role_bool_exp>;
  _or?: InputMaybe<Array<Role_bool_exp>>;
  accessPointRoles?: InputMaybe<AccessPointRole_bool_exp>;
  accessPointRoles_aggregate?: InputMaybe<AccessPointRole_aggregate_bool_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  deprecatedType?: InputMaybe<String_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  isLocked?: InputMaybe<Boolean_comparison_exp>;
  key?: InputMaybe<RoleKey_enum_comparison_exp>;
  maxAccessDurationSeconds?: InputMaybe<Int_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  organization?: InputMaybe<Organization_bool_exp>;
  organizationId?: InputMaybe<uuid_comparison_exp>;
  permissionScope?: InputMaybe<PermissionScope_enum_comparison_exp>;
  permissionScopeEnum?: InputMaybe<PermissionScope_bool_exp>;
  roleId?: InputMaybe<uuid_comparison_exp>;
  roleKeyEnum?: InputMaybe<RoleKey_bool_exp>;
  rolePermissions?: InputMaybe<RolePermission_bool_exp>;
  rolePermissions_aggregate?: InputMaybe<RolePermission_aggregate_bool_exp>;
  roleRelationshipsByRelatedRole?: InputMaybe<RoleRelationship_bool_exp>;
  roleRelationshipsByRelatedRole_aggregate?: InputMaybe<RoleRelationship_aggregate_bool_exp>;
  roleRelationshipsByRole?: InputMaybe<RoleRelationship_bool_exp>;
  roleRelationshipsByRole_aggregate?: InputMaybe<RoleRelationship_aggregate_bool_exp>;
  uniqueName?: InputMaybe<String_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  userRolePermissions?: InputMaybe<UserRolePermission_bool_exp>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_bool_exp>;
  userRoles?: InputMaybe<UserRole_bool_exp>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "Role" */
export enum Role_constraint {
  /** unique or primary key constraint on columns "key" */
  Role_key_key = 'Role_key_key',
  /** unique or primary key constraint on columns "name", "permissionScope" */
  Role_name_permissionScope_key = 'Role_name_permissionScope_key',
  /** unique or primary key constraint on columns "name", "organizationId", "permissionScope" */
  Role_organizationId_name_permissionScope_key = 'Role_organizationId_name_permissionScope_key',
  /** unique or primary key constraint on columns "organizationId", "uniqueName" */
  Role_organizationId_uniqueName_key = 'Role_organizationId_uniqueName_key',
  /** unique or primary key constraint on columns "roleId" */
  Role_pkey = 'Role_pkey',
  /** unique or primary key constraint on columns "uniqueName" */
  Role_uniqueName_key = 'Role_uniqueName_key'
}

/** input type for incrementing numeric columns in table "Role" */
export type Role_inc_input = {
  maxAccessDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "Role" */
export type Role_insert_input = {
  accessPointRoles?: InputMaybe<AccessPointRole_arr_rel_insert_input>;
  deprecatedType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  maxAccessDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_obj_rel_insert_input>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  permissionScope?: InputMaybe<PermissionScope_enum>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  rolePermissions?: InputMaybe<RolePermission_arr_rel_insert_input>;
  roleRelationshipsByRelatedRole?: InputMaybe<RoleRelationship_arr_rel_insert_input>;
  roleRelationshipsByRole?: InputMaybe<RoleRelationship_arr_rel_insert_input>;
  uniqueName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Role_max_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deprecatedType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  maxAccessDurationSeconds?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  uniqueName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Role" */
export type Role_max_order_by = {
  createdAt?: InputMaybe<order_by>;
  deprecatedType?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  maxAccessDurationSeconds?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  organizationId?: InputMaybe<order_by>;
  roleId?: InputMaybe<order_by>;
  uniqueName?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type Role_min_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deprecatedType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  maxAccessDurationSeconds?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  uniqueName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Role" */
export type Role_min_order_by = {
  createdAt?: InputMaybe<order_by>;
  deprecatedType?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  maxAccessDurationSeconds?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  organizationId?: InputMaybe<order_by>;
  roleId?: InputMaybe<order_by>;
  uniqueName?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** response of any mutation on the table "Role" */
export type Role_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Role>;
};

/** input type for inserting object relation for remote table "Role" */
export type Role_obj_rel_insert_input = {
  data: Role_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_on_conflict>;
};

/** on_conflict condition type for table "Role" */
export type Role_on_conflict = {
  constraint: Role_constraint;
  update_columns?: Array<Role_update_column>;
  where?: InputMaybe<Role_bool_exp>;
};

/** Ordering options when selecting data from "Role". */
export type Role_order_by = {
  accessPointRoles_aggregate?: InputMaybe<AccessPointRole_aggregate_order_by>;
  createdAt?: InputMaybe<order_by>;
  deprecatedType?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  isLocked?: InputMaybe<order_by>;
  key?: InputMaybe<order_by>;
  maxAccessDurationSeconds?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  organization?: InputMaybe<Organization_order_by>;
  organizationId?: InputMaybe<order_by>;
  permissionScope?: InputMaybe<order_by>;
  permissionScopeEnum?: InputMaybe<PermissionScope_order_by>;
  roleId?: InputMaybe<order_by>;
  roleKeyEnum?: InputMaybe<RoleKey_order_by>;
  rolePermissions_aggregate?: InputMaybe<RolePermission_aggregate_order_by>;
  roleRelationshipsByRelatedRole_aggregate?: InputMaybe<RoleRelationship_aggregate_order_by>;
  roleRelationshipsByRole_aggregate?: InputMaybe<RoleRelationship_aggregate_order_by>;
  uniqueName?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_order_by>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
};

/** primary key columns input for table: Role */
export type Role_pk_columns_input = {
  roleId: Scalars['uuid']['input'];
};

/** select columns of table "Role" */
export enum Role_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deprecatedType = 'deprecatedType',
  /** column name */
  description = 'description',
  /** column name */
  isLocked = 'isLocked',
  /** column name */
  key = 'key',
  /** column name */
  maxAccessDurationSeconds = 'maxAccessDurationSeconds',
  /** column name */
  name = 'name',
  /** column name */
  organizationId = 'organizationId',
  /** column name */
  permissionScope = 'permissionScope',
  /** column name */
  roleId = 'roleId',
  /** column name */
  uniqueName = 'uniqueName',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "Role_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Role" */
export enum Role_select_column_Role_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  isLocked = 'isLocked'
}

/** select "Role_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Role" */
export enum Role_select_column_Role_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  isLocked = 'isLocked'
}

/** input type for updating data in table "Role" */
export type Role_set_input = {
  deprecatedType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  maxAccessDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uniqueName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Role_stddev_fields = {
  maxAccessDurationSeconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "Role" */
export type Role_stddev_order_by = {
  maxAccessDurationSeconds?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type Role_stddev_pop_fields = {
  maxAccessDurationSeconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "Role" */
export type Role_stddev_pop_order_by = {
  maxAccessDurationSeconds?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type Role_stddev_samp_fields = {
  maxAccessDurationSeconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "Role" */
export type Role_stddev_samp_order_by = {
  maxAccessDurationSeconds?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "Role" */
export type Role_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Role_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecatedType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<RoleKey_enum>;
  maxAccessDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  permissionScope?: InputMaybe<PermissionScope_enum>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  uniqueName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Role_sum_fields = {
  maxAccessDurationSeconds?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "Role" */
export type Role_sum_order_by = {
  maxAccessDurationSeconds?: InputMaybe<order_by>;
};

/** update columns of table "Role" */
export enum Role_update_column {
  /** column name */
  deprecatedType = 'deprecatedType',
  /** column name */
  description = 'description',
  /** column name */
  maxAccessDurationSeconds = 'maxAccessDurationSeconds',
  /** column name */
  name = 'name',
  /** column name */
  uniqueName = 'uniqueName'
}

export type Role_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Role_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Role_set_input>;
  /** filter the rows which have to be updated */
  where: Role_bool_exp;
};

/** aggregate var_pop on columns */
export type Role_var_pop_fields = {
  maxAccessDurationSeconds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "Role" */
export type Role_var_pop_order_by = {
  maxAccessDurationSeconds?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type Role_var_samp_fields = {
  maxAccessDurationSeconds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "Role" */
export type Role_var_samp_order_by = {
  maxAccessDurationSeconds?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type Role_variance_fields = {
  maxAccessDurationSeconds?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "Role" */
export type Role_variance_order_by = {
  maxAccessDurationSeconds?: InputMaybe<order_by>;
};

/** columns and relationships of "Session" */
export type Session = {
  authMethod?: Maybe<AuthMethod_enum>;
  /** An object relationship */
  authMethodEnum?: Maybe<AuthMethod>;
  createdAt: Scalars['timestamptz']['output'];
  deviceFingerprint?: Maybe<Scalars['String']['output']>;
  deviceInfo: Scalars['jsonb']['output'];
  expiresAt: Scalars['timestamptz']['output'];
  renewedAt?: Maybe<Scalars['timestamptz']['output']>;
  revokedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  revokedByUser?: Maybe<User>;
  revokedByUserId?: Maybe<Scalars['uuid']['output']>;
  sessionId: Scalars['uuid']['output'];
  type: SessionType_enum;
  /** An object relationship */
  typeEnum: SessionType;
  /** An object relationship */
  user: User;
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "Session" */
export type Session_deviceInfoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "SessionType" */
export type SessionType = {
  label?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  sessions: Array<Session>;
  /** An aggregate relationship */
  sessions_aggregate: Session_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "SessionType" */
export type SessionType_sessionsArgs = {
  distinct_on?: InputMaybe<Array<Session_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_order_by>>;
  where?: InputMaybe<Session_bool_exp>;
};


/** columns and relationships of "SessionType" */
export type SessionType_sessions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Session_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_order_by>>;
  where?: InputMaybe<Session_bool_exp>;
};

/** aggregated selection of "SessionType" */
export type SessionType_aggregate = {
  aggregate?: Maybe<SessionType_aggregate_fields>;
  nodes: Array<SessionType>;
};

/** aggregate fields of "SessionType" */
export type SessionType_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<SessionType_max_fields>;
  min?: Maybe<SessionType_min_fields>;
};


/** aggregate fields of "SessionType" */
export type SessionType_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<SessionType_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "SessionType". All fields are combined with a logical 'AND'. */
export type SessionType_bool_exp = {
  _and?: InputMaybe<Array<SessionType_bool_exp>>;
  _not?: InputMaybe<SessionType_bool_exp>;
  _or?: InputMaybe<Array<SessionType_bool_exp>>;
  label?: InputMaybe<String_comparison_exp>;
  sessions?: InputMaybe<Session_bool_exp>;
  sessions_aggregate?: InputMaybe<Session_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum SessionType_enum {
  /** Access App */
  ACCESS_APP = 'ACCESS_APP',
  /** Admin Panel */
  ADMIN_PANEL = 'ADMIN_PANEL'
}

/** Boolean expression to compare columns of type "SessionType_enum". All fields are combined with logical 'AND'. */
export type SessionType_enum_comparison_exp = {
  _eq?: InputMaybe<SessionType_enum>;
  _in?: InputMaybe<Array<SessionType_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<SessionType_enum>;
  _nin?: InputMaybe<Array<SessionType_enum>>;
};

/** aggregate max on columns */
export type SessionType_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type SessionType_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "SessionType". */
export type SessionType_order_by = {
  label?: InputMaybe<order_by>;
  sessions_aggregate?: InputMaybe<Session_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "SessionType" */
export enum SessionType_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "SessionType" */
export type SessionType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: SessionType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SessionType_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Session" */
export type Session_aggregate = {
  aggregate?: Maybe<Session_aggregate_fields>;
  nodes: Array<Session>;
};

export type Session_aggregate_bool_exp = {
  count?: InputMaybe<Session_aggregate_bool_exp_count>;
};

export type Session_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<Session_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Session_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "Session" */
export type Session_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Session_max_fields>;
  min?: Maybe<Session_min_fields>;
};


/** aggregate fields of "Session" */
export type Session_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<Session_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Session" */
export type Session_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<Session_max_order_by>;
  min?: InputMaybe<Session_min_order_by>;
};

/** Boolean expression to filter rows from the table "Session". All fields are combined with a logical 'AND'. */
export type Session_bool_exp = {
  _and?: InputMaybe<Array<Session_bool_exp>>;
  _not?: InputMaybe<Session_bool_exp>;
  _or?: InputMaybe<Array<Session_bool_exp>>;
  authMethod?: InputMaybe<AuthMethod_enum_comparison_exp>;
  authMethodEnum?: InputMaybe<AuthMethod_bool_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  deviceFingerprint?: InputMaybe<String_comparison_exp>;
  deviceInfo?: InputMaybe<jsonb_comparison_exp>;
  expiresAt?: InputMaybe<timestamptz_comparison_exp>;
  renewedAt?: InputMaybe<timestamptz_comparison_exp>;
  revokedAt?: InputMaybe<timestamptz_comparison_exp>;
  revokedByUser?: InputMaybe<User_bool_exp>;
  revokedByUserId?: InputMaybe<uuid_comparison_exp>;
  sessionId?: InputMaybe<uuid_comparison_exp>;
  type?: InputMaybe<SessionType_enum_comparison_exp>;
  typeEnum?: InputMaybe<SessionType_bool_exp>;
  user?: InputMaybe<User_bool_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** aggregate max on columns */
export type Session_max_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deviceFingerprint?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  renewedAt?: Maybe<Scalars['timestamptz']['output']>;
  revokedAt?: Maybe<Scalars['timestamptz']['output']>;
  revokedByUserId?: Maybe<Scalars['uuid']['output']>;
  sessionId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "Session" */
export type Session_max_order_by = {
  createdAt?: InputMaybe<order_by>;
  deviceFingerprint?: InputMaybe<order_by>;
  expiresAt?: InputMaybe<order_by>;
  renewedAt?: InputMaybe<order_by>;
  revokedAt?: InputMaybe<order_by>;
  revokedByUserId?: InputMaybe<order_by>;
  sessionId?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type Session_min_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deviceFingerprint?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  renewedAt?: Maybe<Scalars['timestamptz']['output']>;
  revokedAt?: Maybe<Scalars['timestamptz']['output']>;
  revokedByUserId?: Maybe<Scalars['uuid']['output']>;
  sessionId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "Session" */
export type Session_min_order_by = {
  createdAt?: InputMaybe<order_by>;
  deviceFingerprint?: InputMaybe<order_by>;
  expiresAt?: InputMaybe<order_by>;
  renewedAt?: InputMaybe<order_by>;
  revokedAt?: InputMaybe<order_by>;
  revokedByUserId?: InputMaybe<order_by>;
  sessionId?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "Session". */
export type Session_order_by = {
  authMethod?: InputMaybe<order_by>;
  authMethodEnum?: InputMaybe<AuthMethod_order_by>;
  createdAt?: InputMaybe<order_by>;
  deviceFingerprint?: InputMaybe<order_by>;
  deviceInfo?: InputMaybe<order_by>;
  expiresAt?: InputMaybe<order_by>;
  renewedAt?: InputMaybe<order_by>;
  revokedAt?: InputMaybe<order_by>;
  revokedByUser?: InputMaybe<User_order_by>;
  revokedByUserId?: InputMaybe<order_by>;
  sessionId?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  typeEnum?: InputMaybe<SessionType_order_by>;
  user?: InputMaybe<User_order_by>;
  userId?: InputMaybe<order_by>;
};

/** select columns of table "Session" */
export enum Session_select_column {
  /** column name */
  authMethod = 'authMethod',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deviceFingerprint = 'deviceFingerprint',
  /** column name */
  deviceInfo = 'deviceInfo',
  /** column name */
  expiresAt = 'expiresAt',
  /** column name */
  renewedAt = 'renewedAt',
  /** column name */
  revokedAt = 'revokedAt',
  /** column name */
  revokedByUserId = 'revokedByUserId',
  /** column name */
  sessionId = 'sessionId',
  /** column name */
  type = 'type',
  /** column name */
  userId = 'userId'
}

/** Streaming cursor of the table "Session" */
export type Session_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Session_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Session_stream_cursor_value_input = {
  authMethod?: InputMaybe<AuthMethod_enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deviceFingerprint?: InputMaybe<Scalars['String']['input']>;
  deviceInfo?: InputMaybe<Scalars['jsonb']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  renewedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  revokedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  revokedByUserId?: InputMaybe<Scalars['uuid']['input']>;
  sessionId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<SessionType_enum>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "SmartLock" */
export type SmartLock = {
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  serialNumber?: Maybe<Scalars['String']['output']>;
  smartLockId: Scalars['uuid']['output'];
  /** An array relationship */
  smartLockLogs: Array<SmartLockLog>;
  /** An aggregate relationship */
  smartLockLogs_aggregate: SmartLockLog_aggregate;
  sourceId: Scalars['String']['output'];
  /** An array relationship */
  tickets: Array<Ticket>;
  /** An aggregate relationship */
  tickets_aggregate: Ticket_aggregate;
  /** An object relationship */
  unit: Unit;
  unitId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userRoles: Array<UserRole>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRole_aggregate;
};


/** columns and relationships of "SmartLock" */
export type SmartLock_smartLockLogsArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLog_order_by>>;
  where?: InputMaybe<SmartLockLog_bool_exp>;
};


/** columns and relationships of "SmartLock" */
export type SmartLock_smartLockLogs_aggregateArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLog_order_by>>;
  where?: InputMaybe<SmartLockLog_bool_exp>;
};


/** columns and relationships of "SmartLock" */
export type SmartLock_ticketsArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


/** columns and relationships of "SmartLock" */
export type SmartLock_tickets_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


/** columns and relationships of "SmartLock" */
export type SmartLock_userRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "SmartLock" */
export type SmartLock_userRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};

/** columns and relationships of "SmartLockLog" */
export type SmartLockLog = {
  /** An object relationship */
  actingUser?: Maybe<User>;
  actingUserId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  actingUserRole?: Maybe<UserRole>;
  actingUserRoleId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  affectedUser?: Maybe<User>;
  affectedUserId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  affectedUserRole?: Maybe<UserRole>;
  affectedUserRoleId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  smartLock: SmartLock;
  smartLockId: Scalars['uuid']['output'];
  smartLockLogId: Scalars['uuid']['output'];
  sourceId?: Maybe<Scalars['String']['output']>;
  type: SmartLockLogType_enum;
  /** An object relationship */
  typeEnum: SmartLockLogType;
};

/** columns and relationships of "SmartLockLogType" */
export type SmartLockLogType = {
  label: Scalars['String']['output'];
  /** An array relationship */
  smartLockLogs: Array<SmartLockLog>;
  /** An aggregate relationship */
  smartLockLogs_aggregate: SmartLockLog_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "SmartLockLogType" */
export type SmartLockLogType_smartLockLogsArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLog_order_by>>;
  where?: InputMaybe<SmartLockLog_bool_exp>;
};


/** columns and relationships of "SmartLockLogType" */
export type SmartLockLogType_smartLockLogs_aggregateArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLog_order_by>>;
  where?: InputMaybe<SmartLockLog_bool_exp>;
};

/** aggregated selection of "SmartLockLogType" */
export type SmartLockLogType_aggregate = {
  aggregate?: Maybe<SmartLockLogType_aggregate_fields>;
  nodes: Array<SmartLockLogType>;
};

/** aggregate fields of "SmartLockLogType" */
export type SmartLockLogType_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<SmartLockLogType_max_fields>;
  min?: Maybe<SmartLockLogType_min_fields>;
};


/** aggregate fields of "SmartLockLogType" */
export type SmartLockLogType_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<SmartLockLogType_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "SmartLockLogType". All fields are combined with a logical 'AND'. */
export type SmartLockLogType_bool_exp = {
  _and?: InputMaybe<Array<SmartLockLogType_bool_exp>>;
  _not?: InputMaybe<SmartLockLogType_bool_exp>;
  _or?: InputMaybe<Array<SmartLockLogType_bool_exp>>;
  label?: InputMaybe<String_comparison_exp>;
  smartLockLogs?: InputMaybe<SmartLockLog_bool_exp>;
  smartLockLogs_aggregate?: InputMaybe<SmartLockLog_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum SmartLockLogType_enum {
  /** Lock - Manual */
  LOCK_MANUAL = 'LOCK_MANUAL',
  /** Lock - Via App */
  LOCK_VIA_APP = 'LOCK_VIA_APP',
  /** Lock - Via Auto-Lock */
  LOCK_VIA_AUTO_LOCK = 'LOCK_VIA_AUTO_LOCK',
  /** Lock - Via Keypad */
  LOCK_VIA_KEYPAD = 'LOCK_VIA_KEYPAD',
  /** Pin Code Management - Create */
  PIN_CODE_MANAGEMENT_CREATE = 'PIN_CODE_MANAGEMENT_CREATE',
  /** Pin Code Management - Delete */
  PIN_CODE_MANAGEMENT_DELETE = 'PIN_CODE_MANAGEMENT_DELETE',
  /** Unlock - Manual */
  UNLOCK_MANUAL = 'UNLOCK_MANUAL',
  /** Unlock - Via App */
  UNLOCK_VIA_APP = 'UNLOCK_VIA_APP',
  /** Unlock - Via Keypad */
  UNLOCK_VIA_KEYPAD = 'UNLOCK_VIA_KEYPAD',
  /** User Management - Add */
  USER_MANAGEMENT_ADD = 'USER_MANAGEMENT_ADD',
  /** User Management - Remove */
  USER_MANAGEMENT_REMOVE = 'USER_MANAGEMENT_REMOVE'
}

/** Boolean expression to compare columns of type "SmartLockLogType_enum". All fields are combined with logical 'AND'. */
export type SmartLockLogType_enum_comparison_exp = {
  _eq?: InputMaybe<SmartLockLogType_enum>;
  _in?: InputMaybe<Array<SmartLockLogType_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<SmartLockLogType_enum>;
  _nin?: InputMaybe<Array<SmartLockLogType_enum>>;
};

/** aggregate max on columns */
export type SmartLockLogType_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type SmartLockLogType_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "SmartLockLogType". */
export type SmartLockLogType_order_by = {
  label?: InputMaybe<order_by>;
  smartLockLogs_aggregate?: InputMaybe<SmartLockLog_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "SmartLockLogType" */
export enum SmartLockLogType_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "SmartLockLogType" */
export type SmartLockLogType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: SmartLockLogType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SmartLockLogType_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "SmartLockLog" */
export type SmartLockLog_aggregate = {
  aggregate?: Maybe<SmartLockLog_aggregate_fields>;
  nodes: Array<SmartLockLog>;
};

export type SmartLockLog_aggregate_bool_exp = {
  count?: InputMaybe<SmartLockLog_aggregate_bool_exp_count>;
};

export type SmartLockLog_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<SmartLockLog_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SmartLockLog_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "SmartLockLog" */
export type SmartLockLog_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<SmartLockLog_max_fields>;
  min?: Maybe<SmartLockLog_min_fields>;
};


/** aggregate fields of "SmartLockLog" */
export type SmartLockLog_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<SmartLockLog_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "SmartLockLog" */
export type SmartLockLog_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<SmartLockLog_max_order_by>;
  min?: InputMaybe<SmartLockLog_min_order_by>;
};

/** Boolean expression to filter rows from the table "SmartLockLog". All fields are combined with a logical 'AND'. */
export type SmartLockLog_bool_exp = {
  _and?: InputMaybe<Array<SmartLockLog_bool_exp>>;
  _not?: InputMaybe<SmartLockLog_bool_exp>;
  _or?: InputMaybe<Array<SmartLockLog_bool_exp>>;
  actingUser?: InputMaybe<User_bool_exp>;
  actingUserId?: InputMaybe<uuid_comparison_exp>;
  actingUserRole?: InputMaybe<UserRole_bool_exp>;
  actingUserRoleId?: InputMaybe<uuid_comparison_exp>;
  affectedUser?: InputMaybe<User_bool_exp>;
  affectedUserId?: InputMaybe<uuid_comparison_exp>;
  affectedUserRole?: InputMaybe<UserRole_bool_exp>;
  affectedUserRoleId?: InputMaybe<uuid_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  smartLock?: InputMaybe<SmartLock_bool_exp>;
  smartLockId?: InputMaybe<uuid_comparison_exp>;
  smartLockLogId?: InputMaybe<uuid_comparison_exp>;
  sourceId?: InputMaybe<String_comparison_exp>;
  type?: InputMaybe<SmartLockLogType_enum_comparison_exp>;
  typeEnum?: InputMaybe<SmartLockLogType_bool_exp>;
};

/** aggregate max on columns */
export type SmartLockLog_max_fields = {
  actingUserId?: Maybe<Scalars['uuid']['output']>;
  actingUserRoleId?: Maybe<Scalars['uuid']['output']>;
  affectedUserId?: Maybe<Scalars['uuid']['output']>;
  affectedUserRoleId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  smartLockId?: Maybe<Scalars['uuid']['output']>;
  smartLockLogId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "SmartLockLog" */
export type SmartLockLog_max_order_by = {
  actingUserId?: InputMaybe<order_by>;
  actingUserRoleId?: InputMaybe<order_by>;
  affectedUserId?: InputMaybe<order_by>;
  affectedUserRoleId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  smartLockId?: InputMaybe<order_by>;
  smartLockLogId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type SmartLockLog_min_fields = {
  actingUserId?: Maybe<Scalars['uuid']['output']>;
  actingUserRoleId?: Maybe<Scalars['uuid']['output']>;
  affectedUserId?: Maybe<Scalars['uuid']['output']>;
  affectedUserRoleId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  smartLockId?: Maybe<Scalars['uuid']['output']>;
  smartLockLogId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "SmartLockLog" */
export type SmartLockLog_min_order_by = {
  actingUserId?: InputMaybe<order_by>;
  actingUserRoleId?: InputMaybe<order_by>;
  affectedUserId?: InputMaybe<order_by>;
  affectedUserRoleId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  smartLockId?: InputMaybe<order_by>;
  smartLockLogId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "SmartLockLog". */
export type SmartLockLog_order_by = {
  actingUser?: InputMaybe<User_order_by>;
  actingUserId?: InputMaybe<order_by>;
  actingUserRole?: InputMaybe<UserRole_order_by>;
  actingUserRoleId?: InputMaybe<order_by>;
  affectedUser?: InputMaybe<User_order_by>;
  affectedUserId?: InputMaybe<order_by>;
  affectedUserRole?: InputMaybe<UserRole_order_by>;
  affectedUserRoleId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  smartLock?: InputMaybe<SmartLock_order_by>;
  smartLockId?: InputMaybe<order_by>;
  smartLockLogId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  typeEnum?: InputMaybe<SmartLockLogType_order_by>;
};

/** select columns of table "SmartLockLog" */
export enum SmartLockLog_select_column {
  /** column name */
  actingUserId = 'actingUserId',
  /** column name */
  actingUserRoleId = 'actingUserRoleId',
  /** column name */
  affectedUserId = 'affectedUserId',
  /** column name */
  affectedUserRoleId = 'affectedUserRoleId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  smartLockId = 'smartLockId',
  /** column name */
  smartLockLogId = 'smartLockLogId',
  /** column name */
  sourceId = 'sourceId',
  /** column name */
  type = 'type'
}

/** Streaming cursor of the table "SmartLockLog" */
export type SmartLockLog_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: SmartLockLog_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SmartLockLog_stream_cursor_value_input = {
  actingUserId?: InputMaybe<Scalars['uuid']['input']>;
  actingUserRoleId?: InputMaybe<Scalars['uuid']['input']>;
  affectedUserId?: InputMaybe<Scalars['uuid']['input']>;
  affectedUserRoleId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  smartLockId?: InputMaybe<Scalars['uuid']['input']>;
  smartLockLogId?: InputMaybe<Scalars['uuid']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SmartLockLogType_enum>;
};

/** aggregated selection of "SmartLock" */
export type SmartLock_aggregate = {
  aggregate?: Maybe<SmartLock_aggregate_fields>;
  nodes: Array<SmartLock>;
};

export type SmartLock_aggregate_bool_exp = {
  bool_and?: InputMaybe<SmartLock_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<SmartLock_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<SmartLock_aggregate_bool_exp_count>;
};

export type SmartLock_aggregate_bool_exp_bool_and = {
  arguments: SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SmartLock_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type SmartLock_aggregate_bool_exp_bool_or = {
  arguments: SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SmartLock_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type SmartLock_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<SmartLock_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SmartLock_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "SmartLock" */
export type SmartLock_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<SmartLock_max_fields>;
  min?: Maybe<SmartLock_min_fields>;
};


/** aggregate fields of "SmartLock" */
export type SmartLock_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<SmartLock_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "SmartLock" */
export type SmartLock_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<SmartLock_max_order_by>;
  min?: InputMaybe<SmartLock_min_order_by>;
};

/** Boolean expression to filter rows from the table "SmartLock". All fields are combined with a logical 'AND'. */
export type SmartLock_bool_exp = {
  _and?: InputMaybe<Array<SmartLock_bool_exp>>;
  _not?: InputMaybe<SmartLock_bool_exp>;
  _or?: InputMaybe<Array<SmartLock_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  createdByUser?: InputMaybe<User_bool_exp>;
  createdByUserId?: InputMaybe<uuid_comparison_exp>;
  enabled?: InputMaybe<Boolean_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  serialNumber?: InputMaybe<String_comparison_exp>;
  smartLockId?: InputMaybe<uuid_comparison_exp>;
  smartLockLogs?: InputMaybe<SmartLockLog_bool_exp>;
  smartLockLogs_aggregate?: InputMaybe<SmartLockLog_aggregate_bool_exp>;
  sourceId?: InputMaybe<String_comparison_exp>;
  tickets?: InputMaybe<Ticket_bool_exp>;
  tickets_aggregate?: InputMaybe<Ticket_aggregate_bool_exp>;
  unit?: InputMaybe<Unit_bool_exp>;
  unitId?: InputMaybe<uuid_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  userRoles?: InputMaybe<UserRole_bool_exp>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
};

/** aggregate max on columns */
export type SmartLock_max_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  smartLockId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "SmartLock" */
export type SmartLock_max_order_by = {
  createdAt?: InputMaybe<order_by>;
  createdByUserId?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  serialNumber?: InputMaybe<order_by>;
  smartLockId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
  unitId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type SmartLock_min_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  smartLockId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "SmartLock" */
export type SmartLock_min_order_by = {
  createdAt?: InputMaybe<order_by>;
  createdByUserId?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  serialNumber?: InputMaybe<order_by>;
  smartLockId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
  unitId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** response of any mutation on the table "SmartLock" */
export type SmartLock_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<SmartLock>;
};

/** Ordering options when selecting data from "SmartLock". */
export type SmartLock_order_by = {
  createdAt?: InputMaybe<order_by>;
  createdByUser?: InputMaybe<User_order_by>;
  createdByUserId?: InputMaybe<order_by>;
  enabled?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  serialNumber?: InputMaybe<order_by>;
  smartLockId?: InputMaybe<order_by>;
  smartLockLogs_aggregate?: InputMaybe<SmartLockLog_aggregate_order_by>;
  sourceId?: InputMaybe<order_by>;
  tickets_aggregate?: InputMaybe<Ticket_aggregate_order_by>;
  unit?: InputMaybe<Unit_order_by>;
  unitId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
};

/** primary key columns input for table: SmartLock */
export type SmartLock_pk_columns_input = {
  smartLockId: Scalars['uuid']['input'];
};

/** select columns of table "SmartLock" */
export enum SmartLock_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdByUserId = 'createdByUserId',
  /** column name */
  enabled = 'enabled',
  /** column name */
  name = 'name',
  /** column name */
  serialNumber = 'serialNumber',
  /** column name */
  smartLockId = 'smartLockId',
  /** column name */
  sourceId = 'sourceId',
  /** column name */
  unitId = 'unitId',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "SmartLock_aggregate_bool_exp_bool_and_arguments_columns" columns of table "SmartLock" */
export enum SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  enabled = 'enabled'
}

/** select "SmartLock_aggregate_bool_exp_bool_or_arguments_columns" columns of table "SmartLock" */
export enum SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  enabled = 'enabled'
}

/** input type for updating data in table "SmartLock" */
export type SmartLock_set_input = {
  name?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "SmartLock" */
export type SmartLock_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: SmartLock_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SmartLock_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  smartLockId?: InputMaybe<Scalars['uuid']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type SmartLock_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SmartLock_set_input>;
  /** filter the rows which have to be updated */
  where: SmartLock_bool_exp;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_comparison_exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "Ticket" */
export type Ticket = {
  /** An object relationship */
  assignedToUser?: Maybe<User>;
  assignedToUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  property: Property;
  propertyId: Scalars['uuid']['output'];
  /** An object relationship */
  smartLock?: Maybe<SmartLock>;
  smartLockId?: Maybe<Scalars['uuid']['output']>;
  solvedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  solvedByUser?: Maybe<User>;
  solvedByUserId?: Maybe<Scalars['uuid']['output']>;
  status: TicketStatus_enum;
  /** An object relationship */
  statusEnum: TicketStatus;
  ticketId: Scalars['uuid']['output'];
  type: TicketType_enum;
  /** An object relationship */
  typeEnum: TicketType;
  /** An object relationship */
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** columns and relationships of "TicketStatus" */
export type TicketStatus = {
  label: Scalars['String']['output'];
  /** An array relationship */
  tickets: Array<Ticket>;
  /** An aggregate relationship */
  tickets_aggregate: Ticket_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "TicketStatus" */
export type TicketStatus_ticketsArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


/** columns and relationships of "TicketStatus" */
export type TicketStatus_tickets_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};

/** aggregated selection of "TicketStatus" */
export type TicketStatus_aggregate = {
  aggregate?: Maybe<TicketStatus_aggregate_fields>;
  nodes: Array<TicketStatus>;
};

/** aggregate fields of "TicketStatus" */
export type TicketStatus_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<TicketStatus_max_fields>;
  min?: Maybe<TicketStatus_min_fields>;
};


/** aggregate fields of "TicketStatus" */
export type TicketStatus_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<TicketStatus_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "TicketStatus". All fields are combined with a logical 'AND'. */
export type TicketStatus_bool_exp = {
  _and?: InputMaybe<Array<TicketStatus_bool_exp>>;
  _not?: InputMaybe<TicketStatus_bool_exp>;
  _or?: InputMaybe<Array<TicketStatus_bool_exp>>;
  label?: InputMaybe<String_comparison_exp>;
  tickets?: InputMaybe<Ticket_bool_exp>;
  tickets_aggregate?: InputMaybe<Ticket_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum TicketStatus_enum {
  /** Pending */
  PENDING = 'PENDING',
  /** Solved */
  SOLVED = 'SOLVED',
  /** Unsolved */
  UNSOLVED = 'UNSOLVED'
}

/** Boolean expression to compare columns of type "TicketStatus_enum". All fields are combined with logical 'AND'. */
export type TicketStatus_enum_comparison_exp = {
  _eq?: InputMaybe<TicketStatus_enum>;
  _in?: InputMaybe<Array<TicketStatus_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TicketStatus_enum>;
  _nin?: InputMaybe<Array<TicketStatus_enum>>;
};

/** aggregate max on columns */
export type TicketStatus_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TicketStatus_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "TicketStatus". */
export type TicketStatus_order_by = {
  label?: InputMaybe<order_by>;
  tickets_aggregate?: InputMaybe<Ticket_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "TicketStatus" */
export enum TicketStatus_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "TicketStatus" */
export type TicketStatus_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: TicketStatus_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TicketStatus_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "TicketType" */
export type TicketType = {
  label: Scalars['String']['output'];
  /** An array relationship */
  tickets: Array<Ticket>;
  /** An aggregate relationship */
  tickets_aggregate: Ticket_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "TicketType" */
export type TicketType_ticketsArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


/** columns and relationships of "TicketType" */
export type TicketType_tickets_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};

/** aggregated selection of "TicketType" */
export type TicketType_aggregate = {
  aggregate?: Maybe<TicketType_aggregate_fields>;
  nodes: Array<TicketType>;
};

/** aggregate fields of "TicketType" */
export type TicketType_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<TicketType_max_fields>;
  min?: Maybe<TicketType_min_fields>;
};


/** aggregate fields of "TicketType" */
export type TicketType_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<TicketType_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "TicketType". All fields are combined with a logical 'AND'. */
export type TicketType_bool_exp = {
  _and?: InputMaybe<Array<TicketType_bool_exp>>;
  _not?: InputMaybe<TicketType_bool_exp>;
  _or?: InputMaybe<Array<TicketType_bool_exp>>;
  label?: InputMaybe<String_comparison_exp>;
  tickets?: InputMaybe<Ticket_bool_exp>;
  tickets_aggregate?: InputMaybe<Ticket_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum TicketType_enum {
  /** Smart Lock - Low Battery */
  SMART_LOCK_LOW_BATTERY = 'SMART_LOCK_LOW_BATTERY',
  /** Turnover - Lock Reset */
  TURNOVER_LOCK_RESET = 'TURNOVER_LOCK_RESET'
}

/** Boolean expression to compare columns of type "TicketType_enum". All fields are combined with logical 'AND'. */
export type TicketType_enum_comparison_exp = {
  _eq?: InputMaybe<TicketType_enum>;
  _in?: InputMaybe<Array<TicketType_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TicketType_enum>;
  _nin?: InputMaybe<Array<TicketType_enum>>;
};

/** aggregate max on columns */
export type TicketType_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TicketType_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "TicketType". */
export type TicketType_order_by = {
  label?: InputMaybe<order_by>;
  tickets_aggregate?: InputMaybe<Ticket_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "TicketType" */
export enum TicketType_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "TicketType" */
export type TicketType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: TicketType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TicketType_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Ticket" */
export type Ticket_aggregate = {
  aggregate?: Maybe<Ticket_aggregate_fields>;
  nodes: Array<Ticket>;
};

export type Ticket_aggregate_bool_exp = {
  count?: InputMaybe<Ticket_aggregate_bool_exp_count>;
};

export type Ticket_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<Ticket_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ticket_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "Ticket" */
export type Ticket_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Ticket_max_fields>;
  min?: Maybe<Ticket_min_fields>;
};


/** aggregate fields of "Ticket" */
export type Ticket_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<Ticket_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Ticket" */
export type Ticket_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<Ticket_max_order_by>;
  min?: InputMaybe<Ticket_min_order_by>;
};

/** input type for inserting array relation for remote table "Ticket" */
export type Ticket_arr_rel_insert_input = {
  data: Array<Ticket_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ticket_on_conflict>;
};

/** Boolean expression to filter rows from the table "Ticket". All fields are combined with a logical 'AND'. */
export type Ticket_bool_exp = {
  _and?: InputMaybe<Array<Ticket_bool_exp>>;
  _not?: InputMaybe<Ticket_bool_exp>;
  _or?: InputMaybe<Array<Ticket_bool_exp>>;
  assignedToUser?: InputMaybe<User_bool_exp>;
  assignedToUserId?: InputMaybe<uuid_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  createdByUser?: InputMaybe<User_bool_exp>;
  createdByUserId?: InputMaybe<uuid_comparison_exp>;
  property?: InputMaybe<Property_bool_exp>;
  propertyId?: InputMaybe<uuid_comparison_exp>;
  smartLock?: InputMaybe<SmartLock_bool_exp>;
  smartLockId?: InputMaybe<uuid_comparison_exp>;
  solvedAt?: InputMaybe<timestamptz_comparison_exp>;
  solvedByUser?: InputMaybe<User_bool_exp>;
  solvedByUserId?: InputMaybe<uuid_comparison_exp>;
  status?: InputMaybe<TicketStatus_enum_comparison_exp>;
  statusEnum?: InputMaybe<TicketStatus_bool_exp>;
  ticketId?: InputMaybe<uuid_comparison_exp>;
  type?: InputMaybe<TicketType_enum_comparison_exp>;
  typeEnum?: InputMaybe<TicketType_bool_exp>;
  unit?: InputMaybe<Unit_bool_exp>;
  unitId?: InputMaybe<uuid_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "Ticket" */
export enum Ticket_constraint {
  /** unique or primary key constraint on columns "ticketId" */
  Ticket_pkey = 'Ticket_pkey'
}

/** input type for inserting data into table "Ticket" */
export type Ticket_insert_input = {
  assignedToUserId?: InputMaybe<Scalars['uuid']['input']>;
  property?: InputMaybe<Property_obj_rel_insert_input>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  smartLockId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<TicketStatus_enum>;
  type?: InputMaybe<TicketType_enum>;
  unit?: InputMaybe<Unit_obj_rel_insert_input>;
  unitId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Ticket_max_fields = {
  assignedToUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  smartLockId?: Maybe<Scalars['uuid']['output']>;
  solvedAt?: Maybe<Scalars['timestamptz']['output']>;
  solvedByUserId?: Maybe<Scalars['uuid']['output']>;
  ticketId?: Maybe<Scalars['uuid']['output']>;
  unitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Ticket" */
export type Ticket_max_order_by = {
  assignedToUserId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUserId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  smartLockId?: InputMaybe<order_by>;
  solvedAt?: InputMaybe<order_by>;
  solvedByUserId?: InputMaybe<order_by>;
  ticketId?: InputMaybe<order_by>;
  unitId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type Ticket_min_fields = {
  assignedToUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  smartLockId?: Maybe<Scalars['uuid']['output']>;
  solvedAt?: Maybe<Scalars['timestamptz']['output']>;
  solvedByUserId?: Maybe<Scalars['uuid']['output']>;
  ticketId?: Maybe<Scalars['uuid']['output']>;
  unitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Ticket" */
export type Ticket_min_order_by = {
  assignedToUserId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUserId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  smartLockId?: InputMaybe<order_by>;
  solvedAt?: InputMaybe<order_by>;
  solvedByUserId?: InputMaybe<order_by>;
  ticketId?: InputMaybe<order_by>;
  unitId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** response of any mutation on the table "Ticket" */
export type Ticket_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ticket>;
};

/** on_conflict condition type for table "Ticket" */
export type Ticket_on_conflict = {
  constraint: Ticket_constraint;
  update_columns?: Array<Ticket_update_column>;
  where?: InputMaybe<Ticket_bool_exp>;
};

/** Ordering options when selecting data from "Ticket". */
export type Ticket_order_by = {
  assignedToUser?: InputMaybe<User_order_by>;
  assignedToUserId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUser?: InputMaybe<User_order_by>;
  createdByUserId?: InputMaybe<order_by>;
  property?: InputMaybe<Property_order_by>;
  propertyId?: InputMaybe<order_by>;
  smartLock?: InputMaybe<SmartLock_order_by>;
  smartLockId?: InputMaybe<order_by>;
  solvedAt?: InputMaybe<order_by>;
  solvedByUser?: InputMaybe<User_order_by>;
  solvedByUserId?: InputMaybe<order_by>;
  status?: InputMaybe<order_by>;
  statusEnum?: InputMaybe<TicketStatus_order_by>;
  ticketId?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  typeEnum?: InputMaybe<TicketType_order_by>;
  unit?: InputMaybe<Unit_order_by>;
  unitId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** select columns of table "Ticket" */
export enum Ticket_select_column {
  /** column name */
  assignedToUserId = 'assignedToUserId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdByUserId = 'createdByUserId',
  /** column name */
  propertyId = 'propertyId',
  /** column name */
  smartLockId = 'smartLockId',
  /** column name */
  solvedAt = 'solvedAt',
  /** column name */
  solvedByUserId = 'solvedByUserId',
  /** column name */
  status = 'status',
  /** column name */
  ticketId = 'ticketId',
  /** column name */
  type = 'type',
  /** column name */
  unitId = 'unitId',
  /** column name */
  updatedAt = 'updatedAt'
}

/** Streaming cursor of the table "Ticket" */
export type Ticket_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Ticket_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ticket_stream_cursor_value_input = {
  assignedToUserId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  smartLockId?: InputMaybe<Scalars['uuid']['input']>;
  solvedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  solvedByUserId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<TicketStatus_enum>;
  ticketId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<TicketType_enum>;
  unitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** placeholder for update columns of table "Ticket" (current role has no relevant permissions) */
export enum Ticket_update_column {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "Timezone" */
export type Timezone = {
  /** An array relationship */
  properties: Array<Property>;
  /** An aggregate relationship */
  properties_aggregate: Property_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "Timezone" */
export type Timezone_propertiesArgs = {
  distinct_on?: InputMaybe<Array<Property_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_order_by>>;
  where?: InputMaybe<Property_bool_exp>;
};


/** columns and relationships of "Timezone" */
export type Timezone_properties_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_order_by>>;
  where?: InputMaybe<Property_bool_exp>;
};

/** aggregated selection of "Timezone" */
export type Timezone_aggregate = {
  aggregate?: Maybe<Timezone_aggregate_fields>;
  nodes: Array<Timezone>;
};

/** aggregate fields of "Timezone" */
export type Timezone_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Timezone_max_fields>;
  min?: Maybe<Timezone_min_fields>;
};


/** aggregate fields of "Timezone" */
export type Timezone_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<Timezone_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "Timezone". All fields are combined with a logical 'AND'. */
export type Timezone_bool_exp = {
  _and?: InputMaybe<Array<Timezone_bool_exp>>;
  _not?: InputMaybe<Timezone_bool_exp>;
  _or?: InputMaybe<Array<Timezone_bool_exp>>;
  properties?: InputMaybe<Property_bool_exp>;
  properties_aggregate?: InputMaybe<Property_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

/** aggregate max on columns */
export type Timezone_max_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Timezone_min_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "Timezone". */
export type Timezone_order_by = {
  properties_aggregate?: InputMaybe<Property_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "Timezone" */
export enum Timezone_select_column {
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "Timezone" */
export type Timezone_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Timezone_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Timezone_stream_cursor_value_input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "Unit" */
export type Unit = {
  building?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  occupantCount?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  property: Property;
  propertyId: Scalars['uuid']['output'];
  /** An array relationship */
  smartLocks: Array<SmartLock>;
  /** An aggregate relationship */
  smartLocks_aggregate: SmartLock_aggregate;
  sourceId?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  tickets: Array<Ticket>;
  /** An aggregate relationship */
  tickets_aggregate: Ticket_aggregate;
  type?: Maybe<UnitType_enum>;
  /** An object relationship */
  typeEnum?: Maybe<UnitType>;
  /** An object relationship */
  unitGroup?: Maybe<UnitGroup>;
  unitGroupId?: Maybe<Scalars['uuid']['output']>;
  unitId: Scalars['uuid']['output'];
  unitNumber: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userRolePermissions: Array<UserRolePermission>;
  /** An aggregate relationship */
  userRolePermissions_aggregate: UserRolePermission_aggregate;
  /** An array relationship */
  userRoles: Array<UserRole>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRole_aggregate;
  virtualDirectoryEnabled: Scalars['Boolean']['output'];
};


/** columns and relationships of "Unit" */
export type Unit_smartLocksArgs = {
  distinct_on?: InputMaybe<Array<SmartLock_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLock_order_by>>;
  where?: InputMaybe<SmartLock_bool_exp>;
};


/** columns and relationships of "Unit" */
export type Unit_smartLocks_aggregateArgs = {
  distinct_on?: InputMaybe<Array<SmartLock_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLock_order_by>>;
  where?: InputMaybe<SmartLock_bool_exp>;
};


/** columns and relationships of "Unit" */
export type Unit_ticketsArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


/** columns and relationships of "Unit" */
export type Unit_tickets_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


/** columns and relationships of "Unit" */
export type Unit_userRolePermissionsArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


/** columns and relationships of "Unit" */
export type Unit_userRolePermissions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


/** columns and relationships of "Unit" */
export type Unit_userRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "Unit" */
export type Unit_userRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};

/** columns and relationships of "UnitGroup" */
export type UnitGroup = {
  /** An array relationship */
  accessPointRoles: Array<AccessPointRole>;
  /** An aggregate relationship */
  accessPointRoles_aggregate: AccessPointRole_aggregate;
  /** An array relationship */
  childUnitGroups: Array<UnitGroup>;
  /** An aggregate relationship */
  childUnitGroups_aggregate: UnitGroup_aggregate;
  createdAt: Scalars['timestamptz']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  parentUnitGroup?: Maybe<UnitGroup>;
  parentUnitGroupId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  property: Property;
  propertyId: Scalars['uuid']['output'];
  /** Allow fetching property name for cross-property access */
  propertyName?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  unitGroupId: Scalars['uuid']['output'];
  /** An array relationship */
  units: Array<Unit>;
  /** An aggregate relationship */
  units_aggregate: Unit_aggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "UnitGroup" */
export type UnitGroup_accessPointRolesArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRole_order_by>>;
  where?: InputMaybe<AccessPointRole_bool_exp>;
};


/** columns and relationships of "UnitGroup" */
export type UnitGroup_accessPointRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRole_order_by>>;
  where?: InputMaybe<AccessPointRole_bool_exp>;
};


/** columns and relationships of "UnitGroup" */
export type UnitGroup_childUnitGroupsArgs = {
  distinct_on?: InputMaybe<Array<UnitGroup_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnitGroup_order_by>>;
  where?: InputMaybe<UnitGroup_bool_exp>;
};


/** columns and relationships of "UnitGroup" */
export type UnitGroup_childUnitGroups_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UnitGroup_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnitGroup_order_by>>;
  where?: InputMaybe<UnitGroup_bool_exp>;
};


/** columns and relationships of "UnitGroup" */
export type UnitGroup_unitsArgs = {
  distinct_on?: InputMaybe<Array<Unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_order_by>>;
  where?: InputMaybe<Unit_bool_exp>;
};


/** columns and relationships of "UnitGroup" */
export type UnitGroup_units_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_order_by>>;
  where?: InputMaybe<Unit_bool_exp>;
};

/** aggregated selection of "UnitGroup" */
export type UnitGroup_aggregate = {
  aggregate?: Maybe<UnitGroup_aggregate_fields>;
  nodes: Array<UnitGroup>;
};

export type UnitGroup_aggregate_bool_exp = {
  count?: InputMaybe<UnitGroup_aggregate_bool_exp_count>;
};

export type UnitGroup_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<UnitGroup_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UnitGroup_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "UnitGroup" */
export type UnitGroup_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<UnitGroup_max_fields>;
  min?: Maybe<UnitGroup_min_fields>;
};


/** aggregate fields of "UnitGroup" */
export type UnitGroup_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<UnitGroup_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "UnitGroup" */
export type UnitGroup_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<UnitGroup_max_order_by>;
  min?: InputMaybe<UnitGroup_min_order_by>;
};

/** input type for inserting array relation for remote table "UnitGroup" */
export type UnitGroup_arr_rel_insert_input = {
  data: Array<UnitGroup_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UnitGroup_on_conflict>;
};

/** Boolean expression to filter rows from the table "UnitGroup". All fields are combined with a logical 'AND'. */
export type UnitGroup_bool_exp = {
  _and?: InputMaybe<Array<UnitGroup_bool_exp>>;
  _not?: InputMaybe<UnitGroup_bool_exp>;
  _or?: InputMaybe<Array<UnitGroup_bool_exp>>;
  accessPointRoles?: InputMaybe<AccessPointRole_bool_exp>;
  accessPointRoles_aggregate?: InputMaybe<AccessPointRole_aggregate_bool_exp>;
  childUnitGroups?: InputMaybe<UnitGroup_bool_exp>;
  childUnitGroups_aggregate?: InputMaybe<UnitGroup_aggregate_bool_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  parentUnitGroup?: InputMaybe<UnitGroup_bool_exp>;
  parentUnitGroupId?: InputMaybe<uuid_comparison_exp>;
  property?: InputMaybe<Property_bool_exp>;
  propertyId?: InputMaybe<uuid_comparison_exp>;
  propertyName?: InputMaybe<String_comparison_exp>;
  sourceId?: InputMaybe<String_comparison_exp>;
  unitGroupId?: InputMaybe<uuid_comparison_exp>;
  units?: InputMaybe<Unit_bool_exp>;
  units_aggregate?: InputMaybe<Unit_aggregate_bool_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "UnitGroup" */
export enum UnitGroup_constraint {
  /** unique or primary key constraint on columns "unitGroupId" */
  UnitGroup_pkey = 'UnitGroup_pkey',
  /** unique or primary key constraint on columns "name", "propertyId" */
  UnitGroup_propertyId_name_key = 'UnitGroup_propertyId_name_key',
  /** unique or primary key constraint on columns "name", "propertyId", "parentUnitGroupId" */
  UnitGroup_propertyId_parentUnitGroupId_name_key = 'UnitGroup_propertyId_parentUnitGroupId_name_key',
  /** unique or primary key constraint on columns "sourceId" */
  UnitGroup_sourceId_key = 'UnitGroup_sourceId_key'
}

/** input type for inserting data into table "UnitGroup" */
export type UnitGroup_insert_input = {
  accessPointRoles?: InputMaybe<AccessPointRole_arr_rel_insert_input>;
  childUnitGroups?: InputMaybe<UnitGroup_arr_rel_insert_input>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentUnitGroup?: InputMaybe<UnitGroup_obj_rel_insert_input>;
  parentUnitGroupId?: InputMaybe<Scalars['uuid']['input']>;
  property?: InputMaybe<Property_obj_rel_insert_input>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  units?: InputMaybe<Unit_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type UnitGroup_max_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentUnitGroupId?: Maybe<Scalars['uuid']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  unitGroupId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "UnitGroup" */
export type UnitGroup_max_order_by = {
  createdAt?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  parentUnitGroupId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
  unitGroupId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type UnitGroup_min_fields = {
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentUnitGroupId?: Maybe<Scalars['uuid']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  unitGroupId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "UnitGroup" */
export type UnitGroup_min_order_by = {
  createdAt?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  parentUnitGroupId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
  unitGroupId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** response of any mutation on the table "UnitGroup" */
export type UnitGroup_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UnitGroup>;
};

/** input type for inserting object relation for remote table "UnitGroup" */
export type UnitGroup_obj_rel_insert_input = {
  data: UnitGroup_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<UnitGroup_on_conflict>;
};

/** on_conflict condition type for table "UnitGroup" */
export type UnitGroup_on_conflict = {
  constraint: UnitGroup_constraint;
  update_columns?: Array<UnitGroup_update_column>;
  where?: InputMaybe<UnitGroup_bool_exp>;
};

/** Ordering options when selecting data from "UnitGroup". */
export type UnitGroup_order_by = {
  accessPointRoles_aggregate?: InputMaybe<AccessPointRole_aggregate_order_by>;
  childUnitGroups_aggregate?: InputMaybe<UnitGroup_aggregate_order_by>;
  createdAt?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  parentUnitGroup?: InputMaybe<UnitGroup_order_by>;
  parentUnitGroupId?: InputMaybe<order_by>;
  property?: InputMaybe<Property_order_by>;
  propertyId?: InputMaybe<order_by>;
  propertyName?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
  unitGroupId?: InputMaybe<order_by>;
  units_aggregate?: InputMaybe<Unit_aggregate_order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** primary key columns input for table: UnitGroup */
export type UnitGroup_pk_columns_input = {
  unitGroupId: Scalars['uuid']['input'];
};

/** select columns of table "UnitGroup" */
export enum UnitGroup_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  name = 'name',
  /** column name */
  parentUnitGroupId = 'parentUnitGroupId',
  /** column name */
  propertyId = 'propertyId',
  /** column name */
  sourceId = 'sourceId',
  /** column name */
  unitGroupId = 'unitGroupId',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "UnitGroup" */
export type UnitGroup_set_input = {
  name?: InputMaybe<Scalars['String']['input']>;
  parentUnitGroupId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "UnitGroup" */
export type UnitGroup_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: UnitGroup_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UnitGroup_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentUnitGroupId?: InputMaybe<Scalars['uuid']['input']>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  unitGroupId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "UnitGroup" */
export enum UnitGroup_update_column {
  /** column name */
  name = 'name',
  /** column name */
  parentUnitGroupId = 'parentUnitGroupId'
}

export type UnitGroup_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UnitGroup_set_input>;
  /** filter the rows which have to be updated */
  where: UnitGroup_bool_exp;
};

/** columns and relationships of "UnitType" */
export type UnitType = {
  /** An array relationship */
  units: Array<Unit>;
  /** An aggregate relationship */
  units_aggregate: Unit_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "UnitType" */
export type UnitType_unitsArgs = {
  distinct_on?: InputMaybe<Array<Unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_order_by>>;
  where?: InputMaybe<Unit_bool_exp>;
};


/** columns and relationships of "UnitType" */
export type UnitType_units_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_order_by>>;
  where?: InputMaybe<Unit_bool_exp>;
};

/** aggregated selection of "UnitType" */
export type UnitType_aggregate = {
  aggregate?: Maybe<UnitType_aggregate_fields>;
  nodes: Array<UnitType>;
};

/** aggregate fields of "UnitType" */
export type UnitType_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<UnitType_max_fields>;
  min?: Maybe<UnitType_min_fields>;
};


/** aggregate fields of "UnitType" */
export type UnitType_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<UnitType_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "UnitType". All fields are combined with a logical 'AND'. */
export type UnitType_bool_exp = {
  _and?: InputMaybe<Array<UnitType_bool_exp>>;
  _not?: InputMaybe<UnitType_bool_exp>;
  _or?: InputMaybe<Array<UnitType_bool_exp>>;
  units?: InputMaybe<Unit_bool_exp>;
  units_aggregate?: InputMaybe<Unit_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum UnitType_enum {
  RESIDENTIAL = 'RESIDENTIAL',
  STAFF = 'STAFF'
}

/** Boolean expression to compare columns of type "UnitType_enum". All fields are combined with logical 'AND'. */
export type UnitType_enum_comparison_exp = {
  _eq?: InputMaybe<UnitType_enum>;
  _in?: InputMaybe<Array<UnitType_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<UnitType_enum>;
  _nin?: InputMaybe<Array<UnitType_enum>>;
};

/** aggregate max on columns */
export type UnitType_max_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UnitType_min_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "UnitType". */
export type UnitType_order_by = {
  units_aggregate?: InputMaybe<Unit_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "UnitType" */
export enum UnitType_select_column {
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "UnitType" */
export type UnitType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: UnitType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UnitType_stream_cursor_value_input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Unit" */
export type Unit_aggregate = {
  aggregate?: Maybe<Unit_aggregate_fields>;
  nodes: Array<Unit>;
};

export type Unit_aggregate_bool_exp = {
  bool_and?: InputMaybe<Unit_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<Unit_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<Unit_aggregate_bool_exp_count>;
};

export type Unit_aggregate_bool_exp_bool_and = {
  arguments: Unit_select_column_Unit_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Unit_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type Unit_aggregate_bool_exp_bool_or = {
  arguments: Unit_select_column_Unit_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Unit_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type Unit_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<Unit_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Unit_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "Unit" */
export type Unit_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Unit_max_fields>;
  min?: Maybe<Unit_min_fields>;
};


/** aggregate fields of "Unit" */
export type Unit_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<Unit_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Unit" */
export type Unit_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<Unit_max_order_by>;
  min?: InputMaybe<Unit_min_order_by>;
};

/** input type for inserting array relation for remote table "Unit" */
export type Unit_arr_rel_insert_input = {
  data: Array<Unit_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Unit_on_conflict>;
};

/** Boolean expression to filter rows from the table "Unit". All fields are combined with a logical 'AND'. */
export type Unit_bool_exp = {
  _and?: InputMaybe<Array<Unit_bool_exp>>;
  _not?: InputMaybe<Unit_bool_exp>;
  _or?: InputMaybe<Array<Unit_bool_exp>>;
  building?: InputMaybe<String_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  createdByUser?: InputMaybe<User_bool_exp>;
  createdByUserId?: InputMaybe<uuid_comparison_exp>;
  occupantCount?: InputMaybe<bigint_comparison_exp>;
  property?: InputMaybe<Property_bool_exp>;
  propertyId?: InputMaybe<uuid_comparison_exp>;
  smartLocks?: InputMaybe<SmartLock_bool_exp>;
  smartLocks_aggregate?: InputMaybe<SmartLock_aggregate_bool_exp>;
  sourceId?: InputMaybe<String_comparison_exp>;
  tickets?: InputMaybe<Ticket_bool_exp>;
  tickets_aggregate?: InputMaybe<Ticket_aggregate_bool_exp>;
  type?: InputMaybe<UnitType_enum_comparison_exp>;
  typeEnum?: InputMaybe<UnitType_bool_exp>;
  unitGroup?: InputMaybe<UnitGroup_bool_exp>;
  unitGroupId?: InputMaybe<uuid_comparison_exp>;
  unitId?: InputMaybe<uuid_comparison_exp>;
  unitNumber?: InputMaybe<String_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  userRolePermissions?: InputMaybe<UserRolePermission_bool_exp>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_bool_exp>;
  userRoles?: InputMaybe<UserRole_bool_exp>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
  virtualDirectoryEnabled?: InputMaybe<Boolean_comparison_exp>;
};

/** unique or primary key constraints on table "Unit" */
export enum Unit_constraint {
  /** unique or primary key constraint on columns "unitId" */
  Unit_pkey = 'Unit_pkey',
  /** unique or primary key constraint on columns "unitNumber", "building", "propertyId" */
  Unit_propertyId_unitNumber_building_key = 'Unit_propertyId_unitNumber_building_key',
  /** unique or primary key constraint on columns "unitNumber", "propertyId" */
  Unit_propertyId_unitNumber_key = 'Unit_propertyId_unitNumber_key',
  /** unique or primary key constraint on columns "sourceId" */
  Unit_sourceId_key = 'Unit_sourceId_key'
}

/** input type for inserting data into table "Unit" */
export type Unit_insert_input = {
  building?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Property_obj_rel_insert_input>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  tickets?: InputMaybe<Ticket_arr_rel_insert_input>;
  type?: InputMaybe<UnitType_enum>;
  unitGroup?: InputMaybe<UnitGroup_obj_rel_insert_input>;
  unitGroupId?: InputMaybe<Scalars['uuid']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Unit_max_fields = {
  building?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  unitGroupId?: Maybe<Scalars['uuid']['output']>;
  unitId?: Maybe<Scalars['uuid']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Unit" */
export type Unit_max_order_by = {
  building?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUserId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
  unitGroupId?: InputMaybe<order_by>;
  unitId?: InputMaybe<order_by>;
  unitNumber?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type Unit_min_fields = {
  building?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  propertyId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  unitGroupId?: Maybe<Scalars['uuid']['output']>;
  unitId?: Maybe<Scalars['uuid']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Unit" */
export type Unit_min_order_by = {
  building?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUserId?: InputMaybe<order_by>;
  propertyId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
  unitGroupId?: InputMaybe<order_by>;
  unitId?: InputMaybe<order_by>;
  unitNumber?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** response of any mutation on the table "Unit" */
export type Unit_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Unit>;
};

/** input type for inserting object relation for remote table "Unit" */
export type Unit_obj_rel_insert_input = {
  data: Unit_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unit_on_conflict>;
};

/** on_conflict condition type for table "Unit" */
export type Unit_on_conflict = {
  constraint: Unit_constraint;
  update_columns?: Array<Unit_update_column>;
  where?: InputMaybe<Unit_bool_exp>;
};

/** Ordering options when selecting data from "Unit". */
export type Unit_order_by = {
  building?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUser?: InputMaybe<User_order_by>;
  createdByUserId?: InputMaybe<order_by>;
  occupantCount?: InputMaybe<order_by>;
  property?: InputMaybe<Property_order_by>;
  propertyId?: InputMaybe<order_by>;
  smartLocks_aggregate?: InputMaybe<SmartLock_aggregate_order_by>;
  sourceId?: InputMaybe<order_by>;
  tickets_aggregate?: InputMaybe<Ticket_aggregate_order_by>;
  type?: InputMaybe<order_by>;
  typeEnum?: InputMaybe<UnitType_order_by>;
  unitGroup?: InputMaybe<UnitGroup_order_by>;
  unitGroupId?: InputMaybe<order_by>;
  unitId?: InputMaybe<order_by>;
  unitNumber?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_order_by>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
  virtualDirectoryEnabled?: InputMaybe<order_by>;
};

/** primary key columns input for table: Unit */
export type Unit_pk_columns_input = {
  unitId: Scalars['uuid']['input'];
};

/** select columns of table "Unit" */
export enum Unit_select_column {
  /** column name */
  building = 'building',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdByUserId = 'createdByUserId',
  /** column name */
  propertyId = 'propertyId',
  /** column name */
  sourceId = 'sourceId',
  /** column name */
  type = 'type',
  /** column name */
  unitGroupId = 'unitGroupId',
  /** column name */
  unitId = 'unitId',
  /** column name */
  unitNumber = 'unitNumber',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  virtualDirectoryEnabled = 'virtualDirectoryEnabled'
}

/** select "Unit_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Unit" */
export enum Unit_select_column_Unit_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  virtualDirectoryEnabled = 'virtualDirectoryEnabled'
}

/** select "Unit_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Unit" */
export enum Unit_select_column_Unit_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  virtualDirectoryEnabled = 'virtualDirectoryEnabled'
}

/** input type for updating data in table "Unit" */
export type Unit_set_input = {
  building?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<UnitType_enum>;
  unitGroupId?: InputMaybe<Scalars['uuid']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "Unit" */
export type Unit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: Unit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unit_stream_cursor_value_input = {
  building?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  propertyId?: InputMaybe<Scalars['uuid']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<UnitType_enum>;
  unitGroupId?: InputMaybe<Scalars['uuid']['input']>;
  unitId?: InputMaybe<Scalars['uuid']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  virtualDirectoryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "Unit" */
export enum Unit_update_column {
  /** column name */
  building = 'building',
  /** column name */
  type = 'type',
  /** column name */
  unitGroupId = 'unitGroupId',
  /** column name */
  unitNumber = 'unitNumber'
}

export type Unit_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unit_set_input>;
  /** filter the rows which have to be updated */
  where: Unit_bool_exp;
};

/** columns and relationships of "UnlockMethod" */
export type UnlockMethod = {
  label: Scalars['String']['output'];
  /** An array relationship */
  relayLogs: Array<RelayLog>;
  /** An aggregate relationship */
  relayLogs_aggregate: RelayLog_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "UnlockMethod" */
export type UnlockMethod_relayLogsArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


/** columns and relationships of "UnlockMethod" */
export type UnlockMethod_relayLogs_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};

/** aggregated selection of "UnlockMethod" */
export type UnlockMethod_aggregate = {
  aggregate?: Maybe<UnlockMethod_aggregate_fields>;
  nodes: Array<UnlockMethod>;
};

/** aggregate fields of "UnlockMethod" */
export type UnlockMethod_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<UnlockMethod_max_fields>;
  min?: Maybe<UnlockMethod_min_fields>;
};


/** aggregate fields of "UnlockMethod" */
export type UnlockMethod_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<UnlockMethod_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "UnlockMethod". All fields are combined with a logical 'AND'. */
export type UnlockMethod_bool_exp = {
  _and?: InputMaybe<Array<UnlockMethod_bool_exp>>;
  _not?: InputMaybe<UnlockMethod_bool_exp>;
  _or?: InputMaybe<Array<UnlockMethod_bool_exp>>;
  label?: InputMaybe<String_comparison_exp>;
  relayLogs?: InputMaybe<RelayLog_bool_exp>;
  relayLogs_aggregate?: InputMaybe<RelayLog_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum UnlockMethod_enum {
  /** Access App - Favorites */
  ACCESS_APP_FAVORITES = 'ACCESS_APP_FAVORITES',
  /** Access App - Nearby */
  ACCESS_APP_NEARBY = 'ACCESS_APP_NEARBY',
  /** Access App - Search */
  ACCESS_APP_SEARCH = 'ACCESS_APP_SEARCH',
  /** Access Web App */
  ACCESS_WEB = 'ACCESS_WEB',
  /** Admin Panel */
  ADMIN_PANEL = 'ADMIN_PANEL',
  /** Credential - Mobile */
  CREDENTIAL_MOBILE = 'CREDENTIAL_MOBILE',
  /** Credential - Physical */
  CREDENTIAL_PHYSICAL = 'CREDENTIAL_PHYSICAL',
  /** Credential - Unknown */
  CREDENTIAL_UNKNOWN = 'CREDENTIAL_UNKNOWN',
  /** Input Device */
  INPUT_DEVICE = 'INPUT_DEVICE',
  /** NFC */
  NFC = 'NFC',
  /** Pin Code */
  PIN_CODE = 'PIN_CODE',
  /** QR Code */
  QR_CODE = 'QR_CODE',
  /** Siri Shortcut */
  SIRI_SHORTCUT = 'SIRI_SHORTCUT',
  /** Smart Building Portal */
  SMART_BUILDING_PORTAL = 'SMART_BUILDING_PORTAL',
  /** Spaceship Mode */
  SPACESHIP_MODE = 'SPACESHIP_MODE',
  /** Widget - Favorites */
  WIDGET_FAVORITES = 'WIDGET_FAVORITES',
  /** Widget - Nearby */
  WIDGET_NEARBY = 'WIDGET_NEARBY'
}

/** Boolean expression to compare columns of type "UnlockMethod_enum". All fields are combined with logical 'AND'. */
export type UnlockMethod_enum_comparison_exp = {
  _eq?: InputMaybe<UnlockMethod_enum>;
  _in?: InputMaybe<Array<UnlockMethod_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<UnlockMethod_enum>;
  _nin?: InputMaybe<Array<UnlockMethod_enum>>;
};

/** aggregate max on columns */
export type UnlockMethod_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UnlockMethod_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "UnlockMethod". */
export type UnlockMethod_order_by = {
  label?: InputMaybe<order_by>;
  relayLogs_aggregate?: InputMaybe<RelayLog_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "UnlockMethod" */
export enum UnlockMethod_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "UnlockMethod" */
export type UnlockMethod_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: UnlockMethod_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UnlockMethod_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "UnlockResult" */
export type UnlockResult = {
  label: Scalars['String']['output'];
  /** An array relationship */
  relayLogs: Array<RelayLog>;
  /** An aggregate relationship */
  relayLogs_aggregate: RelayLog_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "UnlockResult" */
export type UnlockResult_relayLogsArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


/** columns and relationships of "UnlockResult" */
export type UnlockResult_relayLogs_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};

/** aggregated selection of "UnlockResult" */
export type UnlockResult_aggregate = {
  aggregate?: Maybe<UnlockResult_aggregate_fields>;
  nodes: Array<UnlockResult>;
};

/** aggregate fields of "UnlockResult" */
export type UnlockResult_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<UnlockResult_max_fields>;
  min?: Maybe<UnlockResult_min_fields>;
};


/** aggregate fields of "UnlockResult" */
export type UnlockResult_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<UnlockResult_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "UnlockResult". All fields are combined with a logical 'AND'. */
export type UnlockResult_bool_exp = {
  _and?: InputMaybe<Array<UnlockResult_bool_exp>>;
  _not?: InputMaybe<UnlockResult_bool_exp>;
  _or?: InputMaybe<Array<UnlockResult_bool_exp>>;
  label?: InputMaybe<String_comparison_exp>;
  relayLogs?: InputMaybe<RelayLog_bool_exp>;
  relayLogs_aggregate?: InputMaybe<RelayLog_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum UnlockResult_enum {
  /** Access Denied */
  ACCESS_DENIED = 'ACCESS_DENIED',
  /** Access Granted */
  ACCESS_GRANTED = 'ACCESS_GRANTED'
}

/** Boolean expression to compare columns of type "UnlockResult_enum". All fields are combined with logical 'AND'. */
export type UnlockResult_enum_comparison_exp = {
  _eq?: InputMaybe<UnlockResult_enum>;
  _in?: InputMaybe<Array<UnlockResult_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<UnlockResult_enum>;
  _nin?: InputMaybe<Array<UnlockResult_enum>>;
};

/** aggregate max on columns */
export type UnlockResult_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UnlockResult_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "UnlockResult". */
export type UnlockResult_order_by = {
  label?: InputMaybe<order_by>;
  relayLogs_aggregate?: InputMaybe<RelayLog_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "UnlockResult" */
export enum UnlockResult_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "UnlockResult" */
export type UnlockResult_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: UnlockResult_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UnlockResult_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "User" */
export type User = {
  acceptedEulaAt?: Maybe<Scalars['timestamptz']['output']>;
  accountStatus: AccountStatus_enum;
  /** An object relationship */
  accountStatusEnum: AccountStatus;
  /** An array relationship */
  archivedAccessPoints: Array<AccessPoint>;
  /** An aggregate relationship */
  archivedAccessPoints_aggregate: AccessPoint_aggregate;
  /** An array relationship */
  assignedCredentials: Array<Credential>;
  /** An aggregate relationship */
  assignedCredentials_aggregate: Credential_aggregate;
  /** An array relationship */
  assignedPinCodes: Array<PinCode>;
  /** An aggregate relationship */
  assignedPinCodes_aggregate: PinCode_aggregate;
  /** An array relationship */
  assignedTickets: Array<Ticket>;
  /** An aggregate relationship */
  assignedTickets_aggregate: Ticket_aggregate;
  /** An array relationship */
  assignedUserRoles: Array<UserRole>;
  /** An aggregate relationship */
  assignedUserRoles_aggregate: UserRole_aggregate;
  augustSubUserId?: Maybe<Scalars['uuid']['output']>;
  augustUserId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  createdAccessPoints: Array<AccessPoint>;
  /** An aggregate relationship */
  createdAccessPoints_aggregate: AccessPoint_aggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  createdPinCodes: Array<PinCode>;
  /** An aggregate relationship */
  createdPinCodes_aggregate: PinCode_aggregate;
  /** An array relationship */
  createdSmartLocks: Array<SmartLock>;
  /** An aggregate relationship */
  createdSmartLocks_aggregate: SmartLock_aggregate;
  /** An array relationship */
  createdTickets: Array<Ticket>;
  /** An aggregate relationship */
  createdTickets_aggregate: Ticket_aggregate;
  /** An array relationship */
  createdUnits: Array<Unit>;
  /** An aggregate relationship */
  createdUnits_aggregate: Unit_aggregate;
  /** An array relationship */
  createdUserRoles: Array<UserRole>;
  /** An aggregate relationship */
  createdUserRoles_aggregate: UserRole_aggregate;
  email?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  favorites: Array<Favorite>;
  /** An aggregate relationship */
  favorites_aggregate: Favorite_aggregate;
  firstName?: Maybe<Scalars['String']['output']>;
  hasAugustPassword: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastReadAnnouncementsAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  password?: Maybe<PasswordRedacted>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  provisionedCredentials: Array<Credential>;
  /** An aggregate relationship */
  provisionedCredentials_aggregate: Credential_aggregate;
  /** An array relationship */
  relayLogs: Array<RelayLog>;
  /** An aggregate relationship */
  relayLogs_aggregate: RelayLog_aggregate;
  /** An array relationship */
  revokedUserRoles: Array<UserRole>;
  /** An aggregate relationship */
  revokedUserRoles_aggregate: UserRole_aggregate;
  /** An array relationship */
  sessions: Array<Session>;
  /** An array relationship */
  sessionsRevokedByUser: Array<Session>;
  /** An aggregate relationship */
  sessionsRevokedByUser_aggregate: Session_aggregate;
  /** An aggregate relationship */
  sessions_aggregate: Session_aggregate;
  /** An array relationship */
  smartLockLogsByActingUser: Array<SmartLockLog>;
  /** An aggregate relationship */
  smartLockLogsByActingUser_aggregate: SmartLockLog_aggregate;
  /** An array relationship */
  smartLockLogsByAffectedUser: Array<SmartLockLog>;
  /** An aggregate relationship */
  smartLockLogsByAffectedUser_aggregate: SmartLockLog_aggregate;
  /** An array relationship */
  solvedTickets: Array<Ticket>;
  /** An aggregate relationship */
  solvedTickets_aggregate: Ticket_aggregate;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  updatedPinCodes: Array<PinCode>;
  /** An aggregate relationship */
  updatedPinCodes_aggregate: PinCode_aggregate;
  /** An array relationship */
  uploadedImages: Array<Image>;
  /** An aggregate relationship */
  uploadedImages_aggregate: Image_aggregate;
  userId: Scalars['uuid']['output'];
  /** An array relationship */
  userRolePermissions: Array<UserRolePermission>;
  /** An aggregate relationship */
  userRolePermissions_aggregate: UserRolePermission_aggregate;
  virtualDirectoryEnabled: Scalars['Boolean']['output'];
};


/** columns and relationships of "User" */
export type User_archivedAccessPointsArgs = {
  distinct_on?: InputMaybe<Array<AccessPoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPoint_order_by>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};


/** columns and relationships of "User" */
export type User_archivedAccessPoints_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPoint_order_by>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};


/** columns and relationships of "User" */
export type User_assignedCredentialsArgs = {
  distinct_on?: InputMaybe<Array<Credential_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credential_order_by>>;
  where?: InputMaybe<Credential_bool_exp>;
};


/** columns and relationships of "User" */
export type User_assignedCredentials_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Credential_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credential_order_by>>;
  where?: InputMaybe<Credential_bool_exp>;
};


/** columns and relationships of "User" */
export type User_assignedPinCodesArgs = {
  distinct_on?: InputMaybe<Array<PinCode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCode_order_by>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


/** columns and relationships of "User" */
export type User_assignedPinCodes_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PinCode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCode_order_by>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


/** columns and relationships of "User" */
export type User_assignedTicketsArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


/** columns and relationships of "User" */
export type User_assignedTickets_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


/** columns and relationships of "User" */
export type User_assignedUserRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "User" */
export type User_assignedUserRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "User" */
export type User_createdAccessPointsArgs = {
  distinct_on?: InputMaybe<Array<AccessPoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPoint_order_by>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};


/** columns and relationships of "User" */
export type User_createdAccessPoints_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPoint_order_by>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};


/** columns and relationships of "User" */
export type User_createdPinCodesArgs = {
  distinct_on?: InputMaybe<Array<PinCode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCode_order_by>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


/** columns and relationships of "User" */
export type User_createdPinCodes_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PinCode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCode_order_by>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


/** columns and relationships of "User" */
export type User_createdSmartLocksArgs = {
  distinct_on?: InputMaybe<Array<SmartLock_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLock_order_by>>;
  where?: InputMaybe<SmartLock_bool_exp>;
};


/** columns and relationships of "User" */
export type User_createdSmartLocks_aggregateArgs = {
  distinct_on?: InputMaybe<Array<SmartLock_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLock_order_by>>;
  where?: InputMaybe<SmartLock_bool_exp>;
};


/** columns and relationships of "User" */
export type User_createdTicketsArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


/** columns and relationships of "User" */
export type User_createdTickets_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


/** columns and relationships of "User" */
export type User_createdUnitsArgs = {
  distinct_on?: InputMaybe<Array<Unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_order_by>>;
  where?: InputMaybe<Unit_bool_exp>;
};


/** columns and relationships of "User" */
export type User_createdUnits_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_order_by>>;
  where?: InputMaybe<Unit_bool_exp>;
};


/** columns and relationships of "User" */
export type User_createdUserRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "User" */
export type User_createdUserRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "User" */
export type User_favoritesArgs = {
  distinct_on?: InputMaybe<Array<Favorite_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorite_order_by>>;
  where?: InputMaybe<Favorite_bool_exp>;
};


/** columns and relationships of "User" */
export type User_favorites_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Favorite_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorite_order_by>>;
  where?: InputMaybe<Favorite_bool_exp>;
};


/** columns and relationships of "User" */
export type User_provisionedCredentialsArgs = {
  distinct_on?: InputMaybe<Array<Credential_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credential_order_by>>;
  where?: InputMaybe<Credential_bool_exp>;
};


/** columns and relationships of "User" */
export type User_provisionedCredentials_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Credential_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credential_order_by>>;
  where?: InputMaybe<Credential_bool_exp>;
};


/** columns and relationships of "User" */
export type User_relayLogsArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


/** columns and relationships of "User" */
export type User_relayLogs_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


/** columns and relationships of "User" */
export type User_revokedUserRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "User" */
export type User_revokedUserRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "User" */
export type User_sessionsArgs = {
  distinct_on?: InputMaybe<Array<Session_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_order_by>>;
  where?: InputMaybe<Session_bool_exp>;
};


/** columns and relationships of "User" */
export type User_sessionsRevokedByUserArgs = {
  distinct_on?: InputMaybe<Array<Session_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_order_by>>;
  where?: InputMaybe<Session_bool_exp>;
};


/** columns and relationships of "User" */
export type User_sessionsRevokedByUser_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Session_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_order_by>>;
  where?: InputMaybe<Session_bool_exp>;
};


/** columns and relationships of "User" */
export type User_sessions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Session_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_order_by>>;
  where?: InputMaybe<Session_bool_exp>;
};


/** columns and relationships of "User" */
export type User_smartLockLogsByActingUserArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLog_order_by>>;
  where?: InputMaybe<SmartLockLog_bool_exp>;
};


/** columns and relationships of "User" */
export type User_smartLockLogsByActingUser_aggregateArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLog_order_by>>;
  where?: InputMaybe<SmartLockLog_bool_exp>;
};


/** columns and relationships of "User" */
export type User_smartLockLogsByAffectedUserArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLog_order_by>>;
  where?: InputMaybe<SmartLockLog_bool_exp>;
};


/** columns and relationships of "User" */
export type User_smartLockLogsByAffectedUser_aggregateArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLog_order_by>>;
  where?: InputMaybe<SmartLockLog_bool_exp>;
};


/** columns and relationships of "User" */
export type User_solvedTicketsArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


/** columns and relationships of "User" */
export type User_solvedTickets_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


/** columns and relationships of "User" */
export type User_updatedPinCodesArgs = {
  distinct_on?: InputMaybe<Array<PinCode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCode_order_by>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


/** columns and relationships of "User" */
export type User_updatedPinCodes_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PinCode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCode_order_by>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


/** columns and relationships of "User" */
export type User_uploadedImagesArgs = {
  distinct_on?: InputMaybe<Array<Image_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_order_by>>;
  where?: InputMaybe<Image_bool_exp>;
};


/** columns and relationships of "User" */
export type User_uploadedImages_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Image_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_order_by>>;
  where?: InputMaybe<Image_bool_exp>;
};


/** columns and relationships of "User" */
export type User_userRolePermissionsArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


/** columns and relationships of "User" */
export type User_userRolePermissions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};

/** columns and relationships of "UserRole" */
export type UserRole = {
  activatesAt?: Maybe<Scalars['timestamptz']['output']>;
  assignedToAnonymousUserId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  assignedToUser?: Maybe<User>;
  assignedToUserId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  childUserRoles: Array<UserRole>;
  /** An aggregate relationship */
  childUserRoles_aggregate: UserRole_aggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  grantMethod?: Maybe<UserRoleGrantMethod_enum>;
  /** An object relationship */
  grantMethodEnum?: Maybe<UserRoleGrantMethod>;
  /** An object relationship */
  managedWithinOrganization?: Maybe<Organization>;
  managedWithinOrganizationId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  managedWithinProperty?: Maybe<Property>;
  managedWithinPropertyId?: Maybe<Scalars['uuid']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  parentUserRole?: Maybe<UserRole>;
  parentUserRoleId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  pinCodes: Array<PinCode>;
  /** An aggregate relationship */
  pinCodes_aggregate: PinCode_aggregate;
  reason?: Maybe<UserRoleReason_enum>;
  /** An object relationship */
  reasonEnum?: Maybe<UserRoleReason>;
  revokedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  revokedByUser?: Maybe<User>;
  revokedByUserId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  role: Role;
  roleId: Scalars['uuid']['output'];
  schedule?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  scopedAccessPoint?: Maybe<AccessPoint>;
  scopedAccessPointId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scopedOrganization?: Maybe<Organization>;
  scopedOrganizationId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scopedProperty?: Maybe<Property>;
  scopedPropertyId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scopedSmartLock?: Maybe<SmartLock>;
  scopedSmartLockId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scopedUnit?: Maybe<Unit>;
  scopedUnitId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourcePayload?: Maybe<Scalars['jsonb']['output']>;
  status: UserRoleStatus_enum;
  /** An object relationship */
  statusEnum: UserRoleStatus;
  updatedAt: Scalars['timestamptz']['output'];
  userRoleId: Scalars['uuid']['output'];
  /** An array relationship */
  userRolePermissions: Array<UserRolePermission>;
  /** An aggregate relationship */
  userRolePermissions_aggregate: UserRolePermission_aggregate;
};


/** columns and relationships of "UserRole" */
export type UserRole_childUserRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "UserRole" */
export type UserRole_childUserRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "UserRole" */
export type UserRole_pinCodesArgs = {
  distinct_on?: InputMaybe<Array<PinCode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCode_order_by>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


/** columns and relationships of "UserRole" */
export type UserRole_pinCodes_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PinCode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCode_order_by>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


/** columns and relationships of "UserRole" */
export type UserRole_scheduleArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "UserRole" */
export type UserRole_sourcePayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "UserRole" */
export type UserRole_userRolePermissionsArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


/** columns and relationships of "UserRole" */
export type UserRole_userRolePermissions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};

/** columns and relationships of "UserRoleGrantMethod" */
export type UserRoleGrantMethod = {
  /** An array relationship */
  userRoles: Array<UserRole>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRole_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "UserRoleGrantMethod" */
export type UserRoleGrantMethod_userRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "UserRoleGrantMethod" */
export type UserRoleGrantMethod_userRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};

/** aggregated selection of "UserRoleGrantMethod" */
export type UserRoleGrantMethod_aggregate = {
  aggregate?: Maybe<UserRoleGrantMethod_aggregate_fields>;
  nodes: Array<UserRoleGrantMethod>;
};

/** aggregate fields of "UserRoleGrantMethod" */
export type UserRoleGrantMethod_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<UserRoleGrantMethod_max_fields>;
  min?: Maybe<UserRoleGrantMethod_min_fields>;
};


/** aggregate fields of "UserRoleGrantMethod" */
export type UserRoleGrantMethod_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<UserRoleGrantMethod_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "UserRoleGrantMethod". All fields are combined with a logical 'AND'. */
export type UserRoleGrantMethod_bool_exp = {
  _and?: InputMaybe<Array<UserRoleGrantMethod_bool_exp>>;
  _not?: InputMaybe<UserRoleGrantMethod_bool_exp>;
  _or?: InputMaybe<Array<UserRoleGrantMethod_bool_exp>>;
  userRoles?: InputMaybe<UserRole_bool_exp>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum UserRoleGrantMethod_enum {
  CHIRP_ACCESS_APP = 'CHIRP_ACCESS_APP',
  CHIRP_ADMIN_PANEL = 'CHIRP_ADMIN_PANEL',
  CHIRP_PMS_INTEGRATION = 'CHIRP_PMS_INTEGRATION',
  REALPAGE_SGT = 'REALPAGE_SGT',
  VIRTUAL_DIRECTORY_RESIDENT_APPROVAL = 'VIRTUAL_DIRECTORY_RESIDENT_APPROVAL',
  VIRTUAL_DIRECTORY_STAFF_APPROVAL = 'VIRTUAL_DIRECTORY_STAFF_APPROVAL'
}

/** Boolean expression to compare columns of type "UserRoleGrantMethod_enum". All fields are combined with logical 'AND'. */
export type UserRoleGrantMethod_enum_comparison_exp = {
  _eq?: InputMaybe<UserRoleGrantMethod_enum>;
  _in?: InputMaybe<Array<UserRoleGrantMethod_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<UserRoleGrantMethod_enum>;
  _nin?: InputMaybe<Array<UserRoleGrantMethod_enum>>;
};

/** aggregate max on columns */
export type UserRoleGrantMethod_max_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UserRoleGrantMethod_min_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "UserRoleGrantMethod". */
export type UserRoleGrantMethod_order_by = {
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "UserRoleGrantMethod" */
export enum UserRoleGrantMethod_select_column {
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "UserRoleGrantMethod" */
export type UserRoleGrantMethod_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: UserRoleGrantMethod_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserRoleGrantMethod_stream_cursor_value_input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "UserRolePermission" */
export type UserRolePermission = {
  anonymousUserId?: Maybe<Scalars['uuid']['output']>;
  permissionId?: Maybe<Scalars['uuid']['output']>;
  permissionKey?: Maybe<Scalars['String']['output']>;
  permissionScope?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  role?: Maybe<UserRole>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  roleKey?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  scopedAccessPoint?: Maybe<AccessPoint>;
  scopedAccessPointId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scopedOrganization?: Maybe<Organization>;
  scopedOrganizationId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scopedProperty?: Maybe<Property>;
  scopedPropertyId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  scopedUnit?: Maybe<Unit>;
  scopedUnitId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  userRole?: Maybe<UserRole>;
  userRoleId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "UserRolePermission" */
export type UserRolePermission_aggregate = {
  aggregate?: Maybe<UserRolePermission_aggregate_fields>;
  nodes: Array<UserRolePermission>;
};

export type UserRolePermission_aggregate_bool_exp = {
  count?: InputMaybe<UserRolePermission_aggregate_bool_exp_count>;
};

export type UserRolePermission_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<UserRolePermission_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserRolePermission_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "UserRolePermission" */
export type UserRolePermission_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<UserRolePermission_max_fields>;
  min?: Maybe<UserRolePermission_min_fields>;
};


/** aggregate fields of "UserRolePermission" */
export type UserRolePermission_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<UserRolePermission_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "UserRolePermission" */
export type UserRolePermission_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<UserRolePermission_max_order_by>;
  min?: InputMaybe<UserRolePermission_min_order_by>;
};

/** Boolean expression to filter rows from the table "UserRolePermission". All fields are combined with a logical 'AND'. */
export type UserRolePermission_bool_exp = {
  _and?: InputMaybe<Array<UserRolePermission_bool_exp>>;
  _not?: InputMaybe<UserRolePermission_bool_exp>;
  _or?: InputMaybe<Array<UserRolePermission_bool_exp>>;
  anonymousUserId?: InputMaybe<uuid_comparison_exp>;
  permissionId?: InputMaybe<uuid_comparison_exp>;
  permissionKey?: InputMaybe<String_comparison_exp>;
  permissionScope?: InputMaybe<String_comparison_exp>;
  role?: InputMaybe<UserRole_bool_exp>;
  roleId?: InputMaybe<uuid_comparison_exp>;
  roleKey?: InputMaybe<String_comparison_exp>;
  scopedAccessPoint?: InputMaybe<AccessPoint_bool_exp>;
  scopedAccessPointId?: InputMaybe<uuid_comparison_exp>;
  scopedOrganization?: InputMaybe<Organization_bool_exp>;
  scopedOrganizationId?: InputMaybe<uuid_comparison_exp>;
  scopedProperty?: InputMaybe<Property_bool_exp>;
  scopedPropertyId?: InputMaybe<uuid_comparison_exp>;
  scopedUnit?: InputMaybe<Unit_bool_exp>;
  scopedUnitId?: InputMaybe<uuid_comparison_exp>;
  user?: InputMaybe<User_bool_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
  userRole?: InputMaybe<UserRole_bool_exp>;
  userRoleId?: InputMaybe<uuid_comparison_exp>;
};

/** aggregate max on columns */
export type UserRolePermission_max_fields = {
  anonymousUserId?: Maybe<Scalars['uuid']['output']>;
  permissionId?: Maybe<Scalars['uuid']['output']>;
  permissionKey?: Maybe<Scalars['String']['output']>;
  permissionScope?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  roleKey?: Maybe<Scalars['String']['output']>;
  scopedAccessPointId?: Maybe<Scalars['uuid']['output']>;
  scopedOrganizationId?: Maybe<Scalars['uuid']['output']>;
  scopedPropertyId?: Maybe<Scalars['uuid']['output']>;
  scopedUnitId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  userRoleId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "UserRolePermission" */
export type UserRolePermission_max_order_by = {
  anonymousUserId?: InputMaybe<order_by>;
  permissionId?: InputMaybe<order_by>;
  permissionKey?: InputMaybe<order_by>;
  permissionScope?: InputMaybe<order_by>;
  roleId?: InputMaybe<order_by>;
  roleKey?: InputMaybe<order_by>;
  scopedAccessPointId?: InputMaybe<order_by>;
  scopedOrganizationId?: InputMaybe<order_by>;
  scopedPropertyId?: InputMaybe<order_by>;
  scopedUnitId?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
  userRoleId?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type UserRolePermission_min_fields = {
  anonymousUserId?: Maybe<Scalars['uuid']['output']>;
  permissionId?: Maybe<Scalars['uuid']['output']>;
  permissionKey?: Maybe<Scalars['String']['output']>;
  permissionScope?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  roleKey?: Maybe<Scalars['String']['output']>;
  scopedAccessPointId?: Maybe<Scalars['uuid']['output']>;
  scopedOrganizationId?: Maybe<Scalars['uuid']['output']>;
  scopedPropertyId?: Maybe<Scalars['uuid']['output']>;
  scopedUnitId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  userRoleId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "UserRolePermission" */
export type UserRolePermission_min_order_by = {
  anonymousUserId?: InputMaybe<order_by>;
  permissionId?: InputMaybe<order_by>;
  permissionKey?: InputMaybe<order_by>;
  permissionScope?: InputMaybe<order_by>;
  roleId?: InputMaybe<order_by>;
  roleKey?: InputMaybe<order_by>;
  scopedAccessPointId?: InputMaybe<order_by>;
  scopedOrganizationId?: InputMaybe<order_by>;
  scopedPropertyId?: InputMaybe<order_by>;
  scopedUnitId?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
  userRoleId?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "UserRolePermission". */
export type UserRolePermission_order_by = {
  anonymousUserId?: InputMaybe<order_by>;
  permissionId?: InputMaybe<order_by>;
  permissionKey?: InputMaybe<order_by>;
  permissionScope?: InputMaybe<order_by>;
  role?: InputMaybe<UserRole_order_by>;
  roleId?: InputMaybe<order_by>;
  roleKey?: InputMaybe<order_by>;
  scopedAccessPoint?: InputMaybe<AccessPoint_order_by>;
  scopedAccessPointId?: InputMaybe<order_by>;
  scopedOrganization?: InputMaybe<Organization_order_by>;
  scopedOrganizationId?: InputMaybe<order_by>;
  scopedProperty?: InputMaybe<Property_order_by>;
  scopedPropertyId?: InputMaybe<order_by>;
  scopedUnit?: InputMaybe<Unit_order_by>;
  scopedUnitId?: InputMaybe<order_by>;
  user?: InputMaybe<User_order_by>;
  userId?: InputMaybe<order_by>;
  userRole?: InputMaybe<UserRole_order_by>;
  userRoleId?: InputMaybe<order_by>;
};

/** select columns of table "UserRolePermission" */
export enum UserRolePermission_select_column {
  /** column name */
  anonymousUserId = 'anonymousUserId',
  /** column name */
  permissionId = 'permissionId',
  /** column name */
  permissionKey = 'permissionKey',
  /** column name */
  permissionScope = 'permissionScope',
  /** column name */
  roleId = 'roleId',
  /** column name */
  roleKey = 'roleKey',
  /** column name */
  scopedAccessPointId = 'scopedAccessPointId',
  /** column name */
  scopedOrganizationId = 'scopedOrganizationId',
  /** column name */
  scopedPropertyId = 'scopedPropertyId',
  /** column name */
  scopedUnitId = 'scopedUnitId',
  /** column name */
  userId = 'userId',
  /** column name */
  userRoleId = 'userRoleId'
}

/** Streaming cursor of the table "UserRolePermission" */
export type UserRolePermission_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: UserRolePermission_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserRolePermission_stream_cursor_value_input = {
  anonymousUserId?: InputMaybe<Scalars['uuid']['input']>;
  permissionId?: InputMaybe<Scalars['uuid']['input']>;
  permissionKey?: InputMaybe<Scalars['String']['input']>;
  permissionScope?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  roleKey?: InputMaybe<Scalars['String']['input']>;
  scopedAccessPointId?: InputMaybe<Scalars['uuid']['input']>;
  scopedOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  scopedPropertyId?: InputMaybe<Scalars['uuid']['input']>;
  scopedUnitId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userRoleId?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "UserRoleReason" */
export type UserRoleReason = {
  label: Scalars['String']['output'];
  /** An array relationship */
  userRoles: Array<UserRole>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRole_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "UserRoleReason" */
export type UserRoleReason_userRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "UserRoleReason" */
export type UserRoleReason_userRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};

/** aggregated selection of "UserRoleReason" */
export type UserRoleReason_aggregate = {
  aggregate?: Maybe<UserRoleReason_aggregate_fields>;
  nodes: Array<UserRoleReason>;
};

/** aggregate fields of "UserRoleReason" */
export type UserRoleReason_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<UserRoleReason_max_fields>;
  min?: Maybe<UserRoleReason_min_fields>;
};


/** aggregate fields of "UserRoleReason" */
export type UserRoleReason_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<UserRoleReason_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "UserRoleReason". All fields are combined with a logical 'AND'. */
export type UserRoleReason_bool_exp = {
  _and?: InputMaybe<Array<UserRoleReason_bool_exp>>;
  _not?: InputMaybe<UserRoleReason_bool_exp>;
  _or?: InputMaybe<Array<UserRoleReason_bool_exp>>;
  label?: InputMaybe<String_comparison_exp>;
  userRoles?: InputMaybe<UserRole_bool_exp>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum UserRoleReason_enum {
  /** Capital Project */
  CAPITAL_PROJECT = 'CAPITAL_PROJECT',
  /** Dog Walker */
  DOG_WALKER = 'DOG_WALKER',
  /** Employee Vacation Suite */
  EMPLOYEE_VACATION_SUITE = 'EMPLOYEE_VACATION_SUITE',
  /** Gateway - Installation */
  GATEWAY_INSTALLATION = 'GATEWAY_INSTALLATION',
  /** Gateway - Service Call */
  GATEWAY_SERVICE_CALL = 'GATEWAY_SERVICE_CALL',
  /** Housekeeping */
  HOUSEKEEPING = 'HOUSEKEEPING',
  /** Inspection */
  INSPECTION = 'INSPECTION',
  /** Law Enforcement */
  LAW_ENFORCEMENT = 'LAW_ENFORCEMENT',
  /** Maintenance Emergency */
  MAINTENANCE_EMERGENCY = 'MAINTENANCE_EMERGENCY',
  /** Other */
  OTHER = 'OTHER',
  /** Package Dropoff */
  PACKAGE_DROPOFF = 'PACKAGE_DROPOFF',
  /** Pest Control */
  PEST_CONTROL = 'PEST_CONTROL',
  /** Preventative Maintenance */
  PREVENTATIVE_MAINTENANCE = 'PREVENTATIVE_MAINTENANCE',
  /** Prospect Tour */
  PROSPECT_TOUR = 'PROSPECT_TOUR',
  /** Reposition */
  REPOSITION = 'REPOSITION',
  /** Service Request */
  SERVICE_REQUEST = 'SERVICE_REQUEST',
  /** Skips and evictions */
  SKIPS_AND_EVICTIONS = 'SKIPS_AND_EVICTIONS',
  /** Smart Lock - August Connect */
  SMART_LOCK_AUGUST_CONNECT = 'SMART_LOCK_AUGUST_CONNECT',
  /** Smart Lock - Low Battery */
  SMART_LOCK_LOW_BATTERY = 'SMART_LOCK_LOW_BATTERY',
  /** Smart Lock - Provisioning */
  SMART_LOCK_PROVISIONING = 'SMART_LOCK_PROVISIONING',
  /** Smart Lock - Connect and Sync Data */
  SMART_LOCK_SYNC = 'SMART_LOCK_SYNC',
  /** Smart Lock - Troubleshooting */
  SMART_LOCK_TROUBLESHOOTING = 'SMART_LOCK_TROUBLESHOOTING',
  /** Third Party Services */
  THIRD_PARTY_SERVICES = 'THIRD_PARTY_SERVICES',
  /** Turnover - Clean */
  TURNOVER_CLEAN = 'TURNOVER_CLEAN',
  /** Turnover - Floor Clean */
  TURNOVER_FLOOR_CLEAN = 'TURNOVER_FLOOR_CLEAN',
  /** Turnover - Lock Reset */
  TURNOVER_LOCK_RESET = 'TURNOVER_LOCK_RESET',
  /** Turnover - Maintenance */
  TURNOVER_MAINTENANCE = 'TURNOVER_MAINTENANCE',
  /** Turnover - Other */
  TURNOVER_OTHER = 'TURNOVER_OTHER',
  /** Turnover - Paint */
  TURNOVER_PAINT = 'TURNOVER_PAINT',
  /** Welfare Check */
  WELFARE_CHECK = 'WELFARE_CHECK'
}

/** Boolean expression to compare columns of type "UserRoleReason_enum". All fields are combined with logical 'AND'. */
export type UserRoleReason_enum_comparison_exp = {
  _eq?: InputMaybe<UserRoleReason_enum>;
  _in?: InputMaybe<Array<UserRoleReason_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<UserRoleReason_enum>;
  _nin?: InputMaybe<Array<UserRoleReason_enum>>;
};

/** aggregate max on columns */
export type UserRoleReason_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UserRoleReason_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "UserRoleReason". */
export type UserRoleReason_order_by = {
  label?: InputMaybe<order_by>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "UserRoleReason" */
export enum UserRoleReason_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "UserRoleReason" */
export type UserRoleReason_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: UserRoleReason_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserRoleReason_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "UserRoleStatus" */
export type UserRoleStatus = {
  label: Scalars['String']['output'];
  /** An array relationship */
  userRoles: Array<UserRole>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRole_aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "UserRoleStatus" */
export type UserRoleStatus_userRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


/** columns and relationships of "UserRoleStatus" */
export type UserRoleStatus_userRoles_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};

/** aggregated selection of "UserRoleStatus" */
export type UserRoleStatus_aggregate = {
  aggregate?: Maybe<UserRoleStatus_aggregate_fields>;
  nodes: Array<UserRoleStatus>;
};

/** aggregate fields of "UserRoleStatus" */
export type UserRoleStatus_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<UserRoleStatus_max_fields>;
  min?: Maybe<UserRoleStatus_min_fields>;
};


/** aggregate fields of "UserRoleStatus" */
export type UserRoleStatus_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<UserRoleStatus_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "UserRoleStatus". All fields are combined with a logical 'AND'. */
export type UserRoleStatus_bool_exp = {
  _and?: InputMaybe<Array<UserRoleStatus_bool_exp>>;
  _not?: InputMaybe<UserRoleStatus_bool_exp>;
  _or?: InputMaybe<Array<UserRoleStatus_bool_exp>>;
  label?: InputMaybe<String_comparison_exp>;
  userRoles?: InputMaybe<UserRole_bool_exp>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

export enum UserRoleStatus_enum {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Expired */
  EXPIRED = 'EXPIRED',
  /** Pending */
  PENDING = 'PENDING',
  /** Revoked */
  REVOKED = 'REVOKED'
}

/** Boolean expression to compare columns of type "UserRoleStatus_enum". All fields are combined with logical 'AND'. */
export type UserRoleStatus_enum_comparison_exp = {
  _eq?: InputMaybe<UserRoleStatus_enum>;
  _in?: InputMaybe<Array<UserRoleStatus_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<UserRoleStatus_enum>;
  _nin?: InputMaybe<Array<UserRoleStatus_enum>>;
};

/** aggregate max on columns */
export type UserRoleStatus_max_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UserRoleStatus_min_fields = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "UserRoleStatus". */
export type UserRoleStatus_order_by = {
  label?: InputMaybe<order_by>;
  userRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "UserRoleStatus" */
export enum UserRoleStatus_select_column {
  /** column name */
  label = 'label',
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "UserRoleStatus" */
export type UserRoleStatus_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: UserRoleStatus_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserRoleStatus_stream_cursor_value_input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "UserRole" */
export type UserRole_aggregate = {
  aggregate?: Maybe<UserRole_aggregate_fields>;
  nodes: Array<UserRole>;
};

export type UserRole_aggregate_bool_exp = {
  count?: InputMaybe<UserRole_aggregate_bool_exp_count>;
};

export type UserRole_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<UserRole_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserRole_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "UserRole" */
export type UserRole_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<UserRole_max_fields>;
  min?: Maybe<UserRole_min_fields>;
};


/** aggregate fields of "UserRole" */
export type UserRole_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<UserRole_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "UserRole" */
export type UserRole_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<UserRole_max_order_by>;
  min?: InputMaybe<UserRole_min_order_by>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type UserRole_append_input = {
  schedule?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "UserRole". All fields are combined with a logical 'AND'. */
export type UserRole_bool_exp = {
  _and?: InputMaybe<Array<UserRole_bool_exp>>;
  _not?: InputMaybe<UserRole_bool_exp>;
  _or?: InputMaybe<Array<UserRole_bool_exp>>;
  activatesAt?: InputMaybe<timestamptz_comparison_exp>;
  assignedToAnonymousUserId?: InputMaybe<uuid_comparison_exp>;
  assignedToUser?: InputMaybe<User_bool_exp>;
  assignedToUserId?: InputMaybe<uuid_comparison_exp>;
  childUserRoles?: InputMaybe<UserRole_bool_exp>;
  childUserRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  createdByUser?: InputMaybe<User_bool_exp>;
  createdByUserId?: InputMaybe<uuid_comparison_exp>;
  expiresAt?: InputMaybe<timestamptz_comparison_exp>;
  grantMethod?: InputMaybe<UserRoleGrantMethod_enum_comparison_exp>;
  grantMethodEnum?: InputMaybe<UserRoleGrantMethod_bool_exp>;
  managedWithinOrganization?: InputMaybe<Organization_bool_exp>;
  managedWithinOrganizationId?: InputMaybe<uuid_comparison_exp>;
  managedWithinProperty?: InputMaybe<Property_bool_exp>;
  managedWithinPropertyId?: InputMaybe<uuid_comparison_exp>;
  nickname?: InputMaybe<String_comparison_exp>;
  notes?: InputMaybe<String_comparison_exp>;
  parentUserRole?: InputMaybe<UserRole_bool_exp>;
  parentUserRoleId?: InputMaybe<uuid_comparison_exp>;
  pinCodes?: InputMaybe<PinCode_bool_exp>;
  pinCodes_aggregate?: InputMaybe<PinCode_aggregate_bool_exp>;
  reason?: InputMaybe<UserRoleReason_enum_comparison_exp>;
  reasonEnum?: InputMaybe<UserRoleReason_bool_exp>;
  revokedAt?: InputMaybe<timestamptz_comparison_exp>;
  revokedByUser?: InputMaybe<User_bool_exp>;
  revokedByUserId?: InputMaybe<uuid_comparison_exp>;
  role?: InputMaybe<Role_bool_exp>;
  roleId?: InputMaybe<uuid_comparison_exp>;
  schedule?: InputMaybe<jsonb_comparison_exp>;
  scopedAccessPoint?: InputMaybe<AccessPoint_bool_exp>;
  scopedAccessPointId?: InputMaybe<uuid_comparison_exp>;
  scopedOrganization?: InputMaybe<Organization_bool_exp>;
  scopedOrganizationId?: InputMaybe<uuid_comparison_exp>;
  scopedProperty?: InputMaybe<Property_bool_exp>;
  scopedPropertyId?: InputMaybe<uuid_comparison_exp>;
  scopedSmartLock?: InputMaybe<SmartLock_bool_exp>;
  scopedSmartLockId?: InputMaybe<uuid_comparison_exp>;
  scopedUnit?: InputMaybe<Unit_bool_exp>;
  scopedUnitId?: InputMaybe<uuid_comparison_exp>;
  sourceId?: InputMaybe<String_comparison_exp>;
  sourcePayload?: InputMaybe<jsonb_comparison_exp>;
  status?: InputMaybe<UserRoleStatus_enum_comparison_exp>;
  statusEnum?: InputMaybe<UserRoleStatus_bool_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  userRoleId?: InputMaybe<uuid_comparison_exp>;
  userRolePermissions?: InputMaybe<UserRolePermission_bool_exp>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_bool_exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type UserRole_delete_at_path_input = {
  schedule?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type UserRole_delete_elem_input = {
  schedule?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type UserRole_delete_key_input = {
  schedule?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type UserRole_max_fields = {
  activatesAt?: Maybe<Scalars['timestamptz']['output']>;
  assignedToAnonymousUserId?: Maybe<Scalars['uuid']['output']>;
  assignedToUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  managedWithinOrganizationId?: Maybe<Scalars['uuid']['output']>;
  managedWithinPropertyId?: Maybe<Scalars['uuid']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parentUserRoleId?: Maybe<Scalars['uuid']['output']>;
  revokedAt?: Maybe<Scalars['timestamptz']['output']>;
  revokedByUserId?: Maybe<Scalars['uuid']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  scopedAccessPointId?: Maybe<Scalars['uuid']['output']>;
  scopedOrganizationId?: Maybe<Scalars['uuid']['output']>;
  scopedPropertyId?: Maybe<Scalars['uuid']['output']>;
  scopedSmartLockId?: Maybe<Scalars['uuid']['output']>;
  scopedUnitId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userRoleId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "UserRole" */
export type UserRole_max_order_by = {
  activatesAt?: InputMaybe<order_by>;
  assignedToAnonymousUserId?: InputMaybe<order_by>;
  assignedToUserId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUserId?: InputMaybe<order_by>;
  expiresAt?: InputMaybe<order_by>;
  managedWithinOrganizationId?: InputMaybe<order_by>;
  managedWithinPropertyId?: InputMaybe<order_by>;
  nickname?: InputMaybe<order_by>;
  notes?: InputMaybe<order_by>;
  parentUserRoleId?: InputMaybe<order_by>;
  revokedAt?: InputMaybe<order_by>;
  revokedByUserId?: InputMaybe<order_by>;
  roleId?: InputMaybe<order_by>;
  scopedAccessPointId?: InputMaybe<order_by>;
  scopedOrganizationId?: InputMaybe<order_by>;
  scopedPropertyId?: InputMaybe<order_by>;
  scopedSmartLockId?: InputMaybe<order_by>;
  scopedUnitId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userRoleId?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type UserRole_min_fields = {
  activatesAt?: Maybe<Scalars['timestamptz']['output']>;
  assignedToAnonymousUserId?: Maybe<Scalars['uuid']['output']>;
  assignedToUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  managedWithinOrganizationId?: Maybe<Scalars['uuid']['output']>;
  managedWithinPropertyId?: Maybe<Scalars['uuid']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parentUserRoleId?: Maybe<Scalars['uuid']['output']>;
  revokedAt?: Maybe<Scalars['timestamptz']['output']>;
  revokedByUserId?: Maybe<Scalars['uuid']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  scopedAccessPointId?: Maybe<Scalars['uuid']['output']>;
  scopedOrganizationId?: Maybe<Scalars['uuid']['output']>;
  scopedPropertyId?: Maybe<Scalars['uuid']['output']>;
  scopedSmartLockId?: Maybe<Scalars['uuid']['output']>;
  scopedUnitId?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userRoleId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "UserRole" */
export type UserRole_min_order_by = {
  activatesAt?: InputMaybe<order_by>;
  assignedToAnonymousUserId?: InputMaybe<order_by>;
  assignedToUserId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUserId?: InputMaybe<order_by>;
  expiresAt?: InputMaybe<order_by>;
  managedWithinOrganizationId?: InputMaybe<order_by>;
  managedWithinPropertyId?: InputMaybe<order_by>;
  nickname?: InputMaybe<order_by>;
  notes?: InputMaybe<order_by>;
  parentUserRoleId?: InputMaybe<order_by>;
  revokedAt?: InputMaybe<order_by>;
  revokedByUserId?: InputMaybe<order_by>;
  roleId?: InputMaybe<order_by>;
  scopedAccessPointId?: InputMaybe<order_by>;
  scopedOrganizationId?: InputMaybe<order_by>;
  scopedPropertyId?: InputMaybe<order_by>;
  scopedSmartLockId?: InputMaybe<order_by>;
  scopedUnitId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userRoleId?: InputMaybe<order_by>;
};

/** response of any mutation on the table "UserRole" */
export type UserRole_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserRole>;
};

/** Ordering options when selecting data from "UserRole". */
export type UserRole_order_by = {
  activatesAt?: InputMaybe<order_by>;
  assignedToAnonymousUserId?: InputMaybe<order_by>;
  assignedToUser?: InputMaybe<User_order_by>;
  assignedToUserId?: InputMaybe<order_by>;
  childUserRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
  createdAt?: InputMaybe<order_by>;
  createdByUser?: InputMaybe<User_order_by>;
  createdByUserId?: InputMaybe<order_by>;
  expiresAt?: InputMaybe<order_by>;
  grantMethod?: InputMaybe<order_by>;
  grantMethodEnum?: InputMaybe<UserRoleGrantMethod_order_by>;
  managedWithinOrganization?: InputMaybe<Organization_order_by>;
  managedWithinOrganizationId?: InputMaybe<order_by>;
  managedWithinProperty?: InputMaybe<Property_order_by>;
  managedWithinPropertyId?: InputMaybe<order_by>;
  nickname?: InputMaybe<order_by>;
  notes?: InputMaybe<order_by>;
  parentUserRole?: InputMaybe<UserRole_order_by>;
  parentUserRoleId?: InputMaybe<order_by>;
  pinCodes_aggregate?: InputMaybe<PinCode_aggregate_order_by>;
  reason?: InputMaybe<order_by>;
  reasonEnum?: InputMaybe<UserRoleReason_order_by>;
  revokedAt?: InputMaybe<order_by>;
  revokedByUser?: InputMaybe<User_order_by>;
  revokedByUserId?: InputMaybe<order_by>;
  role?: InputMaybe<Role_order_by>;
  roleId?: InputMaybe<order_by>;
  schedule?: InputMaybe<order_by>;
  scopedAccessPoint?: InputMaybe<AccessPoint_order_by>;
  scopedAccessPointId?: InputMaybe<order_by>;
  scopedOrganization?: InputMaybe<Organization_order_by>;
  scopedOrganizationId?: InputMaybe<order_by>;
  scopedProperty?: InputMaybe<Property_order_by>;
  scopedPropertyId?: InputMaybe<order_by>;
  scopedSmartLock?: InputMaybe<SmartLock_order_by>;
  scopedSmartLockId?: InputMaybe<order_by>;
  scopedUnit?: InputMaybe<Unit_order_by>;
  scopedUnitId?: InputMaybe<order_by>;
  sourceId?: InputMaybe<order_by>;
  sourcePayload?: InputMaybe<order_by>;
  status?: InputMaybe<order_by>;
  statusEnum?: InputMaybe<UserRoleStatus_order_by>;
  updatedAt?: InputMaybe<order_by>;
  userRoleId?: InputMaybe<order_by>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_order_by>;
};

/** primary key columns input for table: UserRole */
export type UserRole_pk_columns_input = {
  userRoleId: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type UserRole_prepend_input = {
  schedule?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "UserRole" */
export enum UserRole_select_column {
  /** column name */
  activatesAt = 'activatesAt',
  /** column name */
  assignedToAnonymousUserId = 'assignedToAnonymousUserId',
  /** column name */
  assignedToUserId = 'assignedToUserId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdByUserId = 'createdByUserId',
  /** column name */
  expiresAt = 'expiresAt',
  /** column name */
  grantMethod = 'grantMethod',
  /** column name */
  managedWithinOrganizationId = 'managedWithinOrganizationId',
  /** column name */
  managedWithinPropertyId = 'managedWithinPropertyId',
  /** column name */
  nickname = 'nickname',
  /** column name */
  notes = 'notes',
  /** column name */
  parentUserRoleId = 'parentUserRoleId',
  /** column name */
  reason = 'reason',
  /** column name */
  revokedAt = 'revokedAt',
  /** column name */
  revokedByUserId = 'revokedByUserId',
  /** column name */
  roleId = 'roleId',
  /** column name */
  schedule = 'schedule',
  /** column name */
  scopedAccessPointId = 'scopedAccessPointId',
  /** column name */
  scopedOrganizationId = 'scopedOrganizationId',
  /** column name */
  scopedPropertyId = 'scopedPropertyId',
  /** column name */
  scopedSmartLockId = 'scopedSmartLockId',
  /** column name */
  scopedUnitId = 'scopedUnitId',
  /** column name */
  sourceId = 'sourceId',
  /** column name */
  sourcePayload = 'sourcePayload',
  /** column name */
  status = 'status',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  userRoleId = 'userRoleId'
}

/** input type for updating data in table "UserRole" */
export type UserRole_set_input = {
  activatesAt?: InputMaybe<Scalars['timestamptz']['input']>;
  assignedToAnonymousUserId?: InputMaybe<Scalars['uuid']['input']>;
  assignedToUserId?: InputMaybe<Scalars['uuid']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<UserRoleReason_enum>;
  revokedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  revokedByUserId?: InputMaybe<Scalars['uuid']['input']>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  schedule?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<UserRoleStatus_enum>;
};

/** Streaming cursor of the table "UserRole" */
export type UserRole_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: UserRole_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserRole_stream_cursor_value_input = {
  activatesAt?: InputMaybe<Scalars['timestamptz']['input']>;
  assignedToAnonymousUserId?: InputMaybe<Scalars['uuid']['input']>;
  assignedToUserId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  grantMethod?: InputMaybe<UserRoleGrantMethod_enum>;
  managedWithinOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  managedWithinPropertyId?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parentUserRoleId?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<UserRoleReason_enum>;
  revokedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  revokedByUserId?: InputMaybe<Scalars['uuid']['input']>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  schedule?: InputMaybe<Scalars['jsonb']['input']>;
  scopedAccessPointId?: InputMaybe<Scalars['uuid']['input']>;
  scopedOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  scopedPropertyId?: InputMaybe<Scalars['uuid']['input']>;
  scopedSmartLockId?: InputMaybe<Scalars['uuid']['input']>;
  scopedUnitId?: InputMaybe<Scalars['uuid']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourcePayload?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<UserRoleStatus_enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userRoleId?: InputMaybe<Scalars['uuid']['input']>;
};

export type UserRole_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<UserRole_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<UserRole_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<UserRole_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<UserRole_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<UserRole_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserRole_set_input>;
  /** filter the rows which have to be updated */
  where: UserRole_bool_exp;
};

/** aggregated selection of "User" */
export type User_aggregate = {
  aggregate?: Maybe<User_aggregate_fields>;
  nodes: Array<User>;
};

export type User_aggregate_bool_exp = {
  bool_and?: InputMaybe<User_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<User_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<User_aggregate_bool_exp_count>;
};

export type User_aggregate_bool_exp_bool_and = {
  arguments: User_select_column_User_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type User_aggregate_bool_exp_bool_or = {
  arguments: User_select_column_User_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type User_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<User_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "User" */
export type User_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<User_max_fields>;
  min?: Maybe<User_min_fields>;
};


/** aggregate fields of "User" */
export type User_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<User_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "User" */
export type User_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<User_max_order_by>;
  min?: InputMaybe<User_min_order_by>;
};

/** Boolean expression to filter rows from the table "User". All fields are combined with a logical 'AND'. */
export type User_bool_exp = {
  _and?: InputMaybe<Array<User_bool_exp>>;
  _not?: InputMaybe<User_bool_exp>;
  _or?: InputMaybe<Array<User_bool_exp>>;
  acceptedEulaAt?: InputMaybe<timestamptz_comparison_exp>;
  accountStatus?: InputMaybe<AccountStatus_enum_comparison_exp>;
  accountStatusEnum?: InputMaybe<AccountStatus_bool_exp>;
  archivedAccessPoints?: InputMaybe<AccessPoint_bool_exp>;
  archivedAccessPoints_aggregate?: InputMaybe<AccessPoint_aggregate_bool_exp>;
  assignedCredentials?: InputMaybe<Credential_bool_exp>;
  assignedCredentials_aggregate?: InputMaybe<Credential_aggregate_bool_exp>;
  assignedPinCodes?: InputMaybe<PinCode_bool_exp>;
  assignedPinCodes_aggregate?: InputMaybe<PinCode_aggregate_bool_exp>;
  assignedTickets?: InputMaybe<Ticket_bool_exp>;
  assignedTickets_aggregate?: InputMaybe<Ticket_aggregate_bool_exp>;
  assignedUserRoles?: InputMaybe<UserRole_bool_exp>;
  assignedUserRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
  augustSubUserId?: InputMaybe<uuid_comparison_exp>;
  augustUserId?: InputMaybe<uuid_comparison_exp>;
  createdAccessPoints?: InputMaybe<AccessPoint_bool_exp>;
  createdAccessPoints_aggregate?: InputMaybe<AccessPoint_aggregate_bool_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  createdPinCodes?: InputMaybe<PinCode_bool_exp>;
  createdPinCodes_aggregate?: InputMaybe<PinCode_aggregate_bool_exp>;
  createdSmartLocks?: InputMaybe<SmartLock_bool_exp>;
  createdSmartLocks_aggregate?: InputMaybe<SmartLock_aggregate_bool_exp>;
  createdTickets?: InputMaybe<Ticket_bool_exp>;
  createdTickets_aggregate?: InputMaybe<Ticket_aggregate_bool_exp>;
  createdUnits?: InputMaybe<Unit_bool_exp>;
  createdUnits_aggregate?: InputMaybe<Unit_aggregate_bool_exp>;
  createdUserRoles?: InputMaybe<UserRole_bool_exp>;
  createdUserRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
  email?: InputMaybe<String_comparison_exp>;
  favorites?: InputMaybe<Favorite_bool_exp>;
  favorites_aggregate?: InputMaybe<Favorite_aggregate_bool_exp>;
  firstName?: InputMaybe<String_comparison_exp>;
  hasAugustPassword?: InputMaybe<Boolean_comparison_exp>;
  lastName?: InputMaybe<String_comparison_exp>;
  lastReadAnnouncementsAt?: InputMaybe<timestamptz_comparison_exp>;
  password?: InputMaybe<PasswordRedacted_bool_exp>;
  phoneNumber?: InputMaybe<String_comparison_exp>;
  provisionedCredentials?: InputMaybe<Credential_bool_exp>;
  provisionedCredentials_aggregate?: InputMaybe<Credential_aggregate_bool_exp>;
  relayLogs?: InputMaybe<RelayLog_bool_exp>;
  relayLogs_aggregate?: InputMaybe<RelayLog_aggregate_bool_exp>;
  revokedUserRoles?: InputMaybe<UserRole_bool_exp>;
  revokedUserRoles_aggregate?: InputMaybe<UserRole_aggregate_bool_exp>;
  sessions?: InputMaybe<Session_bool_exp>;
  sessionsRevokedByUser?: InputMaybe<Session_bool_exp>;
  sessionsRevokedByUser_aggregate?: InputMaybe<Session_aggregate_bool_exp>;
  sessions_aggregate?: InputMaybe<Session_aggregate_bool_exp>;
  smartLockLogsByActingUser?: InputMaybe<SmartLockLog_bool_exp>;
  smartLockLogsByActingUser_aggregate?: InputMaybe<SmartLockLog_aggregate_bool_exp>;
  smartLockLogsByAffectedUser?: InputMaybe<SmartLockLog_bool_exp>;
  smartLockLogsByAffectedUser_aggregate?: InputMaybe<SmartLockLog_aggregate_bool_exp>;
  solvedTickets?: InputMaybe<Ticket_bool_exp>;
  solvedTickets_aggregate?: InputMaybe<Ticket_aggregate_bool_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  updatedPinCodes?: InputMaybe<PinCode_bool_exp>;
  updatedPinCodes_aggregate?: InputMaybe<PinCode_aggregate_bool_exp>;
  uploadedImages?: InputMaybe<Image_bool_exp>;
  uploadedImages_aggregate?: InputMaybe<Image_aggregate_bool_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
  userRolePermissions?: InputMaybe<UserRolePermission_bool_exp>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_bool_exp>;
  virtualDirectoryEnabled?: InputMaybe<Boolean_comparison_exp>;
};

/** aggregate max on columns */
export type User_max_fields = {
  acceptedEulaAt?: Maybe<Scalars['timestamptz']['output']>;
  augustSubUserId?: Maybe<Scalars['uuid']['output']>;
  augustUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastReadAnnouncementsAt?: Maybe<Scalars['timestamptz']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "User" */
export type User_max_order_by = {
  acceptedEulaAt?: InputMaybe<order_by>;
  augustSubUserId?: InputMaybe<order_by>;
  augustUserId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  firstName?: InputMaybe<order_by>;
  lastName?: InputMaybe<order_by>;
  lastReadAnnouncementsAt?: InputMaybe<order_by>;
  phoneNumber?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type User_min_fields = {
  acceptedEulaAt?: Maybe<Scalars['timestamptz']['output']>;
  augustSubUserId?: Maybe<Scalars['uuid']['output']>;
  augustUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastReadAnnouncementsAt?: Maybe<Scalars['timestamptz']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "User" */
export type User_min_order_by = {
  acceptedEulaAt?: InputMaybe<order_by>;
  augustSubUserId?: InputMaybe<order_by>;
  augustUserId?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  firstName?: InputMaybe<order_by>;
  lastName?: InputMaybe<order_by>;
  lastReadAnnouncementsAt?: InputMaybe<order_by>;
  phoneNumber?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "User". */
export type User_order_by = {
  acceptedEulaAt?: InputMaybe<order_by>;
  accountStatus?: InputMaybe<order_by>;
  accountStatusEnum?: InputMaybe<AccountStatus_order_by>;
  archivedAccessPoints_aggregate?: InputMaybe<AccessPoint_aggregate_order_by>;
  assignedCredentials_aggregate?: InputMaybe<Credential_aggregate_order_by>;
  assignedPinCodes_aggregate?: InputMaybe<PinCode_aggregate_order_by>;
  assignedTickets_aggregate?: InputMaybe<Ticket_aggregate_order_by>;
  assignedUserRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
  augustSubUserId?: InputMaybe<order_by>;
  augustUserId?: InputMaybe<order_by>;
  createdAccessPoints_aggregate?: InputMaybe<AccessPoint_aggregate_order_by>;
  createdAt?: InputMaybe<order_by>;
  createdPinCodes_aggregate?: InputMaybe<PinCode_aggregate_order_by>;
  createdSmartLocks_aggregate?: InputMaybe<SmartLock_aggregate_order_by>;
  createdTickets_aggregate?: InputMaybe<Ticket_aggregate_order_by>;
  createdUnits_aggregate?: InputMaybe<Unit_aggregate_order_by>;
  createdUserRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
  email?: InputMaybe<order_by>;
  favorites_aggregate?: InputMaybe<Favorite_aggregate_order_by>;
  firstName?: InputMaybe<order_by>;
  hasAugustPassword?: InputMaybe<order_by>;
  lastName?: InputMaybe<order_by>;
  lastReadAnnouncementsAt?: InputMaybe<order_by>;
  password?: InputMaybe<PasswordRedacted_order_by>;
  phoneNumber?: InputMaybe<order_by>;
  provisionedCredentials_aggregate?: InputMaybe<Credential_aggregate_order_by>;
  relayLogs_aggregate?: InputMaybe<RelayLog_aggregate_order_by>;
  revokedUserRoles_aggregate?: InputMaybe<UserRole_aggregate_order_by>;
  sessionsRevokedByUser_aggregate?: InputMaybe<Session_aggregate_order_by>;
  sessions_aggregate?: InputMaybe<Session_aggregate_order_by>;
  smartLockLogsByActingUser_aggregate?: InputMaybe<SmartLockLog_aggregate_order_by>;
  smartLockLogsByAffectedUser_aggregate?: InputMaybe<SmartLockLog_aggregate_order_by>;
  solvedTickets_aggregate?: InputMaybe<Ticket_aggregate_order_by>;
  updatedAt?: InputMaybe<order_by>;
  updatedPinCodes_aggregate?: InputMaybe<PinCode_aggregate_order_by>;
  uploadedImages_aggregate?: InputMaybe<Image_aggregate_order_by>;
  userId?: InputMaybe<order_by>;
  userRolePermissions_aggregate?: InputMaybe<UserRolePermission_aggregate_order_by>;
  virtualDirectoryEnabled?: InputMaybe<order_by>;
};

/** select columns of table "User" */
export enum User_select_column {
  /** column name */
  acceptedEulaAt = 'acceptedEulaAt',
  /** column name */
  accountStatus = 'accountStatus',
  /** column name */
  augustSubUserId = 'augustSubUserId',
  /** column name */
  augustUserId = 'augustUserId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  email = 'email',
  /** column name */
  firstName = 'firstName',
  /** column name */
  hasAugustPassword = 'hasAugustPassword',
  /** column name */
  lastName = 'lastName',
  /** column name */
  lastReadAnnouncementsAt = 'lastReadAnnouncementsAt',
  /** column name */
  phoneNumber = 'phoneNumber',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  userId = 'userId',
  /** column name */
  virtualDirectoryEnabled = 'virtualDirectoryEnabled'
}

/** select "User_aggregate_bool_exp_bool_and_arguments_columns" columns of table "User" */
export enum User_select_column_User_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  hasAugustPassword = 'hasAugustPassword',
  /** column name */
  virtualDirectoryEnabled = 'virtualDirectoryEnabled'
}

/** select "User_aggregate_bool_exp_bool_or_arguments_columns" columns of table "User" */
export enum User_select_column_User_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  hasAugustPassword = 'hasAugustPassword',
  /** column name */
  virtualDirectoryEnabled = 'virtualDirectoryEnabled'
}

/** Streaming cursor of the table "User" */
export type User_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: User_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_stream_cursor_value_input = {
  acceptedEulaAt?: InputMaybe<Scalars['timestamptz']['input']>;
  accountStatus?: InputMaybe<AccountStatus_enum>;
  augustSubUserId?: InputMaybe<Scalars['uuid']['input']>;
  augustUserId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasAugustPassword?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastReadAnnouncementsAt?: InputMaybe<Scalars['timestamptz']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  virtualDirectoryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "VirtualDirectoryUserDisplayNameFormat" */
export type VirtualDirectoryUserDisplayNameFormat = {
  value: Scalars['String']['output'];
};

/** aggregated selection of "VirtualDirectoryUserDisplayNameFormat" */
export type VirtualDirectoryUserDisplayNameFormat_aggregate = {
  aggregate?: Maybe<VirtualDirectoryUserDisplayNameFormat_aggregate_fields>;
  nodes: Array<VirtualDirectoryUserDisplayNameFormat>;
};

/** aggregate fields of "VirtualDirectoryUserDisplayNameFormat" */
export type VirtualDirectoryUserDisplayNameFormat_aggregate_fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<VirtualDirectoryUserDisplayNameFormat_max_fields>;
  min?: Maybe<VirtualDirectoryUserDisplayNameFormat_min_fields>;
};


/** aggregate fields of "VirtualDirectoryUserDisplayNameFormat" */
export type VirtualDirectoryUserDisplayNameFormat_aggregate_fields_countArgs = {
  columns?: InputMaybe<Array<VirtualDirectoryUserDisplayNameFormat_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "VirtualDirectoryUserDisplayNameFormat". All fields are combined with a logical 'AND'. */
export type VirtualDirectoryUserDisplayNameFormat_bool_exp = {
  _and?: InputMaybe<Array<VirtualDirectoryUserDisplayNameFormat_bool_exp>>;
  _not?: InputMaybe<VirtualDirectoryUserDisplayNameFormat_bool_exp>;
  _or?: InputMaybe<Array<VirtualDirectoryUserDisplayNameFormat_bool_exp>>;
  value?: InputMaybe<String_comparison_exp>;
};

/** aggregate max on columns */
export type VirtualDirectoryUserDisplayNameFormat_max_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type VirtualDirectoryUserDisplayNameFormat_min_fields = {
  value?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "VirtualDirectoryUserDisplayNameFormat". */
export type VirtualDirectoryUserDisplayNameFormat_order_by = {
  value?: InputMaybe<order_by>;
};

/** select columns of table "VirtualDirectoryUserDisplayNameFormat" */
export enum VirtualDirectoryUserDisplayNameFormat_select_column {
  /** column name */
  value = 'value'
}

/** Streaming cursor of the table "VirtualDirectoryUserDisplayNameFormat" */
export type VirtualDirectoryUserDisplayNameFormat_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: VirtualDirectoryUserDisplayNameFormat_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type VirtualDirectoryUserDisplayNameFormat_stream_cursor_value_input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type bigint_comparison_exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** ordering argument of a cursor */
export enum cursor_ordering {
  /** ascending ordering of the cursor */
  ASC = 'ASC',
  /** descending ordering of the cursor */
  DESC = 'DESC'
}

export type jsonb_cast_exp = {
  String?: InputMaybe<String_comparison_exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type jsonb_comparison_exp = {
  _cast?: InputMaybe<jsonb_cast_exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** mutation root */
export type mutation_root = {
  custom_createGuestPass: Custom_CreateGuestPassOutput;
  custom_remoteOperateAugustLock: Custom_RemoteOperateAugustLockOutput;
  custom_revokeSession: Custom_RevokeSessionOutput;
  custom_revokeUserRole: Custom_RevokeUserRoleOutput;
  custom_sendMessageToHubs: Custom_SendMessageToHubsOutput;
  custom_syncEngrainPropertyMap: Custom_SyncEngrainPropertyMapOutput;
  custom_toggleAccessPointArchived: Custom_ToggleAccessPointArchivedOutput;
  custom_unlockAccessPoint: Custom_UnlockAccessPointOutput;
  custom_unlockHubRelays: Custom_HubResponse;
  custom_updateAccessPointMapLocation: Custom_UpdateAccessPointMapLocationOutput;
  custom_updateTicketStatus: Custom_UpdateTicketStatusOutput;
  custom_updateUser: Custom_UpdateUserOutput;
  /** delete data from the table: "AccessPoint" */
  delete_AccessPoint?: Maybe<AccessPoint_mutation_response>;
  /** delete data from the table: "AccessPointRole" */
  delete_AccessPointRole?: Maybe<AccessPointRole_mutation_response>;
  /** delete single row from the table: "AccessPointRole" */
  delete_AccessPointRole_by_pk?: Maybe<AccessPointRole>;
  /** delete single row from the table: "AccessPoint" */
  delete_AccessPoint_by_pk?: Maybe<AccessPoint>;
  /** delete data from the table: "Beacon" */
  delete_Beacon?: Maybe<Beacon_mutation_response>;
  /** delete single row from the table: "Beacon" */
  delete_Beacon_by_pk?: Maybe<Beacon>;
  /** delete data from the table: "Credential" */
  delete_Credential?: Maybe<Credential_mutation_response>;
  /** delete single row from the table: "Credential" */
  delete_Credential_by_pk?: Maybe<Credential>;
  /** delete data from the table: "PinCode" */
  delete_PinCode?: Maybe<PinCode_mutation_response>;
  /** delete single row from the table: "PinCode" */
  delete_PinCode_by_pk?: Maybe<PinCode>;
  /** delete data from the table: "Property" */
  delete_Property?: Maybe<Property_mutation_response>;
  /** delete data from the table: "PropertyFeatureFlag" */
  delete_PropertyFeatureFlag?: Maybe<PropertyFeatureFlag_mutation_response>;
  /** delete single row from the table: "PropertyFeatureFlag" */
  delete_PropertyFeatureFlag_by_pk?: Maybe<PropertyFeatureFlag>;
  /** delete data from the table: "PropertyMap" */
  delete_PropertyMap?: Maybe<PropertyMap_mutation_response>;
  /** delete single row from the table: "PropertyMap" */
  delete_PropertyMap_by_pk?: Maybe<PropertyMap>;
  /** delete single row from the table: "Property" */
  delete_Property_by_pk?: Maybe<Property>;
  /** delete data from the table: "Relay" */
  delete_Relay?: Maybe<Relay_mutation_response>;
  /** delete single row from the table: "Relay" */
  delete_Relay_by_pk?: Maybe<Relay>;
  /** delete data from the table: "Role" */
  delete_Role?: Maybe<Role_mutation_response>;
  /** delete data from the table: "RolePermission" */
  delete_RolePermission?: Maybe<RolePermission_mutation_response>;
  /** delete single row from the table: "RolePermission" */
  delete_RolePermission_by_pk?: Maybe<RolePermission>;
  /** delete data from the table: "RoleRelationship" */
  delete_RoleRelationship?: Maybe<RoleRelationship_mutation_response>;
  /** delete single row from the table: "RoleRelationship" */
  delete_RoleRelationship_by_pk?: Maybe<RoleRelationship>;
  /** delete single row from the table: "Role" */
  delete_Role_by_pk?: Maybe<Role>;
  /** delete data from the table: "SmartLock" */
  delete_SmartLock?: Maybe<SmartLock_mutation_response>;
  /** delete single row from the table: "SmartLock" */
  delete_SmartLock_by_pk?: Maybe<SmartLock>;
  /** delete data from the table: "Ticket" */
  delete_Ticket?: Maybe<Ticket_mutation_response>;
  /** delete single row from the table: "Ticket" */
  delete_Ticket_by_pk?: Maybe<Ticket>;
  /** delete data from the table: "Unit" */
  delete_Unit?: Maybe<Unit_mutation_response>;
  /** delete data from the table: "UnitGroup" */
  delete_UnitGroup?: Maybe<UnitGroup_mutation_response>;
  /** delete single row from the table: "UnitGroup" */
  delete_UnitGroup_by_pk?: Maybe<UnitGroup>;
  /** delete single row from the table: "Unit" */
  delete_Unit_by_pk?: Maybe<Unit>;
  /** insert data into the table: "AccessPoint" */
  insert_AccessPoint?: Maybe<AccessPoint_mutation_response>;
  /** insert data into the table: "AccessPointRole" */
  insert_AccessPointRole?: Maybe<AccessPointRole_mutation_response>;
  /** insert a single row into the table: "AccessPointRole" */
  insert_AccessPointRole_one?: Maybe<AccessPointRole>;
  /** insert a single row into the table: "AccessPoint" */
  insert_AccessPoint_one?: Maybe<AccessPoint>;
  /** insert data into the table: "Credential" */
  insert_Credential?: Maybe<Credential_mutation_response>;
  /** insert a single row into the table: "Credential" */
  insert_Credential_one?: Maybe<Credential>;
  /** insert data into the table: "Organization" */
  insert_Organization?: Maybe<Organization_mutation_response>;
  /** insert a single row into the table: "Organization" */
  insert_Organization_one?: Maybe<Organization>;
  /** insert data into the table: "PinCode" */
  insert_PinCode?: Maybe<PinCode_mutation_response>;
  /** insert a single row into the table: "PinCode" */
  insert_PinCode_one?: Maybe<PinCode>;
  /** insert data into the table: "Property" */
  insert_Property?: Maybe<Property_mutation_response>;
  /** insert data into the table: "PropertyFeatureFlag" */
  insert_PropertyFeatureFlag?: Maybe<PropertyFeatureFlag_mutation_response>;
  /** insert a single row into the table: "PropertyFeatureFlag" */
  insert_PropertyFeatureFlag_one?: Maybe<PropertyFeatureFlag>;
  /** insert a single row into the table: "Property" */
  insert_Property_one?: Maybe<Property>;
  /** insert data into the table: "Role" */
  insert_Role?: Maybe<Role_mutation_response>;
  /** insert data into the table: "RolePermission" */
  insert_RolePermission?: Maybe<RolePermission_mutation_response>;
  /** insert a single row into the table: "RolePermission" */
  insert_RolePermission_one?: Maybe<RolePermission>;
  /** insert data into the table: "RoleRelationship" */
  insert_RoleRelationship?: Maybe<RoleRelationship_mutation_response>;
  /** insert a single row into the table: "RoleRelationship" */
  insert_RoleRelationship_one?: Maybe<RoleRelationship>;
  /** insert a single row into the table: "Role" */
  insert_Role_one?: Maybe<Role>;
  /** insert data into the table: "Ticket" */
  insert_Ticket?: Maybe<Ticket_mutation_response>;
  /** insert a single row into the table: "Ticket" */
  insert_Ticket_one?: Maybe<Ticket>;
  /** insert data into the table: "Unit" */
  insert_Unit?: Maybe<Unit_mutation_response>;
  /** insert data into the table: "UnitGroup" */
  insert_UnitGroup?: Maybe<UnitGroup_mutation_response>;
  /** insert a single row into the table: "UnitGroup" */
  insert_UnitGroup_one?: Maybe<UnitGroup>;
  /** insert a single row into the table: "Unit" */
  insert_Unit_one?: Maybe<Unit>;
  /** update data of the table: "AccessPoint" */
  update_AccessPoint?: Maybe<AccessPoint_mutation_response>;
  /** update data of the table: "AccessPointRole" */
  update_AccessPointRole?: Maybe<AccessPointRole_mutation_response>;
  /** update single row of the table: "AccessPointRole" */
  update_AccessPointRole_by_pk?: Maybe<AccessPointRole>;
  /** update multiples rows of table: "AccessPointRole" */
  update_AccessPointRole_many?: Maybe<Array<Maybe<AccessPointRole_mutation_response>>>;
  /** update single row of the table: "AccessPoint" */
  update_AccessPoint_by_pk?: Maybe<AccessPoint>;
  /** update multiples rows of table: "AccessPoint" */
  update_AccessPoint_many?: Maybe<Array<Maybe<AccessPoint_mutation_response>>>;
  /** update data of the table: "Beacon" */
  update_Beacon?: Maybe<Beacon_mutation_response>;
  /** update single row of the table: "Beacon" */
  update_Beacon_by_pk?: Maybe<Beacon>;
  /** update multiples rows of table: "Beacon" */
  update_Beacon_many?: Maybe<Array<Maybe<Beacon_mutation_response>>>;
  /** update data of the table: "Credential" */
  update_Credential?: Maybe<Credential_mutation_response>;
  /** update single row of the table: "Credential" */
  update_Credential_by_pk?: Maybe<Credential>;
  /** update multiples rows of table: "Credential" */
  update_Credential_many?: Maybe<Array<Maybe<Credential_mutation_response>>>;
  /** update data of the table: "Hub" */
  update_Hub?: Maybe<Hub_mutation_response>;
  /** update single row of the table: "Hub" */
  update_Hub_by_pk?: Maybe<Hub>;
  /** update multiples rows of table: "Hub" */
  update_Hub_many?: Maybe<Array<Maybe<Hub_mutation_response>>>;
  /** update data of the table: "Organization" */
  update_Organization?: Maybe<Organization_mutation_response>;
  /** update single row of the table: "Organization" */
  update_Organization_by_pk?: Maybe<Organization>;
  /** update multiples rows of table: "Organization" */
  update_Organization_many?: Maybe<Array<Maybe<Organization_mutation_response>>>;
  /** update data of the table: "PinCode" */
  update_PinCode?: Maybe<PinCode_mutation_response>;
  /** update single row of the table: "PinCode" */
  update_PinCode_by_pk?: Maybe<PinCode>;
  /** update multiples rows of table: "PinCode" */
  update_PinCode_many?: Maybe<Array<Maybe<PinCode_mutation_response>>>;
  /** update data of the table: "Property" */
  update_Property?: Maybe<Property_mutation_response>;
  /** update data of the table: "PropertyFeatureFlag" */
  update_PropertyFeatureFlag?: Maybe<PropertyFeatureFlag_mutation_response>;
  /** update single row of the table: "PropertyFeatureFlag" */
  update_PropertyFeatureFlag_by_pk?: Maybe<PropertyFeatureFlag>;
  /** update multiples rows of table: "PropertyFeatureFlag" */
  update_PropertyFeatureFlag_many?: Maybe<Array<Maybe<PropertyFeatureFlag_mutation_response>>>;
  /** update data of the table: "PropertyMap" */
  update_PropertyMap?: Maybe<PropertyMap_mutation_response>;
  /** update single row of the table: "PropertyMap" */
  update_PropertyMap_by_pk?: Maybe<PropertyMap>;
  /** update multiples rows of table: "PropertyMap" */
  update_PropertyMap_many?: Maybe<Array<Maybe<PropertyMap_mutation_response>>>;
  /** update single row of the table: "Property" */
  update_Property_by_pk?: Maybe<Property>;
  /** update multiples rows of table: "Property" */
  update_Property_many?: Maybe<Array<Maybe<Property_mutation_response>>>;
  /** update data of the table: "Relay" */
  update_Relay?: Maybe<Relay_mutation_response>;
  /** update single row of the table: "Relay" */
  update_Relay_by_pk?: Maybe<Relay>;
  /** update multiples rows of table: "Relay" */
  update_Relay_many?: Maybe<Array<Maybe<Relay_mutation_response>>>;
  /** update data of the table: "Role" */
  update_Role?: Maybe<Role_mutation_response>;
  /** update data of the table: "RolePermission" */
  update_RolePermission?: Maybe<RolePermission_mutation_response>;
  /** update single row of the table: "RolePermission" */
  update_RolePermission_by_pk?: Maybe<RolePermission>;
  /** update multiples rows of table: "RolePermission" */
  update_RolePermission_many?: Maybe<Array<Maybe<RolePermission_mutation_response>>>;
  /** update data of the table: "RoleRelationship" */
  update_RoleRelationship?: Maybe<RoleRelationship_mutation_response>;
  /** update single row of the table: "RoleRelationship" */
  update_RoleRelationship_by_pk?: Maybe<RoleRelationship>;
  /** update multiples rows of table: "RoleRelationship" */
  update_RoleRelationship_many?: Maybe<Array<Maybe<RoleRelationship_mutation_response>>>;
  /** update single row of the table: "Role" */
  update_Role_by_pk?: Maybe<Role>;
  /** update multiples rows of table: "Role" */
  update_Role_many?: Maybe<Array<Maybe<Role_mutation_response>>>;
  /** update data of the table: "SmartLock" */
  update_SmartLock?: Maybe<SmartLock_mutation_response>;
  /** update single row of the table: "SmartLock" */
  update_SmartLock_by_pk?: Maybe<SmartLock>;
  /** update multiples rows of table: "SmartLock" */
  update_SmartLock_many?: Maybe<Array<Maybe<SmartLock_mutation_response>>>;
  /** update data of the table: "Unit" */
  update_Unit?: Maybe<Unit_mutation_response>;
  /** update data of the table: "UnitGroup" */
  update_UnitGroup?: Maybe<UnitGroup_mutation_response>;
  /** update single row of the table: "UnitGroup" */
  update_UnitGroup_by_pk?: Maybe<UnitGroup>;
  /** update multiples rows of table: "UnitGroup" */
  update_UnitGroup_many?: Maybe<Array<Maybe<UnitGroup_mutation_response>>>;
  /** update single row of the table: "Unit" */
  update_Unit_by_pk?: Maybe<Unit>;
  /** update multiples rows of table: "Unit" */
  update_Unit_many?: Maybe<Array<Maybe<Unit_mutation_response>>>;
  /** update data of the table: "UserRole" */
  update_UserRole?: Maybe<UserRole_mutation_response>;
  /** update single row of the table: "UserRole" */
  update_UserRole_by_pk?: Maybe<UserRole>;
  /** update multiples rows of table: "UserRole" */
  update_UserRole_many?: Maybe<Array<Maybe<UserRole_mutation_response>>>;
};


/** mutation root */
export type mutation_root_custom_createGuestPassArgs = {
  input: Custom_CreateGuestPassInput;
};


/** mutation root */
export type mutation_root_custom_remoteOperateAugustLockArgs = {
  input: Custom_RemoteOperateAugustLockInput;
};


/** mutation root */
export type mutation_root_custom_revokeSessionArgs = {
  sessionId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_custom_revokeUserRoleArgs = {
  userRoleId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_custom_sendMessageToHubsArgs = {
  input: Custom_SendMessageToHubsInput;
};


/** mutation root */
export type mutation_root_custom_syncEngrainPropertyMapArgs = {
  input: Custom_SyncEngrainPropertyMapInput;
};


/** mutation root */
export type mutation_root_custom_toggleAccessPointArchivedArgs = {
  accessPointId: Scalars['uuid']['input'];
  archived: Scalars['Boolean']['input'];
};


/** mutation root */
export type mutation_root_custom_unlockAccessPointArgs = {
  accessPointId?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Custom_UnlockAccessPointInput>;
  unlockMethod?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type mutation_root_custom_unlockHubRelaysArgs = {
  input: Custom_UnlockHubRelaysInput;
};


/** mutation root */
export type mutation_root_custom_updateAccessPointMapLocationArgs = {
  accessPointId: Scalars['uuid']['input'];
  mapLocation?: InputMaybe<Custom_AccessPointMapLocationInput>;
};


/** mutation root */
export type mutation_root_custom_updateTicketStatusArgs = {
  status: Scalars['String']['input'];
  ticketId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_custom_updateUserArgs = {
  _set: Custom_UpdateUserInput;
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_AccessPointArgs = {
  where: AccessPoint_bool_exp;
};


/** mutation root */
export type mutation_root_delete_AccessPointRoleArgs = {
  where: AccessPointRole_bool_exp;
};


/** mutation root */
export type mutation_root_delete_AccessPointRole_by_pkArgs = {
  accessPointRoleId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_AccessPoint_by_pkArgs = {
  accessPointId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_BeaconArgs = {
  where: Beacon_bool_exp;
};


/** mutation root */
export type mutation_root_delete_Beacon_by_pkArgs = {
  beaconId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_CredentialArgs = {
  where: Credential_bool_exp;
};


/** mutation root */
export type mutation_root_delete_Credential_by_pkArgs = {
  credentialId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_PinCodeArgs = {
  where: PinCode_bool_exp;
};


/** mutation root */
export type mutation_root_delete_PinCode_by_pkArgs = {
  pinCodeId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_PropertyArgs = {
  where: Property_bool_exp;
};


/** mutation root */
export type mutation_root_delete_PropertyFeatureFlagArgs = {
  where: PropertyFeatureFlag_bool_exp;
};


/** mutation root */
export type mutation_root_delete_PropertyFeatureFlag_by_pkArgs = {
  propertyFeatureFlagId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_PropertyMapArgs = {
  where: PropertyMap_bool_exp;
};


/** mutation root */
export type mutation_root_delete_PropertyMap_by_pkArgs = {
  propertyMapId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_Property_by_pkArgs = {
  propertyId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_RelayArgs = {
  where: Relay_bool_exp;
};


/** mutation root */
export type mutation_root_delete_Relay_by_pkArgs = {
  relayId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_RoleArgs = {
  where: Role_bool_exp;
};


/** mutation root */
export type mutation_root_delete_RolePermissionArgs = {
  where: RolePermission_bool_exp;
};


/** mutation root */
export type mutation_root_delete_RolePermission_by_pkArgs = {
  rolePermissionId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_RoleRelationshipArgs = {
  where: RoleRelationship_bool_exp;
};


/** mutation root */
export type mutation_root_delete_RoleRelationship_by_pkArgs = {
  roleRelationshipId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_Role_by_pkArgs = {
  roleId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_SmartLockArgs = {
  where: SmartLock_bool_exp;
};


/** mutation root */
export type mutation_root_delete_SmartLock_by_pkArgs = {
  smartLockId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_TicketArgs = {
  where: Ticket_bool_exp;
};


/** mutation root */
export type mutation_root_delete_Ticket_by_pkArgs = {
  ticketId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_UnitArgs = {
  where: Unit_bool_exp;
};


/** mutation root */
export type mutation_root_delete_UnitGroupArgs = {
  where: UnitGroup_bool_exp;
};


/** mutation root */
export type mutation_root_delete_UnitGroup_by_pkArgs = {
  unitGroupId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_delete_Unit_by_pkArgs = {
  unitId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_root_insert_AccessPointArgs = {
  objects: Array<AccessPoint_insert_input>;
  on_conflict?: InputMaybe<AccessPoint_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_AccessPointRoleArgs = {
  objects: Array<AccessPointRole_insert_input>;
  on_conflict?: InputMaybe<AccessPointRole_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_AccessPointRole_oneArgs = {
  object: AccessPointRole_insert_input;
  on_conflict?: InputMaybe<AccessPointRole_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_AccessPoint_oneArgs = {
  object: AccessPoint_insert_input;
  on_conflict?: InputMaybe<AccessPoint_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_CredentialArgs = {
  objects: Array<Credential_insert_input>;
  on_conflict?: InputMaybe<Credential_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_Credential_oneArgs = {
  object: Credential_insert_input;
  on_conflict?: InputMaybe<Credential_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_OrganizationArgs = {
  objects: Array<Organization_insert_input>;
  on_conflict?: InputMaybe<Organization_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_Organization_oneArgs = {
  object: Organization_insert_input;
  on_conflict?: InputMaybe<Organization_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_PinCodeArgs = {
  objects: Array<PinCode_insert_input>;
  on_conflict?: InputMaybe<PinCode_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_PinCode_oneArgs = {
  object: PinCode_insert_input;
  on_conflict?: InputMaybe<PinCode_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_PropertyArgs = {
  objects: Array<Property_insert_input>;
  on_conflict?: InputMaybe<Property_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_PropertyFeatureFlagArgs = {
  objects: Array<PropertyFeatureFlag_insert_input>;
  on_conflict?: InputMaybe<PropertyFeatureFlag_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_PropertyFeatureFlag_oneArgs = {
  object: PropertyFeatureFlag_insert_input;
  on_conflict?: InputMaybe<PropertyFeatureFlag_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_Property_oneArgs = {
  object: Property_insert_input;
  on_conflict?: InputMaybe<Property_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_RoleArgs = {
  objects: Array<Role_insert_input>;
  on_conflict?: InputMaybe<Role_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_RolePermissionArgs = {
  objects: Array<RolePermission_insert_input>;
  on_conflict?: InputMaybe<RolePermission_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_RolePermission_oneArgs = {
  object: RolePermission_insert_input;
  on_conflict?: InputMaybe<RolePermission_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_RoleRelationshipArgs = {
  objects: Array<RoleRelationship_insert_input>;
  on_conflict?: InputMaybe<RoleRelationship_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_RoleRelationship_oneArgs = {
  object: RoleRelationship_insert_input;
  on_conflict?: InputMaybe<RoleRelationship_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_Role_oneArgs = {
  object: Role_insert_input;
  on_conflict?: InputMaybe<Role_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_TicketArgs = {
  objects: Array<Ticket_insert_input>;
  on_conflict?: InputMaybe<Ticket_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_Ticket_oneArgs = {
  object: Ticket_insert_input;
  on_conflict?: InputMaybe<Ticket_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_UnitArgs = {
  objects: Array<Unit_insert_input>;
  on_conflict?: InputMaybe<Unit_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_UnitGroupArgs = {
  objects: Array<UnitGroup_insert_input>;
  on_conflict?: InputMaybe<UnitGroup_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_UnitGroup_oneArgs = {
  object: UnitGroup_insert_input;
  on_conflict?: InputMaybe<UnitGroup_on_conflict>;
};


/** mutation root */
export type mutation_root_insert_Unit_oneArgs = {
  object: Unit_insert_input;
  on_conflict?: InputMaybe<Unit_on_conflict>;
};


/** mutation root */
export type mutation_root_update_AccessPointArgs = {
  _append?: InputMaybe<AccessPoint_append_input>;
  _delete_at_path?: InputMaybe<AccessPoint_delete_at_path_input>;
  _delete_elem?: InputMaybe<AccessPoint_delete_elem_input>;
  _delete_key?: InputMaybe<AccessPoint_delete_key_input>;
  _inc?: InputMaybe<AccessPoint_inc_input>;
  _prepend?: InputMaybe<AccessPoint_prepend_input>;
  _set?: InputMaybe<AccessPoint_set_input>;
  where: AccessPoint_bool_exp;
};


/** mutation root */
export type mutation_root_update_AccessPointRoleArgs = {
  _append?: InputMaybe<AccessPointRole_append_input>;
  _delete_at_path?: InputMaybe<AccessPointRole_delete_at_path_input>;
  _delete_elem?: InputMaybe<AccessPointRole_delete_elem_input>;
  _delete_key?: InputMaybe<AccessPointRole_delete_key_input>;
  _prepend?: InputMaybe<AccessPointRole_prepend_input>;
  _set?: InputMaybe<AccessPointRole_set_input>;
  where: AccessPointRole_bool_exp;
};


/** mutation root */
export type mutation_root_update_AccessPointRole_by_pkArgs = {
  _append?: InputMaybe<AccessPointRole_append_input>;
  _delete_at_path?: InputMaybe<AccessPointRole_delete_at_path_input>;
  _delete_elem?: InputMaybe<AccessPointRole_delete_elem_input>;
  _delete_key?: InputMaybe<AccessPointRole_delete_key_input>;
  _prepend?: InputMaybe<AccessPointRole_prepend_input>;
  _set?: InputMaybe<AccessPointRole_set_input>;
  pk_columns: AccessPointRole_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_AccessPointRole_manyArgs = {
  updates: Array<AccessPointRole_updates>;
};


/** mutation root */
export type mutation_root_update_AccessPoint_by_pkArgs = {
  _append?: InputMaybe<AccessPoint_append_input>;
  _delete_at_path?: InputMaybe<AccessPoint_delete_at_path_input>;
  _delete_elem?: InputMaybe<AccessPoint_delete_elem_input>;
  _delete_key?: InputMaybe<AccessPoint_delete_key_input>;
  _inc?: InputMaybe<AccessPoint_inc_input>;
  _prepend?: InputMaybe<AccessPoint_prepend_input>;
  _set?: InputMaybe<AccessPoint_set_input>;
  pk_columns: AccessPoint_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_AccessPoint_manyArgs = {
  updates: Array<AccessPoint_updates>;
};


/** mutation root */
export type mutation_root_update_BeaconArgs = {
  _set?: InputMaybe<Beacon_set_input>;
  where: Beacon_bool_exp;
};


/** mutation root */
export type mutation_root_update_Beacon_by_pkArgs = {
  _set?: InputMaybe<Beacon_set_input>;
  pk_columns: Beacon_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_Beacon_manyArgs = {
  updates: Array<Beacon_updates>;
};


/** mutation root */
export type mutation_root_update_CredentialArgs = {
  _set?: InputMaybe<Credential_set_input>;
  where: Credential_bool_exp;
};


/** mutation root */
export type mutation_root_update_Credential_by_pkArgs = {
  _set?: InputMaybe<Credential_set_input>;
  pk_columns: Credential_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_Credential_manyArgs = {
  updates: Array<Credential_updates>;
};


/** mutation root */
export type mutation_root_update_HubArgs = {
  _inc?: InputMaybe<Hub_inc_input>;
  _set?: InputMaybe<Hub_set_input>;
  where: Hub_bool_exp;
};


/** mutation root */
export type mutation_root_update_Hub_by_pkArgs = {
  _inc?: InputMaybe<Hub_inc_input>;
  _set?: InputMaybe<Hub_set_input>;
  pk_columns: Hub_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_Hub_manyArgs = {
  updates: Array<Hub_updates>;
};


/** mutation root */
export type mutation_root_update_OrganizationArgs = {
  _set?: InputMaybe<Organization_set_input>;
  where: Organization_bool_exp;
};


/** mutation root */
export type mutation_root_update_Organization_by_pkArgs = {
  _set?: InputMaybe<Organization_set_input>;
  pk_columns: Organization_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_Organization_manyArgs = {
  updates: Array<Organization_updates>;
};


/** mutation root */
export type mutation_root_update_PinCodeArgs = {
  _set?: InputMaybe<PinCode_set_input>;
  where: PinCode_bool_exp;
};


/** mutation root */
export type mutation_root_update_PinCode_by_pkArgs = {
  _set?: InputMaybe<PinCode_set_input>;
  pk_columns: PinCode_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_PinCode_manyArgs = {
  updates: Array<PinCode_updates>;
};


/** mutation root */
export type mutation_root_update_PropertyArgs = {
  _set?: InputMaybe<Property_set_input>;
  where: Property_bool_exp;
};


/** mutation root */
export type mutation_root_update_PropertyFeatureFlagArgs = {
  _set?: InputMaybe<PropertyFeatureFlag_set_input>;
  where: PropertyFeatureFlag_bool_exp;
};


/** mutation root */
export type mutation_root_update_PropertyFeatureFlag_by_pkArgs = {
  _set?: InputMaybe<PropertyFeatureFlag_set_input>;
  pk_columns: PropertyFeatureFlag_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_PropertyFeatureFlag_manyArgs = {
  updates: Array<PropertyFeatureFlag_updates>;
};


/** mutation root */
export type mutation_root_update_PropertyMapArgs = {
  _set?: InputMaybe<PropertyMap_set_input>;
  where: PropertyMap_bool_exp;
};


/** mutation root */
export type mutation_root_update_PropertyMap_by_pkArgs = {
  _set?: InputMaybe<PropertyMap_set_input>;
  pk_columns: PropertyMap_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_PropertyMap_manyArgs = {
  updates: Array<PropertyMap_updates>;
};


/** mutation root */
export type mutation_root_update_Property_by_pkArgs = {
  _set?: InputMaybe<Property_set_input>;
  pk_columns: Property_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_Property_manyArgs = {
  updates: Array<Property_updates>;
};


/** mutation root */
export type mutation_root_update_RelayArgs = {
  _inc?: InputMaybe<Relay_inc_input>;
  _set?: InputMaybe<Relay_set_input>;
  where: Relay_bool_exp;
};


/** mutation root */
export type mutation_root_update_Relay_by_pkArgs = {
  _inc?: InputMaybe<Relay_inc_input>;
  _set?: InputMaybe<Relay_set_input>;
  pk_columns: Relay_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_Relay_manyArgs = {
  updates: Array<Relay_updates>;
};


/** mutation root */
export type mutation_root_update_RoleArgs = {
  _inc?: InputMaybe<Role_inc_input>;
  _set?: InputMaybe<Role_set_input>;
  where: Role_bool_exp;
};


/** mutation root */
export type mutation_root_update_RolePermissionArgs = {
  _set?: InputMaybe<RolePermission_set_input>;
  where: RolePermission_bool_exp;
};


/** mutation root */
export type mutation_root_update_RolePermission_by_pkArgs = {
  _set?: InputMaybe<RolePermission_set_input>;
  pk_columns: RolePermission_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_RolePermission_manyArgs = {
  updates: Array<RolePermission_updates>;
};


/** mutation root */
export type mutation_root_update_RoleRelationshipArgs = {
  _set?: InputMaybe<RoleRelationship_set_input>;
  where: RoleRelationship_bool_exp;
};


/** mutation root */
export type mutation_root_update_RoleRelationship_by_pkArgs = {
  _set?: InputMaybe<RoleRelationship_set_input>;
  pk_columns: RoleRelationship_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_RoleRelationship_manyArgs = {
  updates: Array<RoleRelationship_updates>;
};


/** mutation root */
export type mutation_root_update_Role_by_pkArgs = {
  _inc?: InputMaybe<Role_inc_input>;
  _set?: InputMaybe<Role_set_input>;
  pk_columns: Role_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_Role_manyArgs = {
  updates: Array<Role_updates>;
};


/** mutation root */
export type mutation_root_update_SmartLockArgs = {
  _set?: InputMaybe<SmartLock_set_input>;
  where: SmartLock_bool_exp;
};


/** mutation root */
export type mutation_root_update_SmartLock_by_pkArgs = {
  _set?: InputMaybe<SmartLock_set_input>;
  pk_columns: SmartLock_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_SmartLock_manyArgs = {
  updates: Array<SmartLock_updates>;
};


/** mutation root */
export type mutation_root_update_UnitArgs = {
  _set?: InputMaybe<Unit_set_input>;
  where: Unit_bool_exp;
};


/** mutation root */
export type mutation_root_update_UnitGroupArgs = {
  _set?: InputMaybe<UnitGroup_set_input>;
  where: UnitGroup_bool_exp;
};


/** mutation root */
export type mutation_root_update_UnitGroup_by_pkArgs = {
  _set?: InputMaybe<UnitGroup_set_input>;
  pk_columns: UnitGroup_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_UnitGroup_manyArgs = {
  updates: Array<UnitGroup_updates>;
};


/** mutation root */
export type mutation_root_update_Unit_by_pkArgs = {
  _set?: InputMaybe<Unit_set_input>;
  pk_columns: Unit_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_Unit_manyArgs = {
  updates: Array<Unit_updates>;
};


/** mutation root */
export type mutation_root_update_UserRoleArgs = {
  _append?: InputMaybe<UserRole_append_input>;
  _delete_at_path?: InputMaybe<UserRole_delete_at_path_input>;
  _delete_elem?: InputMaybe<UserRole_delete_elem_input>;
  _delete_key?: InputMaybe<UserRole_delete_key_input>;
  _prepend?: InputMaybe<UserRole_prepend_input>;
  _set?: InputMaybe<UserRole_set_input>;
  where: UserRole_bool_exp;
};


/** mutation root */
export type mutation_root_update_UserRole_by_pkArgs = {
  _append?: InputMaybe<UserRole_append_input>;
  _delete_at_path?: InputMaybe<UserRole_delete_at_path_input>;
  _delete_elem?: InputMaybe<UserRole_delete_elem_input>;
  _delete_key?: InputMaybe<UserRole_delete_key_input>;
  _prepend?: InputMaybe<UserRole_prepend_input>;
  _set?: InputMaybe<UserRole_set_input>;
  pk_columns: UserRole_pk_columns_input;
};


/** mutation root */
export type mutation_root_update_UserRole_manyArgs = {
  updates: Array<UserRole_updates>;
};

/** column ordering options */
export enum order_by {
  /** in ascending order, nulls last */
  asc = 'asc',
  /** in ascending order, nulls first */
  asc_nulls_first = 'asc_nulls_first',
  /** in ascending order, nulls last */
  asc_nulls_last = 'asc_nulls_last',
  /** in descending order, nulls first */
  desc = 'desc',
  /** in descending order, nulls first */
  desc_nulls_first = 'desc_nulls_first',
  /** in descending order, nulls last */
  desc_nulls_last = 'desc_nulls_last'
}

export type query_root = {
  /** fetch data from the table: "AccessPoint" */
  AccessPoint: Array<AccessPoint>;
  /** fetch data from the table: "AccessPointRelay" */
  AccessPointRelay: Array<AccessPointRelay>;
  /** fetch aggregated fields from the table: "AccessPointRelay" */
  AccessPointRelay_aggregate: AccessPointRelay_aggregate;
  /** fetch data from the table: "AccessPointRelay" using primary key columns */
  AccessPointRelay_by_pk?: Maybe<AccessPointRelay>;
  /** fetch data from the table: "AccessPointRole" */
  AccessPointRole: Array<AccessPointRole>;
  /** fetch aggregated fields from the table: "AccessPointRole" */
  AccessPointRole_aggregate: AccessPointRole_aggregate;
  /** fetch data from the table: "AccessPointRole" using primary key columns */
  AccessPointRole_by_pk?: Maybe<AccessPointRole>;
  /** fetch data from the table: "AccessPointType" */
  AccessPointType: Array<AccessPointType>;
  /** fetch aggregated fields from the table: "AccessPointType" */
  AccessPointType_aggregate: AccessPointType_aggregate;
  /** fetch data from the table: "AccessPointType" using primary key columns */
  AccessPointType_by_pk?: Maybe<AccessPointType>;
  /** fetch aggregated fields from the table: "AccessPoint" */
  AccessPoint_aggregate: AccessPoint_aggregate;
  /** fetch data from the table: "AccessPoint" using primary key columns */
  AccessPoint_by_pk?: Maybe<AccessPoint>;
  /** fetch data from the table: "AccountStatus" */
  AccountStatus: Array<AccountStatus>;
  /** fetch aggregated fields from the table: "AccountStatus" */
  AccountStatus_aggregate: AccountStatus_aggregate;
  /** fetch data from the table: "AccountStatus" using primary key columns */
  AccountStatus_by_pk?: Maybe<AccountStatus>;
  /** fetch data from the table: "AuthMethod" */
  AuthMethod: Array<AuthMethod>;
  /** fetch aggregated fields from the table: "AuthMethod" */
  AuthMethod_aggregate: AuthMethod_aggregate;
  /** fetch data from the table: "AuthMethod" using primary key columns */
  AuthMethod_by_pk?: Maybe<AuthMethod>;
  /** fetch data from the table: "Beacon" */
  Beacon: Array<Beacon>;
  /** fetch aggregated fields from the table: "Beacon" */
  Beacon_aggregate: Beacon_aggregate;
  /** fetch data from the table: "Beacon" using primary key columns */
  Beacon_by_pk?: Maybe<Beacon>;
  /** fetch data from the table: "Credential" */
  Credential: Array<Credential>;
  /** fetch data from the table: "CredentialType" */
  CredentialType: Array<CredentialType>;
  /** fetch aggregated fields from the table: "CredentialType" */
  CredentialType_aggregate: CredentialType_aggregate;
  /** fetch data from the table: "CredentialType" using primary key columns */
  CredentialType_by_pk?: Maybe<CredentialType>;
  /** fetch aggregated fields from the table: "Credential" */
  Credential_aggregate: Credential_aggregate;
  /** fetch data from the table: "Credential" using primary key columns */
  Credential_by_pk?: Maybe<Credential>;
  /** fetch data from the table: "EmergencyPlan" */
  EmergencyPlan: Array<EmergencyPlan>;
  /** fetch aggregated fields from the table: "EmergencyPlan" */
  EmergencyPlan_aggregate: EmergencyPlan_aggregate;
  /** fetch data from the table: "EmergencyPlan" using primary key columns */
  EmergencyPlan_by_pk?: Maybe<EmergencyPlan>;
  /** fetch data from the table: "EmergencyScenarioStatus" */
  EmergencyScenarioStatus: Array<EmergencyScenarioStatus>;
  /** fetch aggregated fields from the table: "EmergencyScenarioStatus" */
  EmergencyScenarioStatus_aggregate: EmergencyScenarioStatus_aggregate;
  /** fetch data from the table: "EmergencyScenarioStatus" using primary key columns */
  EmergencyScenarioStatus_by_pk?: Maybe<EmergencyScenarioStatus>;
  /** fetch data from the table: "FailurePlan" */
  FailurePlan: Array<FailurePlan>;
  /** fetch aggregated fields from the table: "FailurePlan" */
  FailurePlan_aggregate: FailurePlan_aggregate;
  /** fetch data from the table: "FailurePlan" using primary key columns */
  FailurePlan_by_pk?: Maybe<FailurePlan>;
  /** fetch data from the table: "Favorite" */
  Favorite: Array<Favorite>;
  /** fetch aggregated fields from the table: "Favorite" */
  Favorite_aggregate: Favorite_aggregate;
  /** fetch data from the table: "Favorite" using primary key columns */
  Favorite_by_pk?: Maybe<Favorite>;
  /** fetch data from the table: "FeatureFlag" */
  FeatureFlag: Array<FeatureFlag>;
  /** fetch data from the table: "FeatureFlagKey" */
  FeatureFlagKey: Array<FeatureFlagKey>;
  /** fetch aggregated fields from the table: "FeatureFlagKey" */
  FeatureFlagKey_aggregate: FeatureFlagKey_aggregate;
  /** fetch data from the table: "FeatureFlagKey" using primary key columns */
  FeatureFlagKey_by_pk?: Maybe<FeatureFlagKey>;
  /** fetch aggregated fields from the table: "FeatureFlag" */
  FeatureFlag_aggregate: FeatureFlag_aggregate;
  /** fetch data from the table: "FeatureFlag" using primary key columns */
  FeatureFlag_by_pk?: Maybe<FeatureFlag>;
  /** fetch data from the table: "GpioMode" */
  GpioMode: Array<GpioMode>;
  /** fetch aggregated fields from the table: "GpioMode" */
  GpioMode_aggregate: GpioMode_aggregate;
  /** fetch data from the table: "GpioMode" using primary key columns */
  GpioMode_by_pk?: Maybe<GpioMode>;
  /** fetch data from the table: "Hub" */
  Hub: Array<Hub>;
  /** fetch data from the table: "HubActivationStatus" */
  HubActivationStatus: Array<HubActivationStatus>;
  /** fetch aggregated fields from the table: "HubActivationStatus" */
  HubActivationStatus_aggregate: HubActivationStatus_aggregate;
  /** fetch data from the table: "HubActivationStatus" using primary key columns */
  HubActivationStatus_by_pk?: Maybe<HubActivationStatus>;
  /** fetch data from the table: "HubDeviceType" */
  HubDeviceType: Array<HubDeviceType>;
  /** fetch aggregated fields from the table: "HubDeviceType" */
  HubDeviceType_aggregate: HubDeviceType_aggregate;
  /** fetch data from the table: "HubDeviceType" using primary key columns */
  HubDeviceType_by_pk?: Maybe<HubDeviceType>;
  /** fetch aggregated fields from the table: "Hub" */
  Hub_aggregate: Hub_aggregate;
  /** fetch data from the table: "Hub" using primary key columns */
  Hub_by_pk?: Maybe<Hub>;
  /** fetch data from the table: "Image" */
  Image: Array<Image>;
  /** fetch aggregated fields from the table: "Image" */
  Image_aggregate: Image_aggregate;
  /** fetch data from the table: "Image" using primary key columns */
  Image_by_pk?: Maybe<Image>;
  /** fetch data from the table: "InputDevice" */
  InputDevice: Array<InputDevice>;
  /** fetch aggregated fields from the table: "InputDevice" */
  InputDevice_aggregate: InputDevice_aggregate;
  /** fetch data from the table: "InputDevice" using primary key columns */
  InputDevice_by_pk?: Maybe<InputDevice>;
  /** fetch data from the table: "Organization" */
  Organization: Array<Organization>;
  /** fetch aggregated fields from the table: "Organization" */
  Organization_aggregate: Organization_aggregate;
  /** fetch data from the table: "Organization" using primary key columns */
  Organization_by_pk?: Maybe<Organization>;
  /** fetch data from the table: "Permission" */
  Permission: Array<Permission>;
  /** fetch data from the table: "PermissionKey" */
  PermissionKey: Array<PermissionKey>;
  /** fetch aggregated fields from the table: "PermissionKey" */
  PermissionKey_aggregate: PermissionKey_aggregate;
  /** fetch data from the table: "PermissionKey" using primary key columns */
  PermissionKey_by_pk?: Maybe<PermissionKey>;
  /** fetch data from the table: "PermissionScope" */
  PermissionScope: Array<PermissionScope>;
  /** fetch aggregated fields from the table: "PermissionScope" */
  PermissionScope_aggregate: PermissionScope_aggregate;
  /** fetch data from the table: "PermissionScope" using primary key columns */
  PermissionScope_by_pk?: Maybe<PermissionScope>;
  /** fetch aggregated fields from the table: "Permission" */
  Permission_aggregate: Permission_aggregate;
  /** fetch data from the table: "Permission" using primary key columns */
  Permission_by_pk?: Maybe<Permission>;
  /** fetch data from the table: "PinCode" */
  PinCode: Array<PinCode>;
  /** fetch data from the table: "PinCodePrivate" */
  PinCodePrivate: Array<PinCodePrivate>;
  /** fetch aggregated fields from the table: "PinCodePrivate" */
  PinCodePrivate_aggregate: PinCodePrivate_aggregate;
  /** fetch aggregated fields from the table: "PinCode" */
  PinCode_aggregate: PinCode_aggregate;
  /** fetch data from the table: "PinCode" using primary key columns */
  PinCode_by_pk?: Maybe<PinCode>;
  /** fetch data from the table: "Property" */
  Property: Array<Property>;
  /** fetch data from the table: "PropertyFeatureFlag" */
  PropertyFeatureFlag: Array<PropertyFeatureFlag>;
  /** fetch aggregated fields from the table: "PropertyFeatureFlag" */
  PropertyFeatureFlag_aggregate: PropertyFeatureFlag_aggregate;
  /** fetch data from the table: "PropertyFeatureFlag" using primary key columns */
  PropertyFeatureFlag_by_pk?: Maybe<PropertyFeatureFlag>;
  /** fetch data from the table: "PropertyMap" */
  PropertyMap: Array<PropertyMap>;
  /** fetch aggregated fields from the table: "PropertyMap" */
  PropertyMap_aggregate: PropertyMap_aggregate;
  /** fetch data from the table: "PropertyMap" using primary key columns */
  PropertyMap_by_pk?: Maybe<PropertyMap>;
  /** fetch data from the table: "PropertySource" */
  PropertySource: Array<PropertySource>;
  /** fetch aggregated fields from the table: "PropertySource" */
  PropertySource_aggregate: PropertySource_aggregate;
  /** fetch data from the table: "PropertySource" using primary key columns */
  PropertySource_by_pk?: Maybe<PropertySource>;
  /** fetch aggregated fields from the table: "Property" */
  Property_aggregate: Property_aggregate;
  /** fetch data from the table: "Property" using primary key columns */
  Property_by_pk?: Maybe<Property>;
  /** fetch data from the table: "ReaderType" */
  ReaderType: Array<ReaderType>;
  /** fetch aggregated fields from the table: "ReaderType" */
  ReaderType_aggregate: ReaderType_aggregate;
  /** fetch data from the table: "ReaderType" using primary key columns */
  ReaderType_by_pk?: Maybe<ReaderType>;
  /** fetch data from the table: "Relay" */
  Relay: Array<Relay>;
  /** fetch data from the table: "RelayLog" */
  RelayLog: Array<RelayLog>;
  /** fetch aggregated fields from the table: "RelayLog" */
  RelayLog_aggregate: RelayLog_aggregate;
  /** fetch data from the table: "RelayLog" using primary key columns */
  RelayLog_by_pk?: Maybe<RelayLog>;
  /** fetch aggregated fields from the table: "Relay" */
  Relay_aggregate: Relay_aggregate;
  /** fetch data from the table: "Relay" using primary key columns */
  Relay_by_pk?: Maybe<Relay>;
  /** fetch data from the table: "Role" */
  Role: Array<Role>;
  /** fetch data from the table: "RoleKey" */
  RoleKey: Array<RoleKey>;
  /** fetch aggregated fields from the table: "RoleKey" */
  RoleKey_aggregate: RoleKey_aggregate;
  /** fetch data from the table: "RoleKey" using primary key columns */
  RoleKey_by_pk?: Maybe<RoleKey>;
  /** fetch data from the table: "RolePermission" */
  RolePermission: Array<RolePermission>;
  /** fetch aggregated fields from the table: "RolePermission" */
  RolePermission_aggregate: RolePermission_aggregate;
  /** fetch data from the table: "RolePermission" using primary key columns */
  RolePermission_by_pk?: Maybe<RolePermission>;
  /** fetch data from the table: "RoleRelationship" */
  RoleRelationship: Array<RoleRelationship>;
  /** fetch aggregated fields from the table: "RoleRelationship" */
  RoleRelationship_aggregate: RoleRelationship_aggregate;
  /** fetch data from the table: "RoleRelationship" using primary key columns */
  RoleRelationship_by_pk?: Maybe<RoleRelationship>;
  /** fetch aggregated fields from the table: "Role" */
  Role_aggregate: Role_aggregate;
  /** fetch data from the table: "Role" using primary key columns */
  Role_by_pk?: Maybe<Role>;
  /** fetch data from the table: "Session" */
  Session: Array<Session>;
  /** fetch data from the table: "SessionType" */
  SessionType: Array<SessionType>;
  /** fetch aggregated fields from the table: "SessionType" */
  SessionType_aggregate: SessionType_aggregate;
  /** fetch data from the table: "SessionType" using primary key columns */
  SessionType_by_pk?: Maybe<SessionType>;
  /** fetch aggregated fields from the table: "Session" */
  Session_aggregate: Session_aggregate;
  /** fetch data from the table: "Session" using primary key columns */
  Session_by_pk?: Maybe<Session>;
  /** fetch data from the table: "SmartLock" */
  SmartLock: Array<SmartLock>;
  /** fetch data from the table: "SmartLockLog" */
  SmartLockLog: Array<SmartLockLog>;
  /** fetch data from the table: "SmartLockLogType" */
  SmartLockLogType: Array<SmartLockLogType>;
  /** fetch aggregated fields from the table: "SmartLockLogType" */
  SmartLockLogType_aggregate: SmartLockLogType_aggregate;
  /** fetch data from the table: "SmartLockLogType" using primary key columns */
  SmartLockLogType_by_pk?: Maybe<SmartLockLogType>;
  /** fetch aggregated fields from the table: "SmartLockLog" */
  SmartLockLog_aggregate: SmartLockLog_aggregate;
  /** fetch data from the table: "SmartLockLog" using primary key columns */
  SmartLockLog_by_pk?: Maybe<SmartLockLog>;
  /** fetch aggregated fields from the table: "SmartLock" */
  SmartLock_aggregate: SmartLock_aggregate;
  /** fetch data from the table: "SmartLock" using primary key columns */
  SmartLock_by_pk?: Maybe<SmartLock>;
  /** fetch data from the table: "Ticket" */
  Ticket: Array<Ticket>;
  /** fetch data from the table: "TicketStatus" */
  TicketStatus: Array<TicketStatus>;
  /** fetch aggregated fields from the table: "TicketStatus" */
  TicketStatus_aggregate: TicketStatus_aggregate;
  /** fetch data from the table: "TicketStatus" using primary key columns */
  TicketStatus_by_pk?: Maybe<TicketStatus>;
  /** fetch data from the table: "TicketType" */
  TicketType: Array<TicketType>;
  /** fetch aggregated fields from the table: "TicketType" */
  TicketType_aggregate: TicketType_aggregate;
  /** fetch data from the table: "TicketType" using primary key columns */
  TicketType_by_pk?: Maybe<TicketType>;
  /** fetch aggregated fields from the table: "Ticket" */
  Ticket_aggregate: Ticket_aggregate;
  /** fetch data from the table: "Ticket" using primary key columns */
  Ticket_by_pk?: Maybe<Ticket>;
  /** fetch data from the table: "Timezone" */
  Timezone: Array<Timezone>;
  /** fetch aggregated fields from the table: "Timezone" */
  Timezone_aggregate: Timezone_aggregate;
  /** fetch data from the table: "Timezone" using primary key columns */
  Timezone_by_pk?: Maybe<Timezone>;
  /** fetch data from the table: "Unit" */
  Unit: Array<Unit>;
  /** fetch data from the table: "UnitGroup" */
  UnitGroup: Array<UnitGroup>;
  /** fetch aggregated fields from the table: "UnitGroup" */
  UnitGroup_aggregate: UnitGroup_aggregate;
  /** fetch data from the table: "UnitGroup" using primary key columns */
  UnitGroup_by_pk?: Maybe<UnitGroup>;
  /** fetch data from the table: "UnitType" */
  UnitType: Array<UnitType>;
  /** fetch aggregated fields from the table: "UnitType" */
  UnitType_aggregate: UnitType_aggregate;
  /** fetch data from the table: "UnitType" using primary key columns */
  UnitType_by_pk?: Maybe<UnitType>;
  /** fetch aggregated fields from the table: "Unit" */
  Unit_aggregate: Unit_aggregate;
  /** fetch data from the table: "Unit" using primary key columns */
  Unit_by_pk?: Maybe<Unit>;
  /** fetch data from the table: "UnlockMethod" */
  UnlockMethod: Array<UnlockMethod>;
  /** fetch aggregated fields from the table: "UnlockMethod" */
  UnlockMethod_aggregate: UnlockMethod_aggregate;
  /** fetch data from the table: "UnlockMethod" using primary key columns */
  UnlockMethod_by_pk?: Maybe<UnlockMethod>;
  /** fetch data from the table: "UnlockResult" */
  UnlockResult: Array<UnlockResult>;
  /** fetch aggregated fields from the table: "UnlockResult" */
  UnlockResult_aggregate: UnlockResult_aggregate;
  /** fetch data from the table: "UnlockResult" using primary key columns */
  UnlockResult_by_pk?: Maybe<UnlockResult>;
  /** fetch data from the table: "User" */
  User: Array<User>;
  /** fetch data from the table: "UserRole" */
  UserRole: Array<UserRole>;
  /** fetch data from the table: "UserRoleGrantMethod" */
  UserRoleGrantMethod: Array<UserRoleGrantMethod>;
  /** fetch aggregated fields from the table: "UserRoleGrantMethod" */
  UserRoleGrantMethod_aggregate: UserRoleGrantMethod_aggregate;
  /** fetch data from the table: "UserRoleGrantMethod" using primary key columns */
  UserRoleGrantMethod_by_pk?: Maybe<UserRoleGrantMethod>;
  /** fetch data from the table: "UserRolePermission" */
  UserRolePermission: Array<UserRolePermission>;
  /** fetch aggregated fields from the table: "UserRolePermission" */
  UserRolePermission_aggregate: UserRolePermission_aggregate;
  /** fetch data from the table: "UserRoleReason" */
  UserRoleReason: Array<UserRoleReason>;
  /** fetch aggregated fields from the table: "UserRoleReason" */
  UserRoleReason_aggregate: UserRoleReason_aggregate;
  /** fetch data from the table: "UserRoleReason" using primary key columns */
  UserRoleReason_by_pk?: Maybe<UserRoleReason>;
  /** fetch data from the table: "UserRoleStatus" */
  UserRoleStatus: Array<UserRoleStatus>;
  /** fetch aggregated fields from the table: "UserRoleStatus" */
  UserRoleStatus_aggregate: UserRoleStatus_aggregate;
  /** fetch data from the table: "UserRoleStatus" using primary key columns */
  UserRoleStatus_by_pk?: Maybe<UserRoleStatus>;
  /** fetch aggregated fields from the table: "UserRole" */
  UserRole_aggregate: UserRole_aggregate;
  /** fetch data from the table: "UserRole" using primary key columns */
  UserRole_by_pk?: Maybe<UserRole>;
  /** fetch aggregated fields from the table: "User" */
  User_aggregate: User_aggregate;
  /** fetch data from the table: "User" using primary key columns */
  User_by_pk?: Maybe<User>;
  /** fetch data from the table: "VirtualDirectoryUserDisplayNameFormat" */
  VirtualDirectoryUserDisplayNameFormat: Array<VirtualDirectoryUserDisplayNameFormat>;
  /** fetch aggregated fields from the table: "VirtualDirectoryUserDisplayNameFormat" */
  VirtualDirectoryUserDisplayNameFormat_aggregate: VirtualDirectoryUserDisplayNameFormat_aggregate;
  /** fetch data from the table: "VirtualDirectoryUserDisplayNameFormat" using primary key columns */
  VirtualDirectoryUserDisplayNameFormat_by_pk?: Maybe<VirtualDirectoryUserDisplayNameFormat>;
  custom_getAugustLockUserRoles: Custom_GetAugustLockUserRolesOutput;
  custom_getHubHealthReports: Custom_GetHubHealthReportsOutput;
};


export type query_root_AccessPointArgs = {
  distinct_on?: InputMaybe<Array<AccessPoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPoint_order_by>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};


export type query_root_AccessPointRelayArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRelay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRelay_order_by>>;
  where?: InputMaybe<AccessPointRelay_bool_exp>;
};


export type query_root_AccessPointRelay_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRelay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRelay_order_by>>;
  where?: InputMaybe<AccessPointRelay_bool_exp>;
};


export type query_root_AccessPointRelay_by_pkArgs = {
  accessPointRelayId: Scalars['uuid']['input'];
};


export type query_root_AccessPointRoleArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRole_order_by>>;
  where?: InputMaybe<AccessPointRole_bool_exp>;
};


export type query_root_AccessPointRole_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRole_order_by>>;
  where?: InputMaybe<AccessPointRole_bool_exp>;
};


export type query_root_AccessPointRole_by_pkArgs = {
  accessPointRoleId: Scalars['uuid']['input'];
};


export type query_root_AccessPointTypeArgs = {
  distinct_on?: InputMaybe<Array<AccessPointType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointType_order_by>>;
  where?: InputMaybe<AccessPointType_bool_exp>;
};


export type query_root_AccessPointType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPointType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointType_order_by>>;
  where?: InputMaybe<AccessPointType_bool_exp>;
};


export type query_root_AccessPointType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_AccessPoint_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPoint_order_by>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};


export type query_root_AccessPoint_by_pkArgs = {
  accessPointId: Scalars['uuid']['input'];
};


export type query_root_AccountStatusArgs = {
  distinct_on?: InputMaybe<Array<AccountStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccountStatus_order_by>>;
  where?: InputMaybe<AccountStatus_bool_exp>;
};


export type query_root_AccountStatus_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccountStatus_order_by>>;
  where?: InputMaybe<AccountStatus_bool_exp>;
};


export type query_root_AccountStatus_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_AuthMethodArgs = {
  distinct_on?: InputMaybe<Array<AuthMethod_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthMethod_order_by>>;
  where?: InputMaybe<AuthMethod_bool_exp>;
};


export type query_root_AuthMethod_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthMethod_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthMethod_order_by>>;
  where?: InputMaybe<AuthMethod_bool_exp>;
};


export type query_root_AuthMethod_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_BeaconArgs = {
  distinct_on?: InputMaybe<Array<Beacon_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Beacon_order_by>>;
  where?: InputMaybe<Beacon_bool_exp>;
};


export type query_root_Beacon_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Beacon_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Beacon_order_by>>;
  where?: InputMaybe<Beacon_bool_exp>;
};


export type query_root_Beacon_by_pkArgs = {
  beaconId: Scalars['uuid']['input'];
};


export type query_root_CredentialArgs = {
  distinct_on?: InputMaybe<Array<Credential_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credential_order_by>>;
  where?: InputMaybe<Credential_bool_exp>;
};


export type query_root_CredentialTypeArgs = {
  distinct_on?: InputMaybe<Array<CredentialType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CredentialType_order_by>>;
  where?: InputMaybe<CredentialType_bool_exp>;
};


export type query_root_CredentialType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<CredentialType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CredentialType_order_by>>;
  where?: InputMaybe<CredentialType_bool_exp>;
};


export type query_root_CredentialType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_Credential_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Credential_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credential_order_by>>;
  where?: InputMaybe<Credential_bool_exp>;
};


export type query_root_Credential_by_pkArgs = {
  credentialId: Scalars['uuid']['input'];
};


export type query_root_EmergencyPlanArgs = {
  distinct_on?: InputMaybe<Array<EmergencyPlan_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EmergencyPlan_order_by>>;
  where?: InputMaybe<EmergencyPlan_bool_exp>;
};


export type query_root_EmergencyPlan_aggregateArgs = {
  distinct_on?: InputMaybe<Array<EmergencyPlan_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EmergencyPlan_order_by>>;
  where?: InputMaybe<EmergencyPlan_bool_exp>;
};


export type query_root_EmergencyPlan_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_EmergencyScenarioStatusArgs = {
  distinct_on?: InputMaybe<Array<EmergencyScenarioStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EmergencyScenarioStatus_order_by>>;
  where?: InputMaybe<EmergencyScenarioStatus_bool_exp>;
};


export type query_root_EmergencyScenarioStatus_aggregateArgs = {
  distinct_on?: InputMaybe<Array<EmergencyScenarioStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EmergencyScenarioStatus_order_by>>;
  where?: InputMaybe<EmergencyScenarioStatus_bool_exp>;
};


export type query_root_EmergencyScenarioStatus_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_FailurePlanArgs = {
  distinct_on?: InputMaybe<Array<FailurePlan_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FailurePlan_order_by>>;
  where?: InputMaybe<FailurePlan_bool_exp>;
};


export type query_root_FailurePlan_aggregateArgs = {
  distinct_on?: InputMaybe<Array<FailurePlan_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FailurePlan_order_by>>;
  where?: InputMaybe<FailurePlan_bool_exp>;
};


export type query_root_FailurePlan_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_FavoriteArgs = {
  distinct_on?: InputMaybe<Array<Favorite_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorite_order_by>>;
  where?: InputMaybe<Favorite_bool_exp>;
};


export type query_root_Favorite_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Favorite_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorite_order_by>>;
  where?: InputMaybe<Favorite_bool_exp>;
};


export type query_root_Favorite_by_pkArgs = {
  favoriteId: Scalars['uuid']['input'];
};


export type query_root_FeatureFlagArgs = {
  distinct_on?: InputMaybe<Array<FeatureFlag_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FeatureFlag_order_by>>;
  where?: InputMaybe<FeatureFlag_bool_exp>;
};


export type query_root_FeatureFlagKeyArgs = {
  distinct_on?: InputMaybe<Array<FeatureFlagKey_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FeatureFlagKey_order_by>>;
  where?: InputMaybe<FeatureFlagKey_bool_exp>;
};


export type query_root_FeatureFlagKey_aggregateArgs = {
  distinct_on?: InputMaybe<Array<FeatureFlagKey_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FeatureFlagKey_order_by>>;
  where?: InputMaybe<FeatureFlagKey_bool_exp>;
};


export type query_root_FeatureFlagKey_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_FeatureFlag_aggregateArgs = {
  distinct_on?: InputMaybe<Array<FeatureFlag_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FeatureFlag_order_by>>;
  where?: InputMaybe<FeatureFlag_bool_exp>;
};


export type query_root_FeatureFlag_by_pkArgs = {
  featureFlagId: Scalars['uuid']['input'];
};


export type query_root_GpioModeArgs = {
  distinct_on?: InputMaybe<Array<GpioMode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GpioMode_order_by>>;
  where?: InputMaybe<GpioMode_bool_exp>;
};


export type query_root_GpioMode_aggregateArgs = {
  distinct_on?: InputMaybe<Array<GpioMode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GpioMode_order_by>>;
  where?: InputMaybe<GpioMode_bool_exp>;
};


export type query_root_GpioMode_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_HubArgs = {
  distinct_on?: InputMaybe<Array<Hub_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_order_by>>;
  where?: InputMaybe<Hub_bool_exp>;
};


export type query_root_HubActivationStatusArgs = {
  distinct_on?: InputMaybe<Array<HubActivationStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<HubActivationStatus_order_by>>;
  where?: InputMaybe<HubActivationStatus_bool_exp>;
};


export type query_root_HubActivationStatus_aggregateArgs = {
  distinct_on?: InputMaybe<Array<HubActivationStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<HubActivationStatus_order_by>>;
  where?: InputMaybe<HubActivationStatus_bool_exp>;
};


export type query_root_HubActivationStatus_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_HubDeviceTypeArgs = {
  distinct_on?: InputMaybe<Array<HubDeviceType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<HubDeviceType_order_by>>;
  where?: InputMaybe<HubDeviceType_bool_exp>;
};


export type query_root_HubDeviceType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<HubDeviceType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<HubDeviceType_order_by>>;
  where?: InputMaybe<HubDeviceType_bool_exp>;
};


export type query_root_HubDeviceType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_Hub_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Hub_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_order_by>>;
  where?: InputMaybe<Hub_bool_exp>;
};


export type query_root_Hub_by_pkArgs = {
  hubId: Scalars['uuid']['input'];
};


export type query_root_ImageArgs = {
  distinct_on?: InputMaybe<Array<Image_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_order_by>>;
  where?: InputMaybe<Image_bool_exp>;
};


export type query_root_Image_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Image_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_order_by>>;
  where?: InputMaybe<Image_bool_exp>;
};


export type query_root_Image_by_pkArgs = {
  imageId: Scalars['uuid']['input'];
};


export type query_root_InputDeviceArgs = {
  distinct_on?: InputMaybe<Array<InputDevice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputDevice_order_by>>;
  where?: InputMaybe<InputDevice_bool_exp>;
};


export type query_root_InputDevice_aggregateArgs = {
  distinct_on?: InputMaybe<Array<InputDevice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputDevice_order_by>>;
  where?: InputMaybe<InputDevice_bool_exp>;
};


export type query_root_InputDevice_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_OrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_order_by>>;
  where?: InputMaybe<Organization_bool_exp>;
};


export type query_root_Organization_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_order_by>>;
  where?: InputMaybe<Organization_bool_exp>;
};


export type query_root_Organization_by_pkArgs = {
  organizationId: Scalars['uuid']['input'];
};


export type query_root_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permission_order_by>>;
  where?: InputMaybe<Permission_bool_exp>;
};


export type query_root_PermissionKeyArgs = {
  distinct_on?: InputMaybe<Array<PermissionKey_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PermissionKey_order_by>>;
  where?: InputMaybe<PermissionKey_bool_exp>;
};


export type query_root_PermissionKey_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PermissionKey_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PermissionKey_order_by>>;
  where?: InputMaybe<PermissionKey_bool_exp>;
};


export type query_root_PermissionKey_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_PermissionScopeArgs = {
  distinct_on?: InputMaybe<Array<PermissionScope_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PermissionScope_order_by>>;
  where?: InputMaybe<PermissionScope_bool_exp>;
};


export type query_root_PermissionScope_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PermissionScope_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PermissionScope_order_by>>;
  where?: InputMaybe<PermissionScope_bool_exp>;
};


export type query_root_PermissionScope_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_Permission_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permission_order_by>>;
  where?: InputMaybe<Permission_bool_exp>;
};


export type query_root_Permission_by_pkArgs = {
  permissionId: Scalars['uuid']['input'];
};


export type query_root_PinCodeArgs = {
  distinct_on?: InputMaybe<Array<PinCode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCode_order_by>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


export type query_root_PinCodePrivateArgs = {
  distinct_on?: InputMaybe<Array<PinCodePrivate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCodePrivate_order_by>>;
  where?: InputMaybe<PinCodePrivate_bool_exp>;
};


export type query_root_PinCodePrivate_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PinCodePrivate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCodePrivate_order_by>>;
  where?: InputMaybe<PinCodePrivate_bool_exp>;
};


export type query_root_PinCode_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PinCode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCode_order_by>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


export type query_root_PinCode_by_pkArgs = {
  pinCodeId: Scalars['uuid']['input'];
};


export type query_root_PropertyArgs = {
  distinct_on?: InputMaybe<Array<Property_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_order_by>>;
  where?: InputMaybe<Property_bool_exp>;
};


export type query_root_PropertyFeatureFlagArgs = {
  distinct_on?: InputMaybe<Array<PropertyFeatureFlag_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertyFeatureFlag_order_by>>;
  where?: InputMaybe<PropertyFeatureFlag_bool_exp>;
};


export type query_root_PropertyFeatureFlag_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PropertyFeatureFlag_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertyFeatureFlag_order_by>>;
  where?: InputMaybe<PropertyFeatureFlag_bool_exp>;
};


export type query_root_PropertyFeatureFlag_by_pkArgs = {
  propertyFeatureFlagId: Scalars['uuid']['input'];
};


export type query_root_PropertyMapArgs = {
  distinct_on?: InputMaybe<Array<PropertyMap_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertyMap_order_by>>;
  where?: InputMaybe<PropertyMap_bool_exp>;
};


export type query_root_PropertyMap_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PropertyMap_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertyMap_order_by>>;
  where?: InputMaybe<PropertyMap_bool_exp>;
};


export type query_root_PropertyMap_by_pkArgs = {
  propertyMapId: Scalars['uuid']['input'];
};


export type query_root_PropertySourceArgs = {
  distinct_on?: InputMaybe<Array<PropertySource_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertySource_order_by>>;
  where?: InputMaybe<PropertySource_bool_exp>;
};


export type query_root_PropertySource_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PropertySource_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertySource_order_by>>;
  where?: InputMaybe<PropertySource_bool_exp>;
};


export type query_root_PropertySource_by_pkArgs = {
  propertySourceId: Scalars['uuid']['input'];
};


export type query_root_Property_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_order_by>>;
  where?: InputMaybe<Property_bool_exp>;
};


export type query_root_Property_by_pkArgs = {
  propertyId: Scalars['uuid']['input'];
};


export type query_root_ReaderTypeArgs = {
  distinct_on?: InputMaybe<Array<ReaderType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReaderType_order_by>>;
  where?: InputMaybe<ReaderType_bool_exp>;
};


export type query_root_ReaderType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<ReaderType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReaderType_order_by>>;
  where?: InputMaybe<ReaderType_bool_exp>;
};


export type query_root_ReaderType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_RelayArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};


export type query_root_RelayLogArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


export type query_root_RelayLog_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


export type query_root_RelayLog_by_pkArgs = {
  relayLogId: Scalars['uuid']['input'];
};


export type query_root_Relay_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};


export type query_root_Relay_by_pkArgs = {
  relayId: Scalars['uuid']['input'];
};


export type query_root_RoleArgs = {
  distinct_on?: InputMaybe<Array<Role_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_order_by>>;
  where?: InputMaybe<Role_bool_exp>;
};


export type query_root_RoleKeyArgs = {
  distinct_on?: InputMaybe<Array<RoleKey_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoleKey_order_by>>;
  where?: InputMaybe<RoleKey_bool_exp>;
};


export type query_root_RoleKey_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleKey_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoleKey_order_by>>;
  where?: InputMaybe<RoleKey_bool_exp>;
};


export type query_root_RoleKey_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_RolePermissionArgs = {
  distinct_on?: InputMaybe<Array<RolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RolePermission_order_by>>;
  where?: InputMaybe<RolePermission_bool_exp>;
};


export type query_root_RolePermission_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RolePermission_order_by>>;
  where?: InputMaybe<RolePermission_bool_exp>;
};


export type query_root_RolePermission_by_pkArgs = {
  rolePermissionId: Scalars['uuid']['input'];
};


export type query_root_RoleRelationshipArgs = {
  distinct_on?: InputMaybe<Array<RoleRelationship_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoleRelationship_order_by>>;
  where?: InputMaybe<RoleRelationship_bool_exp>;
};


export type query_root_RoleRelationship_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleRelationship_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoleRelationship_order_by>>;
  where?: InputMaybe<RoleRelationship_bool_exp>;
};


export type query_root_RoleRelationship_by_pkArgs = {
  roleRelationshipId: Scalars['uuid']['input'];
};


export type query_root_Role_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_order_by>>;
  where?: InputMaybe<Role_bool_exp>;
};


export type query_root_Role_by_pkArgs = {
  roleId: Scalars['uuid']['input'];
};


export type query_root_SessionArgs = {
  distinct_on?: InputMaybe<Array<Session_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_order_by>>;
  where?: InputMaybe<Session_bool_exp>;
};


export type query_root_SessionTypeArgs = {
  distinct_on?: InputMaybe<Array<SessionType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SessionType_order_by>>;
  where?: InputMaybe<SessionType_bool_exp>;
};


export type query_root_SessionType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<SessionType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SessionType_order_by>>;
  where?: InputMaybe<SessionType_bool_exp>;
};


export type query_root_SessionType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_Session_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Session_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_order_by>>;
  where?: InputMaybe<Session_bool_exp>;
};


export type query_root_Session_by_pkArgs = {
  sessionId: Scalars['uuid']['input'];
};


export type query_root_SmartLockArgs = {
  distinct_on?: InputMaybe<Array<SmartLock_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLock_order_by>>;
  where?: InputMaybe<SmartLock_bool_exp>;
};


export type query_root_SmartLockLogArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLog_order_by>>;
  where?: InputMaybe<SmartLockLog_bool_exp>;
};


export type query_root_SmartLockLogTypeArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLogType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLogType_order_by>>;
  where?: InputMaybe<SmartLockLogType_bool_exp>;
};


export type query_root_SmartLockLogType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLogType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLogType_order_by>>;
  where?: InputMaybe<SmartLockLogType_bool_exp>;
};


export type query_root_SmartLockLogType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_SmartLockLog_aggregateArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLog_order_by>>;
  where?: InputMaybe<SmartLockLog_bool_exp>;
};


export type query_root_SmartLockLog_by_pkArgs = {
  smartLockLogId: Scalars['uuid']['input'];
};


export type query_root_SmartLock_aggregateArgs = {
  distinct_on?: InputMaybe<Array<SmartLock_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLock_order_by>>;
  where?: InputMaybe<SmartLock_bool_exp>;
};


export type query_root_SmartLock_by_pkArgs = {
  smartLockId: Scalars['uuid']['input'];
};


export type query_root_TicketArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


export type query_root_TicketStatusArgs = {
  distinct_on?: InputMaybe<Array<TicketStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TicketStatus_order_by>>;
  where?: InputMaybe<TicketStatus_bool_exp>;
};


export type query_root_TicketStatus_aggregateArgs = {
  distinct_on?: InputMaybe<Array<TicketStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TicketStatus_order_by>>;
  where?: InputMaybe<TicketStatus_bool_exp>;
};


export type query_root_TicketStatus_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_TicketTypeArgs = {
  distinct_on?: InputMaybe<Array<TicketType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TicketType_order_by>>;
  where?: InputMaybe<TicketType_bool_exp>;
};


export type query_root_TicketType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<TicketType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TicketType_order_by>>;
  where?: InputMaybe<TicketType_bool_exp>;
};


export type query_root_TicketType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_Ticket_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


export type query_root_Ticket_by_pkArgs = {
  ticketId: Scalars['uuid']['input'];
};


export type query_root_TimezoneArgs = {
  distinct_on?: InputMaybe<Array<Timezone_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Timezone_order_by>>;
  where?: InputMaybe<Timezone_bool_exp>;
};


export type query_root_Timezone_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Timezone_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Timezone_order_by>>;
  where?: InputMaybe<Timezone_bool_exp>;
};


export type query_root_Timezone_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_UnitArgs = {
  distinct_on?: InputMaybe<Array<Unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_order_by>>;
  where?: InputMaybe<Unit_bool_exp>;
};


export type query_root_UnitGroupArgs = {
  distinct_on?: InputMaybe<Array<UnitGroup_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnitGroup_order_by>>;
  where?: InputMaybe<UnitGroup_bool_exp>;
};


export type query_root_UnitGroup_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UnitGroup_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnitGroup_order_by>>;
  where?: InputMaybe<UnitGroup_bool_exp>;
};


export type query_root_UnitGroup_by_pkArgs = {
  unitGroupId: Scalars['uuid']['input'];
};


export type query_root_UnitTypeArgs = {
  distinct_on?: InputMaybe<Array<UnitType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnitType_order_by>>;
  where?: InputMaybe<UnitType_bool_exp>;
};


export type query_root_UnitType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UnitType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnitType_order_by>>;
  where?: InputMaybe<UnitType_bool_exp>;
};


export type query_root_UnitType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_Unit_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_order_by>>;
  where?: InputMaybe<Unit_bool_exp>;
};


export type query_root_Unit_by_pkArgs = {
  unitId: Scalars['uuid']['input'];
};


export type query_root_UnlockMethodArgs = {
  distinct_on?: InputMaybe<Array<UnlockMethod_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnlockMethod_order_by>>;
  where?: InputMaybe<UnlockMethod_bool_exp>;
};


export type query_root_UnlockMethod_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UnlockMethod_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnlockMethod_order_by>>;
  where?: InputMaybe<UnlockMethod_bool_exp>;
};


export type query_root_UnlockMethod_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_UnlockResultArgs = {
  distinct_on?: InputMaybe<Array<UnlockResult_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnlockResult_order_by>>;
  where?: InputMaybe<UnlockResult_bool_exp>;
};


export type query_root_UnlockResult_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UnlockResult_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnlockResult_order_by>>;
  where?: InputMaybe<UnlockResult_bool_exp>;
};


export type query_root_UnlockResult_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_UserArgs = {
  distinct_on?: InputMaybe<Array<User_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_order_by>>;
  where?: InputMaybe<User_bool_exp>;
};


export type query_root_UserRoleArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


export type query_root_UserRoleGrantMethodArgs = {
  distinct_on?: InputMaybe<Array<UserRoleGrantMethod_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoleGrantMethod_order_by>>;
  where?: InputMaybe<UserRoleGrantMethod_bool_exp>;
};


export type query_root_UserRoleGrantMethod_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRoleGrantMethod_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoleGrantMethod_order_by>>;
  where?: InputMaybe<UserRoleGrantMethod_bool_exp>;
};


export type query_root_UserRoleGrantMethod_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_UserRolePermissionArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


export type query_root_UserRolePermission_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


export type query_root_UserRoleReasonArgs = {
  distinct_on?: InputMaybe<Array<UserRoleReason_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoleReason_order_by>>;
  where?: InputMaybe<UserRoleReason_bool_exp>;
};


export type query_root_UserRoleReason_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRoleReason_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoleReason_order_by>>;
  where?: InputMaybe<UserRoleReason_bool_exp>;
};


export type query_root_UserRoleReason_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_UserRoleStatusArgs = {
  distinct_on?: InputMaybe<Array<UserRoleStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoleStatus_order_by>>;
  where?: InputMaybe<UserRoleStatus_bool_exp>;
};


export type query_root_UserRoleStatus_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRoleStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoleStatus_order_by>>;
  where?: InputMaybe<UserRoleStatus_bool_exp>;
};


export type query_root_UserRoleStatus_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_UserRole_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


export type query_root_UserRole_by_pkArgs = {
  userRoleId: Scalars['uuid']['input'];
};


export type query_root_User_aggregateArgs = {
  distinct_on?: InputMaybe<Array<User_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_order_by>>;
  where?: InputMaybe<User_bool_exp>;
};


export type query_root_User_by_pkArgs = {
  userId: Scalars['uuid']['input'];
};


export type query_root_VirtualDirectoryUserDisplayNameFormatArgs = {
  distinct_on?: InputMaybe<Array<VirtualDirectoryUserDisplayNameFormat_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VirtualDirectoryUserDisplayNameFormat_order_by>>;
  where?: InputMaybe<VirtualDirectoryUserDisplayNameFormat_bool_exp>;
};


export type query_root_VirtualDirectoryUserDisplayNameFormat_aggregateArgs = {
  distinct_on?: InputMaybe<Array<VirtualDirectoryUserDisplayNameFormat_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VirtualDirectoryUserDisplayNameFormat_order_by>>;
  where?: InputMaybe<VirtualDirectoryUserDisplayNameFormat_bool_exp>;
};


export type query_root_VirtualDirectoryUserDisplayNameFormat_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type query_root_custom_getAugustLockUserRolesArgs = {
  input: Custom_GetAugustLockUserRolesInput;
};


export type query_root_custom_getHubHealthReportsArgs = {
  input: Custom_GetHubHealthReportsInput;
};

export type subscription_root = {
  /** fetch data from the table: "AccessPoint" */
  AccessPoint: Array<AccessPoint>;
  /** fetch data from the table: "AccessPointRelay" */
  AccessPointRelay: Array<AccessPointRelay>;
  /** fetch aggregated fields from the table: "AccessPointRelay" */
  AccessPointRelay_aggregate: AccessPointRelay_aggregate;
  /** fetch data from the table: "AccessPointRelay" using primary key columns */
  AccessPointRelay_by_pk?: Maybe<AccessPointRelay>;
  /** fetch data from the table in a streaming manner: "AccessPointRelay" */
  AccessPointRelay_stream: Array<AccessPointRelay>;
  /** fetch data from the table: "AccessPointRole" */
  AccessPointRole: Array<AccessPointRole>;
  /** fetch aggregated fields from the table: "AccessPointRole" */
  AccessPointRole_aggregate: AccessPointRole_aggregate;
  /** fetch data from the table: "AccessPointRole" using primary key columns */
  AccessPointRole_by_pk?: Maybe<AccessPointRole>;
  /** fetch data from the table in a streaming manner: "AccessPointRole" */
  AccessPointRole_stream: Array<AccessPointRole>;
  /** fetch data from the table: "AccessPointType" */
  AccessPointType: Array<AccessPointType>;
  /** fetch aggregated fields from the table: "AccessPointType" */
  AccessPointType_aggregate: AccessPointType_aggregate;
  /** fetch data from the table: "AccessPointType" using primary key columns */
  AccessPointType_by_pk?: Maybe<AccessPointType>;
  /** fetch data from the table in a streaming manner: "AccessPointType" */
  AccessPointType_stream: Array<AccessPointType>;
  /** fetch aggregated fields from the table: "AccessPoint" */
  AccessPoint_aggregate: AccessPoint_aggregate;
  /** fetch data from the table: "AccessPoint" using primary key columns */
  AccessPoint_by_pk?: Maybe<AccessPoint>;
  /** fetch data from the table in a streaming manner: "AccessPoint" */
  AccessPoint_stream: Array<AccessPoint>;
  /** fetch data from the table: "AccountStatus" */
  AccountStatus: Array<AccountStatus>;
  /** fetch aggregated fields from the table: "AccountStatus" */
  AccountStatus_aggregate: AccountStatus_aggregate;
  /** fetch data from the table: "AccountStatus" using primary key columns */
  AccountStatus_by_pk?: Maybe<AccountStatus>;
  /** fetch data from the table in a streaming manner: "AccountStatus" */
  AccountStatus_stream: Array<AccountStatus>;
  /** fetch data from the table: "AuthMethod" */
  AuthMethod: Array<AuthMethod>;
  /** fetch aggregated fields from the table: "AuthMethod" */
  AuthMethod_aggregate: AuthMethod_aggregate;
  /** fetch data from the table: "AuthMethod" using primary key columns */
  AuthMethod_by_pk?: Maybe<AuthMethod>;
  /** fetch data from the table in a streaming manner: "AuthMethod" */
  AuthMethod_stream: Array<AuthMethod>;
  /** fetch data from the table: "Beacon" */
  Beacon: Array<Beacon>;
  /** fetch aggregated fields from the table: "Beacon" */
  Beacon_aggregate: Beacon_aggregate;
  /** fetch data from the table: "Beacon" using primary key columns */
  Beacon_by_pk?: Maybe<Beacon>;
  /** fetch data from the table in a streaming manner: "Beacon" */
  Beacon_stream: Array<Beacon>;
  /** fetch data from the table: "Credential" */
  Credential: Array<Credential>;
  /** fetch data from the table: "CredentialType" */
  CredentialType: Array<CredentialType>;
  /** fetch aggregated fields from the table: "CredentialType" */
  CredentialType_aggregate: CredentialType_aggregate;
  /** fetch data from the table: "CredentialType" using primary key columns */
  CredentialType_by_pk?: Maybe<CredentialType>;
  /** fetch data from the table in a streaming manner: "CredentialType" */
  CredentialType_stream: Array<CredentialType>;
  /** fetch aggregated fields from the table: "Credential" */
  Credential_aggregate: Credential_aggregate;
  /** fetch data from the table: "Credential" using primary key columns */
  Credential_by_pk?: Maybe<Credential>;
  /** fetch data from the table in a streaming manner: "Credential" */
  Credential_stream: Array<Credential>;
  /** fetch data from the table: "EmergencyPlan" */
  EmergencyPlan: Array<EmergencyPlan>;
  /** fetch aggregated fields from the table: "EmergencyPlan" */
  EmergencyPlan_aggregate: EmergencyPlan_aggregate;
  /** fetch data from the table: "EmergencyPlan" using primary key columns */
  EmergencyPlan_by_pk?: Maybe<EmergencyPlan>;
  /** fetch data from the table in a streaming manner: "EmergencyPlan" */
  EmergencyPlan_stream: Array<EmergencyPlan>;
  /** fetch data from the table: "EmergencyScenarioStatus" */
  EmergencyScenarioStatus: Array<EmergencyScenarioStatus>;
  /** fetch aggregated fields from the table: "EmergencyScenarioStatus" */
  EmergencyScenarioStatus_aggregate: EmergencyScenarioStatus_aggregate;
  /** fetch data from the table: "EmergencyScenarioStatus" using primary key columns */
  EmergencyScenarioStatus_by_pk?: Maybe<EmergencyScenarioStatus>;
  /** fetch data from the table in a streaming manner: "EmergencyScenarioStatus" */
  EmergencyScenarioStatus_stream: Array<EmergencyScenarioStatus>;
  /** fetch data from the table: "FailurePlan" */
  FailurePlan: Array<FailurePlan>;
  /** fetch aggregated fields from the table: "FailurePlan" */
  FailurePlan_aggregate: FailurePlan_aggregate;
  /** fetch data from the table: "FailurePlan" using primary key columns */
  FailurePlan_by_pk?: Maybe<FailurePlan>;
  /** fetch data from the table in a streaming manner: "FailurePlan" */
  FailurePlan_stream: Array<FailurePlan>;
  /** fetch data from the table: "Favorite" */
  Favorite: Array<Favorite>;
  /** fetch aggregated fields from the table: "Favorite" */
  Favorite_aggregate: Favorite_aggregate;
  /** fetch data from the table: "Favorite" using primary key columns */
  Favorite_by_pk?: Maybe<Favorite>;
  /** fetch data from the table in a streaming manner: "Favorite" */
  Favorite_stream: Array<Favorite>;
  /** fetch data from the table: "FeatureFlag" */
  FeatureFlag: Array<FeatureFlag>;
  /** fetch data from the table: "FeatureFlagKey" */
  FeatureFlagKey: Array<FeatureFlagKey>;
  /** fetch aggregated fields from the table: "FeatureFlagKey" */
  FeatureFlagKey_aggregate: FeatureFlagKey_aggregate;
  /** fetch data from the table: "FeatureFlagKey" using primary key columns */
  FeatureFlagKey_by_pk?: Maybe<FeatureFlagKey>;
  /** fetch data from the table in a streaming manner: "FeatureFlagKey" */
  FeatureFlagKey_stream: Array<FeatureFlagKey>;
  /** fetch aggregated fields from the table: "FeatureFlag" */
  FeatureFlag_aggregate: FeatureFlag_aggregate;
  /** fetch data from the table: "FeatureFlag" using primary key columns */
  FeatureFlag_by_pk?: Maybe<FeatureFlag>;
  /** fetch data from the table in a streaming manner: "FeatureFlag" */
  FeatureFlag_stream: Array<FeatureFlag>;
  /** fetch data from the table: "GpioMode" */
  GpioMode: Array<GpioMode>;
  /** fetch aggregated fields from the table: "GpioMode" */
  GpioMode_aggregate: GpioMode_aggregate;
  /** fetch data from the table: "GpioMode" using primary key columns */
  GpioMode_by_pk?: Maybe<GpioMode>;
  /** fetch data from the table in a streaming manner: "GpioMode" */
  GpioMode_stream: Array<GpioMode>;
  /** fetch data from the table: "Hub" */
  Hub: Array<Hub>;
  /** fetch data from the table: "HubActivationStatus" */
  HubActivationStatus: Array<HubActivationStatus>;
  /** fetch aggregated fields from the table: "HubActivationStatus" */
  HubActivationStatus_aggregate: HubActivationStatus_aggregate;
  /** fetch data from the table: "HubActivationStatus" using primary key columns */
  HubActivationStatus_by_pk?: Maybe<HubActivationStatus>;
  /** fetch data from the table in a streaming manner: "HubActivationStatus" */
  HubActivationStatus_stream: Array<HubActivationStatus>;
  /** fetch data from the table: "HubDeviceType" */
  HubDeviceType: Array<HubDeviceType>;
  /** fetch aggregated fields from the table: "HubDeviceType" */
  HubDeviceType_aggregate: HubDeviceType_aggregate;
  /** fetch data from the table: "HubDeviceType" using primary key columns */
  HubDeviceType_by_pk?: Maybe<HubDeviceType>;
  /** fetch data from the table in a streaming manner: "HubDeviceType" */
  HubDeviceType_stream: Array<HubDeviceType>;
  /** fetch aggregated fields from the table: "Hub" */
  Hub_aggregate: Hub_aggregate;
  /** fetch data from the table: "Hub" using primary key columns */
  Hub_by_pk?: Maybe<Hub>;
  /** fetch data from the table in a streaming manner: "Hub" */
  Hub_stream: Array<Hub>;
  /** fetch data from the table: "Image" */
  Image: Array<Image>;
  /** fetch aggregated fields from the table: "Image" */
  Image_aggregate: Image_aggregate;
  /** fetch data from the table: "Image" using primary key columns */
  Image_by_pk?: Maybe<Image>;
  /** fetch data from the table in a streaming manner: "Image" */
  Image_stream: Array<Image>;
  /** fetch data from the table: "InputDevice" */
  InputDevice: Array<InputDevice>;
  /** fetch aggregated fields from the table: "InputDevice" */
  InputDevice_aggregate: InputDevice_aggregate;
  /** fetch data from the table: "InputDevice" using primary key columns */
  InputDevice_by_pk?: Maybe<InputDevice>;
  /** fetch data from the table in a streaming manner: "InputDevice" */
  InputDevice_stream: Array<InputDevice>;
  /** fetch data from the table: "Organization" */
  Organization: Array<Organization>;
  /** fetch aggregated fields from the table: "Organization" */
  Organization_aggregate: Organization_aggregate;
  /** fetch data from the table: "Organization" using primary key columns */
  Organization_by_pk?: Maybe<Organization>;
  /** fetch data from the table in a streaming manner: "Organization" */
  Organization_stream: Array<Organization>;
  /** fetch data from the table: "Permission" */
  Permission: Array<Permission>;
  /** fetch data from the table: "PermissionKey" */
  PermissionKey: Array<PermissionKey>;
  /** fetch aggregated fields from the table: "PermissionKey" */
  PermissionKey_aggregate: PermissionKey_aggregate;
  /** fetch data from the table: "PermissionKey" using primary key columns */
  PermissionKey_by_pk?: Maybe<PermissionKey>;
  /** fetch data from the table in a streaming manner: "PermissionKey" */
  PermissionKey_stream: Array<PermissionKey>;
  /** fetch data from the table: "PermissionScope" */
  PermissionScope: Array<PermissionScope>;
  /** fetch aggregated fields from the table: "PermissionScope" */
  PermissionScope_aggregate: PermissionScope_aggregate;
  /** fetch data from the table: "PermissionScope" using primary key columns */
  PermissionScope_by_pk?: Maybe<PermissionScope>;
  /** fetch data from the table in a streaming manner: "PermissionScope" */
  PermissionScope_stream: Array<PermissionScope>;
  /** fetch aggregated fields from the table: "Permission" */
  Permission_aggregate: Permission_aggregate;
  /** fetch data from the table: "Permission" using primary key columns */
  Permission_by_pk?: Maybe<Permission>;
  /** fetch data from the table in a streaming manner: "Permission" */
  Permission_stream: Array<Permission>;
  /** fetch data from the table: "PinCode" */
  PinCode: Array<PinCode>;
  /** fetch data from the table: "PinCodePrivate" */
  PinCodePrivate: Array<PinCodePrivate>;
  /** fetch aggregated fields from the table: "PinCodePrivate" */
  PinCodePrivate_aggregate: PinCodePrivate_aggregate;
  /** fetch data from the table in a streaming manner: "PinCodePrivate" */
  PinCodePrivate_stream: Array<PinCodePrivate>;
  /** fetch aggregated fields from the table: "PinCode" */
  PinCode_aggregate: PinCode_aggregate;
  /** fetch data from the table: "PinCode" using primary key columns */
  PinCode_by_pk?: Maybe<PinCode>;
  /** fetch data from the table in a streaming manner: "PinCode" */
  PinCode_stream: Array<PinCode>;
  /** fetch data from the table: "Property" */
  Property: Array<Property>;
  /** fetch data from the table: "PropertyFeatureFlag" */
  PropertyFeatureFlag: Array<PropertyFeatureFlag>;
  /** fetch aggregated fields from the table: "PropertyFeatureFlag" */
  PropertyFeatureFlag_aggregate: PropertyFeatureFlag_aggregate;
  /** fetch data from the table: "PropertyFeatureFlag" using primary key columns */
  PropertyFeatureFlag_by_pk?: Maybe<PropertyFeatureFlag>;
  /** fetch data from the table in a streaming manner: "PropertyFeatureFlag" */
  PropertyFeatureFlag_stream: Array<PropertyFeatureFlag>;
  /** fetch data from the table: "PropertyMap" */
  PropertyMap: Array<PropertyMap>;
  /** fetch aggregated fields from the table: "PropertyMap" */
  PropertyMap_aggregate: PropertyMap_aggregate;
  /** fetch data from the table: "PropertyMap" using primary key columns */
  PropertyMap_by_pk?: Maybe<PropertyMap>;
  /** fetch data from the table in a streaming manner: "PropertyMap" */
  PropertyMap_stream: Array<PropertyMap>;
  /** fetch data from the table: "PropertySource" */
  PropertySource: Array<PropertySource>;
  /** fetch aggregated fields from the table: "PropertySource" */
  PropertySource_aggregate: PropertySource_aggregate;
  /** fetch data from the table: "PropertySource" using primary key columns */
  PropertySource_by_pk?: Maybe<PropertySource>;
  /** fetch data from the table in a streaming manner: "PropertySource" */
  PropertySource_stream: Array<PropertySource>;
  /** fetch aggregated fields from the table: "Property" */
  Property_aggregate: Property_aggregate;
  /** fetch data from the table: "Property" using primary key columns */
  Property_by_pk?: Maybe<Property>;
  /** fetch data from the table in a streaming manner: "Property" */
  Property_stream: Array<Property>;
  /** fetch data from the table: "ReaderType" */
  ReaderType: Array<ReaderType>;
  /** fetch aggregated fields from the table: "ReaderType" */
  ReaderType_aggregate: ReaderType_aggregate;
  /** fetch data from the table: "ReaderType" using primary key columns */
  ReaderType_by_pk?: Maybe<ReaderType>;
  /** fetch data from the table in a streaming manner: "ReaderType" */
  ReaderType_stream: Array<ReaderType>;
  /** fetch data from the table: "Relay" */
  Relay: Array<Relay>;
  /** fetch data from the table: "RelayLog" */
  RelayLog: Array<RelayLog>;
  /** fetch aggregated fields from the table: "RelayLog" */
  RelayLog_aggregate: RelayLog_aggregate;
  /** fetch data from the table: "RelayLog" using primary key columns */
  RelayLog_by_pk?: Maybe<RelayLog>;
  /** fetch data from the table in a streaming manner: "RelayLog" */
  RelayLog_stream: Array<RelayLog>;
  /** fetch aggregated fields from the table: "Relay" */
  Relay_aggregate: Relay_aggregate;
  /** fetch data from the table: "Relay" using primary key columns */
  Relay_by_pk?: Maybe<Relay>;
  /** fetch data from the table in a streaming manner: "Relay" */
  Relay_stream: Array<Relay>;
  /** fetch data from the table: "Role" */
  Role: Array<Role>;
  /** fetch data from the table: "RoleKey" */
  RoleKey: Array<RoleKey>;
  /** fetch aggregated fields from the table: "RoleKey" */
  RoleKey_aggregate: RoleKey_aggregate;
  /** fetch data from the table: "RoleKey" using primary key columns */
  RoleKey_by_pk?: Maybe<RoleKey>;
  /** fetch data from the table in a streaming manner: "RoleKey" */
  RoleKey_stream: Array<RoleKey>;
  /** fetch data from the table: "RolePermission" */
  RolePermission: Array<RolePermission>;
  /** fetch aggregated fields from the table: "RolePermission" */
  RolePermission_aggregate: RolePermission_aggregate;
  /** fetch data from the table: "RolePermission" using primary key columns */
  RolePermission_by_pk?: Maybe<RolePermission>;
  /** fetch data from the table in a streaming manner: "RolePermission" */
  RolePermission_stream: Array<RolePermission>;
  /** fetch data from the table: "RoleRelationship" */
  RoleRelationship: Array<RoleRelationship>;
  /** fetch aggregated fields from the table: "RoleRelationship" */
  RoleRelationship_aggregate: RoleRelationship_aggregate;
  /** fetch data from the table: "RoleRelationship" using primary key columns */
  RoleRelationship_by_pk?: Maybe<RoleRelationship>;
  /** fetch data from the table in a streaming manner: "RoleRelationship" */
  RoleRelationship_stream: Array<RoleRelationship>;
  /** fetch aggregated fields from the table: "Role" */
  Role_aggregate: Role_aggregate;
  /** fetch data from the table: "Role" using primary key columns */
  Role_by_pk?: Maybe<Role>;
  /** fetch data from the table in a streaming manner: "Role" */
  Role_stream: Array<Role>;
  /** fetch data from the table: "Session" */
  Session: Array<Session>;
  /** fetch data from the table: "SessionType" */
  SessionType: Array<SessionType>;
  /** fetch aggregated fields from the table: "SessionType" */
  SessionType_aggregate: SessionType_aggregate;
  /** fetch data from the table: "SessionType" using primary key columns */
  SessionType_by_pk?: Maybe<SessionType>;
  /** fetch data from the table in a streaming manner: "SessionType" */
  SessionType_stream: Array<SessionType>;
  /** fetch aggregated fields from the table: "Session" */
  Session_aggregate: Session_aggregate;
  /** fetch data from the table: "Session" using primary key columns */
  Session_by_pk?: Maybe<Session>;
  /** fetch data from the table in a streaming manner: "Session" */
  Session_stream: Array<Session>;
  /** fetch data from the table: "SmartLock" */
  SmartLock: Array<SmartLock>;
  /** fetch data from the table: "SmartLockLog" */
  SmartLockLog: Array<SmartLockLog>;
  /** fetch data from the table: "SmartLockLogType" */
  SmartLockLogType: Array<SmartLockLogType>;
  /** fetch aggregated fields from the table: "SmartLockLogType" */
  SmartLockLogType_aggregate: SmartLockLogType_aggregate;
  /** fetch data from the table: "SmartLockLogType" using primary key columns */
  SmartLockLogType_by_pk?: Maybe<SmartLockLogType>;
  /** fetch data from the table in a streaming manner: "SmartLockLogType" */
  SmartLockLogType_stream: Array<SmartLockLogType>;
  /** fetch aggregated fields from the table: "SmartLockLog" */
  SmartLockLog_aggregate: SmartLockLog_aggregate;
  /** fetch data from the table: "SmartLockLog" using primary key columns */
  SmartLockLog_by_pk?: Maybe<SmartLockLog>;
  /** fetch data from the table in a streaming manner: "SmartLockLog" */
  SmartLockLog_stream: Array<SmartLockLog>;
  /** fetch aggregated fields from the table: "SmartLock" */
  SmartLock_aggregate: SmartLock_aggregate;
  /** fetch data from the table: "SmartLock" using primary key columns */
  SmartLock_by_pk?: Maybe<SmartLock>;
  /** fetch data from the table in a streaming manner: "SmartLock" */
  SmartLock_stream: Array<SmartLock>;
  /** fetch data from the table: "Ticket" */
  Ticket: Array<Ticket>;
  /** fetch data from the table: "TicketStatus" */
  TicketStatus: Array<TicketStatus>;
  /** fetch aggregated fields from the table: "TicketStatus" */
  TicketStatus_aggregate: TicketStatus_aggregate;
  /** fetch data from the table: "TicketStatus" using primary key columns */
  TicketStatus_by_pk?: Maybe<TicketStatus>;
  /** fetch data from the table in a streaming manner: "TicketStatus" */
  TicketStatus_stream: Array<TicketStatus>;
  /** fetch data from the table: "TicketType" */
  TicketType: Array<TicketType>;
  /** fetch aggregated fields from the table: "TicketType" */
  TicketType_aggregate: TicketType_aggregate;
  /** fetch data from the table: "TicketType" using primary key columns */
  TicketType_by_pk?: Maybe<TicketType>;
  /** fetch data from the table in a streaming manner: "TicketType" */
  TicketType_stream: Array<TicketType>;
  /** fetch aggregated fields from the table: "Ticket" */
  Ticket_aggregate: Ticket_aggregate;
  /** fetch data from the table: "Ticket" using primary key columns */
  Ticket_by_pk?: Maybe<Ticket>;
  /** fetch data from the table in a streaming manner: "Ticket" */
  Ticket_stream: Array<Ticket>;
  /** fetch data from the table: "Timezone" */
  Timezone: Array<Timezone>;
  /** fetch aggregated fields from the table: "Timezone" */
  Timezone_aggregate: Timezone_aggregate;
  /** fetch data from the table: "Timezone" using primary key columns */
  Timezone_by_pk?: Maybe<Timezone>;
  /** fetch data from the table in a streaming manner: "Timezone" */
  Timezone_stream: Array<Timezone>;
  /** fetch data from the table: "Unit" */
  Unit: Array<Unit>;
  /** fetch data from the table: "UnitGroup" */
  UnitGroup: Array<UnitGroup>;
  /** fetch aggregated fields from the table: "UnitGroup" */
  UnitGroup_aggregate: UnitGroup_aggregate;
  /** fetch data from the table: "UnitGroup" using primary key columns */
  UnitGroup_by_pk?: Maybe<UnitGroup>;
  /** fetch data from the table in a streaming manner: "UnitGroup" */
  UnitGroup_stream: Array<UnitGroup>;
  /** fetch data from the table: "UnitType" */
  UnitType: Array<UnitType>;
  /** fetch aggregated fields from the table: "UnitType" */
  UnitType_aggregate: UnitType_aggregate;
  /** fetch data from the table: "UnitType" using primary key columns */
  UnitType_by_pk?: Maybe<UnitType>;
  /** fetch data from the table in a streaming manner: "UnitType" */
  UnitType_stream: Array<UnitType>;
  /** fetch aggregated fields from the table: "Unit" */
  Unit_aggregate: Unit_aggregate;
  /** fetch data from the table: "Unit" using primary key columns */
  Unit_by_pk?: Maybe<Unit>;
  /** fetch data from the table in a streaming manner: "Unit" */
  Unit_stream: Array<Unit>;
  /** fetch data from the table: "UnlockMethod" */
  UnlockMethod: Array<UnlockMethod>;
  /** fetch aggregated fields from the table: "UnlockMethod" */
  UnlockMethod_aggregate: UnlockMethod_aggregate;
  /** fetch data from the table: "UnlockMethod" using primary key columns */
  UnlockMethod_by_pk?: Maybe<UnlockMethod>;
  /** fetch data from the table in a streaming manner: "UnlockMethod" */
  UnlockMethod_stream: Array<UnlockMethod>;
  /** fetch data from the table: "UnlockResult" */
  UnlockResult: Array<UnlockResult>;
  /** fetch aggregated fields from the table: "UnlockResult" */
  UnlockResult_aggregate: UnlockResult_aggregate;
  /** fetch data from the table: "UnlockResult" using primary key columns */
  UnlockResult_by_pk?: Maybe<UnlockResult>;
  /** fetch data from the table in a streaming manner: "UnlockResult" */
  UnlockResult_stream: Array<UnlockResult>;
  /** fetch data from the table: "User" */
  User: Array<User>;
  /** fetch data from the table: "UserRole" */
  UserRole: Array<UserRole>;
  /** fetch data from the table: "UserRoleGrantMethod" */
  UserRoleGrantMethod: Array<UserRoleGrantMethod>;
  /** fetch aggregated fields from the table: "UserRoleGrantMethod" */
  UserRoleGrantMethod_aggregate: UserRoleGrantMethod_aggregate;
  /** fetch data from the table: "UserRoleGrantMethod" using primary key columns */
  UserRoleGrantMethod_by_pk?: Maybe<UserRoleGrantMethod>;
  /** fetch data from the table in a streaming manner: "UserRoleGrantMethod" */
  UserRoleGrantMethod_stream: Array<UserRoleGrantMethod>;
  /** fetch data from the table: "UserRolePermission" */
  UserRolePermission: Array<UserRolePermission>;
  /** fetch aggregated fields from the table: "UserRolePermission" */
  UserRolePermission_aggregate: UserRolePermission_aggregate;
  /** fetch data from the table in a streaming manner: "UserRolePermission" */
  UserRolePermission_stream: Array<UserRolePermission>;
  /** fetch data from the table: "UserRoleReason" */
  UserRoleReason: Array<UserRoleReason>;
  /** fetch aggregated fields from the table: "UserRoleReason" */
  UserRoleReason_aggregate: UserRoleReason_aggregate;
  /** fetch data from the table: "UserRoleReason" using primary key columns */
  UserRoleReason_by_pk?: Maybe<UserRoleReason>;
  /** fetch data from the table in a streaming manner: "UserRoleReason" */
  UserRoleReason_stream: Array<UserRoleReason>;
  /** fetch data from the table: "UserRoleStatus" */
  UserRoleStatus: Array<UserRoleStatus>;
  /** fetch aggregated fields from the table: "UserRoleStatus" */
  UserRoleStatus_aggregate: UserRoleStatus_aggregate;
  /** fetch data from the table: "UserRoleStatus" using primary key columns */
  UserRoleStatus_by_pk?: Maybe<UserRoleStatus>;
  /** fetch data from the table in a streaming manner: "UserRoleStatus" */
  UserRoleStatus_stream: Array<UserRoleStatus>;
  /** fetch aggregated fields from the table: "UserRole" */
  UserRole_aggregate: UserRole_aggregate;
  /** fetch data from the table: "UserRole" using primary key columns */
  UserRole_by_pk?: Maybe<UserRole>;
  /** fetch data from the table in a streaming manner: "UserRole" */
  UserRole_stream: Array<UserRole>;
  /** fetch aggregated fields from the table: "User" */
  User_aggregate: User_aggregate;
  /** fetch data from the table: "User" using primary key columns */
  User_by_pk?: Maybe<User>;
  /** fetch data from the table in a streaming manner: "User" */
  User_stream: Array<User>;
  /** fetch data from the table: "VirtualDirectoryUserDisplayNameFormat" */
  VirtualDirectoryUserDisplayNameFormat: Array<VirtualDirectoryUserDisplayNameFormat>;
  /** fetch aggregated fields from the table: "VirtualDirectoryUserDisplayNameFormat" */
  VirtualDirectoryUserDisplayNameFormat_aggregate: VirtualDirectoryUserDisplayNameFormat_aggregate;
  /** fetch data from the table: "VirtualDirectoryUserDisplayNameFormat" using primary key columns */
  VirtualDirectoryUserDisplayNameFormat_by_pk?: Maybe<VirtualDirectoryUserDisplayNameFormat>;
  /** fetch data from the table in a streaming manner: "VirtualDirectoryUserDisplayNameFormat" */
  VirtualDirectoryUserDisplayNameFormat_stream: Array<VirtualDirectoryUserDisplayNameFormat>;
};


export type subscription_root_AccessPointArgs = {
  distinct_on?: InputMaybe<Array<AccessPoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPoint_order_by>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};


export type subscription_root_AccessPointRelayArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRelay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRelay_order_by>>;
  where?: InputMaybe<AccessPointRelay_bool_exp>;
};


export type subscription_root_AccessPointRelay_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRelay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRelay_order_by>>;
  where?: InputMaybe<AccessPointRelay_bool_exp>;
};


export type subscription_root_AccessPointRelay_by_pkArgs = {
  accessPointRelayId: Scalars['uuid']['input'];
};


export type subscription_root_AccessPointRelay_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AccessPointRelay_stream_cursor_input>>;
  where?: InputMaybe<AccessPointRelay_bool_exp>;
};


export type subscription_root_AccessPointRoleArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRole_order_by>>;
  where?: InputMaybe<AccessPointRole_bool_exp>;
};


export type subscription_root_AccessPointRole_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPointRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointRole_order_by>>;
  where?: InputMaybe<AccessPointRole_bool_exp>;
};


export type subscription_root_AccessPointRole_by_pkArgs = {
  accessPointRoleId: Scalars['uuid']['input'];
};


export type subscription_root_AccessPointRole_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AccessPointRole_stream_cursor_input>>;
  where?: InputMaybe<AccessPointRole_bool_exp>;
};


export type subscription_root_AccessPointTypeArgs = {
  distinct_on?: InputMaybe<Array<AccessPointType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointType_order_by>>;
  where?: InputMaybe<AccessPointType_bool_exp>;
};


export type subscription_root_AccessPointType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPointType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPointType_order_by>>;
  where?: InputMaybe<AccessPointType_bool_exp>;
};


export type subscription_root_AccessPointType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_AccessPointType_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AccessPointType_stream_cursor_input>>;
  where?: InputMaybe<AccessPointType_bool_exp>;
};


export type subscription_root_AccessPoint_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessPoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccessPoint_order_by>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};


export type subscription_root_AccessPoint_by_pkArgs = {
  accessPointId: Scalars['uuid']['input'];
};


export type subscription_root_AccessPoint_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AccessPoint_stream_cursor_input>>;
  where?: InputMaybe<AccessPoint_bool_exp>;
};


export type subscription_root_AccountStatusArgs = {
  distinct_on?: InputMaybe<Array<AccountStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccountStatus_order_by>>;
  where?: InputMaybe<AccountStatus_bool_exp>;
};


export type subscription_root_AccountStatus_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccountStatus_order_by>>;
  where?: InputMaybe<AccountStatus_bool_exp>;
};


export type subscription_root_AccountStatus_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_AccountStatus_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AccountStatus_stream_cursor_input>>;
  where?: InputMaybe<AccountStatus_bool_exp>;
};


export type subscription_root_AuthMethodArgs = {
  distinct_on?: InputMaybe<Array<AuthMethod_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthMethod_order_by>>;
  where?: InputMaybe<AuthMethod_bool_exp>;
};


export type subscription_root_AuthMethod_aggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthMethod_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthMethod_order_by>>;
  where?: InputMaybe<AuthMethod_bool_exp>;
};


export type subscription_root_AuthMethod_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_AuthMethod_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthMethod_stream_cursor_input>>;
  where?: InputMaybe<AuthMethod_bool_exp>;
};


export type subscription_root_BeaconArgs = {
  distinct_on?: InputMaybe<Array<Beacon_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Beacon_order_by>>;
  where?: InputMaybe<Beacon_bool_exp>;
};


export type subscription_root_Beacon_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Beacon_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Beacon_order_by>>;
  where?: InputMaybe<Beacon_bool_exp>;
};


export type subscription_root_Beacon_by_pkArgs = {
  beaconId: Scalars['uuid']['input'];
};


export type subscription_root_Beacon_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Beacon_stream_cursor_input>>;
  where?: InputMaybe<Beacon_bool_exp>;
};


export type subscription_root_CredentialArgs = {
  distinct_on?: InputMaybe<Array<Credential_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credential_order_by>>;
  where?: InputMaybe<Credential_bool_exp>;
};


export type subscription_root_CredentialTypeArgs = {
  distinct_on?: InputMaybe<Array<CredentialType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CredentialType_order_by>>;
  where?: InputMaybe<CredentialType_bool_exp>;
};


export type subscription_root_CredentialType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<CredentialType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CredentialType_order_by>>;
  where?: InputMaybe<CredentialType_bool_exp>;
};


export type subscription_root_CredentialType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_CredentialType_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CredentialType_stream_cursor_input>>;
  where?: InputMaybe<CredentialType_bool_exp>;
};


export type subscription_root_Credential_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Credential_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credential_order_by>>;
  where?: InputMaybe<Credential_bool_exp>;
};


export type subscription_root_Credential_by_pkArgs = {
  credentialId: Scalars['uuid']['input'];
};


export type subscription_root_Credential_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credential_stream_cursor_input>>;
  where?: InputMaybe<Credential_bool_exp>;
};


export type subscription_root_EmergencyPlanArgs = {
  distinct_on?: InputMaybe<Array<EmergencyPlan_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EmergencyPlan_order_by>>;
  where?: InputMaybe<EmergencyPlan_bool_exp>;
};


export type subscription_root_EmergencyPlan_aggregateArgs = {
  distinct_on?: InputMaybe<Array<EmergencyPlan_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EmergencyPlan_order_by>>;
  where?: InputMaybe<EmergencyPlan_bool_exp>;
};


export type subscription_root_EmergencyPlan_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_EmergencyPlan_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EmergencyPlan_stream_cursor_input>>;
  where?: InputMaybe<EmergencyPlan_bool_exp>;
};


export type subscription_root_EmergencyScenarioStatusArgs = {
  distinct_on?: InputMaybe<Array<EmergencyScenarioStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EmergencyScenarioStatus_order_by>>;
  where?: InputMaybe<EmergencyScenarioStatus_bool_exp>;
};


export type subscription_root_EmergencyScenarioStatus_aggregateArgs = {
  distinct_on?: InputMaybe<Array<EmergencyScenarioStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EmergencyScenarioStatus_order_by>>;
  where?: InputMaybe<EmergencyScenarioStatus_bool_exp>;
};


export type subscription_root_EmergencyScenarioStatus_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_EmergencyScenarioStatus_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EmergencyScenarioStatus_stream_cursor_input>>;
  where?: InputMaybe<EmergencyScenarioStatus_bool_exp>;
};


export type subscription_root_FailurePlanArgs = {
  distinct_on?: InputMaybe<Array<FailurePlan_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FailurePlan_order_by>>;
  where?: InputMaybe<FailurePlan_bool_exp>;
};


export type subscription_root_FailurePlan_aggregateArgs = {
  distinct_on?: InputMaybe<Array<FailurePlan_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FailurePlan_order_by>>;
  where?: InputMaybe<FailurePlan_bool_exp>;
};


export type subscription_root_FailurePlan_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_FailurePlan_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<FailurePlan_stream_cursor_input>>;
  where?: InputMaybe<FailurePlan_bool_exp>;
};


export type subscription_root_FavoriteArgs = {
  distinct_on?: InputMaybe<Array<Favorite_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorite_order_by>>;
  where?: InputMaybe<Favorite_bool_exp>;
};


export type subscription_root_Favorite_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Favorite_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorite_order_by>>;
  where?: InputMaybe<Favorite_bool_exp>;
};


export type subscription_root_Favorite_by_pkArgs = {
  favoriteId: Scalars['uuid']['input'];
};


export type subscription_root_Favorite_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Favorite_stream_cursor_input>>;
  where?: InputMaybe<Favorite_bool_exp>;
};


export type subscription_root_FeatureFlagArgs = {
  distinct_on?: InputMaybe<Array<FeatureFlag_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FeatureFlag_order_by>>;
  where?: InputMaybe<FeatureFlag_bool_exp>;
};


export type subscription_root_FeatureFlagKeyArgs = {
  distinct_on?: InputMaybe<Array<FeatureFlagKey_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FeatureFlagKey_order_by>>;
  where?: InputMaybe<FeatureFlagKey_bool_exp>;
};


export type subscription_root_FeatureFlagKey_aggregateArgs = {
  distinct_on?: InputMaybe<Array<FeatureFlagKey_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FeatureFlagKey_order_by>>;
  where?: InputMaybe<FeatureFlagKey_bool_exp>;
};


export type subscription_root_FeatureFlagKey_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_FeatureFlagKey_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<FeatureFlagKey_stream_cursor_input>>;
  where?: InputMaybe<FeatureFlagKey_bool_exp>;
};


export type subscription_root_FeatureFlag_aggregateArgs = {
  distinct_on?: InputMaybe<Array<FeatureFlag_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FeatureFlag_order_by>>;
  where?: InputMaybe<FeatureFlag_bool_exp>;
};


export type subscription_root_FeatureFlag_by_pkArgs = {
  featureFlagId: Scalars['uuid']['input'];
};


export type subscription_root_FeatureFlag_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<FeatureFlag_stream_cursor_input>>;
  where?: InputMaybe<FeatureFlag_bool_exp>;
};


export type subscription_root_GpioModeArgs = {
  distinct_on?: InputMaybe<Array<GpioMode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GpioMode_order_by>>;
  where?: InputMaybe<GpioMode_bool_exp>;
};


export type subscription_root_GpioMode_aggregateArgs = {
  distinct_on?: InputMaybe<Array<GpioMode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GpioMode_order_by>>;
  where?: InputMaybe<GpioMode_bool_exp>;
};


export type subscription_root_GpioMode_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_GpioMode_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GpioMode_stream_cursor_input>>;
  where?: InputMaybe<GpioMode_bool_exp>;
};


export type subscription_root_HubArgs = {
  distinct_on?: InputMaybe<Array<Hub_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_order_by>>;
  where?: InputMaybe<Hub_bool_exp>;
};


export type subscription_root_HubActivationStatusArgs = {
  distinct_on?: InputMaybe<Array<HubActivationStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<HubActivationStatus_order_by>>;
  where?: InputMaybe<HubActivationStatus_bool_exp>;
};


export type subscription_root_HubActivationStatus_aggregateArgs = {
  distinct_on?: InputMaybe<Array<HubActivationStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<HubActivationStatus_order_by>>;
  where?: InputMaybe<HubActivationStatus_bool_exp>;
};


export type subscription_root_HubActivationStatus_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_HubActivationStatus_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<HubActivationStatus_stream_cursor_input>>;
  where?: InputMaybe<HubActivationStatus_bool_exp>;
};


export type subscription_root_HubDeviceTypeArgs = {
  distinct_on?: InputMaybe<Array<HubDeviceType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<HubDeviceType_order_by>>;
  where?: InputMaybe<HubDeviceType_bool_exp>;
};


export type subscription_root_HubDeviceType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<HubDeviceType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<HubDeviceType_order_by>>;
  where?: InputMaybe<HubDeviceType_bool_exp>;
};


export type subscription_root_HubDeviceType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_HubDeviceType_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<HubDeviceType_stream_cursor_input>>;
  where?: InputMaybe<HubDeviceType_bool_exp>;
};


export type subscription_root_Hub_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Hub_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_order_by>>;
  where?: InputMaybe<Hub_bool_exp>;
};


export type subscription_root_Hub_by_pkArgs = {
  hubId: Scalars['uuid']['input'];
};


export type subscription_root_Hub_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Hub_stream_cursor_input>>;
  where?: InputMaybe<Hub_bool_exp>;
};


export type subscription_root_ImageArgs = {
  distinct_on?: InputMaybe<Array<Image_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_order_by>>;
  where?: InputMaybe<Image_bool_exp>;
};


export type subscription_root_Image_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Image_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_order_by>>;
  where?: InputMaybe<Image_bool_exp>;
};


export type subscription_root_Image_by_pkArgs = {
  imageId: Scalars['uuid']['input'];
};


export type subscription_root_Image_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Image_stream_cursor_input>>;
  where?: InputMaybe<Image_bool_exp>;
};


export type subscription_root_InputDeviceArgs = {
  distinct_on?: InputMaybe<Array<InputDevice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputDevice_order_by>>;
  where?: InputMaybe<InputDevice_bool_exp>;
};


export type subscription_root_InputDevice_aggregateArgs = {
  distinct_on?: InputMaybe<Array<InputDevice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputDevice_order_by>>;
  where?: InputMaybe<InputDevice_bool_exp>;
};


export type subscription_root_InputDevice_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_InputDevice_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<InputDevice_stream_cursor_input>>;
  where?: InputMaybe<InputDevice_bool_exp>;
};


export type subscription_root_OrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_order_by>>;
  where?: InputMaybe<Organization_bool_exp>;
};


export type subscription_root_Organization_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_order_by>>;
  where?: InputMaybe<Organization_bool_exp>;
};


export type subscription_root_Organization_by_pkArgs = {
  organizationId: Scalars['uuid']['input'];
};


export type subscription_root_Organization_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_stream_cursor_input>>;
  where?: InputMaybe<Organization_bool_exp>;
};


export type subscription_root_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permission_order_by>>;
  where?: InputMaybe<Permission_bool_exp>;
};


export type subscription_root_PermissionKeyArgs = {
  distinct_on?: InputMaybe<Array<PermissionKey_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PermissionKey_order_by>>;
  where?: InputMaybe<PermissionKey_bool_exp>;
};


export type subscription_root_PermissionKey_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PermissionKey_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PermissionKey_order_by>>;
  where?: InputMaybe<PermissionKey_bool_exp>;
};


export type subscription_root_PermissionKey_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_PermissionKey_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PermissionKey_stream_cursor_input>>;
  where?: InputMaybe<PermissionKey_bool_exp>;
};


export type subscription_root_PermissionScopeArgs = {
  distinct_on?: InputMaybe<Array<PermissionScope_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PermissionScope_order_by>>;
  where?: InputMaybe<PermissionScope_bool_exp>;
};


export type subscription_root_PermissionScope_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PermissionScope_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PermissionScope_order_by>>;
  where?: InputMaybe<PermissionScope_bool_exp>;
};


export type subscription_root_PermissionScope_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_PermissionScope_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PermissionScope_stream_cursor_input>>;
  where?: InputMaybe<PermissionScope_bool_exp>;
};


export type subscription_root_Permission_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permission_order_by>>;
  where?: InputMaybe<Permission_bool_exp>;
};


export type subscription_root_Permission_by_pkArgs = {
  permissionId: Scalars['uuid']['input'];
};


export type subscription_root_Permission_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Permission_stream_cursor_input>>;
  where?: InputMaybe<Permission_bool_exp>;
};


export type subscription_root_PinCodeArgs = {
  distinct_on?: InputMaybe<Array<PinCode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCode_order_by>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


export type subscription_root_PinCodePrivateArgs = {
  distinct_on?: InputMaybe<Array<PinCodePrivate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCodePrivate_order_by>>;
  where?: InputMaybe<PinCodePrivate_bool_exp>;
};


export type subscription_root_PinCodePrivate_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PinCodePrivate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCodePrivate_order_by>>;
  where?: InputMaybe<PinCodePrivate_bool_exp>;
};


export type subscription_root_PinCodePrivate_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PinCodePrivate_stream_cursor_input>>;
  where?: InputMaybe<PinCodePrivate_bool_exp>;
};


export type subscription_root_PinCode_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PinCode_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PinCode_order_by>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


export type subscription_root_PinCode_by_pkArgs = {
  pinCodeId: Scalars['uuid']['input'];
};


export type subscription_root_PinCode_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PinCode_stream_cursor_input>>;
  where?: InputMaybe<PinCode_bool_exp>;
};


export type subscription_root_PropertyArgs = {
  distinct_on?: InputMaybe<Array<Property_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_order_by>>;
  where?: InputMaybe<Property_bool_exp>;
};


export type subscription_root_PropertyFeatureFlagArgs = {
  distinct_on?: InputMaybe<Array<PropertyFeatureFlag_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertyFeatureFlag_order_by>>;
  where?: InputMaybe<PropertyFeatureFlag_bool_exp>;
};


export type subscription_root_PropertyFeatureFlag_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PropertyFeatureFlag_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertyFeatureFlag_order_by>>;
  where?: InputMaybe<PropertyFeatureFlag_bool_exp>;
};


export type subscription_root_PropertyFeatureFlag_by_pkArgs = {
  propertyFeatureFlagId: Scalars['uuid']['input'];
};


export type subscription_root_PropertyFeatureFlag_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PropertyFeatureFlag_stream_cursor_input>>;
  where?: InputMaybe<PropertyFeatureFlag_bool_exp>;
};


export type subscription_root_PropertyMapArgs = {
  distinct_on?: InputMaybe<Array<PropertyMap_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertyMap_order_by>>;
  where?: InputMaybe<PropertyMap_bool_exp>;
};


export type subscription_root_PropertyMap_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PropertyMap_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertyMap_order_by>>;
  where?: InputMaybe<PropertyMap_bool_exp>;
};


export type subscription_root_PropertyMap_by_pkArgs = {
  propertyMapId: Scalars['uuid']['input'];
};


export type subscription_root_PropertyMap_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PropertyMap_stream_cursor_input>>;
  where?: InputMaybe<PropertyMap_bool_exp>;
};


export type subscription_root_PropertySourceArgs = {
  distinct_on?: InputMaybe<Array<PropertySource_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertySource_order_by>>;
  where?: InputMaybe<PropertySource_bool_exp>;
};


export type subscription_root_PropertySource_aggregateArgs = {
  distinct_on?: InputMaybe<Array<PropertySource_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PropertySource_order_by>>;
  where?: InputMaybe<PropertySource_bool_exp>;
};


export type subscription_root_PropertySource_by_pkArgs = {
  propertySourceId: Scalars['uuid']['input'];
};


export type subscription_root_PropertySource_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PropertySource_stream_cursor_input>>;
  where?: InputMaybe<PropertySource_bool_exp>;
};


export type subscription_root_Property_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_order_by>>;
  where?: InputMaybe<Property_bool_exp>;
};


export type subscription_root_Property_by_pkArgs = {
  propertyId: Scalars['uuid']['input'];
};


export type subscription_root_Property_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_stream_cursor_input>>;
  where?: InputMaybe<Property_bool_exp>;
};


export type subscription_root_ReaderTypeArgs = {
  distinct_on?: InputMaybe<Array<ReaderType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReaderType_order_by>>;
  where?: InputMaybe<ReaderType_bool_exp>;
};


export type subscription_root_ReaderType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<ReaderType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReaderType_order_by>>;
  where?: InputMaybe<ReaderType_bool_exp>;
};


export type subscription_root_ReaderType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_ReaderType_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ReaderType_stream_cursor_input>>;
  where?: InputMaybe<ReaderType_bool_exp>;
};


export type subscription_root_RelayArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};


export type subscription_root_RelayLogArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


export type subscription_root_RelayLog_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RelayLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelayLog_order_by>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


export type subscription_root_RelayLog_by_pkArgs = {
  relayLogId: Scalars['uuid']['input'];
};


export type subscription_root_RelayLog_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RelayLog_stream_cursor_input>>;
  where?: InputMaybe<RelayLog_bool_exp>;
};


export type subscription_root_Relay_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Relay_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_order_by>>;
  where?: InputMaybe<Relay_bool_exp>;
};


export type subscription_root_Relay_by_pkArgs = {
  relayId: Scalars['uuid']['input'];
};


export type subscription_root_Relay_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Relay_stream_cursor_input>>;
  where?: InputMaybe<Relay_bool_exp>;
};


export type subscription_root_RoleArgs = {
  distinct_on?: InputMaybe<Array<Role_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_order_by>>;
  where?: InputMaybe<Role_bool_exp>;
};


export type subscription_root_RoleKeyArgs = {
  distinct_on?: InputMaybe<Array<RoleKey_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoleKey_order_by>>;
  where?: InputMaybe<RoleKey_bool_exp>;
};


export type subscription_root_RoleKey_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleKey_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoleKey_order_by>>;
  where?: InputMaybe<RoleKey_bool_exp>;
};


export type subscription_root_RoleKey_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_RoleKey_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoleKey_stream_cursor_input>>;
  where?: InputMaybe<RoleKey_bool_exp>;
};


export type subscription_root_RolePermissionArgs = {
  distinct_on?: InputMaybe<Array<RolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RolePermission_order_by>>;
  where?: InputMaybe<RolePermission_bool_exp>;
};


export type subscription_root_RolePermission_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RolePermission_order_by>>;
  where?: InputMaybe<RolePermission_bool_exp>;
};


export type subscription_root_RolePermission_by_pkArgs = {
  rolePermissionId: Scalars['uuid']['input'];
};


export type subscription_root_RolePermission_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RolePermission_stream_cursor_input>>;
  where?: InputMaybe<RolePermission_bool_exp>;
};


export type subscription_root_RoleRelationshipArgs = {
  distinct_on?: InputMaybe<Array<RoleRelationship_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoleRelationship_order_by>>;
  where?: InputMaybe<RoleRelationship_bool_exp>;
};


export type subscription_root_RoleRelationship_aggregateArgs = {
  distinct_on?: InputMaybe<Array<RoleRelationship_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoleRelationship_order_by>>;
  where?: InputMaybe<RoleRelationship_bool_exp>;
};


export type subscription_root_RoleRelationship_by_pkArgs = {
  roleRelationshipId: Scalars['uuid']['input'];
};


export type subscription_root_RoleRelationship_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoleRelationship_stream_cursor_input>>;
  where?: InputMaybe<RoleRelationship_bool_exp>;
};


export type subscription_root_Role_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_order_by>>;
  where?: InputMaybe<Role_bool_exp>;
};


export type subscription_root_Role_by_pkArgs = {
  roleId: Scalars['uuid']['input'];
};


export type subscription_root_Role_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Role_stream_cursor_input>>;
  where?: InputMaybe<Role_bool_exp>;
};


export type subscription_root_SessionArgs = {
  distinct_on?: InputMaybe<Array<Session_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_order_by>>;
  where?: InputMaybe<Session_bool_exp>;
};


export type subscription_root_SessionTypeArgs = {
  distinct_on?: InputMaybe<Array<SessionType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SessionType_order_by>>;
  where?: InputMaybe<SessionType_bool_exp>;
};


export type subscription_root_SessionType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<SessionType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SessionType_order_by>>;
  where?: InputMaybe<SessionType_bool_exp>;
};


export type subscription_root_SessionType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_SessionType_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SessionType_stream_cursor_input>>;
  where?: InputMaybe<SessionType_bool_exp>;
};


export type subscription_root_Session_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Session_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Session_order_by>>;
  where?: InputMaybe<Session_bool_exp>;
};


export type subscription_root_Session_by_pkArgs = {
  sessionId: Scalars['uuid']['input'];
};


export type subscription_root_Session_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Session_stream_cursor_input>>;
  where?: InputMaybe<Session_bool_exp>;
};


export type subscription_root_SmartLockArgs = {
  distinct_on?: InputMaybe<Array<SmartLock_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLock_order_by>>;
  where?: InputMaybe<SmartLock_bool_exp>;
};


export type subscription_root_SmartLockLogArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLog_order_by>>;
  where?: InputMaybe<SmartLockLog_bool_exp>;
};


export type subscription_root_SmartLockLogTypeArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLogType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLogType_order_by>>;
  where?: InputMaybe<SmartLockLogType_bool_exp>;
};


export type subscription_root_SmartLockLogType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLogType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLogType_order_by>>;
  where?: InputMaybe<SmartLockLogType_bool_exp>;
};


export type subscription_root_SmartLockLogType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_SmartLockLogType_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SmartLockLogType_stream_cursor_input>>;
  where?: InputMaybe<SmartLockLogType_bool_exp>;
};


export type subscription_root_SmartLockLog_aggregateArgs = {
  distinct_on?: InputMaybe<Array<SmartLockLog_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLockLog_order_by>>;
  where?: InputMaybe<SmartLockLog_bool_exp>;
};


export type subscription_root_SmartLockLog_by_pkArgs = {
  smartLockLogId: Scalars['uuid']['input'];
};


export type subscription_root_SmartLockLog_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SmartLockLog_stream_cursor_input>>;
  where?: InputMaybe<SmartLockLog_bool_exp>;
};


export type subscription_root_SmartLock_aggregateArgs = {
  distinct_on?: InputMaybe<Array<SmartLock_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartLock_order_by>>;
  where?: InputMaybe<SmartLock_bool_exp>;
};


export type subscription_root_SmartLock_by_pkArgs = {
  smartLockId: Scalars['uuid']['input'];
};


export type subscription_root_SmartLock_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SmartLock_stream_cursor_input>>;
  where?: InputMaybe<SmartLock_bool_exp>;
};


export type subscription_root_TicketArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


export type subscription_root_TicketStatusArgs = {
  distinct_on?: InputMaybe<Array<TicketStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TicketStatus_order_by>>;
  where?: InputMaybe<TicketStatus_bool_exp>;
};


export type subscription_root_TicketStatus_aggregateArgs = {
  distinct_on?: InputMaybe<Array<TicketStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TicketStatus_order_by>>;
  where?: InputMaybe<TicketStatus_bool_exp>;
};


export type subscription_root_TicketStatus_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_TicketStatus_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TicketStatus_stream_cursor_input>>;
  where?: InputMaybe<TicketStatus_bool_exp>;
};


export type subscription_root_TicketTypeArgs = {
  distinct_on?: InputMaybe<Array<TicketType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TicketType_order_by>>;
  where?: InputMaybe<TicketType_bool_exp>;
};


export type subscription_root_TicketType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<TicketType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TicketType_order_by>>;
  where?: InputMaybe<TicketType_bool_exp>;
};


export type subscription_root_TicketType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_TicketType_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TicketType_stream_cursor_input>>;
  where?: InputMaybe<TicketType_bool_exp>;
};


export type subscription_root_Ticket_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_order_by>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


export type subscription_root_Ticket_by_pkArgs = {
  ticketId: Scalars['uuid']['input'];
};


export type subscription_root_Ticket_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ticket_stream_cursor_input>>;
  where?: InputMaybe<Ticket_bool_exp>;
};


export type subscription_root_TimezoneArgs = {
  distinct_on?: InputMaybe<Array<Timezone_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Timezone_order_by>>;
  where?: InputMaybe<Timezone_bool_exp>;
};


export type subscription_root_Timezone_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Timezone_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Timezone_order_by>>;
  where?: InputMaybe<Timezone_bool_exp>;
};


export type subscription_root_Timezone_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_Timezone_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Timezone_stream_cursor_input>>;
  where?: InputMaybe<Timezone_bool_exp>;
};


export type subscription_root_UnitArgs = {
  distinct_on?: InputMaybe<Array<Unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_order_by>>;
  where?: InputMaybe<Unit_bool_exp>;
};


export type subscription_root_UnitGroupArgs = {
  distinct_on?: InputMaybe<Array<UnitGroup_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnitGroup_order_by>>;
  where?: InputMaybe<UnitGroup_bool_exp>;
};


export type subscription_root_UnitGroup_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UnitGroup_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnitGroup_order_by>>;
  where?: InputMaybe<UnitGroup_bool_exp>;
};


export type subscription_root_UnitGroup_by_pkArgs = {
  unitGroupId: Scalars['uuid']['input'];
};


export type subscription_root_UnitGroup_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UnitGroup_stream_cursor_input>>;
  where?: InputMaybe<UnitGroup_bool_exp>;
};


export type subscription_root_UnitTypeArgs = {
  distinct_on?: InputMaybe<Array<UnitType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnitType_order_by>>;
  where?: InputMaybe<UnitType_bool_exp>;
};


export type subscription_root_UnitType_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UnitType_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnitType_order_by>>;
  where?: InputMaybe<UnitType_bool_exp>;
};


export type subscription_root_UnitType_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_UnitType_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UnitType_stream_cursor_input>>;
  where?: InputMaybe<UnitType_bool_exp>;
};


export type subscription_root_Unit_aggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_order_by>>;
  where?: InputMaybe<Unit_bool_exp>;
};


export type subscription_root_Unit_by_pkArgs = {
  unitId: Scalars['uuid']['input'];
};


export type subscription_root_Unit_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Unit_stream_cursor_input>>;
  where?: InputMaybe<Unit_bool_exp>;
};


export type subscription_root_UnlockMethodArgs = {
  distinct_on?: InputMaybe<Array<UnlockMethod_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnlockMethod_order_by>>;
  where?: InputMaybe<UnlockMethod_bool_exp>;
};


export type subscription_root_UnlockMethod_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UnlockMethod_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnlockMethod_order_by>>;
  where?: InputMaybe<UnlockMethod_bool_exp>;
};


export type subscription_root_UnlockMethod_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_UnlockMethod_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UnlockMethod_stream_cursor_input>>;
  where?: InputMaybe<UnlockMethod_bool_exp>;
};


export type subscription_root_UnlockResultArgs = {
  distinct_on?: InputMaybe<Array<UnlockResult_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnlockResult_order_by>>;
  where?: InputMaybe<UnlockResult_bool_exp>;
};


export type subscription_root_UnlockResult_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UnlockResult_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnlockResult_order_by>>;
  where?: InputMaybe<UnlockResult_bool_exp>;
};


export type subscription_root_UnlockResult_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_UnlockResult_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UnlockResult_stream_cursor_input>>;
  where?: InputMaybe<UnlockResult_bool_exp>;
};


export type subscription_root_UserArgs = {
  distinct_on?: InputMaybe<Array<User_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_order_by>>;
  where?: InputMaybe<User_bool_exp>;
};


export type subscription_root_UserRoleArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


export type subscription_root_UserRoleGrantMethodArgs = {
  distinct_on?: InputMaybe<Array<UserRoleGrantMethod_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoleGrantMethod_order_by>>;
  where?: InputMaybe<UserRoleGrantMethod_bool_exp>;
};


export type subscription_root_UserRoleGrantMethod_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRoleGrantMethod_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoleGrantMethod_order_by>>;
  where?: InputMaybe<UserRoleGrantMethod_bool_exp>;
};


export type subscription_root_UserRoleGrantMethod_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_UserRoleGrantMethod_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserRoleGrantMethod_stream_cursor_input>>;
  where?: InputMaybe<UserRoleGrantMethod_bool_exp>;
};


export type subscription_root_UserRolePermissionArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


export type subscription_root_UserRolePermission_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolePermission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRolePermission_order_by>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


export type subscription_root_UserRolePermission_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserRolePermission_stream_cursor_input>>;
  where?: InputMaybe<UserRolePermission_bool_exp>;
};


export type subscription_root_UserRoleReasonArgs = {
  distinct_on?: InputMaybe<Array<UserRoleReason_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoleReason_order_by>>;
  where?: InputMaybe<UserRoleReason_bool_exp>;
};


export type subscription_root_UserRoleReason_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRoleReason_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoleReason_order_by>>;
  where?: InputMaybe<UserRoleReason_bool_exp>;
};


export type subscription_root_UserRoleReason_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_UserRoleReason_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserRoleReason_stream_cursor_input>>;
  where?: InputMaybe<UserRoleReason_bool_exp>;
};


export type subscription_root_UserRoleStatusArgs = {
  distinct_on?: InputMaybe<Array<UserRoleStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoleStatus_order_by>>;
  where?: InputMaybe<UserRoleStatus_bool_exp>;
};


export type subscription_root_UserRoleStatus_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRoleStatus_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoleStatus_order_by>>;
  where?: InputMaybe<UserRoleStatus_bool_exp>;
};


export type subscription_root_UserRoleStatus_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_UserRoleStatus_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserRoleStatus_stream_cursor_input>>;
  where?: InputMaybe<UserRoleStatus_bool_exp>;
};


export type subscription_root_UserRole_aggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_order_by>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


export type subscription_root_UserRole_by_pkArgs = {
  userRoleId: Scalars['uuid']['input'];
};


export type subscription_root_UserRole_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserRole_stream_cursor_input>>;
  where?: InputMaybe<UserRole_bool_exp>;
};


export type subscription_root_User_aggregateArgs = {
  distinct_on?: InputMaybe<Array<User_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_order_by>>;
  where?: InputMaybe<User_bool_exp>;
};


export type subscription_root_User_by_pkArgs = {
  userId: Scalars['uuid']['input'];
};


export type subscription_root_User_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_stream_cursor_input>>;
  where?: InputMaybe<User_bool_exp>;
};


export type subscription_root_VirtualDirectoryUserDisplayNameFormatArgs = {
  distinct_on?: InputMaybe<Array<VirtualDirectoryUserDisplayNameFormat_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VirtualDirectoryUserDisplayNameFormat_order_by>>;
  where?: InputMaybe<VirtualDirectoryUserDisplayNameFormat_bool_exp>;
};


export type subscription_root_VirtualDirectoryUserDisplayNameFormat_aggregateArgs = {
  distinct_on?: InputMaybe<Array<VirtualDirectoryUserDisplayNameFormat_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<VirtualDirectoryUserDisplayNameFormat_order_by>>;
  where?: InputMaybe<VirtualDirectoryUserDisplayNameFormat_bool_exp>;
};


export type subscription_root_VirtualDirectoryUserDisplayNameFormat_by_pkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_root_VirtualDirectoryUserDisplayNameFormat_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<VirtualDirectoryUserDisplayNameFormat_stream_cursor_input>>;
  where?: InputMaybe<VirtualDirectoryUserDisplayNameFormat_bool_exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type timestamptz_comparison_exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type uuid_comparison_exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/**
 * A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.
 *
 * In some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.
 */
export type __Directive = {
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isRepeatable: Scalars['Boolean']['output'];
  locations: Array<__DirectiveLocation>;
  args: Array<__InputValue>;
};


/**
 * A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.
 *
 * In some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.
 */
export type __Directive_argsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies. */
export enum __DirectiveLocation {
  /** Location adjacent to a query operation. */
  QUERY = 'QUERY',
  /** Location adjacent to a mutation operation. */
  MUTATION = 'MUTATION',
  /** Location adjacent to a subscription operation. */
  SUBSCRIPTION = 'SUBSCRIPTION',
  /** Location adjacent to a field. */
  FIELD = 'FIELD',
  /** Location adjacent to a fragment definition. */
  FRAGMENT_DEFINITION = 'FRAGMENT_DEFINITION',
  /** Location adjacent to a fragment spread. */
  FRAGMENT_SPREAD = 'FRAGMENT_SPREAD',
  /** Location adjacent to an inline fragment. */
  INLINE_FRAGMENT = 'INLINE_FRAGMENT',
  /** Location adjacent to a variable definition. */
  VARIABLE_DEFINITION = 'VARIABLE_DEFINITION',
  /** Location adjacent to a schema definition. */
  SCHEMA = 'SCHEMA',
  /** Location adjacent to a scalar definition. */
  SCALAR = 'SCALAR',
  /** Location adjacent to an object type definition. */
  OBJECT = 'OBJECT',
  /** Location adjacent to a field definition. */
  FIELD_DEFINITION = 'FIELD_DEFINITION',
  /** Location adjacent to an argument definition. */
  ARGUMENT_DEFINITION = 'ARGUMENT_DEFINITION',
  /** Location adjacent to an interface definition. */
  INTERFACE = 'INTERFACE',
  /** Location adjacent to a union definition. */
  UNION = 'UNION',
  /** Location adjacent to an enum definition. */
  ENUM = 'ENUM',
  /** Location adjacent to an enum value definition. */
  ENUM_VALUE = 'ENUM_VALUE',
  /** Location adjacent to an input object type definition. */
  INPUT_OBJECT = 'INPUT_OBJECT',
  /** Location adjacent to an input object field definition. */
  INPUT_FIELD_DEFINITION = 'INPUT_FIELD_DEFINITION'
}

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field_argsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations. */
export type __Schema = {
  description?: Maybe<Scalars['String']['output']>;
  /** A list of all types supported by this server. */
  types: Array<__Type>;
  /** The type that query operations will be rooted at. */
  queryType: __Type;
  /** If this server supports mutation, the type that mutation operations will be rooted at. */
  mutationType?: Maybe<__Type>;
  /** If this server support subscription, the type that subscription operations will be rooted at. */
  subscriptionType?: Maybe<__Type>;
  /** A list of all directives supported by this server. */
  directives: Array<__Directive>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  kind: __TypeKind;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  specifiedByURL?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
  isOneOf?: Maybe<Scalars['Boolean']['output']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type_fieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type_enumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type_inputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  SCALAR = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  OBJECT = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  INTERFACE = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  UNION = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  ENUM = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  INPUT_OBJECT = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  LIST = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NON_NULL = 'NON_NULL'
}

export type introspectionQueryVariables = Exact<{ [key: string]: never; }>;


export type introspectionQuery = { __schema: { types: Array<{ kind: __TypeKind, name?: string | null, fields?: Array<{ name: string, type: { kind: __TypeKind, name?: string | null, ofType?: { kind: __TypeKind, name?: string | null, ofType?: { kind: __TypeKind, name?: string | null, ofType?: { kind: __TypeKind, name?: string | null } | null } | null } | null } }> | null, inputFields?: Array<{ name: string }> | null }> } };

export type FieldFragment = { name: string, type: { kind: __TypeKind, name?: string | null, ofType?: { kind: __TypeKind, name?: string | null, ofType?: { kind: __TypeKind, name?: string | null, ofType?: { kind: __TypeKind, name?: string | null } | null } | null } | null } };

export type TypeRefFragment = { kind: __TypeKind, name?: string | null, ofType?: { kind: __TypeKind, name?: string | null, ofType?: { kind: __TypeKind, name?: string | null, ofType?: { kind: __TypeKind, name?: string | null } | null } | null } | null };

export type AccessPointLabelFragment = { accessPointId: string, name: string };

export type AccessPointUniqueLabelFragment = { accessPointId: string, name: string, property: { propertyId: string, name: string } };

export type AccessPointAvailabilityFragment = { accessPointId: string, timetable?: any | null, property: { propertyId: string, timezone: string } };

export type AccessPointRowFragment = { propertyId: string, type: AccessPointType_enum, accessTimeout: number, timetable?: any | null, spaceshipModeEnabled: boolean, proximityRestriction: boolean, createdAt: string, accessPointId: string, name: string, deprecatedAccessPointId: number, archivedAt?: string | null, property: { timezone: string, propertyId: string, name: string, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string }> }, image?: { imageId: string, cloudId: string } | null, archivedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type AccessPointActionsFragment = { accessPointId: string, deprecatedAccessPointId: number, name: string, timetable?: any | null, proximityRestriction: boolean, archivedAt?: string | null, property: { propertyId: string, name: string, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string }> }, archivedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type AccessPointDetailsFragment = { rexAccessTimeout: number, maxOccupancy?: number | null, dpsAlertDelay?: number | null, dpsAlertInterval?: number | null, mapLocation?: any | null, updatedAt: string, propertyId: string, type: AccessPointType_enum, accessTimeout: number, timetable?: any | null, spaceshipModeEnabled: boolean, proximityRestriction: boolean, createdAt: string, accessPointId: string, name: string, deprecatedAccessPointId: number, archivedAt?: string | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, property: { timezone: string, propertyId: string, name: string, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string }> }, image?: { imageId: string, cloudId: string } | null, archivedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type AccessPointByPropertyFragment = { propertyId: string, type: AccessPointType_enum, accessTimeout: number, timetable?: any | null, spaceshipModeEnabled: boolean, proximityRestriction: boolean, createdAt: string, accessPointId: string, name: string, deprecatedAccessPointId: number, archivedAt?: string | null, accessPointRelays_aggregate: { aggregate?: { count: number } | null }, beacons_aggregate: { aggregate?: { count: number } | null }, property: { timezone: string, propertyId: string, name: string, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string }> }, image?: { imageId: string, cloudId: string } | null, archivedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type AccessPointWithMapLocationFragment = { mapLocation?: any | null, accessPointId: string, name: string };

export type getAccessPointDetailsQueryVariables = Exact<{
  accessPointId: Scalars['uuid']['input'];
}>;


export type getAccessPointDetailsQuery = { accessPoint?: { rexAccessTimeout: number, maxOccupancy?: number | null, dpsAlertDelay?: number | null, dpsAlertInterval?: number | null, mapLocation?: any | null, updatedAt: string, propertyId: string, type: AccessPointType_enum, accessTimeout: number, timetable?: any | null, spaceshipModeEnabled: boolean, proximityRestriction: boolean, createdAt: string, accessPointId: string, name: string, deprecatedAccessPointId: number, archivedAt?: string | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, property: { timezone: string, propertyId: string, name: string, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string }> }, image?: { imageId: string, cloudId: string } | null, archivedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null } | null };

export type getAccessPointsWithRelaysQueryVariables = Exact<{
  where: AccessPoint_bool_exp;
}>;


export type getAccessPointsWithRelaysQuery = { accessPoints: Array<{ accessPointId: string, name: string, accessPointRelays: Array<{ accessPointRelayId: string, relay: { relayId: string, name: string } }> }> };

export type getAccessPointsWithMapLocationQueryVariables = Exact<{
  where: AccessPoint_bool_exp;
}>;


export type getAccessPointsWithMapLocationQuery = { accessPoints: Array<{ mapLocation?: any | null, accessPointId: string, name: string }> };

export type getGrantableAccessPointsQueryVariables = Exact<{
  where: AccessPoint_bool_exp;
}>;


export type getGrantableAccessPointsQuery = { accessPoints: Array<{ type: AccessPointType_enum, accessPointId: string, name: string, property: { timezone: string } }> };

export type upsertAccessPointsMutationVariables = Exact<{
  objects: Array<AccessPoint_insert_input> | AccessPoint_insert_input;
}>;


export type upsertAccessPointsMutation = { upsertAccessPoints?: { returning: Array<{ accessPointId: string, name: string }> } | null };

export type updateAccessPointMapLocationMutationVariables = Exact<{
  accessPointId: Scalars['uuid']['input'];
  mapLocation?: InputMaybe<Custom_AccessPointMapLocationInput>;
}>;


export type updateAccessPointMapLocationMutation = { custom_updateAccessPointMapLocation: { accessPoint?: { accessPointId: string, name: string, mapLocation?: any | null } | null } };

export type toggleAccessPointArchivedMutationVariables = Exact<{
  accessPointId: Scalars['uuid']['input'];
  archived: Scalars['Boolean']['input'];
}>;


export type toggleAccessPointArchivedMutation = { custom_toggleAccessPointArchived: { accessPoint?: { propertyId: string, type: AccessPointType_enum, accessTimeout: number, timetable?: any | null, spaceshipModeEnabled: boolean, proximityRestriction: boolean, createdAt: string, accessPointId: string, deprecatedAccessPointId: number, name: string, archivedAt?: string | null, property: { timezone: string, propertyId: string, name: string, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string }> }, image?: { imageId: string, cloudId: string } | null, archivedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null } | null } };

export type unlockAccessPointMutationVariables = Exact<{
  accessPointId: Scalars['String']['input'];
}>;


export type unlockAccessPointMutation = { custom_unlockAccessPoint: { accessPointId: string, result: Custom_UnlockAccessPointResult } };

export type RelayAccessPointsFragment = { accessPointRelayId: string, accessPoint: { accessPointId: string, name: string } };

export type AccessPointRoleTableFragment = { accessPointRoleId: string, roleId: string, unitGroupId?: string | null, schedule?: any | null, hasAccess: boolean, role: { roleId: string, name: string, uniqueName?: string | null, organization?: { organizationId: string, name: string } | null }, unitGroup?: { unitGroupId: string, name: string, propertyName?: string | null, parentUnitGroup?: { unitGroupId: string, name: string } | null } | null };

export type AccessPointRoleByUnitGroupFragment = { accessPointRoleId: string, hasAccess: boolean, createdAt: string, accessPoint: { type: AccessPointType_enum, accessPointId: string, name: string, property: { propertyId: string, name: string } }, role: { roleId: string, name: string, uniqueName?: string | null, organization?: { organizationId: string, name: string } | null } };

export type getAccessPointRolesQueryVariables = Exact<{
  accessPointId: Scalars['uuid']['input'];
  roleExp: Role_bool_exp;
}>;


export type getAccessPointRolesQuery = { accessPointRoles: Array<{ accessPointRoleId: string, roleId: string, unitGroupId?: string | null, schedule?: any | null, hasAccess: boolean, role: { roleId: string, name: string, uniqueName?: string | null, organization?: { organizationId: string, name: string } | null }, unitGroup?: { unitGroupId: string, name: string, propertyName?: string | null, parentUnitGroup?: { unitGroupId: string, name: string } | null } | null }>, roles: Array<{ key?: RoleKey_enum | null, permissionScope: PermissionScope_enum, roleId: string, name: string, uniqueName?: string | null, rolePermissions: Array<{ rolePermissionId: string, permission: { permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean } }>, organization?: { organizationId: string, name: string } | null }> };

export type BeaconLabelFragment = { beaconId: string, name: string, accessPoint: { accessPointId: string, name: string, property: { propertyId: string, name: string } } };

export type BeaconTableFragment = { accessPointId: string, uuid: string, macAddress: string, location?: string | null, createdAt: string, passwordRotatedAt?: string | null, beaconId: string, name: string, accessPoint: { accessPointId: string, name: string, property: { propertyId: string, name: string } } };

export type CredentialRequiredRowFragment = { credentialId: string, type: CredentialType_enum };

export type CredentialTableFragment = { credentialId: string, identifier: string, facilityCode?: number | null, cardNumber?: number | null, createdAt: string, type: CredentialType_enum, ownedByProperty?: { propertyId: string, name: string } | null, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, provisionedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type UserCredentialFragment = { credentialId: string, identifier: string, facilityCode?: number | null, cardNumber?: number | null, createdAt: string, type: CredentialType_enum, ownedByProperty?: { propertyId: string, name: string } | null, provisionedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type PropertyCredentialFragment = { credentialId: string, identifier: string, facilityCode?: number | null, cardNumber?: number | null, createdAt: string, type: CredentialType_enum, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, provisionedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type AccessPointFavoriteFragment = { favoriteId: string, position: number, user: { userId: string, firstName?: string | null, lastName?: string | null } };

export type UserFavoriteFragment = { favoriteId: string, position: number, accessPoint: { accessPointId: string, name: string, property: { propertyId: string, name: string } } };

export type FeatureFlagLabelFragment = { featureFlagId: string, key: FeatureFlagKey_enum, name: string, description?: string | null, isLocked: boolean };

export type getFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type getFeatureFlagsQuery = { featureFlags: Array<{ featureFlagId: string, key: FeatureFlagKey_enum, name: string, description?: string | null, isLocked: boolean }> };

export type HubLabelFragment = { hubId: string, name?: string | null, macAddress?: string | null };

export type HubUniqueLabelFragment = { deviceType: HubDeviceType_enum, hubId: string, name?: string | null, macAddress?: string | null, property?: { propertyId: string, name: string } | null };

export type HubRequiredRowFragment = { deviceType: HubDeviceType_enum, hubId: string, name?: string | null, macAddress?: string | null, property?: { propertyId: string, name: string } | null };

export type HubTableFragment = { hubId: string, activationStatus: HubActivationStatus_enum, host?: string | null, port?: number | null, macAddress?: string | null, ipAddress?: string | null, createdAt: string, updatedAt: string, deviceType: HubDeviceType_enum, name?: string | null, property?: { propertyId: string, name: string } | null };

export type HubDetailsFragment = { installedAt?: string | null, location?: string | null, hubVersion?: string | null, cliVersion?: string | null, firmwareVersion?: string | null, hubId: string, activationStatus: HubActivationStatus_enum, host?: string | null, port?: number | null, macAddress?: string | null, ipAddress?: string | null, createdAt: string, updatedAt: string, deviceType: HubDeviceType_enum, name?: string | null, property?: { propertyId: string, name: string } | null };

export type getHubDetailsQueryVariables = Exact<{
  hubId: Scalars['uuid']['input'];
}>;


export type getHubDetailsQuery = { hub?: { installedAt?: string | null, location?: string | null, hubVersion?: string | null, cliVersion?: string | null, firmwareVersion?: string | null, hubId: string, activationStatus: HubActivationStatus_enum, host?: string | null, port?: number | null, macAddress?: string | null, ipAddress?: string | null, createdAt: string, updatedAt: string, deviceType: HubDeviceType_enum, name?: string | null, property?: { propertyId: string, name: string } | null } | null };

export type unlockHubRelaysMutationVariables = Exact<{
  input: Custom_UnlockHubRelaysInput;
}>;


export type unlockHubRelaysMutation = { custom_unlockHubRelays: { response?: { hubId: string } | null } };

export type getHubHealthReportsQueryVariables = Exact<{
  input: Custom_GetHubHealthReportsInput;
}>;


export type getHubHealthReportsQuery = { custom_getHubHealthReports: { hubId: string, healthReports: Array<any>, hub?: { ipAddress?: string | null, macAddress?: string | null, deviceType: HubDeviceType_enum, hubId: string, name?: string | null, property?: { propertyId: string, name: string } | null } | null } };

export type ImageThumbnailFragment = { cloudId: string };

export type OrganizationLabelFragment = { organizationId: string, name: string };

export type OrganizationsMainTableFragment = { organizationId: string, name: string, identifier: string, createdAt: string, properties_aggregate: { aggregate?: { count: number } | null }, roles_aggregate: { aggregate?: { count: number } | null } };

export type getOrganizationsQueryVariables = Exact<{
  where: Organization_bool_exp;
}>;


export type getOrganizationsQuery = { organizations: Array<{ organizationId: string, name: string }> };

export type AllowedPermissionFragment = { permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean };

export type getPermissionsQueryVariables = Exact<{
  where: Permission_bool_exp;
}>;


export type getPermissionsQuery = { permissions: Array<{ permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean }> };

export type getAllowedAndEnabledPermissionsQueryVariables = Exact<{
  permissionScope: PermissionScope_enum;
  roleId: Scalars['uuid']['input'];
}>;


export type getAllowedAndEnabledPermissionsQuery = { allowedPermissions: Array<{ permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean }>, enabledPermissions: Array<{ permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean }> };

export type PinCodeTableFragment = { pinCodeId: string, assignedToUserId?: string | null, userRoleId?: string | null, createdAt: string, updatedAt: string, property: { propertyId: string, name: string }, assignedToUser?: { phoneNumber?: string | null, email?: string | null, userId: string, firstName?: string | null, lastName?: string | null } | null, private?: { code?: string | null } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, updatedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type PropertyLabelFragment = { propertyId: string, name: string };

export type PropertyActionsFragment = { propertyId: string, name: string, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string, featureFlag: { featureFlagId: string, key: FeatureFlagKey_enum, name: string, description?: string | null, isLocked: boolean } }>, propertySources_aggregate: { aggregate?: { count: number } | null } };

export type PropertyResidentAuditFragment = { propertyId: string, name: string, propertySources: Array<{ propertySourceId: string, sourceId: string }>, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string, featureFlag: { featureFlagId: string, key: FeatureFlagKey_enum, name: string, description?: string | null, isLocked: boolean } }>, propertySources_aggregate: { aggregate?: { count: number } | null } };

export type PropertyTableFragment = { propertyId: string, name: string, timezone: string, address?: string | null, supportPhoneNumber?: string | null, supportEmail?: string | null, funnelCommunityId?: string | null, createdAt: string, updatedAt: string, organization: { organizationId: string, name: string }, image?: { imageId: string, cloudId: string } | null, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string, featureFlag: { featureFlagId: string, key: FeatureFlagKey_enum, name: string, description?: string | null, isLocked: boolean } }>, propertySources_aggregate: { aggregate?: { count: number } | null } };

export type OrganizationPropertyTabFragment = { propertyId: string, name: string, supportPhoneNumber?: string | null, supportEmail?: string | null, timezone: string, createdAt: string, image?: { imageId: string, cloudId: string } | null, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string, featureFlag: { featureFlagId: string, key: FeatureFlagKey_enum, name: string, description?: string | null, isLocked: boolean } }>, propertySources_aggregate: { aggregate?: { count: number } | null } };

export type getPropertiesQueryVariables = Exact<{
  where: Property_bool_exp;
}>;


export type getPropertiesQuery = { properties: Array<{ propertyId: string, name: string, timezone: string, address?: string | null, supportPhoneNumber?: string | null, supportEmail?: string | null, funnelCommunityId?: string | null, createdAt: string, updatedAt: string, organization: { organizationId: string, name: string }, image?: { imageId: string, cloudId: string } | null, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string, featureFlag: { featureFlagId: string, key: FeatureFlagKey_enum, name: string, description?: string | null, isLocked: boolean } }>, propertySources_aggregate: { aggregate?: { count: number } | null } }> };

export type getPropertyDetailsQueryVariables = Exact<{
  propertyId: Scalars['uuid']['input'];
}>;


export type getPropertyDetailsQuery = { property?: { propertyId: string, name: string, timezone: string, address?: string | null, supportPhoneNumber?: string | null, supportEmail?: string | null, funnelCommunityId?: string | null, createdAt: string, updatedAt: string, organization: { organizationId: string, name: string }, image?: { imageId: string, cloudId: string } | null, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string, featureFlag: { featureFlagId: string, key: FeatureFlagKey_enum, name: string, description?: string | null, isLocked: boolean } }>, propertySources_aggregate: { aggregate?: { count: number } | null } } | null };

export type getPropertyWithPropertySourcesQueryVariables = Exact<{
  propertyId: Scalars['uuid']['input'];
}>;


export type getPropertyWithPropertySourcesQuery = { property?: { propertyId: string, name: string, propertySources: Array<{ propertySourceId: string, sourceId: string }>, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string, featureFlag: { featureFlagId: string, key: FeatureFlagKey_enum, name: string, description?: string | null, isLocked: boolean } }>, propertySources_aggregate: { aggregate?: { count: number } | null } } | null };

export type getPropertyWithPropertyMapsQueryVariables = Exact<{
  propertyId: Scalars['uuid']['input'];
}>;


export type getPropertyWithPropertyMapsQuery = { property?: { propertyId: string, name: string, propertySources: Array<{ propertySourceId: string, sourceId: string }>, propertyMap?: { propertyMapId: string, propertyId: string, type: PropertyMapType_enum, externalAssetId: string, externalMapId: string, externalUnits: any, externalFloors: any, published: boolean, property: { propertyId: string, name: string } } | null } | null };

export type getGatewayPinCodePropertiesByUserQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type getGatewayPinCodePropertiesByUserQuery = { properties: Array<{ propertyId: string, name: string }> };

export type getGamPropertiesByUserQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type getGamPropertiesByUserQuery = { properties: Array<{ propertyId: string, name: string }> };

export type PropertyFeatureFlagLabelFragment = { propertyFeatureFlagId: string, featureFlagKey: string, featureFlag: { featureFlagId: string, key: FeatureFlagKey_enum, name: string, description?: string | null, isLocked: boolean } };

export type upsertPropertyFeatureFlagsMutationVariables = Exact<{
  objects: Array<PropertyFeatureFlag_insert_input> | PropertyFeatureFlag_insert_input;
}>;


export type upsertPropertyFeatureFlagsMutation = { propertyFeatureFlags?: { returning: Array<{ propertyFeatureFlagId: string, property: { propertyId: string, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string, featureFlag: { featureFlagId: string, key: FeatureFlagKey_enum, name: string, description?: string | null, isLocked: boolean } }> } }> } | null };

export type deletePropertyFeatureFlagsMutationVariables = Exact<{
  where: PropertyFeatureFlag_bool_exp;
}>;


export type deletePropertyFeatureFlagsMutation = { propertyFeatureFlags?: { returning: Array<{ propertyFeatureFlagId: string, property: { propertyId: string, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string, featureFlag: { featureFlagId: string, key: FeatureFlagKey_enum, name: string, description?: string | null, isLocked: boolean } }> } }> } | null };

export type PropertyMapTableFragment = { propertyMapId: string, propertyId: string, type: PropertyMapType_enum, externalAssetId: string, externalMapId: string, externalUnits: any, externalFloors: any, published: boolean, property: { propertyId: string, name: string } };

export type syncEngrainPropertyMapMutationVariables = Exact<{
  input: Custom_SyncEngrainPropertyMapInput;
}>;


export type syncEngrainPropertyMapMutation = { custom_syncEngrainPropertyMap: { propertyMapId: string, property?: { propertyId: string, propertyMap?: { propertyMapId: string, propertyId: string, type: PropertyMapType_enum, externalAssetId: string, externalMapId: string, externalUnits: any, externalFloors: any, published: boolean, property: { propertyId: string, name: string } } | null } | null } };

export type updatePropertyMapByPkMutationVariables = Exact<{
  propertyMapId: Scalars['uuid']['input'];
  _set: PropertyMap_set_input;
}>;


export type updatePropertyMapByPkMutation = { propertyMap?: { propertyMapId: string, propertyId: string, type: PropertyMapType_enum, externalAssetId: string, externalMapId: string, externalUnits: any, externalFloors: any, published: boolean, property: { propertyId: string, name: string } } | null };

export type RelayLabelFragment = { relayId: string, name: string };

export type RelayUniqueLabelFragment = { relayId: string, name: string, hub: { hubId: string, name?: string | null, macAddress?: string | null, property?: { propertyId: string, name: string } | null } };

export type RelayActionFragment = { gpioMode: GpioMode_enum, position: number, relayId: string, name: string, hub: { hubId: string, name?: string | null, macAddress?: string | null } };

export type RelayRequiredRowFragment = { hub: { property?: { propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string }> } | null } };

export type RelayTableFragment = { position: number, failurePlan: FailurePlan_enum, unlockOnInternetFailure: boolean, readerType?: ReaderType_enum | null, inputDevice?: InputDevice_enum | null, createdAt: string, relayId: string, name: string, gpioMode: GpioMode_enum, hub: { hubId: string, name?: string | null, macAddress?: string | null, property?: { propertyId: string, name: string } | null }, accessPointRelays: Array<{ accessPointRelayId: string, accessPoint: { accessPointId: string, name: string } }>, childHub?: { hubId: string, name?: string | null, macAddress?: string | null } | null };

export type RelayFailurePlanFragment = { relayId: string, hubId: string, position: number, name: string, gpioMode: GpioMode_enum, failurePlan: FailurePlan_enum };

export type getRelaysQueryVariables = Exact<{
  where: Relay_bool_exp;
}>;


export type getRelaysQuery = { relays: Array<{ relayId: string, hubId: string, position: number, name: string, gpioMode: GpioMode_enum, failurePlan: FailurePlan_enum }> };

export type updateRelaysMutationVariables = Exact<{
  where: Relay_bool_exp;
  _set: Relay_set_input;
}>;


export type updateRelaysMutation = { updateRelays?: { returning: Array<{ relayId: string, hubId: string, position: number, name: string, gpioMode: GpioMode_enum, failurePlan: FailurePlan_enum }> } | null };

export type getRelaysWithAccessPointInfoQueryVariables = Exact<{
  where: Relay_bool_exp;
}>;


export type getRelaysWithAccessPointInfoQuery = { relays: Array<{ hubId: string, position: number, relayId: string, name: string, accessPointRelays: Array<{ accessPointRelayId: string, accessPoint: { accessPointId: string, name: string } }> }> };

export type RoleLabelFragment = { roleId: string, name: string };

export type RoleUniqueLabelFragment = { roleId: string, name: string, uniqueName?: string | null, organization?: { organizationId: string, name: string } | null };

export type RoleRequiredRowFragment = { key?: RoleKey_enum | null, permissionScope: PermissionScope_enum, isLocked: boolean, roleId: string, name: string, organization?: { organizationId: string, name: string } | null };

export type AllowedRoleFragment = { roleId: string, key?: RoleKey_enum | null, name: string, permissionScope: PermissionScope_enum, organization?: { organizationId: string, name: string } | null };

export type RoleDetailsFragment = { uniqueName?: string | null, description?: string | null, maxAccessDurationSeconds?: number | null, isLocked: boolean, deprecatedType?: string | null, createdAt: string, updatedAt: string, roleId: string, key?: RoleKey_enum | null, name: string, permissionScope: PermissionScope_enum, rolePermissions: Array<{ rolePermissionId: string, permission: { permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean } }>, roleRelationshipsByRole: Array<{ roleRelationshipId: string, roleId: string, canReadUserRole: boolean, canGrantUserRole: boolean, canRevokeUserRole: boolean, createdAt: string, relatedRole: { key?: RoleKey_enum | null, permissionScope: PermissionScope_enum, roleId: string, name: string, uniqueName?: string | null, rolePermissions_aggregate: { aggregate?: { count: number } | null }, organization?: { organizationId: string, name: string } | null } }>, organization?: { organizationId: string, name: string } | null };

export type RelatableRoleFragment = { key?: RoleKey_enum | null, permissionScope: PermissionScope_enum, roleId: string, name: string, uniqueName?: string | null, rolePermissions_aggregate: { aggregate?: { count: number } | null }, organization?: { organizationId: string, name: string } | null };

export type GrantableRoleFragment = { roleId: string, key?: RoleKey_enum | null, name: string, description?: string | null, permissionScope: PermissionScope_enum, maxAccessDurationSeconds?: number | null, rolePermissions: Array<{ rolePermissionId: string, permission: { permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean } }> };

export type RoleWithStaffPermissionsFragment = { key?: RoleKey_enum | null, permissionScope: PermissionScope_enum, roleId: string, name: string, uniqueName?: string | null, rolePermissions: Array<{ rolePermissionId: string, permission: { permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean } }>, organization?: { organizationId: string, name: string } | null };

export type RoleCommonTableFragment = { roleId: string, key?: RoleKey_enum | null, name: string, permissionScope: PermissionScope_enum, createdAt: string, isLocked: boolean, rolePermissions_aggregate: { aggregate?: { count: number } | null }, rolePermissions: Array<{ rolePermissionId: string, permission: { permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean } }>, canReadAggregate: { aggregate?: { count: number } | null }, canGrantAggregate: { aggregate?: { count: number } | null }, canRevokeAggregate: { aggregate?: { count: number } | null }, organization?: { organizationId: string, name: string } | null };

export type getRolePermissionsAndRelationshipsQueryVariables = Exact<{
  roleIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type getRolePermissionsAndRelationshipsQuery = { permissions: Array<{ permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean }>, roleRelationships: Array<{ roleRelationshipId: string, roleId: string, canReadUserRole: boolean, canGrantUserRole: boolean, canRevokeUserRole: boolean, createdAt: string, relatedRole: { key?: RoleKey_enum | null, permissionScope: PermissionScope_enum, roleId: string, name: string, uniqueName?: string | null, organization?: { organizationId: string, name: string } | null } }> };

export type getRoleDetailsQueryVariables = Exact<{
  roleId: Scalars['uuid']['input'];
}>;


export type getRoleDetailsQuery = { role?: { uniqueName?: string | null, description?: string | null, maxAccessDurationSeconds?: number | null, isLocked: boolean, deprecatedType?: string | null, createdAt: string, updatedAt: string, roleId: string, key?: RoleKey_enum | null, name: string, permissionScope: PermissionScope_enum, rolePermissions: Array<{ rolePermissionId: string, permission: { permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean } }>, roleRelationshipsByRole: Array<{ roleRelationshipId: string, roleId: string, canReadUserRole: boolean, canGrantUserRole: boolean, canRevokeUserRole: boolean, createdAt: string, relatedRole: { key?: RoleKey_enum | null, permissionScope: PermissionScope_enum, roleId: string, name: string, uniqueName?: string | null, rolePermissions_aggregate: { aggregate?: { count: number } | null }, organization?: { organizationId: string, name: string } | null } }>, organization?: { organizationId: string, name: string } | null } | null };

export type getRolesQueryVariables = Exact<{
  where: Role_bool_exp;
}>;


export type getRolesQuery = { roles: Array<{ key?: RoleKey_enum | null, permissionScope: PermissionScope_enum, roleId: string, name: string, uniqueName?: string | null, organization?: { organizationId: string, name: string } | null }> };

export type getRelatableRolesQueryVariables = Exact<{
  where: Role_bool_exp;
  order_by?: InputMaybe<Array<Role_order_by> | Role_order_by>;
}>;


export type getRelatableRolesQuery = { roles: Array<{ key?: RoleKey_enum | null, permissionScope: PermissionScope_enum, roleId: string, name: string, uniqueName?: string | null, rolePermissions_aggregate: { aggregate?: { count: number } | null }, organization?: { organizationId: string, name: string } | null }> };

export type getGrantableRolesQueryVariables = Exact<{
  where: Role_bool_exp;
  order_by?: InputMaybe<Array<Role_order_by> | Role_order_by>;
}>;


export type getGrantableRolesQuery = { roles: Array<{ roleId: string, key?: RoleKey_enum | null, name: string, description?: string | null, permissionScope: PermissionScope_enum, maxAccessDurationSeconds?: number | null, rolePermissions: Array<{ rolePermissionId: string, permission: { permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean } }> }> };

export type getRoleByKeyQueryVariables = Exact<{
  key: RoleKey_enum;
}>;


export type getRoleByKeyQuery = { roles: Array<{ roleId: string, name: string, uniqueName?: string | null, organization?: { organizationId: string, name: string } | null }> };

export type insertRolesMutationVariables = Exact<{
  objects: Array<Role_insert_input> | Role_insert_input;
}>;


export type insertRolesMutation = { roles?: { returning: Array<{ uniqueName?: string | null, description?: string | null, maxAccessDurationSeconds?: number | null, isLocked: boolean, deprecatedType?: string | null, createdAt: string, updatedAt: string, roleId: string, key?: RoleKey_enum | null, name: string, permissionScope: PermissionScope_enum, rolePermissions: Array<{ rolePermissionId: string, permission: { permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean } }>, roleRelationshipsByRole: Array<{ roleRelationshipId: string, roleId: string, canReadUserRole: boolean, canGrantUserRole: boolean, canRevokeUserRole: boolean, createdAt: string, relatedRole: { key?: RoleKey_enum | null, permissionScope: PermissionScope_enum, roleId: string, name: string, uniqueName?: string | null, rolePermissions_aggregate: { aggregate?: { count: number } | null }, organization?: { organizationId: string, name: string } | null } }>, organization?: { organizationId: string, name: string } | null }> } | null };

export type RolePermissionFragment = { rolePermissionId: string, permission: { permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean } };

export type upsertRolePermissionsMutationVariables = Exact<{
  objects: Array<RolePermission_insert_input> | RolePermission_insert_input;
}>;


export type upsertRolePermissionsMutation = { rolePermissions?: { returning: Array<{ rolePermissionId: string, permission: { permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean } }> } | null };

export type deleteRolePermissionsMutationVariables = Exact<{
  where: RolePermission_bool_exp;
}>;


export type deleteRolePermissionsMutation = { rolePermissions?: { returning: Array<{ rolePermissionId: string, permission: { permissionId: string, key: PermissionKey_enum, scope: PermissionScope_enum, isLocked: boolean } }> } | null };

export type RoleRelationshipFragment = { roleRelationshipId: string, roleId: string, canReadUserRole: boolean, canGrantUserRole: boolean, canRevokeUserRole: boolean, createdAt: string, relatedRole: { key?: RoleKey_enum | null, permissionScope: PermissionScope_enum, roleId: string, name: string, uniqueName?: string | null, organization?: { organizationId: string, name: string } | null } };

export type RoleRelationshipDetailsFragment = { roleRelationshipId: string, roleId: string, canReadUserRole: boolean, canGrantUserRole: boolean, canRevokeUserRole: boolean, createdAt: string, relatedRole: { key?: RoleKey_enum | null, permissionScope: PermissionScope_enum, roleId: string, name: string, uniqueName?: string | null, rolePermissions_aggregate: { aggregate?: { count: number } | null }, organization?: { organizationId: string, name: string } | null } };

export type upsertRoleRelationshipsMutationVariables = Exact<{
  objects: Array<RoleRelationship_insert_input> | RoleRelationship_insert_input;
}>;


export type upsertRoleRelationshipsMutation = { roleRelationships?: { returning: Array<{ roleRelationshipId: string, roleId: string, canReadUserRole: boolean, canGrantUserRole: boolean, canRevokeUserRole: boolean, createdAt: string, relatedRole: { key?: RoleKey_enum | null, permissionScope: PermissionScope_enum, roleId: string, name: string, uniqueName?: string | null, rolePermissions_aggregate: { aggregate?: { count: number } | null }, organization?: { organizationId: string, name: string } | null } }> } | null };

export type deleteRoleRelationshipMutationVariables = Exact<{
  roleId: Scalars['uuid']['input'];
  relatedRoleId: Scalars['uuid']['input'];
}>;


export type deleteRoleRelationshipMutation = { roleRelationships?: { returning: Array<{ roleRelationshipId: string, roleId: string, canReadUserRole: boolean, canGrantUserRole: boolean, canRevokeUserRole: boolean, createdAt: string, relatedRole: { key?: RoleKey_enum | null, permissionScope: PermissionScope_enum, roleId: string, name: string, uniqueName?: string | null, rolePermissions_aggregate: { aggregate?: { count: number } | null }, organization?: { organizationId: string, name: string } | null } }> } | null };

export type SessionRequiredRowFragment = { sessionId: string, revokedAt?: string | null, deviceFingerprint?: string | null };

export type SessionTableFragment = { sessionId: string, type: SessionType_enum, authMethod?: AuthMethod_enum | null, deviceInfo: any, expiresAt: string, renewedAt?: string | null, createdAt: string, revokedAt?: string | null, deviceFingerprint?: string | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, user: { userId: string, firstName?: string | null, lastName?: string | null } };

export type UserSessionFragment = { sessionId: string, type: SessionType_enum, authMethod?: AuthMethod_enum | null, deviceInfo: any, expiresAt: string, renewedAt?: string | null, createdAt: string, revokedAt?: string | null, deviceFingerprint?: string | null };

export type getSessionDetailsQueryVariables = Exact<{
  sessionId: Scalars['uuid']['input'];
}>;


export type getSessionDetailsQuery = { session?: { sessionId: string, type: SessionType_enum, authMethod?: AuthMethod_enum | null, deviceInfo: any, expiresAt: string, renewedAt?: string | null, createdAt: string, revokedAt?: string | null, deviceFingerprint?: string | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, user: { userId: string, firstName?: string | null, lastName?: string | null } } | null };

export type revokeSessionMutationVariables = Exact<{
  sessionId: Scalars['uuid']['input'];
}>;


export type revokeSessionMutation = { custom_revokeSession: { session?: { sessionId: string, type: SessionType_enum, authMethod?: AuthMethod_enum | null, deviceInfo: any, expiresAt: string, renewedAt?: string | null, createdAt: string, revokedAt?: string | null, deviceFingerprint?: string | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, user: { userId: string, firstName?: string | null, lastName?: string | null } } | null } };

export type SmartLockLabelFragment = { smartLockId: string, name: string };

export type SmartLockUniqueLabelFragment = { smartLockId: string, name: string, unit: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null, property: { propertyId: string, name: string } } };

export type SmartLockActionFragment = { unitId: string, sourceId: string, smartLockId: string, name: string };

export type SmartLockTableFragment = { smartLockId: string, name: string, sourceId: string, serialNumber?: string | null, createdAt: string, unitId: string, unit: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null, property: { propertyId: string, name: string } }, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type PropertySmartLockFragment = { smartLockId: string, name: string, sourceId: string, serialNumber?: string | null, createdAt: string, unitId: string, unit: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null }, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type UnitSmartLockFragment = { smartLockId: string, name: string, sourceId: string, serialNumber?: string | null, createdAt: string, unitId: string, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type augustSdkFeesReportQueryVariables = Exact<{
  startDate: Scalars['timestamptz']['input'];
  endDate: Scalars['timestamptz']['input'];
}>;


export type augustSdkFeesReportQuery = { totalSmartLocks: { aggregate?: { count: number } | null }, totalProperties: { aggregate?: { count: number } | null } };

export type remoteOperateAugustLockMutationVariables = Exact<{
  input: Custom_RemoteOperateAugustLockInput;
}>;


export type remoteOperateAugustLockMutation = { custom_remoteOperateAugustLock: { lockStatus: string, doorStatus: string } };

export type TicketLabelFragment = { ticketId: string };

export type TicketRequiredRowFragment = { ticketId: string, type: TicketType_enum, status: TicketStatus_enum, unit?: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null } | null };

export type TicketTableFragment = { ticketId: string, solvedAt?: string | null, createdAt: string, type: TicketType_enum, status: TicketStatus_enum, property: { propertyId: string, name: string }, smartLock?: { smartLockId: string, name: string } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, solvedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, unit?: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null } | null };

export type SmartLockTicketTabFragment = { ticketId: string, createdAt: string, type: TicketType_enum, status: TicketStatus_enum, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, solvedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, unit?: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null } | null };

export type getTicketDetailsQueryVariables = Exact<{
  ticketId: Scalars['uuid']['input'];
}>;


export type getTicketDetailsQuery = { ticket?: { ticketId: string, solvedAt?: string | null, createdAt: string, type: TicketType_enum, status: TicketStatus_enum, property: { propertyId: string, name: string }, smartLock?: { smartLockId: string, name: string } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, solvedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, unit?: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null } | null } | null };

export type updateTicketStatusMutationVariables = Exact<{
  ticketId: Scalars['uuid']['input'];
  status: Scalars['String']['input'];
}>;


export type updateTicketStatusMutation = { custom_updateTicketStatus: { ticket?: { ticketId: string, solvedAt?: string | null, createdAt: string, type: TicketType_enum, status: TicketStatus_enum, property: { propertyId: string, name: string }, smartLock?: { smartLockId: string, name: string } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, solvedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, unit?: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null } | null } | null } };

export type UnitLabelFragment = { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null };

export type UnitUniqueLabelFragment = { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null, property: { propertyId: string, name: string } };

export type UnitWithOccupantCountFragment = { occupantCount?: number | null, unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null, property: { propertyId: string, name: string } };

export type UnitTableFragment = { unitId: string, unitNumber: string, building?: string | null, type?: UnitType_enum | null, sourceId?: string | null, occupantCount?: number | null, createdAt: string, property: { propertyId: string, name: string }, unitGroup?: { unitGroupId: string, name: string } | null, smartLocks: Array<{ smartLockId: string, name: string }> };

export type UnitDetailsFragment = { updatedAt: string, virtualDirectoryEnabled: boolean, unitId: string, unitNumber: string, building?: string | null, type?: UnitType_enum | null, sourceId?: string | null, occupantCount?: number | null, createdAt: string, property: { propertyId: string, name: string, propertyFeatureFlags: Array<{ featureFlagKey: string }> }, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, unitGroup?: { unitGroupId: string, name: string } | null, smartLocks: Array<{ smartLockId: string, name: string }> };

export type getUnitDetailsQueryVariables = Exact<{
  unitId: Scalars['uuid']['input'];
}>;


export type getUnitDetailsQuery = { unit?: { updatedAt: string, virtualDirectoryEnabled: boolean, unitId: string, unitNumber: string, building?: string | null, type?: UnitType_enum | null, sourceId?: string | null, occupantCount?: number | null, createdAt: string, property: { propertyId: string, name: string, propertyFeatureFlags: Array<{ featureFlagKey: string }> }, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, unitGroup?: { unitGroupId: string, name: string } | null, smartLocks: Array<{ smartLockId: string, name: string }> } | null };

export type getUnitWithPropertyQueryVariables = Exact<{
  unitId: Scalars['uuid']['input'];
}>;


export type getUnitWithPropertyQuery = { unit?: { unitId: string, propertyId: string, sourceId?: string | null, unitNumber: string, building?: string | null, occupantCount?: number | null, property: { propertyId: string, name: string, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string }> } } | null };

export type getUnitsQueryVariables = Exact<{
  where: Unit_bool_exp;
}>;


export type getUnitsQuery = { units: Array<{ unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null }> };

export type getGrantableUnitsQueryVariables = Exact<{
  where: Unit_bool_exp;
}>;


export type getGrantableUnitsQuery = { units: Array<{ unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null, property: { timezone: string } }> };

export type insertUnitsMutationVariables = Exact<{
  objects: Array<Unit_insert_input> | Unit_insert_input;
}>;


export type insertUnitsMutation = { insertUnits?: { returning: Array<{ unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null }> } | null };

export type UnitGroupLabelFragment = { unitGroupId: string, name: string };

export type UnitGroupUniqueLabelFragment = { unitGroupId: string, name: string, propertyName?: string | null, parentUnitGroup?: { unitGroupId: string, name: string } | null };

export type UnitGroupRowFragment = { propertyId: string, sourceId?: string | null, unitGroupId: string, name: string };

export type UnitGroupTableFragment = { propertyId: string, propertyName?: string | null, sourceId?: string | null, createdAt: string, unitGroupId: string, name: string, parentUnitGroup?: { unitGroupId: string, name: string } | null };

export type AuthenticatedUserFragment = { userId: string, accountStatus: AccountStatus_enum, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, acceptedEulaAt?: string | null };

export type UserLabelFragment = { userId: string, firstName?: string | null, lastName?: string | null };

export type UserUniqueLabelFragment = { phoneNumber?: string | null, email?: string | null, userId: string, firstName?: string | null, lastName?: string | null };

export type UserRowFragment = { userId: string, accountStatus: AccountStatus_enum, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, augustUserId?: string | null, augustSubUserId?: string | null, hasAugustPassword: boolean, createdAt: string, password?: { passwordId?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type UserActionFragment = { accountStatus: AccountStatus_enum, userId: string, firstName?: string | null, lastName?: string | null };

export type UsersMainTableFragment = { userId: string, accountStatus: AccountStatus_enum, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, augustUserId?: string | null, augustSubUserId?: string | null, hasAugustPassword: boolean, createdAt: string, assignedUserRoles: Array<{ userRoleId: string, role: { roleId: string, name: string } }>, password?: { passwordId?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type UserDetailsFragment = { updatedAt: string, userId: string, accountStatus: AccountStatus_enum, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, augustUserId?: string | null, augustSubUserId?: string | null, hasAugustPassword: boolean, createdAt: string, password?: { passwordId?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type UserDetailsWithGlobalRolesFragment = { updatedAt: string, userId: string, accountStatus: AccountStatus_enum, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, augustUserId?: string | null, augustSubUserId?: string | null, hasAugustPassword: boolean, createdAt: string, globalUserRoles: Array<{ userRoleId: string, role: { roleId: string, name: string } }>, password?: { passwordId?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type authenticatedUserQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type authenticatedUserQuery = { user?: { userId: string, accountStatus: AccountStatus_enum, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, acceptedEulaAt?: string | null } | null, userRoles: Array<{ userRoleId: string, role: { roleId: string, key?: RoleKey_enum | null, name: string, permissionScope: PermissionScope_enum, organization?: { organizationId: string, name: string } | null }, scopedOrganization?: { organizationId: string, name: string } | null, scopedProperty?: { propertyId: string, name: string } | null }> };

export type userDetailsSubscriptionVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type userDetailsSubscription = { user?: { updatedAt: string, userId: string, accountStatus: AccountStatus_enum, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, augustUserId?: string | null, augustSubUserId?: string | null, hasAugustPassword: boolean, createdAt: string, password?: { passwordId?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } | null };

export type userDetailsWithGlobalRolesSubscriptionVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type userDetailsWithGlobalRolesSubscription = { user?: { updatedAt: string, userId: string, accountStatus: AccountStatus_enum, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, augustUserId?: string | null, augustSubUserId?: string | null, hasAugustPassword: boolean, createdAt: string, globalUserRoles: Array<{ userRoleId: string, role: { roleId: string, name: string } }>, password?: { passwordId?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } | null };

export type updateUserMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  _set: Custom_UpdateUserInput;
}>;


export type updateUserMutation = { custom_updateUser: { user?: { updatedAt: string, userId: string, accountStatus: AccountStatus_enum, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, augustUserId?: string | null, augustSubUserId?: string | null, hasAugustPassword: boolean, createdAt: string, password?: { passwordId?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } | null } };

export type UserRoleAssignedToFragment = { userRoleId: string, nickname?: string | null, sourceId?: string | null, role: { key?: RoleKey_enum | null }, assignedToUser?: { phoneNumber?: string | null, email?: string | null, userId: string, firstName?: string | null, lastName?: string | null } | null };

export type UserRoleUniqueLabelFragment = { userRoleId: string, status: UserRoleStatus_enum, nickname?: string | null, sourceId?: string | null, scopedOrganization?: { organizationId: string, name: string } | null, scopedProperty?: { propertyId: string, name: string } | null, scopedUnit?: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null, property: { propertyId: string, name: string } } | null, scopedAccessPoint?: { accessPointId: string, name: string, property: { propertyId: string, name: string } } | null, scopedSmartLock?: { smartLockId: string, name: string, unit: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null, property: { propertyId: string, name: string } } } | null, role: { key?: RoleKey_enum | null, roleId: string, name: string }, assignedToUser?: { phoneNumber?: string | null, email?: string | null, userId: string, firstName?: string | null, lastName?: string | null } | null };

export type UserRoleActionFragment = { userRoleId: string, status: UserRoleStatus_enum, expiresAt?: string | null, schedule?: any | null, sourceId?: string | null, role: { roleId: string, key?: RoleKey_enum | null, permissionScope: PermissionScope_enum }, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type UserRoleExpandedFragment = { schedule?: any | null, sourceId?: string | null, grantMethod?: UserRoleGrantMethod_enum | null, reason?: UserRoleReason_enum | null, notes?: string | null, revokedAt?: string | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type UserRoleSmartLockFragment = { scopedSmartLock?: { smartLockId: string, name: string, unit: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null } } | null };

export type UserRolesCommonTableFragment = { userRoleId: string, activatesAt?: string | null, expiresAt?: string | null, createdAt: string, status: UserRoleStatus_enum, schedule?: any | null, sourceId?: string | null, grantMethod?: UserRoleGrantMethod_enum | null, reason?: UserRoleReason_enum | null, notes?: string | null, revokedAt?: string | null, role: { key?: RoleKey_enum | null, roleId: string, permissionScope: PermissionScope_enum, name: string }, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type GlobalUserRolesTableFragment = { userRoleId: string, activatesAt?: string | null, expiresAt?: string | null, createdAt: string, status: UserRoleStatus_enum, schedule?: any | null, sourceId?: string | null, grantMethod?: UserRoleGrantMethod_enum | null, reason?: UserRoleReason_enum | null, notes?: string | null, revokedAt?: string | null, role: { key?: RoleKey_enum | null, roleId: string, permissionScope: PermissionScope_enum, name: string }, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type OrganizationUserRolesTableFragment = { userRoleId: string, activatesAt?: string | null, expiresAt?: string | null, createdAt: string, status: UserRoleStatus_enum, schedule?: any | null, sourceId?: string | null, grantMethod?: UserRoleGrantMethod_enum | null, reason?: UserRoleReason_enum | null, notes?: string | null, revokedAt?: string | null, scopedOrganization?: { organizationId: string, name: string } | null, role: { key?: RoleKey_enum | null, roleId: string, permissionScope: PermissionScope_enum, name: string }, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type PropertyUserRolesTableFragment = { userRoleId: string, activatesAt?: string | null, expiresAt?: string | null, createdAt: string, nickname?: string | null, sourceId?: string | null, status: UserRoleStatus_enum, schedule?: any | null, grantMethod?: UserRoleGrantMethod_enum | null, reason?: UserRoleReason_enum | null, notes?: string | null, revokedAt?: string | null, scopedProperty?: { propertyId: string, name: string } | null, role: { key?: RoleKey_enum | null, roleId: string, permissionScope: PermissionScope_enum, name: string }, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type UnitUserRolesTableFragment = { userRoleId: string, activatesAt?: string | null, expiresAt?: string | null, createdAt: string, nickname?: string | null, sourceId?: string | null, status: UserRoleStatus_enum, schedule?: any | null, grantMethod?: UserRoleGrantMethod_enum | null, reason?: UserRoleReason_enum | null, notes?: string | null, revokedAt?: string | null, managedWithinProperty?: { propertyId: string, name: string } | null, scopedUnit?: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null } | null, role: { key?: RoleKey_enum | null, roleId: string, permissionScope: PermissionScope_enum, name: string }, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type AccessPointUserRolesTableFragment = { userRoleId: string, activatesAt?: string | null, expiresAt?: string | null, createdAt: string, status: UserRoleStatus_enum, schedule?: any | null, sourceId?: string | null, grantMethod?: UserRoleGrantMethod_enum | null, reason?: UserRoleReason_enum | null, notes?: string | null, revokedAt?: string | null, managedWithinProperty?: { propertyId: string, name: string } | null, scopedAccessPoint?: { accessPointId: string, name: string } | null, role: { key?: RoleKey_enum | null, roleId: string, permissionScope: PermissionScope_enum, name: string }, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type SmartLockUserRolesTableFragment = { userRoleId: string, activatesAt?: string | null, expiresAt?: string | null, createdAt: string, nickname?: string | null, sourceId?: string | null, status: UserRoleStatus_enum, schedule?: any | null, grantMethod?: UserRoleGrantMethod_enum | null, reason?: UserRoleReason_enum | null, notes?: string | null, revokedAt?: string | null, managedWithinProperty?: { propertyId: string, name: string } | null, role: { key?: RoleKey_enum | null, roleId: string, permissionScope: PermissionScope_enum, name: string }, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, scopedSmartLock?: { smartLockId: string, name: string, unit: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null } } | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type AugustPinCodeUserRoleFragment = { userRoleId: string, status: UserRoleStatus_enum, expiresAt?: string | null, revokedAt?: string | null, createdAt: string, schedule?: any | null, sourceId?: string | null, role: { key?: RoleKey_enum | null, roleId: string, permissionScope: PermissionScope_enum }, scopedSmartLock?: { sourceId: string, smartLockId: string, name: string, openLockResetTickets: { aggregate?: { count: number } | null }, unit: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null, property: { propertyId: string, name: string } } } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type UserRoleDetailsFragment = { parentUserRoleId?: string | null, sourcePayload?: any | null, userRoleId: string, activatesAt?: string | null, expiresAt?: string | null, createdAt: string, status: UserRoleStatus_enum, revokedAt?: string | null, schedule?: any | null, sourceId?: string | null, grantMethod?: UserRoleGrantMethod_enum | null, reason?: UserRoleReason_enum | null, notes?: string | null, nickname?: string | null, role: { key?: RoleKey_enum | null, roleId: string, permissionScope: PermissionScope_enum, name: string }, childUserRoles: Array<{ userRoleId: string, status: UserRoleStatus_enum, expiresAt?: string | null, revokedAt?: string | null, createdAt: string, schedule?: any | null, sourceId?: string | null, role: { key?: RoleKey_enum | null, roleId: string, permissionScope: PermissionScope_enum }, scopedSmartLock?: { sourceId: string, smartLockId: string, name: string, openLockResetTickets: { aggregate?: { count: number } | null }, unit: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null, property: { propertyId: string, name: string } } } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null }>, pinCodes: Array<{ pinCodeId: string }>, managedWithinProperty?: { timezone: string, propertyId: string, name: string, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string }> } | null, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, scopedOrganization?: { organizationId: string, name: string } | null, scopedProperty?: { propertyId: string, name: string } | null, scopedUnit?: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null } | null, scopedAccessPoint?: { accessPointId: string, name: string } | null, scopedSmartLock?: { sourceId: string, smartLockId: string, name: string, openLockResetTickets: { aggregate?: { count: number } | null }, unit: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null, property: { propertyId: string, name: string } } } | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type UnitUserRoleAuditTableFragment = { userRoleId: string, activatesAt?: string | null, expiresAt?: string | null, nickname?: string | null, sourceId?: string | null, status: UserRoleStatus_enum, schedule?: any | null, grantMethod?: UserRoleGrantMethod_enum | null, reason?: UserRoleReason_enum | null, notes?: string | null, revokedAt?: string | null, role: { key?: RoleKey_enum | null, roleId: string, permissionScope: PermissionScope_enum, name: string }, assignedToUser?: { userId: string, accountStatus: AccountStatus_enum, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null };

export type AugustAccessUserRoleFragment = { userRoleId: string, activatesAt?: string | null, expiresAt?: string | null, reason?: UserRoleReason_enum | null, nickname?: string | null, sourceId?: string | null, parentUserRole?: { userRoleId: string } | null, role: { key?: RoleKey_enum | null, roleId: string, name: string }, assignedToUser?: { userId: string, accountStatus: AccountStatus_enum, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, augustUserId?: string | null, augustSubUserId?: string | null, hasAugustPassword: boolean, createdAt: string, password?: { passwordId?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } | null };

export type Custom_AugustLockUserRoleFragment = { userRoleId: string, augustUserId?: string | null, augustUserType?: string | null, permissions: Array<string>, role?: { key?: RoleKey_enum | null, roleId: string, name: string } | null, userRole?: { userRoleId: string, activatesAt?: string | null, expiresAt?: string | null, reason?: UserRoleReason_enum | null, nickname?: string | null, sourceId?: string | null, parentUserRole?: { userRoleId: string } | null, role: { key?: RoleKey_enum | null, roleId: string, name: string }, assignedToUser?: { userId: string, accountStatus: AccountStatus_enum, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, augustUserId?: string | null, augustSubUserId?: string | null, hasAugustPassword: boolean, createdAt: string, password?: { passwordId?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } | null } | null };

export type getUserRoleDetailsSubscriptionVariables = Exact<{
  userRoleId: Scalars['uuid']['input'];
}>;


export type getUserRoleDetailsSubscription = { userRole?: { parentUserRoleId?: string | null, sourcePayload?: any | null, userRoleId: string, activatesAt?: string | null, expiresAt?: string | null, createdAt: string, status: UserRoleStatus_enum, revokedAt?: string | null, schedule?: any | null, sourceId?: string | null, grantMethod?: UserRoleGrantMethod_enum | null, reason?: UserRoleReason_enum | null, notes?: string | null, nickname?: string | null, role: { key?: RoleKey_enum | null, roleId: string, permissionScope: PermissionScope_enum, name: string }, childUserRoles: Array<{ userRoleId: string, status: UserRoleStatus_enum, expiresAt?: string | null, revokedAt?: string | null, createdAt: string, schedule?: any | null, sourceId?: string | null, role: { key?: RoleKey_enum | null, roleId: string, permissionScope: PermissionScope_enum }, scopedSmartLock?: { sourceId: string, smartLockId: string, name: string, openLockResetTickets: { aggregate?: { count: number } | null }, unit: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null, property: { propertyId: string, name: string } } } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null }>, pinCodes: Array<{ pinCodeId: string }>, managedWithinProperty?: { timezone: string, propertyId: string, name: string, propertyFeatureFlags: Array<{ propertyFeatureFlagId: string, featureFlagKey: string }> } | null, assignedToUser?: { userId: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null } | null, createdByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null, scopedOrganization?: { organizationId: string, name: string } | null, scopedProperty?: { propertyId: string, name: string } | null, scopedUnit?: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null } | null, scopedAccessPoint?: { accessPointId: string, name: string } | null, scopedSmartLock?: { sourceId: string, smartLockId: string, name: string, openLockResetTickets: { aggregate?: { count: number } | null }, unit: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null, property: { propertyId: string, name: string } } } | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null } | null };

export type getUserRolesQueryVariables = Exact<{
  where: UserRole_bool_exp;
}>;


export type getUserRolesQuery = { userRoles: Array<{ userRoleId: string, status: UserRoleStatus_enum, nickname?: string | null, sourceId?: string | null, scopedOrganization?: { organizationId: string, name: string } | null, scopedProperty?: { propertyId: string, name: string } | null, scopedUnit?: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null, property: { propertyId: string, name: string } } | null, scopedAccessPoint?: { accessPointId: string, name: string, property: { propertyId: string, name: string } } | null, scopedSmartLock?: { smartLockId: string, name: string, unit: { unitId: string, unitNumber: string, building?: string | null, sourceId?: string | null, property: { propertyId: string, name: string } } } | null, role: { key?: RoleKey_enum | null, roleId: string, name: string }, assignedToUser?: { phoneNumber?: string | null, email?: string | null, userId: string, firstName?: string | null, lastName?: string | null } | null }> };

export type getAugustLockUserRolesQueryVariables = Exact<{
  input: Custom_GetAugustLockUserRolesInput;
}>;


export type getAugustLockUserRolesQuery = { custom_getAugustLockUserRoles: { augustLockUserRoles: Array<{ userRoleId: string, augustUserId?: string | null, augustUserType?: string | null, permissions: Array<string>, role?: { key?: RoleKey_enum | null, roleId: string, name: string } | null, userRole?: { userRoleId: string, activatesAt?: string | null, expiresAt?: string | null, reason?: UserRoleReason_enum | null, nickname?: string | null, sourceId?: string | null, parentUserRole?: { userRoleId: string } | null, role: { key?: RoleKey_enum | null, roleId: string, name: string }, assignedToUser?: { userId: string, accountStatus: AccountStatus_enum, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, augustUserId?: string | null, augustSubUserId?: string | null, hasAugustPassword: boolean, createdAt: string, password?: { passwordId?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } | null } | null }> } };

export type createGuestPassMutationVariables = Exact<{
  input: Custom_CreateGuestPassInput;
}>;


export type createGuestPassMutation = { custom_createGuestPass: { userRoleId: string } };

export type revokeUserRoleMutationVariables = Exact<{
  userRoleId: Scalars['uuid']['input'];
}>;


export type revokeUserRoleMutation = { custom_revokeUserRole: { userRole?: { userRoleId: string, status: UserRoleStatus_enum, revokedAt?: string | null, revokedByUser?: { userId: string, firstName?: string | null, lastName?: string | null } | null } | null } };

export const TypeRefFragmentDoc = gql`
    fragment TypeRefFragment on __Type {
  kind
  name
  ofType {
    kind
    name
    ofType {
      kind
      name
      ofType {
        kind
        name
      }
    }
  }
}
    `;
export const FieldFragmentDoc = gql`
    fragment FieldFragment on __Field {
  name
  type {
    ...TypeRefFragment
  }
}
    ${TypeRefFragmentDoc}`;
export const AccessPointLabelFragmentDoc = gql`
    fragment AccessPointLabelFragment on AccessPoint {
  accessPointId
  name
}
    `;
export const PropertyLabelFragmentDoc = gql`
    fragment PropertyLabelFragment on Property {
  propertyId
  name
}
    `;
export const AccessPointAvailabilityFragmentDoc = gql`
    fragment AccessPointAvailabilityFragment on AccessPoint {
  accessPointId
  timetable
  property {
    propertyId
    timezone
  }
}
    `;
export const UserLabelFragmentDoc = gql`
    fragment UserLabelFragment on User {
  userId
  firstName
  lastName
}
    `;
export const AccessPointActionsFragmentDoc = gql`
    fragment AccessPointActionsFragment on AccessPoint {
  accessPointId
  deprecatedAccessPointId
  name
  timetable
  property {
    ...PropertyLabelFragment
    propertyFeatureFlags {
      propertyFeatureFlagId
      featureFlagKey
    }
  }
  proximityRestriction
  archivedAt
  archivedByUser {
    ...UserLabelFragment
  }
}
    ${PropertyLabelFragmentDoc}
${UserLabelFragmentDoc}`;
export const AccessPointRowFragmentDoc = gql`
    fragment AccessPointRowFragment on AccessPoint {
  ...AccessPointLabelFragment
  propertyId
  property {
    ...PropertyLabelFragment
    timezone
  }
  image {
    imageId
    cloudId
  }
  type
  accessTimeout
  timetable
  ...AccessPointAvailabilityFragment
  spaceshipModeEnabled
  proximityRestriction
  createdAt
  ...AccessPointActionsFragment
}
    ${AccessPointLabelFragmentDoc}
${PropertyLabelFragmentDoc}
${AccessPointAvailabilityFragmentDoc}
${AccessPointActionsFragmentDoc}`;
export const AccessPointDetailsFragmentDoc = gql`
    fragment AccessPointDetailsFragment on AccessPoint {
  ...AccessPointRowFragment
  rexAccessTimeout
  maxOccupancy
  dpsAlertDelay
  dpsAlertInterval
  mapLocation
  createdByUser {
    ...UserLabelFragment
  }
  updatedAt
}
    ${AccessPointRowFragmentDoc}
${UserLabelFragmentDoc}`;
export const AccessPointByPropertyFragmentDoc = gql`
    fragment AccessPointByPropertyFragment on AccessPoint {
  ...AccessPointRowFragment
  accessPointRelays_aggregate {
    aggregate {
      count
    }
  }
  beacons_aggregate {
    aggregate {
      count
    }
  }
}
    ${AccessPointRowFragmentDoc}`;
export const AccessPointWithMapLocationFragmentDoc = gql`
    fragment AccessPointWithMapLocationFragment on AccessPoint {
  ...AccessPointLabelFragment
  mapLocation
}
    ${AccessPointLabelFragmentDoc}`;
export const OrganizationLabelFragmentDoc = gql`
    fragment OrganizationLabelFragment on Organization {
  organizationId
  name
}
    `;
export const RoleUniqueLabelFragmentDoc = gql`
    fragment RoleUniqueLabelFragment on Role {
  roleId
  name
  uniqueName
  organization {
    ...OrganizationLabelFragment
  }
}
    ${OrganizationLabelFragmentDoc}`;
export const UnitGroupLabelFragmentDoc = gql`
    fragment UnitGroupLabelFragment on UnitGroup {
  unitGroupId
  name
}
    `;
export const UnitGroupUniqueLabelFragmentDoc = gql`
    fragment UnitGroupUniqueLabelFragment on UnitGroup {
  unitGroupId
  name
  propertyName
  parentUnitGroup {
    ...UnitGroupLabelFragment
  }
}
    ${UnitGroupLabelFragmentDoc}`;
export const AccessPointRoleTableFragmentDoc = gql`
    fragment AccessPointRoleTableFragment on AccessPointRole {
  accessPointRoleId
  roleId
  role {
    ...RoleUniqueLabelFragment
  }
  unitGroupId
  unitGroup {
    ...UnitGroupUniqueLabelFragment
  }
  schedule
  hasAccess
}
    ${RoleUniqueLabelFragmentDoc}
${UnitGroupUniqueLabelFragmentDoc}`;
export const AccessPointRoleByUnitGroupFragmentDoc = gql`
    fragment AccessPointRoleByUnitGroupFragment on AccessPointRole {
  accessPointRoleId
  accessPoint {
    ...AccessPointLabelFragment
    property {
      ...PropertyLabelFragment
    }
    type
  }
  role {
    ...RoleUniqueLabelFragment
  }
  hasAccess
  createdAt
}
    ${AccessPointLabelFragmentDoc}
${PropertyLabelFragmentDoc}
${RoleUniqueLabelFragmentDoc}`;
export const AccessPointUniqueLabelFragmentDoc = gql`
    fragment AccessPointUniqueLabelFragment on AccessPoint {
  ...AccessPointLabelFragment
  property {
    ...PropertyLabelFragment
  }
}
    ${AccessPointLabelFragmentDoc}
${PropertyLabelFragmentDoc}`;
export const BeaconLabelFragmentDoc = gql`
    fragment BeaconLabelFragment on Beacon {
  beaconId
  name
  accessPoint {
    ...AccessPointUniqueLabelFragment
  }
}
    ${AccessPointUniqueLabelFragmentDoc}`;
export const BeaconTableFragmentDoc = gql`
    fragment BeaconTableFragment on Beacon {
  ...BeaconLabelFragment
  accessPointId
  uuid
  macAddress
  location
  createdAt
  passwordRotatedAt
}
    ${BeaconLabelFragmentDoc}`;
export const CredentialRequiredRowFragmentDoc = gql`
    fragment CredentialRequiredRowFragment on Credential {
  credentialId
  type
}
    `;
export const CredentialTableFragmentDoc = gql`
    fragment CredentialTableFragment on Credential {
  credentialId
  ownedByProperty {
    ...PropertyLabelFragment
  }
  assignedToUser {
    ...UserLabelFragment
  }
  provisionedByUser {
    ...UserLabelFragment
  }
  ...CredentialRequiredRowFragment
  identifier
  facilityCode
  cardNumber
  createdAt
}
    ${PropertyLabelFragmentDoc}
${UserLabelFragmentDoc}
${CredentialRequiredRowFragmentDoc}`;
export const UserCredentialFragmentDoc = gql`
    fragment UserCredentialFragment on Credential {
  credentialId
  ownedByProperty {
    ...PropertyLabelFragment
  }
  provisionedByUser {
    ...UserLabelFragment
  }
  ...CredentialRequiredRowFragment
  identifier
  facilityCode
  cardNumber
  createdAt
}
    ${PropertyLabelFragmentDoc}
${UserLabelFragmentDoc}
${CredentialRequiredRowFragmentDoc}`;
export const PropertyCredentialFragmentDoc = gql`
    fragment PropertyCredentialFragment on Credential {
  credentialId
  assignedToUser {
    ...UserLabelFragment
  }
  provisionedByUser {
    ...UserLabelFragment
  }
  ...CredentialRequiredRowFragment
  identifier
  facilityCode
  cardNumber
  createdAt
}
    ${UserLabelFragmentDoc}
${CredentialRequiredRowFragmentDoc}`;
export const AccessPointFavoriteFragmentDoc = gql`
    fragment AccessPointFavoriteFragment on Favorite {
  favoriteId
  user {
    ...UserLabelFragment
  }
  position
}
    ${UserLabelFragmentDoc}`;
export const UserFavoriteFragmentDoc = gql`
    fragment UserFavoriteFragment on Favorite {
  favoriteId
  position
  accessPoint {
    ...AccessPointLabelFragment
    property {
      ...PropertyLabelFragment
    }
  }
}
    ${AccessPointLabelFragmentDoc}
${PropertyLabelFragmentDoc}`;
export const HubLabelFragmentDoc = gql`
    fragment HubLabelFragment on Hub {
  hubId
  name
  macAddress
}
    `;
export const HubUniqueLabelFragmentDoc = gql`
    fragment HubUniqueLabelFragment on Hub {
  ...HubLabelFragment
  deviceType
  property {
    ...PropertyLabelFragment
  }
}
    ${HubLabelFragmentDoc}
${PropertyLabelFragmentDoc}`;
export const HubRequiredRowFragmentDoc = gql`
    fragment HubRequiredRowFragment on Hub {
  ...HubUniqueLabelFragment
}
    ${HubUniqueLabelFragmentDoc}`;
export const HubTableFragmentDoc = gql`
    fragment HubTableFragment on Hub {
  hubId
  ...HubRequiredRowFragment
  activationStatus
  host
  port
  macAddress
  ipAddress
  createdAt
  updatedAt
}
    ${HubRequiredRowFragmentDoc}`;
export const HubDetailsFragmentDoc = gql`
    fragment HubDetailsFragment on Hub {
  ...HubTableFragment
  installedAt
  location
  hubVersion
  cliVersion
  firmwareVersion
}
    ${HubTableFragmentDoc}`;
export const ImageThumbnailFragmentDoc = gql`
    fragment ImageThumbnailFragment on Image {
  cloudId
}
    `;
export const OrganizationsMainTableFragmentDoc = gql`
    fragment OrganizationsMainTableFragment on Organization {
  organizationId
  name
  identifier
  properties_aggregate {
    aggregate {
      count
    }
  }
  roles_aggregate {
    aggregate {
      count
    }
  }
  createdAt
}
    `;
export const PinCodeTableFragmentDoc = gql`
    fragment PinCodeTableFragment on PinCode {
  pinCodeId
  property {
    ...PropertyLabelFragment
  }
  assignedToUserId
  userRoleId
  assignedToUser {
    ...UserLabelFragment
    phoneNumber
    email
  }
  private {
    code
  }
  createdByUser {
    ...UserLabelFragment
  }
  createdAt
  updatedAt
  updatedByUser {
    ...UserLabelFragment
  }
}
    ${PropertyLabelFragmentDoc}
${UserLabelFragmentDoc}`;
export const FeatureFlagLabelFragmentDoc = gql`
    fragment FeatureFlagLabelFragment on FeatureFlag {
  featureFlagId
  key
  name
  description
  isLocked
}
    `;
export const PropertyFeatureFlagLabelFragmentDoc = gql`
    fragment PropertyFeatureFlagLabelFragment on PropertyFeatureFlag {
  propertyFeatureFlagId
  featureFlagKey
  featureFlag {
    ...FeatureFlagLabelFragment
  }
}
    ${FeatureFlagLabelFragmentDoc}`;
export const PropertyActionsFragmentDoc = gql`
    fragment PropertyActionsFragment on Property {
  propertyId
  name
  propertyFeatureFlags {
    ...PropertyFeatureFlagLabelFragment
  }
  propertySources_aggregate {
    aggregate {
      count
    }
  }
}
    ${PropertyFeatureFlagLabelFragmentDoc}`;
export const PropertyResidentAuditFragmentDoc = gql`
    fragment PropertyResidentAuditFragment on Property {
  ...PropertyActionsFragment
  propertySources {
    propertySourceId
    sourceId
  }
}
    ${PropertyActionsFragmentDoc}`;
export const PropertyTableFragmentDoc = gql`
    fragment PropertyTableFragment on Property {
  propertyId
  organization {
    ...OrganizationLabelFragment
  }
  name
  image {
    imageId
    cloudId
  }
  timezone
  address
  supportPhoneNumber
  supportEmail
  funnelCommunityId
  createdAt
  updatedAt
  ...PropertyActionsFragment
}
    ${OrganizationLabelFragmentDoc}
${PropertyActionsFragmentDoc}`;
export const OrganizationPropertyTabFragmentDoc = gql`
    fragment OrganizationPropertyTabFragment on Property {
  propertyId
  name
  image {
    imageId
    cloudId
  }
  supportPhoneNumber
  supportEmail
  timezone
  createdAt
  ...PropertyActionsFragment
}
    ${PropertyActionsFragmentDoc}`;
export const PropertyMapTableFragmentDoc = gql`
    fragment PropertyMapTableFragment on PropertyMap {
  propertyMapId
  propertyId
  property {
    ...PropertyLabelFragment
  }
  type
  externalAssetId
  externalMapId
  externalUnits
  externalFloors
  published
}
    ${PropertyLabelFragmentDoc}`;
export const RelayLabelFragmentDoc = gql`
    fragment RelayLabelFragment on Relay {
  relayId
  name
}
    `;
export const RelayUniqueLabelFragmentDoc = gql`
    fragment RelayUniqueLabelFragment on Relay {
  ...RelayLabelFragment
  hub {
    ...HubLabelFragment
    property {
      ...PropertyLabelFragment
    }
  }
}
    ${RelayLabelFragmentDoc}
${HubLabelFragmentDoc}
${PropertyLabelFragmentDoc}`;
export const RelayRequiredRowFragmentDoc = gql`
    fragment RelayRequiredRowFragment on Relay {
  hub {
    property {
      propertyFeatureFlags {
        propertyFeatureFlagId
        featureFlagKey
      }
    }
  }
}
    `;
export const RelayAccessPointsFragmentDoc = gql`
    fragment RelayAccessPointsFragment on AccessPointRelay {
  accessPointRelayId
  accessPoint {
    ...AccessPointLabelFragment
  }
}
    ${AccessPointLabelFragmentDoc}`;
export const RelayActionFragmentDoc = gql`
    fragment RelayActionFragment on Relay {
  ...RelayLabelFragment
  gpioMode
  position
  hub {
    ...HubLabelFragment
  }
}
    ${RelayLabelFragmentDoc}
${HubLabelFragmentDoc}`;
export const RelayTableFragmentDoc = gql`
    fragment RelayTableFragment on Relay {
  ...RelayLabelFragment
  hub {
    ...HubLabelFragment
    property {
      ...PropertyLabelFragment
    }
  }
  position
  accessPointRelays {
    ...RelayAccessPointsFragment
  }
  failurePlan
  unlockOnInternetFailure
  childHub {
    ...HubLabelFragment
  }
  readerType
  inputDevice
  createdAt
  ...RelayActionFragment
}
    ${RelayLabelFragmentDoc}
${HubLabelFragmentDoc}
${PropertyLabelFragmentDoc}
${RelayAccessPointsFragmentDoc}
${RelayActionFragmentDoc}`;
export const RelayFailurePlanFragmentDoc = gql`
    fragment RelayFailurePlanFragment on Relay {
  relayId
  hubId
  position
  name
  gpioMode
  failurePlan
}
    `;
export const AllowedRoleFragmentDoc = gql`
    fragment AllowedRoleFragment on Role {
  roleId
  key
  name
  permissionScope
  organization {
    ...OrganizationLabelFragment
  }
}
    ${OrganizationLabelFragmentDoc}`;
export const AllowedPermissionFragmentDoc = gql`
    fragment AllowedPermissionFragment on Permission {
  permissionId
  key
  scope
  isLocked
}
    `;
export const RolePermissionFragmentDoc = gql`
    fragment RolePermissionFragment on RolePermission {
  rolePermissionId
  permission {
    ...AllowedPermissionFragment
  }
}
    ${AllowedPermissionFragmentDoc}`;
export const RoleRelationshipFragmentDoc = gql`
    fragment RoleRelationshipFragment on RoleRelationship {
  roleRelationshipId
  roleId
  relatedRole {
    ...RoleUniqueLabelFragment
    key
    permissionScope
  }
  canReadUserRole
  canGrantUserRole
  canRevokeUserRole
  createdAt
}
    ${RoleUniqueLabelFragmentDoc}`;
export const RelatableRoleFragmentDoc = gql`
    fragment RelatableRoleFragment on Role {
  ...RoleUniqueLabelFragment
  key
  permissionScope
  rolePermissions_aggregate {
    aggregate {
      count
    }
  }
}
    ${RoleUniqueLabelFragmentDoc}`;
export const RoleRelationshipDetailsFragmentDoc = gql`
    fragment RoleRelationshipDetailsFragment on RoleRelationship {
  ...RoleRelationshipFragment
  relatedRole {
    ...RelatableRoleFragment
  }
}
    ${RoleRelationshipFragmentDoc}
${RelatableRoleFragmentDoc}`;
export const RoleDetailsFragmentDoc = gql`
    fragment RoleDetailsFragment on Role {
  ...AllowedRoleFragment
  uniqueName
  description
  maxAccessDurationSeconds
  isLocked
  deprecatedType
  createdAt
  updatedAt
  rolePermissions {
    ...RolePermissionFragment
  }
  roleRelationshipsByRole {
    ...RoleRelationshipDetailsFragment
  }
}
    ${AllowedRoleFragmentDoc}
${RolePermissionFragmentDoc}
${RoleRelationshipDetailsFragmentDoc}`;
export const GrantableRoleFragmentDoc = gql`
    fragment GrantableRoleFragment on Role {
  roleId
  key
  name
  description
  permissionScope
  maxAccessDurationSeconds
  rolePermissions {
    ...RolePermissionFragment
  }
}
    ${RolePermissionFragmentDoc}`;
export const RoleWithStaffPermissionsFragmentDoc = gql`
    fragment RoleWithStaffPermissionsFragment on Role {
  ...RoleUniqueLabelFragment
  key
  permissionScope
  rolePermissions(
    where: {permission: {key: {_in: [AccessPoint_StaffAccess, AccessPoint_BypassSchedule]}}}
  ) {
    ...RolePermissionFragment
  }
}
    ${RoleUniqueLabelFragmentDoc}
${RolePermissionFragmentDoc}`;
export const RoleLabelFragmentDoc = gql`
    fragment RoleLabelFragment on Role {
  roleId
  name
}
    `;
export const RoleRequiredRowFragmentDoc = gql`
    fragment RoleRequiredRowFragment on Role {
  ...RoleLabelFragment
  key
  organization {
    ...OrganizationLabelFragment
  }
  permissionScope
  isLocked
}
    ${RoleLabelFragmentDoc}
${OrganizationLabelFragmentDoc}`;
export const RoleCommonTableFragmentDoc = gql`
    fragment RoleCommonTableFragment on Role {
  roleId
  key
  name
  permissionScope
  rolePermissions_aggregate {
    aggregate {
      count
    }
  }
  rolePermissions(
    where: {permission: {key: {_in: [User_Read, UserRole_GrantRevokeGlobal, UserRole_GrantRevokeScoped]}}}
  ) {
    ...RolePermissionFragment
  }
  canReadAggregate: roleRelationshipsByRole_aggregate(
    where: {canReadUserRole: {_eq: true}}
  ) {
    aggregate {
      count
    }
  }
  canGrantAggregate: roleRelationshipsByRole_aggregate(
    where: {canGrantUserRole: {_eq: true}}
  ) {
    aggregate {
      count
    }
  }
  canRevokeAggregate: roleRelationshipsByRole_aggregate(
    where: {canRevokeUserRole: {_eq: true}}
  ) {
    aggregate {
      count
    }
  }
  createdAt
  isLocked
  ...RoleRequiredRowFragment
}
    ${RolePermissionFragmentDoc}
${RoleRequiredRowFragmentDoc}`;
export const SessionRequiredRowFragmentDoc = gql`
    fragment SessionRequiredRowFragment on Session {
  sessionId
  revokedAt
  deviceFingerprint
}
    `;
export const SessionTableFragmentDoc = gql`
    fragment SessionTableFragment on Session {
  sessionId
  type
  authMethod
  deviceInfo
  expiresAt
  renewedAt
  revokedByUser {
    ...UserLabelFragment
  }
  createdAt
  user {
    ...UserLabelFragment
  }
  ...SessionRequiredRowFragment
}
    ${UserLabelFragmentDoc}
${SessionRequiredRowFragmentDoc}`;
export const UserSessionFragmentDoc = gql`
    fragment UserSessionFragment on Session {
  sessionId
  type
  authMethod
  deviceInfo
  expiresAt
  renewedAt
  createdAt
  ...SessionRequiredRowFragment
}
    ${SessionRequiredRowFragmentDoc}`;
export const UnitLabelFragmentDoc = gql`
    fragment UnitLabelFragment on Unit {
  unitId
  unitNumber
  building
  sourceId
}
    `;
export const SmartLockLabelFragmentDoc = gql`
    fragment SmartLockLabelFragment on SmartLock {
  smartLockId
  name
}
    `;
export const SmartLockActionFragmentDoc = gql`
    fragment SmartLockActionFragment on SmartLock {
  ...SmartLockLabelFragment
  unitId
  sourceId
}
    ${SmartLockLabelFragmentDoc}`;
export const SmartLockTableFragmentDoc = gql`
    fragment SmartLockTableFragment on SmartLock {
  smartLockId
  unit {
    ...UnitLabelFragment
    property {
      ...PropertyLabelFragment
    }
  }
  name
  sourceId
  serialNumber
  createdByUser {
    ...UserLabelFragment
  }
  createdAt
  ...SmartLockActionFragment
}
    ${UnitLabelFragmentDoc}
${PropertyLabelFragmentDoc}
${UserLabelFragmentDoc}
${SmartLockActionFragmentDoc}`;
export const PropertySmartLockFragmentDoc = gql`
    fragment PropertySmartLockFragment on SmartLock {
  smartLockId
  unit {
    ...UnitLabelFragment
  }
  name
  sourceId
  serialNumber
  createdByUser {
    ...UserLabelFragment
  }
  createdAt
  ...SmartLockActionFragment
}
    ${UnitLabelFragmentDoc}
${UserLabelFragmentDoc}
${SmartLockActionFragmentDoc}`;
export const UnitSmartLockFragmentDoc = gql`
    fragment UnitSmartLockFragment on SmartLock {
  smartLockId
  name
  sourceId
  serialNumber
  createdByUser {
    ...UserLabelFragment
  }
  createdAt
  ...SmartLockActionFragment
}
    ${UserLabelFragmentDoc}
${SmartLockActionFragmentDoc}`;
export const TicketLabelFragmentDoc = gql`
    fragment TicketLabelFragment on Ticket {
  ticketId
}
    `;
export const TicketRequiredRowFragmentDoc = gql`
    fragment TicketRequiredRowFragment on Ticket {
  ticketId
  type
  status
  unit {
    ...UnitLabelFragment
  }
}
    ${UnitLabelFragmentDoc}`;
export const TicketTableFragmentDoc = gql`
    fragment TicketTableFragment on Ticket {
  ticketId
  property {
    ...PropertyLabelFragment
  }
  smartLock {
    ...SmartLockLabelFragment
  }
  createdByUser {
    ...UserLabelFragment
  }
  assignedToUser {
    ...UserLabelFragment
  }
  solvedByUser {
    ...UserLabelFragment
  }
  solvedAt
  createdAt
  ...TicketRequiredRowFragment
}
    ${PropertyLabelFragmentDoc}
${SmartLockLabelFragmentDoc}
${UserLabelFragmentDoc}
${TicketRequiredRowFragmentDoc}`;
export const SmartLockTicketTabFragmentDoc = gql`
    fragment SmartLockTicketTabFragment on Ticket {
  ticketId
  createdByUser {
    ...UserLabelFragment
  }
  assignedToUser {
    ...UserLabelFragment
  }
  solvedByUser {
    ...UserLabelFragment
  }
  createdAt
  ...TicketRequiredRowFragment
}
    ${UserLabelFragmentDoc}
${TicketRequiredRowFragmentDoc}`;
export const UnitWithOccupantCountFragmentDoc = gql`
    fragment UnitWithOccupantCountFragment on Unit {
  ...UnitLabelFragment
  property {
    ...PropertyLabelFragment
  }
  occupantCount
}
    ${UnitLabelFragmentDoc}
${PropertyLabelFragmentDoc}`;
export const UnitTableFragmentDoc = gql`
    fragment UnitTableFragment on Unit {
  unitId
  property {
    ...PropertyLabelFragment
  }
  unitNumber
  building
  type
  unitGroup {
    ...UnitGroupLabelFragment
  }
  sourceId
  smartLocks {
    ...SmartLockLabelFragment
  }
  occupantCount
  createdAt
}
    ${PropertyLabelFragmentDoc}
${UnitGroupLabelFragmentDoc}
${SmartLockLabelFragmentDoc}`;
export const UnitDetailsFragmentDoc = gql`
    fragment UnitDetailsFragment on Unit {
  ...UnitTableFragment
  property {
    propertyFeatureFlags {
      featureFlagKey
    }
  }
  createdByUser {
    ...UserLabelFragment
  }
  updatedAt
  virtualDirectoryEnabled
}
    ${UnitTableFragmentDoc}
${UserLabelFragmentDoc}`;
export const UnitGroupRowFragmentDoc = gql`
    fragment UnitGroupRowFragment on UnitGroup {
  ...UnitGroupLabelFragment
  propertyId
  sourceId
}
    ${UnitGroupLabelFragmentDoc}`;
export const UnitGroupTableFragmentDoc = gql`
    fragment UnitGroupTableFragment on UnitGroup {
  ...UnitGroupLabelFragment
  propertyId
  propertyName
  parentUnitGroup {
    ...UnitGroupLabelFragment
  }
  sourceId
  createdAt
}
    ${UnitGroupLabelFragmentDoc}`;
export const AuthenticatedUserFragmentDoc = gql`
    fragment AuthenticatedUserFragment on User {
  userId
  accountStatus
  firstName
  lastName
  phoneNumber
  email
  acceptedEulaAt
}
    `;
export const UserRowFragmentDoc = gql`
    fragment UserRowFragment on User {
  userId
  accountStatus
  firstName
  lastName
  phoneNumber
  email
  augustUserId
  augustSubUserId
  hasAugustPassword
  password {
    passwordId
    createdAt
    updatedAt
  }
  createdAt
}
    `;
export const UsersMainTableFragmentDoc = gql`
    fragment UsersMainTableFragment on User {
  ...UserRowFragment
  assignedUserRoles(where: {status: {_eq: ACTIVE}}, distinct_on: roleId) {
    userRoleId
    role {
      ...RoleLabelFragment
    }
  }
}
    ${UserRowFragmentDoc}
${RoleLabelFragmentDoc}`;
export const UserActionFragmentDoc = gql`
    fragment UserActionFragment on User {
  ...UserLabelFragment
  accountStatus
}
    ${UserLabelFragmentDoc}`;
export const UserDetailsFragmentDoc = gql`
    fragment UserDetailsFragment on User {
  ...UserRowFragment
  updatedAt
  ...UserActionFragment
}
    ${UserRowFragmentDoc}
${UserActionFragmentDoc}`;
export const UserDetailsWithGlobalRolesFragmentDoc = gql`
    fragment UserDetailsWithGlobalRolesFragment on User {
  ...UserDetailsFragment
  globalUserRoles: assignedUserRoles(
    where: {status: {_eq: ACTIVE}, role: {permissionScope: {_eq: GLOBAL}}}
  ) {
    userRoleId
    role {
      ...RoleLabelFragment
    }
  }
}
    ${UserDetailsFragmentDoc}
${RoleLabelFragmentDoc}`;
export const UnitUniqueLabelFragmentDoc = gql`
    fragment UnitUniqueLabelFragment on Unit {
  ...UnitLabelFragment
  property {
    ...PropertyLabelFragment
  }
}
    ${UnitLabelFragmentDoc}
${PropertyLabelFragmentDoc}`;
export const SmartLockUniqueLabelFragmentDoc = gql`
    fragment SmartLockUniqueLabelFragment on SmartLock {
  ...SmartLockLabelFragment
  unit {
    ...UnitLabelFragment
    property {
      ...PropertyLabelFragment
    }
  }
}
    ${SmartLockLabelFragmentDoc}
${UnitLabelFragmentDoc}
${PropertyLabelFragmentDoc}`;
export const UserUniqueLabelFragmentDoc = gql`
    fragment UserUniqueLabelFragment on User {
  ...UserLabelFragment
  phoneNumber
  email
}
    ${UserLabelFragmentDoc}`;
export const UserRoleAssignedToFragmentDoc = gql`
    fragment UserRoleAssignedToFragment on UserRole {
  userRoleId
  role {
    key
  }
  assignedToUser {
    ...UserUniqueLabelFragment
  }
  nickname
  sourceId
}
    ${UserUniqueLabelFragmentDoc}`;
export const UserRoleUniqueLabelFragmentDoc = gql`
    fragment UserRoleUniqueLabelFragment on UserRole {
  userRoleId
  scopedOrganization {
    ...OrganizationLabelFragment
  }
  scopedProperty {
    ...PropertyLabelFragment
  }
  scopedUnit {
    ...UnitUniqueLabelFragment
  }
  scopedAccessPoint {
    ...AccessPointUniqueLabelFragment
  }
  scopedSmartLock {
    ...SmartLockUniqueLabelFragment
  }
  role {
    ...RoleLabelFragment
  }
  ...UserRoleAssignedToFragment
  status
}
    ${OrganizationLabelFragmentDoc}
${PropertyLabelFragmentDoc}
${UnitUniqueLabelFragmentDoc}
${AccessPointUniqueLabelFragmentDoc}
${SmartLockUniqueLabelFragmentDoc}
${RoleLabelFragmentDoc}
${UserRoleAssignedToFragmentDoc}`;
export const UserRoleActionFragmentDoc = gql`
    fragment UserRoleActionFragment on UserRole {
  userRoleId
  role {
    roleId
    key
    permissionScope
  }
  status
  assignedToUser {
    ...UserLabelFragment
  }
  expiresAt
  schedule
  sourceId
}
    ${UserLabelFragmentDoc}`;
export const UserRoleExpandedFragmentDoc = gql`
    fragment UserRoleExpandedFragment on UserRole {
  schedule
  sourceId
  grantMethod
  reason
  notes
  revokedAt
  revokedByUser {
    ...UserLabelFragment
  }
}
    ${UserLabelFragmentDoc}`;
export const UserRolesCommonTableFragmentDoc = gql`
    fragment UserRolesCommonTableFragment on UserRole {
  userRoleId
  role {
    ...RoleLabelFragment
    key
  }
  assignedToUser {
    ...UserLabelFragment
  }
  createdByUser {
    ...UserLabelFragment
  }
  activatesAt
  expiresAt
  createdAt
  ...UserRoleActionFragment
  ...UserRoleExpandedFragment
}
    ${RoleLabelFragmentDoc}
${UserLabelFragmentDoc}
${UserRoleActionFragmentDoc}
${UserRoleExpandedFragmentDoc}`;
export const GlobalUserRolesTableFragmentDoc = gql`
    fragment GlobalUserRolesTableFragment on UserRole {
  ...UserRolesCommonTableFragment
}
    ${UserRolesCommonTableFragmentDoc}`;
export const OrganizationUserRolesTableFragmentDoc = gql`
    fragment OrganizationUserRolesTableFragment on UserRole {
  ...UserRolesCommonTableFragment
  scopedOrganization {
    ...OrganizationLabelFragment
  }
}
    ${UserRolesCommonTableFragmentDoc}
${OrganizationLabelFragmentDoc}`;
export const PropertyUserRolesTableFragmentDoc = gql`
    fragment PropertyUserRolesTableFragment on UserRole {
  ...UserRolesCommonTableFragment
  scopedProperty {
    ...PropertyLabelFragment
  }
  ...UserRoleAssignedToFragment
}
    ${UserRolesCommonTableFragmentDoc}
${PropertyLabelFragmentDoc}
${UserRoleAssignedToFragmentDoc}`;
export const UnitUserRolesTableFragmentDoc = gql`
    fragment UnitUserRolesTableFragment on UserRole {
  ...UserRolesCommonTableFragment
  managedWithinProperty {
    ...PropertyLabelFragment
  }
  scopedUnit {
    ...UnitLabelFragment
  }
  ...UserRoleAssignedToFragment
}
    ${UserRolesCommonTableFragmentDoc}
${PropertyLabelFragmentDoc}
${UnitLabelFragmentDoc}
${UserRoleAssignedToFragmentDoc}`;
export const AccessPointUserRolesTableFragmentDoc = gql`
    fragment AccessPointUserRolesTableFragment on UserRole {
  ...UserRolesCommonTableFragment
  managedWithinProperty {
    ...PropertyLabelFragment
  }
  scopedAccessPoint {
    ...AccessPointLabelFragment
  }
}
    ${UserRolesCommonTableFragmentDoc}
${PropertyLabelFragmentDoc}
${AccessPointLabelFragmentDoc}`;
export const UserRoleSmartLockFragmentDoc = gql`
    fragment UserRoleSmartLockFragment on UserRole {
  scopedSmartLock {
    unit {
      ...UnitLabelFragment
    }
    ...SmartLockLabelFragment
  }
}
    ${UnitLabelFragmentDoc}
${SmartLockLabelFragmentDoc}`;
export const SmartLockUserRolesTableFragmentDoc = gql`
    fragment SmartLockUserRolesTableFragment on UserRole {
  ...UserRolesCommonTableFragment
  managedWithinProperty {
    ...PropertyLabelFragment
  }
  ...UserRoleSmartLockFragment
  ...UserRoleAssignedToFragment
}
    ${UserRolesCommonTableFragmentDoc}
${PropertyLabelFragmentDoc}
${UserRoleSmartLockFragmentDoc}
${UserRoleAssignedToFragmentDoc}`;
export const AugustPinCodeUserRoleFragmentDoc = gql`
    fragment AugustPinCodeUserRoleFragment on UserRole {
  userRoleId
  status
  role {
    key
  }
  scopedSmartLock {
    ...SmartLockUniqueLabelFragment
    sourceId
    openLockResetTickets: tickets_aggregate(
      where: {status: {_in: [PENDING, UNSOLVED]}, type: {_eq: TURNOVER_LOCK_RESET}}
    ) {
      aggregate {
        count
      }
    }
  }
  createdByUser {
    ...UserLabelFragment
  }
  ...UserRoleActionFragment
  expiresAt
  revokedAt
  createdAt
}
    ${SmartLockUniqueLabelFragmentDoc}
${UserLabelFragmentDoc}
${UserRoleActionFragmentDoc}`;
export const UserRoleDetailsFragmentDoc = gql`
    fragment UserRoleDetailsFragment on UserRole {
  ...UserRolesCommonTableFragment
  ...OrganizationUserRolesTableFragment
  ...PropertyUserRolesTableFragment
  ...UnitUserRolesTableFragment
  ...AccessPointUserRolesTableFragment
  ...SmartLockUserRolesTableFragment
  ...AugustPinCodeUserRoleFragment
  parentUserRoleId
  role {
    permissionScope
  }
  childUserRoles(limit: 25) {
    ...AugustPinCodeUserRoleFragment
  }
  pinCodes {
    pinCodeId
  }
  managedWithinProperty {
    timezone
    propertyFeatureFlags {
      propertyFeatureFlagId
      featureFlagKey
    }
  }
  sourcePayload
}
    ${UserRolesCommonTableFragmentDoc}
${OrganizationUserRolesTableFragmentDoc}
${PropertyUserRolesTableFragmentDoc}
${UnitUserRolesTableFragmentDoc}
${AccessPointUserRolesTableFragmentDoc}
${SmartLockUserRolesTableFragmentDoc}
${AugustPinCodeUserRoleFragmentDoc}`;
export const UnitUserRoleAuditTableFragmentDoc = gql`
    fragment UnitUserRoleAuditTableFragment on UserRole {
  userRoleId
  role {
    ...RoleLabelFragment
    key
  }
  ...UserRoleAssignedToFragment
  assignedToUser {
    userId
    accountStatus
    phoneNumber
    email
  }
  activatesAt
  expiresAt
  ...UserRoleActionFragment
  ...UserRoleExpandedFragment
}
    ${RoleLabelFragmentDoc}
${UserRoleAssignedToFragmentDoc}
${UserRoleActionFragmentDoc}
${UserRoleExpandedFragmentDoc}`;
export const AugustAccessUserRoleFragmentDoc = gql`
    fragment AugustAccessUserRoleFragment on UserRole {
  userRoleId
  parentUserRole {
    userRoleId
  }
  role {
    ...RoleLabelFragment
    key
  }
  ...UserRoleAssignedToFragment
  assignedToUser {
    ...UserRowFragment
  }
  activatesAt
  expiresAt
  reason
}
    ${RoleLabelFragmentDoc}
${UserRoleAssignedToFragmentDoc}
${UserRowFragmentDoc}`;
export const Custom_AugustLockUserRoleFragmentDoc = gql`
    fragment Custom_AugustLockUserRoleFragment on Custom_AugustLockUserRole {
  role {
    ...RoleLabelFragment
    key
  }
  userRoleId
  userRole {
    ...AugustAccessUserRoleFragment
  }
  augustUserId
  augustUserType
  permissions
}
    ${RoleLabelFragmentDoc}
${AugustAccessUserRoleFragmentDoc}`;
export const introspectionDocument = gql`
    query introspection {
  __schema {
    types {
      kind
      name
      fields(includeDeprecated: true) {
        ...FieldFragment
      }
      inputFields {
        name
      }
    }
  }
}
    ${FieldFragmentDoc}`;
export function useintrospectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<introspectionQuery, introspectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<introspectionQuery, introspectionQueryVariables>(introspectionDocument, options);
      }
export function useintrospectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<introspectionQuery, introspectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<introspectionQuery, introspectionQueryVariables>(introspectionDocument, options);
        }
export function useintrospectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<introspectionQuery, introspectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<introspectionQuery, introspectionQueryVariables>(introspectionDocument, options);
        }
export type introspectionQueryHookResult = ReturnType<typeof useintrospectionQuery>;
export type introspectionLazyQueryHookResult = ReturnType<typeof useintrospectionLazyQuery>;
export type introspectionSuspenseQueryHookResult = ReturnType<typeof useintrospectionSuspenseQuery>;
export type introspectionQueryResult = ApolloReactCommon.QueryResult<introspectionQuery, introspectionQueryVariables>;
export const getAccessPointDetailsDocument = gql`
    query getAccessPointDetails($accessPointId: uuid!) {
  accessPoint: AccessPoint_by_pk(accessPointId: $accessPointId) {
    ...AccessPointDetailsFragment
  }
}
    ${AccessPointDetailsFragmentDoc}`;
export function usegetAccessPointDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getAccessPointDetailsQuery, getAccessPointDetailsQueryVariables> & ({ variables: getAccessPointDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getAccessPointDetailsQuery, getAccessPointDetailsQueryVariables>(getAccessPointDetailsDocument, options);
      }
export function usegetAccessPointDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getAccessPointDetailsQuery, getAccessPointDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getAccessPointDetailsQuery, getAccessPointDetailsQueryVariables>(getAccessPointDetailsDocument, options);
        }
export function usegetAccessPointDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getAccessPointDetailsQuery, getAccessPointDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getAccessPointDetailsQuery, getAccessPointDetailsQueryVariables>(getAccessPointDetailsDocument, options);
        }
export type getAccessPointDetailsQueryHookResult = ReturnType<typeof usegetAccessPointDetailsQuery>;
export type getAccessPointDetailsLazyQueryHookResult = ReturnType<typeof usegetAccessPointDetailsLazyQuery>;
export type getAccessPointDetailsSuspenseQueryHookResult = ReturnType<typeof usegetAccessPointDetailsSuspenseQuery>;
export type getAccessPointDetailsQueryResult = ApolloReactCommon.QueryResult<getAccessPointDetailsQuery, getAccessPointDetailsQueryVariables>;
export const getAccessPointsWithRelaysDocument = gql`
    query getAccessPointsWithRelays($where: AccessPoint_bool_exp!) {
  accessPoints: AccessPoint(where: $where) {
    ...AccessPointLabelFragment
    accessPointRelays {
      accessPointRelayId
      relay {
        ...RelayLabelFragment
      }
    }
  }
}
    ${AccessPointLabelFragmentDoc}
${RelayLabelFragmentDoc}`;
export function usegetAccessPointsWithRelaysQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getAccessPointsWithRelaysQuery, getAccessPointsWithRelaysQueryVariables> & ({ variables: getAccessPointsWithRelaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getAccessPointsWithRelaysQuery, getAccessPointsWithRelaysQueryVariables>(getAccessPointsWithRelaysDocument, options);
      }
export function usegetAccessPointsWithRelaysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getAccessPointsWithRelaysQuery, getAccessPointsWithRelaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getAccessPointsWithRelaysQuery, getAccessPointsWithRelaysQueryVariables>(getAccessPointsWithRelaysDocument, options);
        }
export function usegetAccessPointsWithRelaysSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getAccessPointsWithRelaysQuery, getAccessPointsWithRelaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getAccessPointsWithRelaysQuery, getAccessPointsWithRelaysQueryVariables>(getAccessPointsWithRelaysDocument, options);
        }
export type getAccessPointsWithRelaysQueryHookResult = ReturnType<typeof usegetAccessPointsWithRelaysQuery>;
export type getAccessPointsWithRelaysLazyQueryHookResult = ReturnType<typeof usegetAccessPointsWithRelaysLazyQuery>;
export type getAccessPointsWithRelaysSuspenseQueryHookResult = ReturnType<typeof usegetAccessPointsWithRelaysSuspenseQuery>;
export type getAccessPointsWithRelaysQueryResult = ApolloReactCommon.QueryResult<getAccessPointsWithRelaysQuery, getAccessPointsWithRelaysQueryVariables>;
export const getAccessPointsWithMapLocationDocument = gql`
    query getAccessPointsWithMapLocation($where: AccessPoint_bool_exp!) {
  accessPoints: AccessPoint(where: $where) {
    ...AccessPointWithMapLocationFragment
  }
}
    ${AccessPointWithMapLocationFragmentDoc}`;
export function usegetAccessPointsWithMapLocationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getAccessPointsWithMapLocationQuery, getAccessPointsWithMapLocationQueryVariables> & ({ variables: getAccessPointsWithMapLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getAccessPointsWithMapLocationQuery, getAccessPointsWithMapLocationQueryVariables>(getAccessPointsWithMapLocationDocument, options);
      }
export function usegetAccessPointsWithMapLocationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getAccessPointsWithMapLocationQuery, getAccessPointsWithMapLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getAccessPointsWithMapLocationQuery, getAccessPointsWithMapLocationQueryVariables>(getAccessPointsWithMapLocationDocument, options);
        }
export function usegetAccessPointsWithMapLocationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getAccessPointsWithMapLocationQuery, getAccessPointsWithMapLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getAccessPointsWithMapLocationQuery, getAccessPointsWithMapLocationQueryVariables>(getAccessPointsWithMapLocationDocument, options);
        }
export type getAccessPointsWithMapLocationQueryHookResult = ReturnType<typeof usegetAccessPointsWithMapLocationQuery>;
export type getAccessPointsWithMapLocationLazyQueryHookResult = ReturnType<typeof usegetAccessPointsWithMapLocationLazyQuery>;
export type getAccessPointsWithMapLocationSuspenseQueryHookResult = ReturnType<typeof usegetAccessPointsWithMapLocationSuspenseQuery>;
export type getAccessPointsWithMapLocationQueryResult = ApolloReactCommon.QueryResult<getAccessPointsWithMapLocationQuery, getAccessPointsWithMapLocationQueryVariables>;
export const getGrantableAccessPointsDocument = gql`
    query getGrantableAccessPoints($where: AccessPoint_bool_exp!) {
  accessPoints: AccessPoint(where: $where) {
    ...AccessPointLabelFragment
    type
    property {
      timezone
    }
  }
}
    ${AccessPointLabelFragmentDoc}`;
export function usegetGrantableAccessPointsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getGrantableAccessPointsQuery, getGrantableAccessPointsQueryVariables> & ({ variables: getGrantableAccessPointsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getGrantableAccessPointsQuery, getGrantableAccessPointsQueryVariables>(getGrantableAccessPointsDocument, options);
      }
export function usegetGrantableAccessPointsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getGrantableAccessPointsQuery, getGrantableAccessPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getGrantableAccessPointsQuery, getGrantableAccessPointsQueryVariables>(getGrantableAccessPointsDocument, options);
        }
export function usegetGrantableAccessPointsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getGrantableAccessPointsQuery, getGrantableAccessPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getGrantableAccessPointsQuery, getGrantableAccessPointsQueryVariables>(getGrantableAccessPointsDocument, options);
        }
export type getGrantableAccessPointsQueryHookResult = ReturnType<typeof usegetGrantableAccessPointsQuery>;
export type getGrantableAccessPointsLazyQueryHookResult = ReturnType<typeof usegetGrantableAccessPointsLazyQuery>;
export type getGrantableAccessPointsSuspenseQueryHookResult = ReturnType<typeof usegetGrantableAccessPointsSuspenseQuery>;
export type getGrantableAccessPointsQueryResult = ApolloReactCommon.QueryResult<getGrantableAccessPointsQuery, getGrantableAccessPointsQueryVariables>;
export const upsertAccessPointsDocument = gql`
    mutation upsertAccessPoints($objects: [AccessPoint_insert_input!]!) {
  upsertAccessPoints: insert_AccessPoint(
    objects: $objects
    on_conflict: {constraint: AccessPoint_propertyId_name_key, update_columns: []}
  ) {
    returning {
      ...AccessPointLabelFragment
    }
  }
}
    ${AccessPointLabelFragmentDoc}`;
export type upsertAccessPointsMutationFn = ApolloReactCommon.MutationFunction<upsertAccessPointsMutation, upsertAccessPointsMutationVariables>;
export function useupsertAccessPointsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<upsertAccessPointsMutation, upsertAccessPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<upsertAccessPointsMutation, upsertAccessPointsMutationVariables>(upsertAccessPointsDocument, options);
      }
export type upsertAccessPointsMutationHookResult = ReturnType<typeof useupsertAccessPointsMutation>;
export type upsertAccessPointsMutationResult = ApolloReactCommon.MutationResult<upsertAccessPointsMutation>;
export type upsertAccessPointsMutationOptions = ApolloReactCommon.BaseMutationOptions<upsertAccessPointsMutation, upsertAccessPointsMutationVariables>;
export const updateAccessPointMapLocationDocument = gql`
    mutation updateAccessPointMapLocation($accessPointId: uuid!, $mapLocation: Custom_AccessPointMapLocationInput) {
  custom_updateAccessPointMapLocation(
    accessPointId: $accessPointId
    mapLocation: $mapLocation
  ) {
    accessPoint {
      ...AccessPointLabelFragment
      ...AccessPointWithMapLocationFragment
    }
  }
}
    ${AccessPointLabelFragmentDoc}
${AccessPointWithMapLocationFragmentDoc}`;
export type updateAccessPointMapLocationMutationFn = ApolloReactCommon.MutationFunction<updateAccessPointMapLocationMutation, updateAccessPointMapLocationMutationVariables>;
export function useupdateAccessPointMapLocationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<updateAccessPointMapLocationMutation, updateAccessPointMapLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<updateAccessPointMapLocationMutation, updateAccessPointMapLocationMutationVariables>(updateAccessPointMapLocationDocument, options);
      }
export type updateAccessPointMapLocationMutationHookResult = ReturnType<typeof useupdateAccessPointMapLocationMutation>;
export type updateAccessPointMapLocationMutationResult = ApolloReactCommon.MutationResult<updateAccessPointMapLocationMutation>;
export type updateAccessPointMapLocationMutationOptions = ApolloReactCommon.BaseMutationOptions<updateAccessPointMapLocationMutation, updateAccessPointMapLocationMutationVariables>;
export const toggleAccessPointArchivedDocument = gql`
    mutation toggleAccessPointArchived($accessPointId: uuid!, $archived: Boolean!) {
  custom_toggleAccessPointArchived(
    accessPointId: $accessPointId
    archived: $archived
  ) {
    accessPoint {
      ...AccessPointRowFragment
      ...AccessPointActionsFragment
    }
  }
}
    ${AccessPointRowFragmentDoc}
${AccessPointActionsFragmentDoc}`;
export type toggleAccessPointArchivedMutationFn = ApolloReactCommon.MutationFunction<toggleAccessPointArchivedMutation, toggleAccessPointArchivedMutationVariables>;
export function usetoggleAccessPointArchivedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<toggleAccessPointArchivedMutation, toggleAccessPointArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<toggleAccessPointArchivedMutation, toggleAccessPointArchivedMutationVariables>(toggleAccessPointArchivedDocument, options);
      }
export type toggleAccessPointArchivedMutationHookResult = ReturnType<typeof usetoggleAccessPointArchivedMutation>;
export type toggleAccessPointArchivedMutationResult = ApolloReactCommon.MutationResult<toggleAccessPointArchivedMutation>;
export type toggleAccessPointArchivedMutationOptions = ApolloReactCommon.BaseMutationOptions<toggleAccessPointArchivedMutation, toggleAccessPointArchivedMutationVariables>;
export const unlockAccessPointDocument = gql`
    mutation unlockAccessPoint($accessPointId: String!) {
  custom_unlockAccessPoint(
    input: {accessPointId: $accessPointId, unlockMethod: "ADMIN_PANEL"}
  ) {
    accessPointId
    result
  }
}
    `;
export type unlockAccessPointMutationFn = ApolloReactCommon.MutationFunction<unlockAccessPointMutation, unlockAccessPointMutationVariables>;
export function useunlockAccessPointMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<unlockAccessPointMutation, unlockAccessPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<unlockAccessPointMutation, unlockAccessPointMutationVariables>(unlockAccessPointDocument, options);
      }
export type unlockAccessPointMutationHookResult = ReturnType<typeof useunlockAccessPointMutation>;
export type unlockAccessPointMutationResult = ApolloReactCommon.MutationResult<unlockAccessPointMutation>;
export type unlockAccessPointMutationOptions = ApolloReactCommon.BaseMutationOptions<unlockAccessPointMutation, unlockAccessPointMutationVariables>;
export const getAccessPointRolesDocument = gql`
    query getAccessPointRoles($accessPointId: uuid!, $roleExp: Role_bool_exp!) {
  accessPointRoles: AccessPointRole(where: {accessPointId: {_eq: $accessPointId}}) {
    ...AccessPointRoleTableFragment
  }
  roles: Role(where: $roleExp) {
    ...RoleWithStaffPermissionsFragment
  }
}
    ${AccessPointRoleTableFragmentDoc}
${RoleWithStaffPermissionsFragmentDoc}`;
export function usegetAccessPointRolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getAccessPointRolesQuery, getAccessPointRolesQueryVariables> & ({ variables: getAccessPointRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getAccessPointRolesQuery, getAccessPointRolesQueryVariables>(getAccessPointRolesDocument, options);
      }
export function usegetAccessPointRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getAccessPointRolesQuery, getAccessPointRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getAccessPointRolesQuery, getAccessPointRolesQueryVariables>(getAccessPointRolesDocument, options);
        }
export function usegetAccessPointRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getAccessPointRolesQuery, getAccessPointRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getAccessPointRolesQuery, getAccessPointRolesQueryVariables>(getAccessPointRolesDocument, options);
        }
export type getAccessPointRolesQueryHookResult = ReturnType<typeof usegetAccessPointRolesQuery>;
export type getAccessPointRolesLazyQueryHookResult = ReturnType<typeof usegetAccessPointRolesLazyQuery>;
export type getAccessPointRolesSuspenseQueryHookResult = ReturnType<typeof usegetAccessPointRolesSuspenseQuery>;
export type getAccessPointRolesQueryResult = ApolloReactCommon.QueryResult<getAccessPointRolesQuery, getAccessPointRolesQueryVariables>;
export const getFeatureFlagsDocument = gql`
    query getFeatureFlags {
  featureFlags: FeatureFlag(order_by: {name: asc}) {
    ...FeatureFlagLabelFragment
  }
}
    ${FeatureFlagLabelFragmentDoc}`;
export function usegetFeatureFlagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<getFeatureFlagsQuery, getFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getFeatureFlagsQuery, getFeatureFlagsQueryVariables>(getFeatureFlagsDocument, options);
      }
export function usegetFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getFeatureFlagsQuery, getFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getFeatureFlagsQuery, getFeatureFlagsQueryVariables>(getFeatureFlagsDocument, options);
        }
export function usegetFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getFeatureFlagsQuery, getFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getFeatureFlagsQuery, getFeatureFlagsQueryVariables>(getFeatureFlagsDocument, options);
        }
export type getFeatureFlagsQueryHookResult = ReturnType<typeof usegetFeatureFlagsQuery>;
export type getFeatureFlagsLazyQueryHookResult = ReturnType<typeof usegetFeatureFlagsLazyQuery>;
export type getFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof usegetFeatureFlagsSuspenseQuery>;
export type getFeatureFlagsQueryResult = ApolloReactCommon.QueryResult<getFeatureFlagsQuery, getFeatureFlagsQueryVariables>;
export const getHubDetailsDocument = gql`
    query getHubDetails($hubId: uuid!) {
  hub: Hub_by_pk(hubId: $hubId) {
    ...HubDetailsFragment
  }
}
    ${HubDetailsFragmentDoc}`;
export function usegetHubDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getHubDetailsQuery, getHubDetailsQueryVariables> & ({ variables: getHubDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getHubDetailsQuery, getHubDetailsQueryVariables>(getHubDetailsDocument, options);
      }
export function usegetHubDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getHubDetailsQuery, getHubDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getHubDetailsQuery, getHubDetailsQueryVariables>(getHubDetailsDocument, options);
        }
export function usegetHubDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getHubDetailsQuery, getHubDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getHubDetailsQuery, getHubDetailsQueryVariables>(getHubDetailsDocument, options);
        }
export type getHubDetailsQueryHookResult = ReturnType<typeof usegetHubDetailsQuery>;
export type getHubDetailsLazyQueryHookResult = ReturnType<typeof usegetHubDetailsLazyQuery>;
export type getHubDetailsSuspenseQueryHookResult = ReturnType<typeof usegetHubDetailsSuspenseQuery>;
export type getHubDetailsQueryResult = ApolloReactCommon.QueryResult<getHubDetailsQuery, getHubDetailsQueryVariables>;
export const unlockHubRelaysDocument = gql`
    mutation unlockHubRelays($input: Custom_UnlockHubRelaysInput!) {
  custom_unlockHubRelays(input: $input) {
    response {
      hubId
    }
  }
}
    `;
export type unlockHubRelaysMutationFn = ApolloReactCommon.MutationFunction<unlockHubRelaysMutation, unlockHubRelaysMutationVariables>;
export function useunlockHubRelaysMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<unlockHubRelaysMutation, unlockHubRelaysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<unlockHubRelaysMutation, unlockHubRelaysMutationVariables>(unlockHubRelaysDocument, options);
      }
export type unlockHubRelaysMutationHookResult = ReturnType<typeof useunlockHubRelaysMutation>;
export type unlockHubRelaysMutationResult = ApolloReactCommon.MutationResult<unlockHubRelaysMutation>;
export type unlockHubRelaysMutationOptions = ApolloReactCommon.BaseMutationOptions<unlockHubRelaysMutation, unlockHubRelaysMutationVariables>;
export const getHubHealthReportsDocument = gql`
    query getHubHealthReports($input: Custom_GetHubHealthReportsInput!) {
  custom_getHubHealthReports(input: $input) {
    hubId
    hub {
      ...HubUniqueLabelFragment
      ipAddress
      macAddress
    }
    healthReports
  }
}
    ${HubUniqueLabelFragmentDoc}`;
export function usegetHubHealthReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getHubHealthReportsQuery, getHubHealthReportsQueryVariables> & ({ variables: getHubHealthReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getHubHealthReportsQuery, getHubHealthReportsQueryVariables>(getHubHealthReportsDocument, options);
      }
export function usegetHubHealthReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getHubHealthReportsQuery, getHubHealthReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getHubHealthReportsQuery, getHubHealthReportsQueryVariables>(getHubHealthReportsDocument, options);
        }
export function usegetHubHealthReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getHubHealthReportsQuery, getHubHealthReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getHubHealthReportsQuery, getHubHealthReportsQueryVariables>(getHubHealthReportsDocument, options);
        }
export type getHubHealthReportsQueryHookResult = ReturnType<typeof usegetHubHealthReportsQuery>;
export type getHubHealthReportsLazyQueryHookResult = ReturnType<typeof usegetHubHealthReportsLazyQuery>;
export type getHubHealthReportsSuspenseQueryHookResult = ReturnType<typeof usegetHubHealthReportsSuspenseQuery>;
export type getHubHealthReportsQueryResult = ApolloReactCommon.QueryResult<getHubHealthReportsQuery, getHubHealthReportsQueryVariables>;
export const getOrganizationsDocument = gql`
    query getOrganizations($where: Organization_bool_exp!) {
  organizations: Organization(where: $where) {
    ...OrganizationLabelFragment
  }
}
    ${OrganizationLabelFragmentDoc}`;
export function usegetOrganizationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getOrganizationsQuery, getOrganizationsQueryVariables> & ({ variables: getOrganizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getOrganizationsQuery, getOrganizationsQueryVariables>(getOrganizationsDocument, options);
      }
export function usegetOrganizationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getOrganizationsQuery, getOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getOrganizationsQuery, getOrganizationsQueryVariables>(getOrganizationsDocument, options);
        }
export function usegetOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getOrganizationsQuery, getOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getOrganizationsQuery, getOrganizationsQueryVariables>(getOrganizationsDocument, options);
        }
export type getOrganizationsQueryHookResult = ReturnType<typeof usegetOrganizationsQuery>;
export type getOrganizationsLazyQueryHookResult = ReturnType<typeof usegetOrganizationsLazyQuery>;
export type getOrganizationsSuspenseQueryHookResult = ReturnType<typeof usegetOrganizationsSuspenseQuery>;
export type getOrganizationsQueryResult = ApolloReactCommon.QueryResult<getOrganizationsQuery, getOrganizationsQueryVariables>;
export const getPermissionsDocument = gql`
    query getPermissions($where: Permission_bool_exp!) {
  permissions: Permission(where: $where) {
    ...AllowedPermissionFragment
  }
}
    ${AllowedPermissionFragmentDoc}`;
export function usegetPermissionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getPermissionsQuery, getPermissionsQueryVariables> & ({ variables: getPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getPermissionsQuery, getPermissionsQueryVariables>(getPermissionsDocument, options);
      }
export function usegetPermissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getPermissionsQuery, getPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getPermissionsQuery, getPermissionsQueryVariables>(getPermissionsDocument, options);
        }
export function usegetPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getPermissionsQuery, getPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getPermissionsQuery, getPermissionsQueryVariables>(getPermissionsDocument, options);
        }
export type getPermissionsQueryHookResult = ReturnType<typeof usegetPermissionsQuery>;
export type getPermissionsLazyQueryHookResult = ReturnType<typeof usegetPermissionsLazyQuery>;
export type getPermissionsSuspenseQueryHookResult = ReturnType<typeof usegetPermissionsSuspenseQuery>;
export type getPermissionsQueryResult = ApolloReactCommon.QueryResult<getPermissionsQuery, getPermissionsQueryVariables>;
export const getAllowedAndEnabledPermissionsDocument = gql`
    query getAllowedAndEnabledPermissions($permissionScope: PermissionScope_enum!, $roleId: uuid!) {
  allowedPermissions: Permission(where: {scope: {_eq: $permissionScope}}) {
    ...AllowedPermissionFragment
  }
  enabledPermissions: Permission(
    where: {rolePermissions: {roleId: {_eq: $roleId}}}
  ) {
    ...AllowedPermissionFragment
  }
}
    ${AllowedPermissionFragmentDoc}`;
export function usegetAllowedAndEnabledPermissionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getAllowedAndEnabledPermissionsQuery, getAllowedAndEnabledPermissionsQueryVariables> & ({ variables: getAllowedAndEnabledPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getAllowedAndEnabledPermissionsQuery, getAllowedAndEnabledPermissionsQueryVariables>(getAllowedAndEnabledPermissionsDocument, options);
      }
export function usegetAllowedAndEnabledPermissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getAllowedAndEnabledPermissionsQuery, getAllowedAndEnabledPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getAllowedAndEnabledPermissionsQuery, getAllowedAndEnabledPermissionsQueryVariables>(getAllowedAndEnabledPermissionsDocument, options);
        }
export function usegetAllowedAndEnabledPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getAllowedAndEnabledPermissionsQuery, getAllowedAndEnabledPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getAllowedAndEnabledPermissionsQuery, getAllowedAndEnabledPermissionsQueryVariables>(getAllowedAndEnabledPermissionsDocument, options);
        }
export type getAllowedAndEnabledPermissionsQueryHookResult = ReturnType<typeof usegetAllowedAndEnabledPermissionsQuery>;
export type getAllowedAndEnabledPermissionsLazyQueryHookResult = ReturnType<typeof usegetAllowedAndEnabledPermissionsLazyQuery>;
export type getAllowedAndEnabledPermissionsSuspenseQueryHookResult = ReturnType<typeof usegetAllowedAndEnabledPermissionsSuspenseQuery>;
export type getAllowedAndEnabledPermissionsQueryResult = ApolloReactCommon.QueryResult<getAllowedAndEnabledPermissionsQuery, getAllowedAndEnabledPermissionsQueryVariables>;
export const getPropertiesDocument = gql`
    query getProperties($where: Property_bool_exp!) {
  properties: Property(where: $where) {
    ...PropertyTableFragment
  }
}
    ${PropertyTableFragmentDoc}`;
export function usegetPropertiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getPropertiesQuery, getPropertiesQueryVariables> & ({ variables: getPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getPropertiesQuery, getPropertiesQueryVariables>(getPropertiesDocument, options);
      }
export function usegetPropertiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getPropertiesQuery, getPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getPropertiesQuery, getPropertiesQueryVariables>(getPropertiesDocument, options);
        }
export function usegetPropertiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getPropertiesQuery, getPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getPropertiesQuery, getPropertiesQueryVariables>(getPropertiesDocument, options);
        }
export type getPropertiesQueryHookResult = ReturnType<typeof usegetPropertiesQuery>;
export type getPropertiesLazyQueryHookResult = ReturnType<typeof usegetPropertiesLazyQuery>;
export type getPropertiesSuspenseQueryHookResult = ReturnType<typeof usegetPropertiesSuspenseQuery>;
export type getPropertiesQueryResult = ApolloReactCommon.QueryResult<getPropertiesQuery, getPropertiesQueryVariables>;
export const getPropertyDetailsDocument = gql`
    query getPropertyDetails($propertyId: uuid!) {
  property: Property_by_pk(propertyId: $propertyId) {
    ...PropertyTableFragment
  }
}
    ${PropertyTableFragmentDoc}`;
export function usegetPropertyDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getPropertyDetailsQuery, getPropertyDetailsQueryVariables> & ({ variables: getPropertyDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getPropertyDetailsQuery, getPropertyDetailsQueryVariables>(getPropertyDetailsDocument, options);
      }
export function usegetPropertyDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getPropertyDetailsQuery, getPropertyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getPropertyDetailsQuery, getPropertyDetailsQueryVariables>(getPropertyDetailsDocument, options);
        }
export function usegetPropertyDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getPropertyDetailsQuery, getPropertyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getPropertyDetailsQuery, getPropertyDetailsQueryVariables>(getPropertyDetailsDocument, options);
        }
export type getPropertyDetailsQueryHookResult = ReturnType<typeof usegetPropertyDetailsQuery>;
export type getPropertyDetailsLazyQueryHookResult = ReturnType<typeof usegetPropertyDetailsLazyQuery>;
export type getPropertyDetailsSuspenseQueryHookResult = ReturnType<typeof usegetPropertyDetailsSuspenseQuery>;
export type getPropertyDetailsQueryResult = ApolloReactCommon.QueryResult<getPropertyDetailsQuery, getPropertyDetailsQueryVariables>;
export const getPropertyWithPropertySourcesDocument = gql`
    query getPropertyWithPropertySources($propertyId: uuid!) {
  property: Property_by_pk(propertyId: $propertyId) {
    ...PropertyResidentAuditFragment
  }
}
    ${PropertyResidentAuditFragmentDoc}`;
export function usegetPropertyWithPropertySourcesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getPropertyWithPropertySourcesQuery, getPropertyWithPropertySourcesQueryVariables> & ({ variables: getPropertyWithPropertySourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getPropertyWithPropertySourcesQuery, getPropertyWithPropertySourcesQueryVariables>(getPropertyWithPropertySourcesDocument, options);
      }
export function usegetPropertyWithPropertySourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getPropertyWithPropertySourcesQuery, getPropertyWithPropertySourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getPropertyWithPropertySourcesQuery, getPropertyWithPropertySourcesQueryVariables>(getPropertyWithPropertySourcesDocument, options);
        }
export function usegetPropertyWithPropertySourcesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getPropertyWithPropertySourcesQuery, getPropertyWithPropertySourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getPropertyWithPropertySourcesQuery, getPropertyWithPropertySourcesQueryVariables>(getPropertyWithPropertySourcesDocument, options);
        }
export type getPropertyWithPropertySourcesQueryHookResult = ReturnType<typeof usegetPropertyWithPropertySourcesQuery>;
export type getPropertyWithPropertySourcesLazyQueryHookResult = ReturnType<typeof usegetPropertyWithPropertySourcesLazyQuery>;
export type getPropertyWithPropertySourcesSuspenseQueryHookResult = ReturnType<typeof usegetPropertyWithPropertySourcesSuspenseQuery>;
export type getPropertyWithPropertySourcesQueryResult = ApolloReactCommon.QueryResult<getPropertyWithPropertySourcesQuery, getPropertyWithPropertySourcesQueryVariables>;
export const getPropertyWithPropertyMapsDocument = gql`
    query getPropertyWithPropertyMaps($propertyId: uuid!) {
  property: Property_by_pk(propertyId: $propertyId) {
    ...PropertyLabelFragment
    propertySources {
      propertySourceId
      sourceId
    }
    propertyMap {
      ...PropertyMapTableFragment
    }
  }
}
    ${PropertyLabelFragmentDoc}
${PropertyMapTableFragmentDoc}`;
export function usegetPropertyWithPropertyMapsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getPropertyWithPropertyMapsQuery, getPropertyWithPropertyMapsQueryVariables> & ({ variables: getPropertyWithPropertyMapsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getPropertyWithPropertyMapsQuery, getPropertyWithPropertyMapsQueryVariables>(getPropertyWithPropertyMapsDocument, options);
      }
export function usegetPropertyWithPropertyMapsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getPropertyWithPropertyMapsQuery, getPropertyWithPropertyMapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getPropertyWithPropertyMapsQuery, getPropertyWithPropertyMapsQueryVariables>(getPropertyWithPropertyMapsDocument, options);
        }
export function usegetPropertyWithPropertyMapsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getPropertyWithPropertyMapsQuery, getPropertyWithPropertyMapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getPropertyWithPropertyMapsQuery, getPropertyWithPropertyMapsQueryVariables>(getPropertyWithPropertyMapsDocument, options);
        }
export type getPropertyWithPropertyMapsQueryHookResult = ReturnType<typeof usegetPropertyWithPropertyMapsQuery>;
export type getPropertyWithPropertyMapsLazyQueryHookResult = ReturnType<typeof usegetPropertyWithPropertyMapsLazyQuery>;
export type getPropertyWithPropertyMapsSuspenseQueryHookResult = ReturnType<typeof usegetPropertyWithPropertyMapsSuspenseQuery>;
export type getPropertyWithPropertyMapsQueryResult = ApolloReactCommon.QueryResult<getPropertyWithPropertyMapsQuery, getPropertyWithPropertyMapsQueryVariables>;
export const getGatewayPinCodePropertiesByUserDocument = gql`
    query getGatewayPinCodePropertiesByUser($userId: uuid!) {
  properties: Property(
    where: {propertyFeatureFlags: {featureFlagKey: {_eq: "GATEWAY_PIN_CODES"}}, _not: {propertyFeatureFlags: {featureFlagKey: {_eq: "COMMUNITY_CONNECT"}}}, managedUserRoles: {assignedToUserId: {_eq: $userId}, status: {_in: [ACTIVE, PENDING]}}}
    order_by: {name: asc}
  ) {
    ...PropertyLabelFragment
  }
}
    ${PropertyLabelFragmentDoc}`;
export function usegetGatewayPinCodePropertiesByUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getGatewayPinCodePropertiesByUserQuery, getGatewayPinCodePropertiesByUserQueryVariables> & ({ variables: getGatewayPinCodePropertiesByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getGatewayPinCodePropertiesByUserQuery, getGatewayPinCodePropertiesByUserQueryVariables>(getGatewayPinCodePropertiesByUserDocument, options);
      }
export function usegetGatewayPinCodePropertiesByUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getGatewayPinCodePropertiesByUserQuery, getGatewayPinCodePropertiesByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getGatewayPinCodePropertiesByUserQuery, getGatewayPinCodePropertiesByUserQueryVariables>(getGatewayPinCodePropertiesByUserDocument, options);
        }
export function usegetGatewayPinCodePropertiesByUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getGatewayPinCodePropertiesByUserQuery, getGatewayPinCodePropertiesByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getGatewayPinCodePropertiesByUserQuery, getGatewayPinCodePropertiesByUserQueryVariables>(getGatewayPinCodePropertiesByUserDocument, options);
        }
export type getGatewayPinCodePropertiesByUserQueryHookResult = ReturnType<typeof usegetGatewayPinCodePropertiesByUserQuery>;
export type getGatewayPinCodePropertiesByUserLazyQueryHookResult = ReturnType<typeof usegetGatewayPinCodePropertiesByUserLazyQuery>;
export type getGatewayPinCodePropertiesByUserSuspenseQueryHookResult = ReturnType<typeof usegetGatewayPinCodePropertiesByUserSuspenseQuery>;
export type getGatewayPinCodePropertiesByUserQueryResult = ApolloReactCommon.QueryResult<getGatewayPinCodePropertiesByUserQuery, getGatewayPinCodePropertiesByUserQueryVariables>;
export const getGamPropertiesByUserDocument = gql`
    query getGamPropertiesByUser($userId: uuid!) {
  properties: Property(
    where: {propertyFeatureFlags: {featureFlagKey: {_eq: "GATEWAY_ACCESS_MANAGER"}}, managedUserRoles: {assignedToUserId: {_eq: $userId}, status: {_in: [ACTIVE, PENDING]}}}
    order_by: {name: asc}
  ) {
    ...PropertyLabelFragment
  }
}
    ${PropertyLabelFragmentDoc}`;
export function usegetGamPropertiesByUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getGamPropertiesByUserQuery, getGamPropertiesByUserQueryVariables> & ({ variables: getGamPropertiesByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getGamPropertiesByUserQuery, getGamPropertiesByUserQueryVariables>(getGamPropertiesByUserDocument, options);
      }
export function usegetGamPropertiesByUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getGamPropertiesByUserQuery, getGamPropertiesByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getGamPropertiesByUserQuery, getGamPropertiesByUserQueryVariables>(getGamPropertiesByUserDocument, options);
        }
export function usegetGamPropertiesByUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getGamPropertiesByUserQuery, getGamPropertiesByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getGamPropertiesByUserQuery, getGamPropertiesByUserQueryVariables>(getGamPropertiesByUserDocument, options);
        }
export type getGamPropertiesByUserQueryHookResult = ReturnType<typeof usegetGamPropertiesByUserQuery>;
export type getGamPropertiesByUserLazyQueryHookResult = ReturnType<typeof usegetGamPropertiesByUserLazyQuery>;
export type getGamPropertiesByUserSuspenseQueryHookResult = ReturnType<typeof usegetGamPropertiesByUserSuspenseQuery>;
export type getGamPropertiesByUserQueryResult = ApolloReactCommon.QueryResult<getGamPropertiesByUserQuery, getGamPropertiesByUserQueryVariables>;
export const upsertPropertyFeatureFlagsDocument = gql`
    mutation upsertPropertyFeatureFlags($objects: [PropertyFeatureFlag_insert_input!]!) {
  propertyFeatureFlags: insert_PropertyFeatureFlag(
    objects: $objects
    on_conflict: {constraint: PropertyFeatureFlag_propertyId_featureFlagKey_key, update_columns: []}
  ) {
    returning {
      propertyFeatureFlagId
      property {
        propertyId
        propertyFeatureFlags {
          ...PropertyFeatureFlagLabelFragment
        }
      }
    }
  }
}
    ${PropertyFeatureFlagLabelFragmentDoc}`;
export type upsertPropertyFeatureFlagsMutationFn = ApolloReactCommon.MutationFunction<upsertPropertyFeatureFlagsMutation, upsertPropertyFeatureFlagsMutationVariables>;
export function useupsertPropertyFeatureFlagsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<upsertPropertyFeatureFlagsMutation, upsertPropertyFeatureFlagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<upsertPropertyFeatureFlagsMutation, upsertPropertyFeatureFlagsMutationVariables>(upsertPropertyFeatureFlagsDocument, options);
      }
export type upsertPropertyFeatureFlagsMutationHookResult = ReturnType<typeof useupsertPropertyFeatureFlagsMutation>;
export type upsertPropertyFeatureFlagsMutationResult = ApolloReactCommon.MutationResult<upsertPropertyFeatureFlagsMutation>;
export type upsertPropertyFeatureFlagsMutationOptions = ApolloReactCommon.BaseMutationOptions<upsertPropertyFeatureFlagsMutation, upsertPropertyFeatureFlagsMutationVariables>;
export const deletePropertyFeatureFlagsDocument = gql`
    mutation deletePropertyFeatureFlags($where: PropertyFeatureFlag_bool_exp!) {
  propertyFeatureFlags: delete_PropertyFeatureFlag(where: $where) {
    returning {
      propertyFeatureFlagId
      property {
        propertyId
        propertyFeatureFlags {
          ...PropertyFeatureFlagLabelFragment
        }
      }
    }
  }
}
    ${PropertyFeatureFlagLabelFragmentDoc}`;
export type deletePropertyFeatureFlagsMutationFn = ApolloReactCommon.MutationFunction<deletePropertyFeatureFlagsMutation, deletePropertyFeatureFlagsMutationVariables>;
export function usedeletePropertyFeatureFlagsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<deletePropertyFeatureFlagsMutation, deletePropertyFeatureFlagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<deletePropertyFeatureFlagsMutation, deletePropertyFeatureFlagsMutationVariables>(deletePropertyFeatureFlagsDocument, options);
      }
export type deletePropertyFeatureFlagsMutationHookResult = ReturnType<typeof usedeletePropertyFeatureFlagsMutation>;
export type deletePropertyFeatureFlagsMutationResult = ApolloReactCommon.MutationResult<deletePropertyFeatureFlagsMutation>;
export type deletePropertyFeatureFlagsMutationOptions = ApolloReactCommon.BaseMutationOptions<deletePropertyFeatureFlagsMutation, deletePropertyFeatureFlagsMutationVariables>;
export const syncEngrainPropertyMapDocument = gql`
    mutation syncEngrainPropertyMap($input: Custom_SyncEngrainPropertyMapInput!) {
  custom_syncEngrainPropertyMap(input: $input) {
    propertyMapId
    property {
      propertyId
      propertyMap {
        ...PropertyMapTableFragment
      }
    }
  }
}
    ${PropertyMapTableFragmentDoc}`;
export type syncEngrainPropertyMapMutationFn = ApolloReactCommon.MutationFunction<syncEngrainPropertyMapMutation, syncEngrainPropertyMapMutationVariables>;
export function usesyncEngrainPropertyMapMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<syncEngrainPropertyMapMutation, syncEngrainPropertyMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<syncEngrainPropertyMapMutation, syncEngrainPropertyMapMutationVariables>(syncEngrainPropertyMapDocument, options);
      }
export type syncEngrainPropertyMapMutationHookResult = ReturnType<typeof usesyncEngrainPropertyMapMutation>;
export type syncEngrainPropertyMapMutationResult = ApolloReactCommon.MutationResult<syncEngrainPropertyMapMutation>;
export type syncEngrainPropertyMapMutationOptions = ApolloReactCommon.BaseMutationOptions<syncEngrainPropertyMapMutation, syncEngrainPropertyMapMutationVariables>;
export const updatePropertyMapByPkDocument = gql`
    mutation updatePropertyMapByPk($propertyMapId: uuid!, $_set: PropertyMap_set_input!) {
  propertyMap: update_PropertyMap_by_pk(
    pk_columns: {propertyMapId: $propertyMapId}
    _set: $_set
  ) {
    ...PropertyMapTableFragment
  }
}
    ${PropertyMapTableFragmentDoc}`;
export type updatePropertyMapByPkMutationFn = ApolloReactCommon.MutationFunction<updatePropertyMapByPkMutation, updatePropertyMapByPkMutationVariables>;
export function useupdatePropertyMapByPkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<updatePropertyMapByPkMutation, updatePropertyMapByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<updatePropertyMapByPkMutation, updatePropertyMapByPkMutationVariables>(updatePropertyMapByPkDocument, options);
      }
export type updatePropertyMapByPkMutationHookResult = ReturnType<typeof useupdatePropertyMapByPkMutation>;
export type updatePropertyMapByPkMutationResult = ApolloReactCommon.MutationResult<updatePropertyMapByPkMutation>;
export type updatePropertyMapByPkMutationOptions = ApolloReactCommon.BaseMutationOptions<updatePropertyMapByPkMutation, updatePropertyMapByPkMutationVariables>;
export const getRelaysDocument = gql`
    query getRelays($where: Relay_bool_exp!) {
  relays: Relay(where: $where) {
    ...RelayFailurePlanFragment
  }
}
    ${RelayFailurePlanFragmentDoc}`;
export function usegetRelaysQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getRelaysQuery, getRelaysQueryVariables> & ({ variables: getRelaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getRelaysQuery, getRelaysQueryVariables>(getRelaysDocument, options);
      }
export function usegetRelaysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getRelaysQuery, getRelaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getRelaysQuery, getRelaysQueryVariables>(getRelaysDocument, options);
        }
export function usegetRelaysSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getRelaysQuery, getRelaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getRelaysQuery, getRelaysQueryVariables>(getRelaysDocument, options);
        }
export type getRelaysQueryHookResult = ReturnType<typeof usegetRelaysQuery>;
export type getRelaysLazyQueryHookResult = ReturnType<typeof usegetRelaysLazyQuery>;
export type getRelaysSuspenseQueryHookResult = ReturnType<typeof usegetRelaysSuspenseQuery>;
export type getRelaysQueryResult = ApolloReactCommon.QueryResult<getRelaysQuery, getRelaysQueryVariables>;
export const updateRelaysDocument = gql`
    mutation updateRelays($where: Relay_bool_exp!, $_set: Relay_set_input!) {
  updateRelays: update_Relay(where: $where, _set: $_set) {
    returning {
      ...RelayFailurePlanFragment
    }
  }
}
    ${RelayFailurePlanFragmentDoc}`;
export type updateRelaysMutationFn = ApolloReactCommon.MutationFunction<updateRelaysMutation, updateRelaysMutationVariables>;
export function useupdateRelaysMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<updateRelaysMutation, updateRelaysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<updateRelaysMutation, updateRelaysMutationVariables>(updateRelaysDocument, options);
      }
export type updateRelaysMutationHookResult = ReturnType<typeof useupdateRelaysMutation>;
export type updateRelaysMutationResult = ApolloReactCommon.MutationResult<updateRelaysMutation>;
export type updateRelaysMutationOptions = ApolloReactCommon.BaseMutationOptions<updateRelaysMutation, updateRelaysMutationVariables>;
export const getRelaysWithAccessPointInfoDocument = gql`
    query getRelaysWithAccessPointInfo($where: Relay_bool_exp!) {
  relays: Relay(where: $where) {
    hubId
    position
    ...RelayLabelFragment
    accessPointRelays {
      ...RelayAccessPointsFragment
    }
  }
}
    ${RelayLabelFragmentDoc}
${RelayAccessPointsFragmentDoc}`;
export function usegetRelaysWithAccessPointInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getRelaysWithAccessPointInfoQuery, getRelaysWithAccessPointInfoQueryVariables> & ({ variables: getRelaysWithAccessPointInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getRelaysWithAccessPointInfoQuery, getRelaysWithAccessPointInfoQueryVariables>(getRelaysWithAccessPointInfoDocument, options);
      }
export function usegetRelaysWithAccessPointInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getRelaysWithAccessPointInfoQuery, getRelaysWithAccessPointInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getRelaysWithAccessPointInfoQuery, getRelaysWithAccessPointInfoQueryVariables>(getRelaysWithAccessPointInfoDocument, options);
        }
export function usegetRelaysWithAccessPointInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getRelaysWithAccessPointInfoQuery, getRelaysWithAccessPointInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getRelaysWithAccessPointInfoQuery, getRelaysWithAccessPointInfoQueryVariables>(getRelaysWithAccessPointInfoDocument, options);
        }
export type getRelaysWithAccessPointInfoQueryHookResult = ReturnType<typeof usegetRelaysWithAccessPointInfoQuery>;
export type getRelaysWithAccessPointInfoLazyQueryHookResult = ReturnType<typeof usegetRelaysWithAccessPointInfoLazyQuery>;
export type getRelaysWithAccessPointInfoSuspenseQueryHookResult = ReturnType<typeof usegetRelaysWithAccessPointInfoSuspenseQuery>;
export type getRelaysWithAccessPointInfoQueryResult = ApolloReactCommon.QueryResult<getRelaysWithAccessPointInfoQuery, getRelaysWithAccessPointInfoQueryVariables>;
export const getRolePermissionsAndRelationshipsDocument = gql`
    query getRolePermissionsAndRelationships($roleIds: [uuid!]!) {
  permissions: Permission(where: {rolePermissions: {roleId: {_in: $roleIds}}}) {
    ...AllowedPermissionFragment
  }
  roleRelationships: RoleRelationship(where: {roleId: {_in: $roleIds}}) {
    ...RoleRelationshipFragment
  }
}
    ${AllowedPermissionFragmentDoc}
${RoleRelationshipFragmentDoc}`;
export function usegetRolePermissionsAndRelationshipsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getRolePermissionsAndRelationshipsQuery, getRolePermissionsAndRelationshipsQueryVariables> & ({ variables: getRolePermissionsAndRelationshipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getRolePermissionsAndRelationshipsQuery, getRolePermissionsAndRelationshipsQueryVariables>(getRolePermissionsAndRelationshipsDocument, options);
      }
export function usegetRolePermissionsAndRelationshipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getRolePermissionsAndRelationshipsQuery, getRolePermissionsAndRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getRolePermissionsAndRelationshipsQuery, getRolePermissionsAndRelationshipsQueryVariables>(getRolePermissionsAndRelationshipsDocument, options);
        }
export function usegetRolePermissionsAndRelationshipsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getRolePermissionsAndRelationshipsQuery, getRolePermissionsAndRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getRolePermissionsAndRelationshipsQuery, getRolePermissionsAndRelationshipsQueryVariables>(getRolePermissionsAndRelationshipsDocument, options);
        }
export type getRolePermissionsAndRelationshipsQueryHookResult = ReturnType<typeof usegetRolePermissionsAndRelationshipsQuery>;
export type getRolePermissionsAndRelationshipsLazyQueryHookResult = ReturnType<typeof usegetRolePermissionsAndRelationshipsLazyQuery>;
export type getRolePermissionsAndRelationshipsSuspenseQueryHookResult = ReturnType<typeof usegetRolePermissionsAndRelationshipsSuspenseQuery>;
export type getRolePermissionsAndRelationshipsQueryResult = ApolloReactCommon.QueryResult<getRolePermissionsAndRelationshipsQuery, getRolePermissionsAndRelationshipsQueryVariables>;
export const getRoleDetailsDocument = gql`
    query getRoleDetails($roleId: uuid!) {
  role: Role_by_pk(roleId: $roleId) {
    ...RoleDetailsFragment
  }
}
    ${RoleDetailsFragmentDoc}`;
export function usegetRoleDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getRoleDetailsQuery, getRoleDetailsQueryVariables> & ({ variables: getRoleDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getRoleDetailsQuery, getRoleDetailsQueryVariables>(getRoleDetailsDocument, options);
      }
export function usegetRoleDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getRoleDetailsQuery, getRoleDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getRoleDetailsQuery, getRoleDetailsQueryVariables>(getRoleDetailsDocument, options);
        }
export function usegetRoleDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getRoleDetailsQuery, getRoleDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getRoleDetailsQuery, getRoleDetailsQueryVariables>(getRoleDetailsDocument, options);
        }
export type getRoleDetailsQueryHookResult = ReturnType<typeof usegetRoleDetailsQuery>;
export type getRoleDetailsLazyQueryHookResult = ReturnType<typeof usegetRoleDetailsLazyQuery>;
export type getRoleDetailsSuspenseQueryHookResult = ReturnType<typeof usegetRoleDetailsSuspenseQuery>;
export type getRoleDetailsQueryResult = ApolloReactCommon.QueryResult<getRoleDetailsQuery, getRoleDetailsQueryVariables>;
export const getRolesDocument = gql`
    query getRoles($where: Role_bool_exp!) {
  roles: Role(where: $where) {
    ...RoleUniqueLabelFragment
    key
    permissionScope
  }
}
    ${RoleUniqueLabelFragmentDoc}`;
export function usegetRolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getRolesQuery, getRolesQueryVariables> & ({ variables: getRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getRolesQuery, getRolesQueryVariables>(getRolesDocument, options);
      }
export function usegetRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getRolesQuery, getRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getRolesQuery, getRolesQueryVariables>(getRolesDocument, options);
        }
export function usegetRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getRolesQuery, getRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getRolesQuery, getRolesQueryVariables>(getRolesDocument, options);
        }
export type getRolesQueryHookResult = ReturnType<typeof usegetRolesQuery>;
export type getRolesLazyQueryHookResult = ReturnType<typeof usegetRolesLazyQuery>;
export type getRolesSuspenseQueryHookResult = ReturnType<typeof usegetRolesSuspenseQuery>;
export type getRolesQueryResult = ApolloReactCommon.QueryResult<getRolesQuery, getRolesQueryVariables>;
export const getRelatableRolesDocument = gql`
    query getRelatableRoles($where: Role_bool_exp!, $order_by: [Role_order_by!]) {
  roles: Role(where: $where, order_by: $order_by) {
    ...RelatableRoleFragment
  }
}
    ${RelatableRoleFragmentDoc}`;
export function usegetRelatableRolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getRelatableRolesQuery, getRelatableRolesQueryVariables> & ({ variables: getRelatableRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getRelatableRolesQuery, getRelatableRolesQueryVariables>(getRelatableRolesDocument, options);
      }
export function usegetRelatableRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getRelatableRolesQuery, getRelatableRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getRelatableRolesQuery, getRelatableRolesQueryVariables>(getRelatableRolesDocument, options);
        }
export function usegetRelatableRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getRelatableRolesQuery, getRelatableRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getRelatableRolesQuery, getRelatableRolesQueryVariables>(getRelatableRolesDocument, options);
        }
export type getRelatableRolesQueryHookResult = ReturnType<typeof usegetRelatableRolesQuery>;
export type getRelatableRolesLazyQueryHookResult = ReturnType<typeof usegetRelatableRolesLazyQuery>;
export type getRelatableRolesSuspenseQueryHookResult = ReturnType<typeof usegetRelatableRolesSuspenseQuery>;
export type getRelatableRolesQueryResult = ApolloReactCommon.QueryResult<getRelatableRolesQuery, getRelatableRolesQueryVariables>;
export const getGrantableRolesDocument = gql`
    query getGrantableRoles($where: Role_bool_exp!, $order_by: [Role_order_by!]) {
  roles: Role(where: $where, order_by: $order_by) {
    ...GrantableRoleFragment
  }
}
    ${GrantableRoleFragmentDoc}`;
export function usegetGrantableRolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getGrantableRolesQuery, getGrantableRolesQueryVariables> & ({ variables: getGrantableRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getGrantableRolesQuery, getGrantableRolesQueryVariables>(getGrantableRolesDocument, options);
      }
export function usegetGrantableRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getGrantableRolesQuery, getGrantableRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getGrantableRolesQuery, getGrantableRolesQueryVariables>(getGrantableRolesDocument, options);
        }
export function usegetGrantableRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getGrantableRolesQuery, getGrantableRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getGrantableRolesQuery, getGrantableRolesQueryVariables>(getGrantableRolesDocument, options);
        }
export type getGrantableRolesQueryHookResult = ReturnType<typeof usegetGrantableRolesQuery>;
export type getGrantableRolesLazyQueryHookResult = ReturnType<typeof usegetGrantableRolesLazyQuery>;
export type getGrantableRolesSuspenseQueryHookResult = ReturnType<typeof usegetGrantableRolesSuspenseQuery>;
export type getGrantableRolesQueryResult = ApolloReactCommon.QueryResult<getGrantableRolesQuery, getGrantableRolesQueryVariables>;
export const getRoleByKeyDocument = gql`
    query getRoleByKey($key: RoleKey_enum!) {
  roles: Role(where: {key: {_eq: $key}}) {
    ...RoleUniqueLabelFragment
  }
}
    ${RoleUniqueLabelFragmentDoc}`;
export function usegetRoleByKeyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getRoleByKeyQuery, getRoleByKeyQueryVariables> & ({ variables: getRoleByKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getRoleByKeyQuery, getRoleByKeyQueryVariables>(getRoleByKeyDocument, options);
      }
export function usegetRoleByKeyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getRoleByKeyQuery, getRoleByKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getRoleByKeyQuery, getRoleByKeyQueryVariables>(getRoleByKeyDocument, options);
        }
export function usegetRoleByKeySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getRoleByKeyQuery, getRoleByKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getRoleByKeyQuery, getRoleByKeyQueryVariables>(getRoleByKeyDocument, options);
        }
export type getRoleByKeyQueryHookResult = ReturnType<typeof usegetRoleByKeyQuery>;
export type getRoleByKeyLazyQueryHookResult = ReturnType<typeof usegetRoleByKeyLazyQuery>;
export type getRoleByKeySuspenseQueryHookResult = ReturnType<typeof usegetRoleByKeySuspenseQuery>;
export type getRoleByKeyQueryResult = ApolloReactCommon.QueryResult<getRoleByKeyQuery, getRoleByKeyQueryVariables>;
export const insertRolesDocument = gql`
    mutation insertRoles($objects: [Role_insert_input!]!) {
  roles: insert_Role(objects: $objects) {
    returning {
      ...RoleDetailsFragment
    }
  }
}
    ${RoleDetailsFragmentDoc}`;
export type insertRolesMutationFn = ApolloReactCommon.MutationFunction<insertRolesMutation, insertRolesMutationVariables>;
export function useinsertRolesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<insertRolesMutation, insertRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<insertRolesMutation, insertRolesMutationVariables>(insertRolesDocument, options);
      }
export type insertRolesMutationHookResult = ReturnType<typeof useinsertRolesMutation>;
export type insertRolesMutationResult = ApolloReactCommon.MutationResult<insertRolesMutation>;
export type insertRolesMutationOptions = ApolloReactCommon.BaseMutationOptions<insertRolesMutation, insertRolesMutationVariables>;
export const upsertRolePermissionsDocument = gql`
    mutation upsertRolePermissions($objects: [RolePermission_insert_input!]!) {
  rolePermissions: insert_RolePermission(
    objects: $objects
    on_conflict: {constraint: RolePermission_roleId_permissionId_key, update_columns: []}
  ) {
    returning {
      ...RolePermissionFragment
    }
  }
}
    ${RolePermissionFragmentDoc}`;
export type upsertRolePermissionsMutationFn = ApolloReactCommon.MutationFunction<upsertRolePermissionsMutation, upsertRolePermissionsMutationVariables>;
export function useupsertRolePermissionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<upsertRolePermissionsMutation, upsertRolePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<upsertRolePermissionsMutation, upsertRolePermissionsMutationVariables>(upsertRolePermissionsDocument, options);
      }
export type upsertRolePermissionsMutationHookResult = ReturnType<typeof useupsertRolePermissionsMutation>;
export type upsertRolePermissionsMutationResult = ApolloReactCommon.MutationResult<upsertRolePermissionsMutation>;
export type upsertRolePermissionsMutationOptions = ApolloReactCommon.BaseMutationOptions<upsertRolePermissionsMutation, upsertRolePermissionsMutationVariables>;
export const deleteRolePermissionsDocument = gql`
    mutation deleteRolePermissions($where: RolePermission_bool_exp!) {
  rolePermissions: delete_RolePermission(where: $where) {
    returning {
      ...RolePermissionFragment
    }
  }
}
    ${RolePermissionFragmentDoc}`;
export type deleteRolePermissionsMutationFn = ApolloReactCommon.MutationFunction<deleteRolePermissionsMutation, deleteRolePermissionsMutationVariables>;
export function usedeleteRolePermissionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<deleteRolePermissionsMutation, deleteRolePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<deleteRolePermissionsMutation, deleteRolePermissionsMutationVariables>(deleteRolePermissionsDocument, options);
      }
export type deleteRolePermissionsMutationHookResult = ReturnType<typeof usedeleteRolePermissionsMutation>;
export type deleteRolePermissionsMutationResult = ApolloReactCommon.MutationResult<deleteRolePermissionsMutation>;
export type deleteRolePermissionsMutationOptions = ApolloReactCommon.BaseMutationOptions<deleteRolePermissionsMutation, deleteRolePermissionsMutationVariables>;
export const upsertRoleRelationshipsDocument = gql`
    mutation upsertRoleRelationships($objects: [RoleRelationship_insert_input!]!) {
  roleRelationships: insert_RoleRelationship(
    objects: $objects
    on_conflict: {constraint: RoleRelationship_roleId_relatedRoleId_key, update_columns: [canReadUserRole, canGrantUserRole, canRevokeUserRole]}
  ) {
    returning {
      ...RoleRelationshipDetailsFragment
    }
  }
}
    ${RoleRelationshipDetailsFragmentDoc}`;
export type upsertRoleRelationshipsMutationFn = ApolloReactCommon.MutationFunction<upsertRoleRelationshipsMutation, upsertRoleRelationshipsMutationVariables>;
export function useupsertRoleRelationshipsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<upsertRoleRelationshipsMutation, upsertRoleRelationshipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<upsertRoleRelationshipsMutation, upsertRoleRelationshipsMutationVariables>(upsertRoleRelationshipsDocument, options);
      }
export type upsertRoleRelationshipsMutationHookResult = ReturnType<typeof useupsertRoleRelationshipsMutation>;
export type upsertRoleRelationshipsMutationResult = ApolloReactCommon.MutationResult<upsertRoleRelationshipsMutation>;
export type upsertRoleRelationshipsMutationOptions = ApolloReactCommon.BaseMutationOptions<upsertRoleRelationshipsMutation, upsertRoleRelationshipsMutationVariables>;
export const deleteRoleRelationshipDocument = gql`
    mutation deleteRoleRelationship($roleId: uuid!, $relatedRoleId: uuid!) {
  roleRelationships: delete_RoleRelationship(
    where: {roleId: {_eq: $roleId}, relatedRoleId: {_eq: $relatedRoleId}}
  ) {
    returning {
      ...RoleRelationshipDetailsFragment
    }
  }
}
    ${RoleRelationshipDetailsFragmentDoc}`;
export type deleteRoleRelationshipMutationFn = ApolloReactCommon.MutationFunction<deleteRoleRelationshipMutation, deleteRoleRelationshipMutationVariables>;
export function usedeleteRoleRelationshipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<deleteRoleRelationshipMutation, deleteRoleRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<deleteRoleRelationshipMutation, deleteRoleRelationshipMutationVariables>(deleteRoleRelationshipDocument, options);
      }
export type deleteRoleRelationshipMutationHookResult = ReturnType<typeof usedeleteRoleRelationshipMutation>;
export type deleteRoleRelationshipMutationResult = ApolloReactCommon.MutationResult<deleteRoleRelationshipMutation>;
export type deleteRoleRelationshipMutationOptions = ApolloReactCommon.BaseMutationOptions<deleteRoleRelationshipMutation, deleteRoleRelationshipMutationVariables>;
export const getSessionDetailsDocument = gql`
    query getSessionDetails($sessionId: uuid!) {
  session: Session_by_pk(sessionId: $sessionId) {
    ...SessionTableFragment
  }
}
    ${SessionTableFragmentDoc}`;
export function usegetSessionDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getSessionDetailsQuery, getSessionDetailsQueryVariables> & ({ variables: getSessionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getSessionDetailsQuery, getSessionDetailsQueryVariables>(getSessionDetailsDocument, options);
      }
export function usegetSessionDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getSessionDetailsQuery, getSessionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getSessionDetailsQuery, getSessionDetailsQueryVariables>(getSessionDetailsDocument, options);
        }
export function usegetSessionDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getSessionDetailsQuery, getSessionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getSessionDetailsQuery, getSessionDetailsQueryVariables>(getSessionDetailsDocument, options);
        }
export type getSessionDetailsQueryHookResult = ReturnType<typeof usegetSessionDetailsQuery>;
export type getSessionDetailsLazyQueryHookResult = ReturnType<typeof usegetSessionDetailsLazyQuery>;
export type getSessionDetailsSuspenseQueryHookResult = ReturnType<typeof usegetSessionDetailsSuspenseQuery>;
export type getSessionDetailsQueryResult = ApolloReactCommon.QueryResult<getSessionDetailsQuery, getSessionDetailsQueryVariables>;
export const revokeSessionDocument = gql`
    mutation revokeSession($sessionId: uuid!) {
  custom_revokeSession(sessionId: $sessionId) {
    session {
      ...SessionTableFragment
    }
  }
}
    ${SessionTableFragmentDoc}`;
export type revokeSessionMutationFn = ApolloReactCommon.MutationFunction<revokeSessionMutation, revokeSessionMutationVariables>;
export function userevokeSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<revokeSessionMutation, revokeSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<revokeSessionMutation, revokeSessionMutationVariables>(revokeSessionDocument, options);
      }
export type revokeSessionMutationHookResult = ReturnType<typeof userevokeSessionMutation>;
export type revokeSessionMutationResult = ApolloReactCommon.MutationResult<revokeSessionMutation>;
export type revokeSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<revokeSessionMutation, revokeSessionMutationVariables>;
export const augustSdkFeesReportDocument = gql`
    query augustSdkFeesReport($startDate: timestamptz!, $endDate: timestamptz!) {
  totalSmartLocks: SmartLock_aggregate(
    where: {smartLockLogs: {createdAt: {_gte: $startDate, _lte: $endDate}}}
  ) {
    aggregate {
      count
    }
  }
  totalProperties: Property_aggregate(
    where: {units: {smartLocks: {smartLockLogs: {createdAt: {_gte: $startDate, _lte: $endDate}}}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export function useaugustSdkFeesReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<augustSdkFeesReportQuery, augustSdkFeesReportQueryVariables> & ({ variables: augustSdkFeesReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<augustSdkFeesReportQuery, augustSdkFeesReportQueryVariables>(augustSdkFeesReportDocument, options);
      }
export function useaugustSdkFeesReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<augustSdkFeesReportQuery, augustSdkFeesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<augustSdkFeesReportQuery, augustSdkFeesReportQueryVariables>(augustSdkFeesReportDocument, options);
        }
export function useaugustSdkFeesReportSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<augustSdkFeesReportQuery, augustSdkFeesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<augustSdkFeesReportQuery, augustSdkFeesReportQueryVariables>(augustSdkFeesReportDocument, options);
        }
export type augustSdkFeesReportQueryHookResult = ReturnType<typeof useaugustSdkFeesReportQuery>;
export type augustSdkFeesReportLazyQueryHookResult = ReturnType<typeof useaugustSdkFeesReportLazyQuery>;
export type augustSdkFeesReportSuspenseQueryHookResult = ReturnType<typeof useaugustSdkFeesReportSuspenseQuery>;
export type augustSdkFeesReportQueryResult = ApolloReactCommon.QueryResult<augustSdkFeesReportQuery, augustSdkFeesReportQueryVariables>;
export const remoteOperateAugustLockDocument = gql`
    mutation remoteOperateAugustLock($input: Custom_RemoteOperateAugustLockInput!) {
  custom_remoteOperateAugustLock(input: $input) {
    lockStatus
    doorStatus
  }
}
    `;
export type remoteOperateAugustLockMutationFn = ApolloReactCommon.MutationFunction<remoteOperateAugustLockMutation, remoteOperateAugustLockMutationVariables>;
export function useremoteOperateAugustLockMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<remoteOperateAugustLockMutation, remoteOperateAugustLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<remoteOperateAugustLockMutation, remoteOperateAugustLockMutationVariables>(remoteOperateAugustLockDocument, options);
      }
export type remoteOperateAugustLockMutationHookResult = ReturnType<typeof useremoteOperateAugustLockMutation>;
export type remoteOperateAugustLockMutationResult = ApolloReactCommon.MutationResult<remoteOperateAugustLockMutation>;
export type remoteOperateAugustLockMutationOptions = ApolloReactCommon.BaseMutationOptions<remoteOperateAugustLockMutation, remoteOperateAugustLockMutationVariables>;
export const getTicketDetailsDocument = gql`
    query getTicketDetails($ticketId: uuid!) {
  ticket: Ticket_by_pk(ticketId: $ticketId) {
    ...TicketTableFragment
  }
}
    ${TicketTableFragmentDoc}`;
export function usegetTicketDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getTicketDetailsQuery, getTicketDetailsQueryVariables> & ({ variables: getTicketDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getTicketDetailsQuery, getTicketDetailsQueryVariables>(getTicketDetailsDocument, options);
      }
export function usegetTicketDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getTicketDetailsQuery, getTicketDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getTicketDetailsQuery, getTicketDetailsQueryVariables>(getTicketDetailsDocument, options);
        }
export function usegetTicketDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getTicketDetailsQuery, getTicketDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getTicketDetailsQuery, getTicketDetailsQueryVariables>(getTicketDetailsDocument, options);
        }
export type getTicketDetailsQueryHookResult = ReturnType<typeof usegetTicketDetailsQuery>;
export type getTicketDetailsLazyQueryHookResult = ReturnType<typeof usegetTicketDetailsLazyQuery>;
export type getTicketDetailsSuspenseQueryHookResult = ReturnType<typeof usegetTicketDetailsSuspenseQuery>;
export type getTicketDetailsQueryResult = ApolloReactCommon.QueryResult<getTicketDetailsQuery, getTicketDetailsQueryVariables>;
export const updateTicketStatusDocument = gql`
    mutation updateTicketStatus($ticketId: uuid!, $status: String!) {
  custom_updateTicketStatus(ticketId: $ticketId, status: $status) {
    ticket {
      ...TicketTableFragment
      ...TicketRequiredRowFragment
    }
  }
}
    ${TicketTableFragmentDoc}
${TicketRequiredRowFragmentDoc}`;
export type updateTicketStatusMutationFn = ApolloReactCommon.MutationFunction<updateTicketStatusMutation, updateTicketStatusMutationVariables>;
export function useupdateTicketStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<updateTicketStatusMutation, updateTicketStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<updateTicketStatusMutation, updateTicketStatusMutationVariables>(updateTicketStatusDocument, options);
      }
export type updateTicketStatusMutationHookResult = ReturnType<typeof useupdateTicketStatusMutation>;
export type updateTicketStatusMutationResult = ApolloReactCommon.MutationResult<updateTicketStatusMutation>;
export type updateTicketStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<updateTicketStatusMutation, updateTicketStatusMutationVariables>;
export const getUnitDetailsDocument = gql`
    query getUnitDetails($unitId: uuid!) {
  unit: Unit_by_pk(unitId: $unitId) {
    ...UnitDetailsFragment
  }
}
    ${UnitDetailsFragmentDoc}`;
export function usegetUnitDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getUnitDetailsQuery, getUnitDetailsQueryVariables> & ({ variables: getUnitDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getUnitDetailsQuery, getUnitDetailsQueryVariables>(getUnitDetailsDocument, options);
      }
export function usegetUnitDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getUnitDetailsQuery, getUnitDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getUnitDetailsQuery, getUnitDetailsQueryVariables>(getUnitDetailsDocument, options);
        }
export function usegetUnitDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getUnitDetailsQuery, getUnitDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getUnitDetailsQuery, getUnitDetailsQueryVariables>(getUnitDetailsDocument, options);
        }
export type getUnitDetailsQueryHookResult = ReturnType<typeof usegetUnitDetailsQuery>;
export type getUnitDetailsLazyQueryHookResult = ReturnType<typeof usegetUnitDetailsLazyQuery>;
export type getUnitDetailsSuspenseQueryHookResult = ReturnType<typeof usegetUnitDetailsSuspenseQuery>;
export type getUnitDetailsQueryResult = ApolloReactCommon.QueryResult<getUnitDetailsQuery, getUnitDetailsQueryVariables>;
export const getUnitWithPropertyDocument = gql`
    query getUnitWithProperty($unitId: uuid!) {
  unit: Unit_by_pk(unitId: $unitId) {
    unitId
    propertyId
    sourceId
    unitNumber
    building
    occupantCount
    property {
      ...PropertyLabelFragment
      propertyFeatureFlags {
        propertyFeatureFlagId
        featureFlagKey
      }
    }
  }
}
    ${PropertyLabelFragmentDoc}`;
export function usegetUnitWithPropertyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getUnitWithPropertyQuery, getUnitWithPropertyQueryVariables> & ({ variables: getUnitWithPropertyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getUnitWithPropertyQuery, getUnitWithPropertyQueryVariables>(getUnitWithPropertyDocument, options);
      }
export function usegetUnitWithPropertyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getUnitWithPropertyQuery, getUnitWithPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getUnitWithPropertyQuery, getUnitWithPropertyQueryVariables>(getUnitWithPropertyDocument, options);
        }
export function usegetUnitWithPropertySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getUnitWithPropertyQuery, getUnitWithPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getUnitWithPropertyQuery, getUnitWithPropertyQueryVariables>(getUnitWithPropertyDocument, options);
        }
export type getUnitWithPropertyQueryHookResult = ReturnType<typeof usegetUnitWithPropertyQuery>;
export type getUnitWithPropertyLazyQueryHookResult = ReturnType<typeof usegetUnitWithPropertyLazyQuery>;
export type getUnitWithPropertySuspenseQueryHookResult = ReturnType<typeof usegetUnitWithPropertySuspenseQuery>;
export type getUnitWithPropertyQueryResult = ApolloReactCommon.QueryResult<getUnitWithPropertyQuery, getUnitWithPropertyQueryVariables>;
export const getUnitsDocument = gql`
    query getUnits($where: Unit_bool_exp!) {
  units: Unit(where: $where) {
    ...UnitLabelFragment
  }
}
    ${UnitLabelFragmentDoc}`;
export function usegetUnitsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getUnitsQuery, getUnitsQueryVariables> & ({ variables: getUnitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getUnitsQuery, getUnitsQueryVariables>(getUnitsDocument, options);
      }
export function usegetUnitsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getUnitsQuery, getUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getUnitsQuery, getUnitsQueryVariables>(getUnitsDocument, options);
        }
export function usegetUnitsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getUnitsQuery, getUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getUnitsQuery, getUnitsQueryVariables>(getUnitsDocument, options);
        }
export type getUnitsQueryHookResult = ReturnType<typeof usegetUnitsQuery>;
export type getUnitsLazyQueryHookResult = ReturnType<typeof usegetUnitsLazyQuery>;
export type getUnitsSuspenseQueryHookResult = ReturnType<typeof usegetUnitsSuspenseQuery>;
export type getUnitsQueryResult = ApolloReactCommon.QueryResult<getUnitsQuery, getUnitsQueryVariables>;
export const getGrantableUnitsDocument = gql`
    query getGrantableUnits($where: Unit_bool_exp!) {
  units: Unit(where: $where) {
    ...UnitLabelFragment
    property {
      timezone
    }
  }
}
    ${UnitLabelFragmentDoc}`;
export function usegetGrantableUnitsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getGrantableUnitsQuery, getGrantableUnitsQueryVariables> & ({ variables: getGrantableUnitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getGrantableUnitsQuery, getGrantableUnitsQueryVariables>(getGrantableUnitsDocument, options);
      }
export function usegetGrantableUnitsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getGrantableUnitsQuery, getGrantableUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getGrantableUnitsQuery, getGrantableUnitsQueryVariables>(getGrantableUnitsDocument, options);
        }
export function usegetGrantableUnitsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getGrantableUnitsQuery, getGrantableUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getGrantableUnitsQuery, getGrantableUnitsQueryVariables>(getGrantableUnitsDocument, options);
        }
export type getGrantableUnitsQueryHookResult = ReturnType<typeof usegetGrantableUnitsQuery>;
export type getGrantableUnitsLazyQueryHookResult = ReturnType<typeof usegetGrantableUnitsLazyQuery>;
export type getGrantableUnitsSuspenseQueryHookResult = ReturnType<typeof usegetGrantableUnitsSuspenseQuery>;
export type getGrantableUnitsQueryResult = ApolloReactCommon.QueryResult<getGrantableUnitsQuery, getGrantableUnitsQueryVariables>;
export const insertUnitsDocument = gql`
    mutation insertUnits($objects: [Unit_insert_input!]!) {
  insertUnits: insert_Unit(objects: $objects) {
    returning {
      ...UnitLabelFragment
    }
  }
}
    ${UnitLabelFragmentDoc}`;
export type insertUnitsMutationFn = ApolloReactCommon.MutationFunction<insertUnitsMutation, insertUnitsMutationVariables>;
export function useinsertUnitsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<insertUnitsMutation, insertUnitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<insertUnitsMutation, insertUnitsMutationVariables>(insertUnitsDocument, options);
      }
export type insertUnitsMutationHookResult = ReturnType<typeof useinsertUnitsMutation>;
export type insertUnitsMutationResult = ApolloReactCommon.MutationResult<insertUnitsMutation>;
export type insertUnitsMutationOptions = ApolloReactCommon.BaseMutationOptions<insertUnitsMutation, insertUnitsMutationVariables>;
export const authenticatedUserDocument = gql`
    query authenticatedUser($userId: uuid!) {
  user: User_by_pk(userId: $userId) {
    ...AuthenticatedUserFragment
  }
  userRoles: UserRole(
    where: {assignedToUserId: {_eq: $userId}, userRolePermissions: {permissionKey: {_eq: "Session_AdminPanel"}}}
  ) {
    userRoleId
    role {
      ...AllowedRoleFragment
    }
    scopedOrganization {
      ...OrganizationLabelFragment
    }
    scopedProperty {
      ...PropertyLabelFragment
    }
  }
}
    ${AuthenticatedUserFragmentDoc}
${AllowedRoleFragmentDoc}
${OrganizationLabelFragmentDoc}
${PropertyLabelFragmentDoc}`;
export function useauthenticatedUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<authenticatedUserQuery, authenticatedUserQueryVariables> & ({ variables: authenticatedUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<authenticatedUserQuery, authenticatedUserQueryVariables>(authenticatedUserDocument, options);
      }
export function useauthenticatedUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<authenticatedUserQuery, authenticatedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<authenticatedUserQuery, authenticatedUserQueryVariables>(authenticatedUserDocument, options);
        }
export function useauthenticatedUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<authenticatedUserQuery, authenticatedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<authenticatedUserQuery, authenticatedUserQueryVariables>(authenticatedUserDocument, options);
        }
export type authenticatedUserQueryHookResult = ReturnType<typeof useauthenticatedUserQuery>;
export type authenticatedUserLazyQueryHookResult = ReturnType<typeof useauthenticatedUserLazyQuery>;
export type authenticatedUserSuspenseQueryHookResult = ReturnType<typeof useauthenticatedUserSuspenseQuery>;
export type authenticatedUserQueryResult = ApolloReactCommon.QueryResult<authenticatedUserQuery, authenticatedUserQueryVariables>;
export const userDetailsDocument = gql`
    subscription userDetails($userId: uuid!) {
  user: User_by_pk(userId: $userId) {
    ...UserDetailsFragment
  }
}
    ${UserDetailsFragmentDoc}`;
export function useuserDetailsSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<userDetailsSubscription, userDetailsSubscriptionVariables> & ({ variables: userDetailsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<userDetailsSubscription, userDetailsSubscriptionVariables>(userDetailsDocument, options);
      }
export type userDetailsSubscriptionHookResult = ReturnType<typeof useuserDetailsSubscription>;
export type userDetailsSubscriptionResult = ApolloReactCommon.SubscriptionResult<userDetailsSubscription>;
export const userDetailsWithGlobalRolesDocument = gql`
    subscription userDetailsWithGlobalRoles($userId: uuid!) {
  user: User_by_pk(userId: $userId) {
    ...UserDetailsWithGlobalRolesFragment
  }
}
    ${UserDetailsWithGlobalRolesFragmentDoc}`;
export function useuserDetailsWithGlobalRolesSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<userDetailsWithGlobalRolesSubscription, userDetailsWithGlobalRolesSubscriptionVariables> & ({ variables: userDetailsWithGlobalRolesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<userDetailsWithGlobalRolesSubscription, userDetailsWithGlobalRolesSubscriptionVariables>(userDetailsWithGlobalRolesDocument, options);
      }
export type userDetailsWithGlobalRolesSubscriptionHookResult = ReturnType<typeof useuserDetailsWithGlobalRolesSubscription>;
export type userDetailsWithGlobalRolesSubscriptionResult = ApolloReactCommon.SubscriptionResult<userDetailsWithGlobalRolesSubscription>;
export const updateUserDocument = gql`
    mutation updateUser($userId: uuid!, $_set: Custom_UpdateUserInput!) {
  custom_updateUser(userId: $userId, _set: $_set) {
    user {
      ...UserDetailsFragment
    }
  }
}
    ${UserDetailsFragmentDoc}`;
export type updateUserMutationFn = ApolloReactCommon.MutationFunction<updateUserMutation, updateUserMutationVariables>;
export function useupdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<updateUserMutation, updateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<updateUserMutation, updateUserMutationVariables>(updateUserDocument, options);
      }
export type updateUserMutationHookResult = ReturnType<typeof useupdateUserMutation>;
export type updateUserMutationResult = ApolloReactCommon.MutationResult<updateUserMutation>;
export type updateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<updateUserMutation, updateUserMutationVariables>;
export const getUserRoleDetailsDocument = gql`
    subscription getUserRoleDetails($userRoleId: uuid!) {
  userRole: UserRole_by_pk(userRoleId: $userRoleId) {
    ...UserRoleDetailsFragment
  }
}
    ${UserRoleDetailsFragmentDoc}`;
export function usegetUserRoleDetailsSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<getUserRoleDetailsSubscription, getUserRoleDetailsSubscriptionVariables> & ({ variables: getUserRoleDetailsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<getUserRoleDetailsSubscription, getUserRoleDetailsSubscriptionVariables>(getUserRoleDetailsDocument, options);
      }
export type getUserRoleDetailsSubscriptionHookResult = ReturnType<typeof usegetUserRoleDetailsSubscription>;
export type getUserRoleDetailsSubscriptionResult = ApolloReactCommon.SubscriptionResult<getUserRoleDetailsSubscription>;
export const getUserRolesDocument = gql`
    query getUserRoles($where: UserRole_bool_exp!) {
  userRoles: UserRole(where: $where) {
    ...UserRoleUniqueLabelFragment
  }
}
    ${UserRoleUniqueLabelFragmentDoc}`;
export function usegetUserRolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getUserRolesQuery, getUserRolesQueryVariables> & ({ variables: getUserRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getUserRolesQuery, getUserRolesQueryVariables>(getUserRolesDocument, options);
      }
export function usegetUserRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getUserRolesQuery, getUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getUserRolesQuery, getUserRolesQueryVariables>(getUserRolesDocument, options);
        }
export function usegetUserRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getUserRolesQuery, getUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getUserRolesQuery, getUserRolesQueryVariables>(getUserRolesDocument, options);
        }
export type getUserRolesQueryHookResult = ReturnType<typeof usegetUserRolesQuery>;
export type getUserRolesLazyQueryHookResult = ReturnType<typeof usegetUserRolesLazyQuery>;
export type getUserRolesSuspenseQueryHookResult = ReturnType<typeof usegetUserRolesSuspenseQuery>;
export type getUserRolesQueryResult = ApolloReactCommon.QueryResult<getUserRolesQuery, getUserRolesQueryVariables>;
export const getAugustLockUserRolesDocument = gql`
    query getAugustLockUserRoles($input: Custom_GetAugustLockUserRolesInput!) {
  custom_getAugustLockUserRoles(input: $input) {
    augustLockUserRoles {
      ...Custom_AugustLockUserRoleFragment
    }
  }
}
    ${Custom_AugustLockUserRoleFragmentDoc}`;
export function usegetAugustLockUserRolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<getAugustLockUserRolesQuery, getAugustLockUserRolesQueryVariables> & ({ variables: getAugustLockUserRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<getAugustLockUserRolesQuery, getAugustLockUserRolesQueryVariables>(getAugustLockUserRolesDocument, options);
      }
export function usegetAugustLockUserRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<getAugustLockUserRolesQuery, getAugustLockUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<getAugustLockUserRolesQuery, getAugustLockUserRolesQueryVariables>(getAugustLockUserRolesDocument, options);
        }
export function usegetAugustLockUserRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<getAugustLockUserRolesQuery, getAugustLockUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<getAugustLockUserRolesQuery, getAugustLockUserRolesQueryVariables>(getAugustLockUserRolesDocument, options);
        }
export type getAugustLockUserRolesQueryHookResult = ReturnType<typeof usegetAugustLockUserRolesQuery>;
export type getAugustLockUserRolesLazyQueryHookResult = ReturnType<typeof usegetAugustLockUserRolesLazyQuery>;
export type getAugustLockUserRolesSuspenseQueryHookResult = ReturnType<typeof usegetAugustLockUserRolesSuspenseQuery>;
export type getAugustLockUserRolesQueryResult = ApolloReactCommon.QueryResult<getAugustLockUserRolesQuery, getAugustLockUserRolesQueryVariables>;
export const createGuestPassDocument = gql`
    mutation createGuestPass($input: Custom_CreateGuestPassInput!) {
  custom_createGuestPass(input: $input) {
    userRoleId
  }
}
    `;
export type createGuestPassMutationFn = ApolloReactCommon.MutationFunction<createGuestPassMutation, createGuestPassMutationVariables>;
export function usecreateGuestPassMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<createGuestPassMutation, createGuestPassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<createGuestPassMutation, createGuestPassMutationVariables>(createGuestPassDocument, options);
      }
export type createGuestPassMutationHookResult = ReturnType<typeof usecreateGuestPassMutation>;
export type createGuestPassMutationResult = ApolloReactCommon.MutationResult<createGuestPassMutation>;
export type createGuestPassMutationOptions = ApolloReactCommon.BaseMutationOptions<createGuestPassMutation, createGuestPassMutationVariables>;
export const revokeUserRoleDocument = gql`
    mutation revokeUserRole($userRoleId: uuid!) {
  custom_revokeUserRole(userRoleId: $userRoleId) {
    userRole {
      userRoleId
      status
      status
      revokedAt
      revokedByUser {
        ...UserLabelFragment
      }
    }
  }
}
    ${UserLabelFragmentDoc}`;
export type revokeUserRoleMutationFn = ApolloReactCommon.MutationFunction<revokeUserRoleMutation, revokeUserRoleMutationVariables>;
export function userevokeUserRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<revokeUserRoleMutation, revokeUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<revokeUserRoleMutation, revokeUserRoleMutationVariables>(revokeUserRoleDocument, options);
      }
export type revokeUserRoleMutationHookResult = ReturnType<typeof userevokeUserRoleMutation>;
export type revokeUserRoleMutationResult = ApolloReactCommon.MutationResult<revokeUserRoleMutation>;
export type revokeUserRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<revokeUserRoleMutation, revokeUserRoleMutationVariables>;